var map = {
	"./art/ZZ/zz.txt": 133980,
	"./art/frosthaven/card-dividers/fh-active-boat-events.png": 936437,
	"./art/frosthaven/card-dividers/fh-active-buildings.png": 273843,
	"./art/frosthaven/card-dividers/fh-active-summer-outpost-events.png": 105087,
	"./art/frosthaven/card-dividers/fh-active-summer-road-events.png": 198760,
	"./art/frosthaven/card-dividers/fh-active-winter-outpost-events.png": 949758,
	"./art/frosthaven/card-dividers/fh-active-winter-road-events.png": 118091,
	"./art/frosthaven/card-dividers/fh-ally-attack-modifiers.png": 846848,
	"./art/frosthaven/card-dividers/fh-available-craftable-items.png": 44684,
	"./art/frosthaven/card-dividers/fh-available-pets.png": 958965,
	"./art/frosthaven/card-dividers/fh-available-purchasable-items.png": 413940,
	"./art/frosthaven/card-dividers/fh-available-town-guard.png": 766237,
	"./art/frosthaven/card-dividers/fh-completed-challenge.png": 214517,
	"./art/frosthaven/card-dividers/fh-conditional-modifiers.png": 275741,
	"./art/frosthaven/card-dividers/fh-inactive-boat-events.png": 725899,
	"./art/frosthaven/card-dividers/fh-inactive-buildings.png": 666101,
	"./art/frosthaven/card-dividers/fh-inactive-summer-outpost-events.png": 64946,
	"./art/frosthaven/card-dividers/fh-inactive-summer-road-events.png": 787869,
	"./art/frosthaven/card-dividers/fh-inactive-winter-outpost-events.png": 751590,
	"./art/frosthaven/card-dividers/fh-inactive-winter-road-events.png": 114285,
	"./art/frosthaven/card-dividers/fh-monster-attack-modifiers.png": 153601,
	"./art/frosthaven/card-dividers/fh-random-items.png": 892581,
	"./art/frosthaven/card-dividers/fh-unavailable-craftable-items.png": 136370,
	"./art/frosthaven/card-dividers/fh-unavailable-pets.png": 546303,
	"./art/frosthaven/card-dividers/fh-unavailable-purchasable-items.png": 186707,
	"./art/frosthaven/card-dividers/fh-unavailable-town-guard.png": 409974,
	"./art/frosthaven/card-dividers/fh-uncompleted-challenge.png": 504109,
	"./art/frosthaven/characters/character-boxes/fh-banner-spear-character-box.png": 555270,
	"./art/frosthaven/characters/character-boxes/fh-blinkblade-character-box.png": 426260,
	"./art/frosthaven/characters/character-boxes/fh-boneshaper-character-box.png": 9618,
	"./art/frosthaven/characters/character-boxes/fh-crashing-tide-character-box.png": 423433,
	"./art/frosthaven/characters/character-boxes/fh-deathwalker-character-box.png": 84253,
	"./art/frosthaven/characters/character-boxes/fh-deepwraith-character-box.png": 967823,
	"./art/frosthaven/characters/character-boxes/fh-drifter-character-box.png": 534758,
	"./art/frosthaven/characters/character-boxes/fh-frozen-fist-character-box.png": 589117,
	"./art/frosthaven/characters/character-boxes/fh-geminate-character-box.png": 53963,
	"./art/frosthaven/characters/character-boxes/fh-hive-character-box.png": 696055,
	"./art/frosthaven/characters/character-boxes/fh-infuser-character-box.png": 163304,
	"./art/frosthaven/characters/character-boxes/fh-metal-mosaic-character-box.png": 351606,
	"./art/frosthaven/characters/character-boxes/fh-pain-conduit-character-box.png": 650139,
	"./art/frosthaven/characters/character-boxes/fh-pyroclast-character-box.png": 652055,
	"./art/frosthaven/characters/character-boxes/fh-shattersong-character-box.png": 802468,
	"./art/frosthaven/characters/character-boxes/fh-snowdancer-character-box.png": 222484,
	"./art/frosthaven/characters/character-boxes/fh-trapper-character-box.png": 292090,
	"./art/frosthaven/characters/images/fh-banner-spear.png": 213947,
	"./art/frosthaven/characters/images/fh-blinkblade.png": 738119,
	"./art/frosthaven/characters/images/fh-boneshaper.png": 940093,
	"./art/frosthaven/characters/images/fh-crashing-tide.png": 455826,
	"./art/frosthaven/characters/images/fh-deathwalker.png": 90046,
	"./art/frosthaven/characters/images/fh-deepwraith.png": 299434,
	"./art/frosthaven/characters/images/fh-drifter.png": 325915,
	"./art/frosthaven/characters/images/fh-frozen-fist.png": 103276,
	"./art/frosthaven/characters/images/fh-geminate.png": 996717,
	"./art/frosthaven/characters/images/fh-hive.png": 159643,
	"./art/frosthaven/characters/images/fh-infuser.png": 824807,
	"./art/frosthaven/characters/images/fh-metal-mosaic.png": 722747,
	"./art/frosthaven/characters/images/fh-pain-conduit.png": 537231,
	"./art/frosthaven/characters/images/fh-pyroclast.png": 36444,
	"./art/frosthaven/characters/images/fh-shattersong.png": 473653,
	"./art/frosthaven/characters/images/fh-snowdancer.png": 932015,
	"./art/frosthaven/characters/images/fh-trapper.png": 166664,
	"./art/frosthaven/characters/mini-boxes/fh-banner-spear-mini-box.png": 78495,
	"./art/frosthaven/characters/mini-boxes/fh-blinkblade-mini-box.png": 744072,
	"./art/frosthaven/characters/mini-boxes/fh-boneshaper-mini-box.png": 881993,
	"./art/frosthaven/characters/mini-boxes/fh-crashing-tide-mini-box.png": 438267,
	"./art/frosthaven/characters/mini-boxes/fh-deathwalker-mini-box.png": 806322,
	"./art/frosthaven/characters/mini-boxes/fh-deepwraith-mini-box.png": 125054,
	"./art/frosthaven/characters/mini-boxes/fh-drifter-mini-box.png": 840942,
	"./art/frosthaven/characters/mini-boxes/fh-frozen-fist-mini-box.png": 246995,
	"./art/frosthaven/characters/mini-boxes/fh-geminate-melee-mini-box.png": 832827,
	"./art/frosthaven/characters/mini-boxes/fh-geminate-ranged-mini-box.png": 5371,
	"./art/frosthaven/characters/mini-boxes/fh-hive-mini-box.png": 483258,
	"./art/frosthaven/characters/mini-boxes/fh-infuser-mini-box.png": 92313,
	"./art/frosthaven/characters/mini-boxes/fh-metal-mosaic-mini-box.png": 187521,
	"./art/frosthaven/characters/mini-boxes/fh-pain-conduit-mini-box.png": 745726,
	"./art/frosthaven/characters/mini-boxes/fh-pyroclast-mini-box.png": 217943,
	"./art/frosthaven/characters/mini-boxes/fh-shattersong-mini-box.png": 237557,
	"./art/frosthaven/characters/mini-boxes/fh-snowdancer-mini-box.png": 241466,
	"./art/frosthaven/characters/mini-boxes/fh-trapper-mini-box.png": 945942,
	"./art/frosthaven/characters/standees/fh-banner-spear-standee-back.png": 240474,
	"./art/frosthaven/characters/standees/fh-banner-spear-standee-front.png": 866909,
	"./art/frosthaven/characters/standees/fh-blinkblade-standee-back.png": 459283,
	"./art/frosthaven/characters/standees/fh-blinkblade-standee-front.png": 741841,
	"./art/frosthaven/characters/standees/fh-boneshaper-standee-back.png": 96238,
	"./art/frosthaven/characters/standees/fh-boneshaper-standee-front.png": 902522,
	"./art/frosthaven/characters/standees/fh-crashing-tide-standee-back.png": 156292,
	"./art/frosthaven/characters/standees/fh-crashing-tide-standee-front.png": 880467,
	"./art/frosthaven/characters/standees/fh-deathwalker-standee-back.png": 249712,
	"./art/frosthaven/characters/standees/fh-deathwalker-standee-front.png": 110851,
	"./art/frosthaven/characters/standees/fh-deepwraith-standee-back.png": 171751,
	"./art/frosthaven/characters/standees/fh-deepwraith-standee-front.png": 267152,
	"./art/frosthaven/characters/standees/fh-drifter-standee-back.png": 378378,
	"./art/frosthaven/characters/standees/fh-drifter-standee-front.png": 465884,
	"./art/frosthaven/characters/standees/fh-frozen-fist-standee-back.png": 363508,
	"./art/frosthaven/characters/standees/fh-frozen-fist-standee-front.png": 977125,
	"./art/frosthaven/characters/standees/fh-geminate-melee-standee-back.png": 558077,
	"./art/frosthaven/characters/standees/fh-geminate-melee-standee-front.png": 897125,
	"./art/frosthaven/characters/standees/fh-geminate-ranged-standee-back.png": 262023,
	"./art/frosthaven/characters/standees/fh-geminate-ranged-standee-front.png": 476778,
	"./art/frosthaven/characters/standees/fh-hive-standee-back.png": 545104,
	"./art/frosthaven/characters/standees/fh-hive-standee-front.png": 67411,
	"./art/frosthaven/characters/standees/fh-infuser-standee-back.png": 197367,
	"./art/frosthaven/characters/standees/fh-infuser-standee-front.png": 941508,
	"./art/frosthaven/characters/standees/fh-metal-mosaic-standee-back.png": 890493,
	"./art/frosthaven/characters/standees/fh-metal-mosaic-standee-front.png": 301947,
	"./art/frosthaven/characters/standees/fh-pain-conduit-standee-back.png": 304073,
	"./art/frosthaven/characters/standees/fh-pain-conduit-standee-front.png": 411472,
	"./art/frosthaven/characters/standees/fh-pyroclast-standee-back.png": 27211,
	"./art/frosthaven/characters/standees/fh-pyroclast-standee-front.png": 386127,
	"./art/frosthaven/characters/standees/fh-shattersong-standee-back.png": 690306,
	"./art/frosthaven/characters/standees/fh-shattersong-standee-front.png": 250166,
	"./art/frosthaven/characters/standees/fh-snowdancer-standee-back.png": 474020,
	"./art/frosthaven/characters/standees/fh-snowdancer-standee-front.png": 408905,
	"./art/frosthaven/characters/standees/fh-trapper-standee-back.png": 909831,
	"./art/frosthaven/characters/standees/fh-trapper-standee-front.png": 297878,
	"./art/frosthaven/characters/summons/fh-summon-2-white-owls-1-back.png": 511917,
	"./art/frosthaven/characters/summons/fh-summon-2-white-owls-1-front.png": 970416,
	"./art/frosthaven/characters/summons/fh-summon-2-white-owls-2-back.png": 366738,
	"./art/frosthaven/characters/summons/fh-summon-2-white-owls-2-front.png": 509254,
	"./art/frosthaven/characters/summons/fh-summon-animated-claymore-back.png": 504308,
	"./art/frosthaven/characters/summons/fh-summon-animated-claymore-front.png": 366917,
	"./art/frosthaven/characters/summons/fh-summon-arcing-generator-back.png": 900892,
	"./art/frosthaven/characters/summons/fh-summon-arcing-generator-front.png": 592008,
	"./art/frosthaven/characters/summons/fh-summon-armored-tank-back.png": 655011,
	"./art/frosthaven/characters/summons/fh-summon-armored-tank-front.png": 626589,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-courage-back.png": 291167,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-courage-front.png": 692998,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-doom-back.png": 619719,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-doom-front.png": 171670,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-hope-back.png": 132875,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-hope-front.png": 914649,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-strength-back.png": 488898,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-strength-front.png": 903450,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-valor-back.png": 549162,
	"./art/frosthaven/characters/summons/fh-summon-banner-of-valor-front.png": 393782,
	"./art/frosthaven/characters/summons/fh-summon-bombardier-back.png": 856073,
	"./art/frosthaven/characters/summons/fh-summon-bombardier-front.png": 37883,
	"./art/frosthaven/characters/summons/fh-summon-bone-horde-back.png": 306716,
	"./art/frosthaven/characters/summons/fh-summon-bone-horde-front.png": 391697,
	"./art/frosthaven/characters/summons/fh-summon-dampening-unit-back.png": 839742,
	"./art/frosthaven/characters/summons/fh-summon-dampening-unit-front.png": 177519,
	"./art/frosthaven/characters/summons/fh-summon-defense-grid-back.png": 954121,
	"./art/frosthaven/characters/summons/fh-summon-defense-grid-front.png": 369139,
	"./art/frosthaven/characters/summons/fh-summon-flesh-bomb-back.png": 598841,
	"./art/frosthaven/characters/summons/fh-summon-flesh-bomb-front.png": 935358,
	"./art/frosthaven/characters/summons/fh-summon-flesh-fiend-back.png": 938568,
	"./art/frosthaven/characters/summons/fh-summon-flesh-fiend-front.png": 513062,
	"./art/frosthaven/characters/summons/fh-summon-jackal-mech-back.png": 349116,
	"./art/frosthaven/characters/summons/fh-summon-jackal-mech-front.png": 779641,
	"./art/frosthaven/characters/summons/fh-summon-leaper-back.png": 38302,
	"./art/frosthaven/characters/summons/fh-summon-leaper-front.png": 993748,
	"./art/frosthaven/characters/summons/fh-summon-longbowman-back.png": 989732,
	"./art/frosthaven/characters/summons/fh-summon-longbowman-front.png": 440850,
	"./art/frosthaven/characters/summons/fh-summon-machine-bolter-back.png": 469167,
	"./art/frosthaven/characters/summons/fh-summon-machine-bolter-front.png": 272110,
	"./art/frosthaven/characters/summons/fh-summon-polar-cat-back.png": 221578,
	"./art/frosthaven/characters/summons/fh-summon-polar-cat-front.png": 863309,
	"./art/frosthaven/characters/summons/fh-summon-raging-corpse-back.png": 507370,
	"./art/frosthaven/characters/summons/fh-summon-raging-corpse-front.png": 799769,
	"./art/frosthaven/characters/summons/fh-summon-reinforcement-back.png": 782309,
	"./art/frosthaven/characters/summons/fh-summon-reinforcement-front.png": 944125,
	"./art/frosthaven/characters/summons/fh-summon-repair-drone-back.png": 250189,
	"./art/frosthaven/characters/summons/fh-summon-repair-drone-front.png": 817681,
	"./art/frosthaven/characters/summons/fh-summon-shadow-beast-back.png": 277935,
	"./art/frosthaven/characters/summons/fh-summon-shadow-beast-front.png": 603279,
	"./art/frosthaven/characters/summons/fh-summon-shadow-horror-back.png": 929721,
	"./art/frosthaven/characters/summons/fh-summon-shadow-horror-front.png": 41304,
	"./art/frosthaven/characters/summons/fh-summon-shaggy-lure-back.png": 683530,
	"./art/frosthaven/characters/summons/fh-summon-shaggy-lure-front.png": 762038,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-1-back.png": 942803,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-1-front.png": 798020,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-2-back.png": 911210,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-2-front.png": 159080,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-3-back.png": 686363,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-3-front.png": 343720,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-4-back.png": 276240,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-4-front.png": 834723,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-5-back.png": 301117,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-5-front.png": 540498,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-6-back.png": 396670,
	"./art/frosthaven/characters/summons/fh-summon-shambling-skeleton-6-front.png": 750769,
	"./art/frosthaven/characters/summons/fh-summon-shield-spider-back.png": 801034,
	"./art/frosthaven/characters/summons/fh-summon-shield-spider-front.png": 955738,
	"./art/frosthaven/characters/summons/fh-summon-skeleton-sorcerer-back.png": 631805,
	"./art/frosthaven/characters/summons/fh-summon-skeleton-sorcerer-front.png": 48298,
	"./art/frosthaven/characters/summons/fh-summon-sledge-driver-back.png": 665210,
	"./art/frosthaven/characters/summons/fh-summon-sledge-driver-front.png": 665183,
	"./art/frosthaven/characters/summons/fh-summon-sniper-turret-back.png": 266913,
	"./art/frosthaven/characters/summons/fh-summon-sniper-turret-front.png": 213594,
	"./art/frosthaven/characters/summons/fh-summon-snow-fox-back.png": 149258,
	"./art/frosthaven/characters/summons/fh-summon-snow-fox-front.png": 164626,
	"./art/frosthaven/characters/summons/fh-summon-spiritbound-falchion-back.png": 225723,
	"./art/frosthaven/characters/summons/fh-summon-spiritbound-falchion-front.png": 279877,
	"./art/frosthaven/characters/summons/fh-summon-stitched-atrocity-back.png": 275538,
	"./art/frosthaven/characters/summons/fh-summon-stitched-atrocity-front.png": 711710,
	"./art/frosthaven/characters/summons/fh-summon-sword-propeller-back.png": 160357,
	"./art/frosthaven/characters/summons/fh-summon-sword-propeller-front.png": 644733,
	"./art/frosthaven/characters/summons/fh-summon-torch-bearer-back.png": 142368,
	"./art/frosthaven/characters/summons/fh-summon-torch-bearer-front.png": 859698,
	"./art/frosthaven/characters/summons/fh-summon-toxin-distributor-back.png": 653157,
	"./art/frosthaven/characters/summons/fh-summon-toxin-distributor-front.png": 293206,
	"./art/frosthaven/characters/summons/fh-summon-trained-falcon-back.png": 963763,
	"./art/frosthaven/characters/summons/fh-summon-trained-falcon-front.png": 964761,
	"./art/frosthaven/characters/summons/fh-summon-trapping-unit-back.png": 366625,
	"./art/frosthaven/characters/summons/fh-summon-trapping-unit-front.png": 831747,
	"./art/frosthaven/characters/summons/fh-summon-wraith-back.png": 336333,
	"./art/frosthaven/characters/summons/fh-summon-wraith-front.png": 218526,
	"./art/frosthaven/characters/tokens/fh-banner-spear-character-token.png": 228920,
	"./art/frosthaven/characters/tokens/fh-banner-spear-initiative-order-token-back.png": 911291,
	"./art/frosthaven/characters/tokens/fh-banner-spear-initiative-order-token-front.png": 778744,
	"./art/frosthaven/characters/tokens/fh-blinkblade-character-token.png": 446609,
	"./art/frosthaven/characters/tokens/fh-blinkblade-initiative-order-token-back.png": 654837,
	"./art/frosthaven/characters/tokens/fh-blinkblade-initiative-order-token-front.png": 100242,
	"./art/frosthaven/characters/tokens/fh-blinkblade-time-token.png": 53016,
	"./art/frosthaven/characters/tokens/fh-boneshaper-character-token.png": 867948,
	"./art/frosthaven/characters/tokens/fh-boneshaper-initiative-order-token-back.png": 261166,
	"./art/frosthaven/characters/tokens/fh-boneshaper-initiative-order-token-front.png": 144862,
	"./art/frosthaven/characters/tokens/fh-boneshaper-shambling-skeleton-tracking-token-1.png": 140739,
	"./art/frosthaven/characters/tokens/fh-boneshaper-shambling-skeleton-tracking-token-2.png": 934129,
	"./art/frosthaven/characters/tokens/fh-boneshaper-shambling-skeleton-tracking-token-3.png": 201116,
	"./art/frosthaven/characters/tokens/fh-boneshaper-shambling-skeleton-tracking-token-4.png": 902039,
	"./art/frosthaven/characters/tokens/fh-boneshaper-shambling-skeleton-tracking-token-5.png": 630305,
	"./art/frosthaven/characters/tokens/fh-boneshaper-shambling-skeleton-tracking-token-6.png": 470594,
	"./art/frosthaven/characters/tokens/fh-crashing-tide-character-token.png": 235514,
	"./art/frosthaven/characters/tokens/fh-crashing-tide-initiative-order-token-back.png": 962278,
	"./art/frosthaven/characters/tokens/fh-crashing-tide-initiative-order-token-front.png": 622231,
	"./art/frosthaven/characters/tokens/fh-deathwalker-character-token.png": 541332,
	"./art/frosthaven/characters/tokens/fh-deathwalker-initiative-order-token-back.png": 291493,
	"./art/frosthaven/characters/tokens/fh-deathwalker-initiative-order-token-front.png": 170740,
	"./art/frosthaven/characters/tokens/fh-deathwalker-shadow-token.png": 683100,
	"./art/frosthaven/characters/tokens/fh-deepwraith-character-token.png": 801842,
	"./art/frosthaven/characters/tokens/fh-deepwraith-initiative-order-token-back.png": 797943,
	"./art/frosthaven/characters/tokens/fh-deepwraith-initiative-order-token-front.png": 227355,
	"./art/frosthaven/characters/tokens/fh-deepwraith-trophy-token.png": 28726,
	"./art/frosthaven/characters/tokens/fh-drifter-character-token.png": 920883,
	"./art/frosthaven/characters/tokens/fh-drifter-initiative-order-token-back.png": 573950,
	"./art/frosthaven/characters/tokens/fh-drifter-initiative-order-token-front.png": 143949,
	"./art/frosthaven/characters/tokens/fh-frozen-fist-character-token.png": 132682,
	"./art/frosthaven/characters/tokens/fh-frozen-fist-initiative-order-token-back.png": 530979,
	"./art/frosthaven/characters/tokens/fh-frozen-fist-initiative-order-token-front.png": 105851,
	"./art/frosthaven/characters/tokens/fh-geminate-character-token.png": 367416,
	"./art/frosthaven/characters/tokens/fh-geminate-initiative-order-token-back.png": 66828,
	"./art/frosthaven/characters/tokens/fh-geminate-initiative-order-token-front.png": 425595,
	"./art/frosthaven/characters/tokens/fh-geminate-melee-token.png": 185273,
	"./art/frosthaven/characters/tokens/fh-geminate-ranged-token.png": 92259,
	"./art/frosthaven/characters/tokens/fh-hive-character-token.png": 37369,
	"./art/frosthaven/characters/tokens/fh-hive-initiative-order-token-back.png": 22465,
	"./art/frosthaven/characters/tokens/fh-hive-initiative-order-token-front.png": 152161,
	"./art/frosthaven/characters/tokens/fh-hive-mode-token.png": 267930,
	"./art/frosthaven/characters/tokens/fh-infuser-character-token.png": 927827,
	"./art/frosthaven/characters/tokens/fh-infuser-initiative-order-token-back.png": 53884,
	"./art/frosthaven/characters/tokens/fh-infuser-initiative-order-token-front.png": 875507,
	"./art/frosthaven/characters/tokens/fh-metal-mosaic-character-token.png": 875685,
	"./art/frosthaven/characters/tokens/fh-metal-mosaic-initiative-order-token-back.png": 526399,
	"./art/frosthaven/characters/tokens/fh-metal-mosaic-initiative-order-token-front.png": 674180,
	"./art/frosthaven/characters/tokens/fh-metal-mosaic-pressure-token.png": 186619,
	"./art/frosthaven/characters/tokens/fh-pain-conduit-character-token.png": 697543,
	"./art/frosthaven/characters/tokens/fh-pain-conduit-initiative-order-token-back.png": 244766,
	"./art/frosthaven/characters/tokens/fh-pain-conduit-initiative-order-token-front.png": 965531,
	"./art/frosthaven/characters/tokens/fh-pyroclast-character-token.png": 324730,
	"./art/frosthaven/characters/tokens/fh-pyroclast-hazardous-terrain-token.png": 659644,
	"./art/frosthaven/characters/tokens/fh-pyroclast-initiative-order-token-back.png": 612431,
	"./art/frosthaven/characters/tokens/fh-pyroclast-initiative-order-token-front.png": 771683,
	"./art/frosthaven/characters/tokens/fh-shattersong-character-token.png": 513081,
	"./art/frosthaven/characters/tokens/fh-shattersong-initiative-order-token-back.png": 144677,
	"./art/frosthaven/characters/tokens/fh-shattersong-initiative-order-token-front.png": 778430,
	"./art/frosthaven/characters/tokens/fh-shattersong-resonance-token.png": 680529,
	"./art/frosthaven/characters/tokens/fh-snowdancer-character-token.png": 761023,
	"./art/frosthaven/characters/tokens/fh-snowdancer-initiative-order-token-back.png": 854662,
	"./art/frosthaven/characters/tokens/fh-snowdancer-initiative-order-token-front.png": 174909,
	"./art/frosthaven/characters/tokens/fh-trapper-character-token.png": 800785,
	"./art/frosthaven/characters/tokens/fh-trapper-initiative-order-token-back.png": 242633,
	"./art/frosthaven/characters/tokens/fh-trapper-initiative-order-token-front.png": 183228,
	"./art/frosthaven/characters/tokens/fh-trapper-negative-trap-token.png": 189297,
	"./art/frosthaven/characters/tokens/fh-trapper-positive-trap-token.png": 698669,
	"./art/frosthaven/envelopes/fh-21-inn-envelope.png": 641083,
	"./art/frosthaven/envelopes/fh-24-garden-envelope.png": 792014,
	"./art/frosthaven/envelopes/fh-37-trading-post-envelope.png": 693013,
	"./art/frosthaven/envelopes/fh-39-jeweler-envelope.png": 651603,
	"./art/frosthaven/envelopes/fh-42-temple-envelope.png": 694268,
	"./art/frosthaven/envelopes/fh-44-enhancer-envelope.png": 776937,
	"./art/frosthaven/envelopes/fh-65-metal-depot-envelope.png": 908748,
	"./art/frosthaven/envelopes/fh-67-lumber-depot-envelope.png": 716607,
	"./art/frosthaven/envelopes/fh-72-hide-depot-envelope.png": 333781,
	"./art/frosthaven/envelopes/fh-74-tavern-envelope.png": 739355,
	"./art/frosthaven/envelopes/fh-81-hall-of-revelry-envelope.png": 712983,
	"./art/frosthaven/envelopes/fh-83-library-envelope.png": 674228,
	"./art/frosthaven/envelopes/fh-85-carpenter-envelope.png": 872965,
	"./art/frosthaven/envelopes/fh-88-stables-envelope.png": 905253,
	"./art/frosthaven/envelopes/fh-90-town-hall-envelope.png": 903651,
	"./art/frosthaven/envelopes/fh-a-hall-of-revelry-level-2-envelope.png": 969406,
	"./art/frosthaven/envelopes/fh-b-boat-envelope.png": 77229,
	"./art/frosthaven/fonts/AdobeSongStd-Light.otf": 267514,
	"./art/frosthaven/fonts/AncientGlyphs-Regular.otf": 899753,
	"./art/frosthaven/fonts/AncientGlyphs-Regular.ttf": 189482,
	"./art/frosthaven/fonts/FHBasic.otf": 357029,
	"./art/frosthaven/fonts/FHConditions.otf": 42879,
	"./art/frosthaven/fonts/FHModifers.otf": 569142,
	"./art/frosthaven/fonts/FHResources.otf": 766011,
	"./art/frosthaven/fonts/FrosthavenDotsBlue.otf": 167485,
	"./art/frosthaven/fonts/FrosthavenDotsRed.otf": 17041,
	"./art/frosthaven/fonts/GHGrayCircles.otf": 140881,
	"./art/frosthaven/fonts/GHGrayMarkers.otf": 331132,
	"./art/frosthaven/fonts/GHGreenCircles.otf": 857013,
	"./art/frosthaven/fonts/GHGreenMarkers.otf": 645681,
	"./art/frosthaven/fonts/GermaniaOne-Regular.ttf": 211040,
	"./art/frosthaven/fonts/HelveticaNeueLTCom-BdCn.ttf": 652737,
	"./art/frosthaven/fonts/MarkaziText-Bold.ttf": 776456,
	"./art/frosthaven/fonts/MarkaziText-Medium.ttf": 944213,
	"./art/frosthaven/fonts/MarkaziText-Regular.ttf": 251137,
	"./art/frosthaven/fonts/MarkaziText-SemiBold.ttf": 673180,
	"./art/frosthaven/fonts/MarkaziText-VariableFont_wght.ttf": 608763,
	"./art/frosthaven/fonts/MinionPro-Bold.otf": 420112,
	"./art/frosthaven/fonts/MinionPro-Regular.otf": 769861,
	"./art/frosthaven/fonts/MyriadPro-Regular.otf": 275262,
	"./art/frosthaven/fonts/PirataOne-Gloomhaven.ttf": 271473,
	"./art/frosthaven/fonts/PirataOne-Gloomhaven_0.ttf": 134887,
	"./art/frosthaven/fonts/Texturina-Light.ttf": 824322,
	"./art/frosthaven/fonts/Texturina-Regular.ttf": 737131,
	"./art/frosthaven/fonts/Texturina-VariableFont_opsz,wght.ttf": 681136,
	"./art/frosthaven/fonts/Tinos-Bold.ttf": 943943,
	"./art/frosthaven/fonts/Wingdings 2.ttf": 177420,
	"./art/frosthaven/fonts/Wingdings 3.ttf": 660612,
	"./art/frosthaven/fonts/Wingdings.ttf": 681470,
	"./art/frosthaven/fonts/arial.ttf": 300207,
	"./art/frosthaven/fonts/calibri.ttf": 288934,
	"./art/frosthaven/fonts/calibrib.ttf": 66181,
	"./art/frosthaven/fonts/majalla.ttf": 221196,
	"./art/frosthaven/fonts/majallab.ttf": 960948,
	"./art/frosthaven/game-box/fh-game-box-bottom-longside.png": 683392,
	"./art/frosthaven/game-box/fh-game-box-bottom-shortside.png": 127140,
	"./art/frosthaven/game-box/fh-game-box-bottom.png": 240094,
	"./art/frosthaven/game-box/fh-game-box-top-longside.png": 409964,
	"./art/frosthaven/game-box/fh-game-box-top-shortside.png": 112416,
	"./art/frosthaven/game-box/fh-game-box-top.png": 860174,
	"./art/frosthaven/icons/attack-modifiers/fh-2x-bw-icon.png": 471998,
	"./art/frosthaven/icons/attack-modifiers/fh-minus-1-bw-icon.png": 556700,
	"./art/frosthaven/icons/attack-modifiers/fh-minus-1-modifier-card-bw-icon.png": 136624,
	"./art/frosthaven/icons/attack-modifiers/fh-minus-2-bw-icon.png": 373945,
	"./art/frosthaven/icons/attack-modifiers/fh-plus-0-bw-icon.png": 557159,
	"./art/frosthaven/icons/attack-modifiers/fh-plus-1-bw-icon.png": 572931,
	"./art/frosthaven/icons/attack-modifiers/fh-plus-2-bw-icon.png": 198536,
	"./art/frosthaven/icons/attack-modifiers/fh-plus-3-bw-icon.png": 676816,
	"./art/frosthaven/icons/attack-modifiers/fh-plus-4-bw-icon.png": 828492,
	"./art/frosthaven/icons/characters/fh-banner-spear-bw-icon.png": 220393,
	"./art/frosthaven/icons/characters/fh-blinkblade-bw-icon.png": 929935,
	"./art/frosthaven/icons/characters/fh-boneshaper-bw-icon.png": 672172,
	"./art/frosthaven/icons/characters/fh-crashing-tide-bw-icon.png": 773588,
	"./art/frosthaven/icons/characters/fh-deathwalker-bw-icon.png": 684576,
	"./art/frosthaven/icons/characters/fh-deepwraith-bw-icon.png": 454609,
	"./art/frosthaven/icons/characters/fh-drifter-bw-icon.png": 36061,
	"./art/frosthaven/icons/characters/fh-frozen-fist-bw-icon.png": 334401,
	"./art/frosthaven/icons/characters/fh-geminate-bw-icon.png": 674347,
	"./art/frosthaven/icons/characters/fh-hive-bw-icon.png": 441857,
	"./art/frosthaven/icons/characters/fh-infuser-bw-icon.png": 133115,
	"./art/frosthaven/icons/characters/fh-metal-mosaic-bw-icon.png": 324118,
	"./art/frosthaven/icons/characters/fh-pain-conduit-bw-icon.png": 59929,
	"./art/frosthaven/icons/characters/fh-pyroclast-bw-icon.png": 822814,
	"./art/frosthaven/icons/characters/fh-shattersong-bw-icon.png": 812058,
	"./art/frosthaven/icons/characters/fh-snowdancer-bw-icon.png": 4978,
	"./art/frosthaven/icons/characters/fh-trapper-bw-icon.png": 468081,
	"./art/frosthaven/icons/class/fh-blinkblade-fast-bw-icon.png": 766143,
	"./art/frosthaven/icons/class/fh-blinkblade-fast-color-icon.png": 787787,
	"./art/frosthaven/icons/class/fh-blinkblade-slow-bw-icon.png": 190520,
	"./art/frosthaven/icons/class/fh-blinkblade-slow-color-icon.png": 890871,
	"./art/frosthaven/icons/class/fh-blinkblade-time-bw-icon.png": 143757,
	"./art/frosthaven/icons/class/fh-blinkblade-time-color-icon.png": 651395,
	"./art/frosthaven/icons/class/fh-crashing-tide-tide-bw-icon.png": 175074,
	"./art/frosthaven/icons/class/fh-crashing-tide-tide-color-icon.png": 215683,
	"./art/frosthaven/icons/class/fh-deathwalker-shadow-bw-icon.png": 741582,
	"./art/frosthaven/icons/class/fh-deathwalker-shadow-color-icon.png": 852617,
	"./art/frosthaven/icons/class/fh-deepwraith-trophy-bw-icon.png": 322916,
	"./art/frosthaven/icons/class/fh-deepwraith-trophy-color-icon.png": 300626,
	"./art/frosthaven/icons/class/fh-geminate-melee-bw-icon.png": 941488,
	"./art/frosthaven/icons/class/fh-geminate-melee-color-icon.png": 611832,
	"./art/frosthaven/icons/class/fh-geminate-ranged-bw-icon.png": 69934,
	"./art/frosthaven/icons/class/fh-geminate-ranged-color-icon.png": 270237,
	"./art/frosthaven/icons/class/fh-hive-mode-bw-icon.png": 605709,
	"./art/frosthaven/icons/class/fh-hive-mode-color-icon.png": 762071,
	"./art/frosthaven/icons/class/fh-hive-transfer-bw-icon.png": 223519,
	"./art/frosthaven/icons/class/fh-hive-transfer-color-icon.png": 116774,
	"./art/frosthaven/icons/class/fh-infuser-infusion-bw-icon.png": 349756,
	"./art/frosthaven/icons/class/fh-infuser-infusion-color-icon.png": 35903,
	"./art/frosthaven/icons/class/fh-metal-mosaic-1-pressure-low-bw-icon.png": 876858,
	"./art/frosthaven/icons/class/fh-metal-mosaic-1-pressure-low-color-icon.png": 325105,
	"./art/frosthaven/icons/class/fh-metal-mosaic-2-pressure-regular-bw-icon.png": 312995,
	"./art/frosthaven/icons/class/fh-metal-mosaic-2-pressure-regular-color-icon.png": 427085,
	"./art/frosthaven/icons/class/fh-metal-mosaic-3-pressure-high-bw-icon.png": 924381,
	"./art/frosthaven/icons/class/fh-metal-mosaic-3-pressure-high-color-icon.png": 605840,
	"./art/frosthaven/icons/class/fh-metal-mosaic-4-pressure-over-bw-icon.png": 387985,
	"./art/frosthaven/icons/class/fh-metal-mosaic-4-pressure-over-color-icon.png": 889779,
	"./art/frosthaven/icons/class/fh-metal-mosaic-pressure-bw-icon.png": 593018,
	"./art/frosthaven/icons/class/fh-metal-mosaic-pressure-color-icon.png": 829580,
	"./art/frosthaven/icons/class/fh-metal-mosaic-pressure-down-bw-icon.png": 226722,
	"./art/frosthaven/icons/class/fh-metal-mosaic-pressure-down-color-icon.png": 876715,
	"./art/frosthaven/icons/class/fh-metal-mosaic-pressure-up-bw-icon.png": 133447,
	"./art/frosthaven/icons/class/fh-metal-mosaic-pressure-up-color-icon.png": 207231,
	"./art/frosthaven/icons/class/fh-shattersong-resonance-bw-icon.png": 771262,
	"./art/frosthaven/icons/class/fh-shattersong-resonance-color-icon.png": 417543,
	"./art/frosthaven/icons/conditions/fh-bane-bw-icon.png": 490533,
	"./art/frosthaven/icons/conditions/fh-bane-color-icon.png": 795223,
	"./art/frosthaven/icons/conditions/fh-bless-bw-icon.png": 496577,
	"./art/frosthaven/icons/conditions/fh-bless-color-icon.png": 179241,
	"./art/frosthaven/icons/conditions/fh-brittle-bw-icon.png": 255588,
	"./art/frosthaven/icons/conditions/fh-brittle-color-icon.png": 824606,
	"./art/frosthaven/icons/conditions/fh-brittle-immune-color-icon.png": 436689,
	"./art/frosthaven/icons/conditions/fh-curse-bw-icon.png": 440226,
	"./art/frosthaven/icons/conditions/fh-curse-color-icon.png": 703237,
	"./art/frosthaven/icons/conditions/fh-curse-immune-color-icon.png": 261615,
	"./art/frosthaven/icons/conditions/fh-disarm-bw-icon.png": 856606,
	"./art/frosthaven/icons/conditions/fh-disarm-color-icon.png": 470292,
	"./art/frosthaven/icons/conditions/fh-disarm-immune-color-icon.png": 291333,
	"./art/frosthaven/icons/conditions/fh-immobilize-bw-icon.png": 536779,
	"./art/frosthaven/icons/conditions/fh-immobilize-color-icon.png": 841516,
	"./art/frosthaven/icons/conditions/fh-immobilize-immune-color-icon.png": 476613,
	"./art/frosthaven/icons/conditions/fh-impair-bw-icon.png": 478977,
	"./art/frosthaven/icons/conditions/fh-impair-color-icon.png": 449031,
	"./art/frosthaven/icons/conditions/fh-invisible-bw-icon.png": 202895,
	"./art/frosthaven/icons/conditions/fh-invisible-color-icon.png": 27431,
	"./art/frosthaven/icons/conditions/fh-muddle-bw-icon.png": 836999,
	"./art/frosthaven/icons/conditions/fh-muddle-color-icon.png": 197832,
	"./art/frosthaven/icons/conditions/fh-muddle-immune-color-icon.png": 850370,
	"./art/frosthaven/icons/conditions/fh-pierce-bw-icon.png": 223553,
	"./art/frosthaven/icons/conditions/fh-pierce-color-icon.png": 67453,
	"./art/frosthaven/icons/conditions/fh-poison-bw-icon.png": 380751,
	"./art/frosthaven/icons/conditions/fh-poison-color-icon.png": 293372,
	"./art/frosthaven/icons/conditions/fh-poison-immune-color-icon.png": 517840,
	"./art/frosthaven/icons/conditions/fh-pull-bw-icon.png": 25115,
	"./art/frosthaven/icons/conditions/fh-pull-color-icon.png": 831869,
	"./art/frosthaven/icons/conditions/fh-push-bw-icon.png": 20352,
	"./art/frosthaven/icons/conditions/fh-push-color-icon.png": 889198,
	"./art/frosthaven/icons/conditions/fh-regenerate-bw-icon.png": 526445,
	"./art/frosthaven/icons/conditions/fh-regenerate-color-icon.png": 922487,
	"./art/frosthaven/icons/conditions/fh-rolling-bw-icon.png": 421093,
	"./art/frosthaven/icons/conditions/fh-rolling-color-icon.png": 642451,
	"./art/frosthaven/icons/conditions/fh-strengthen-bw-icon.png": 222610,
	"./art/frosthaven/icons/conditions/fh-strengthen-color-icon.png": 425014,
	"./art/frosthaven/icons/conditions/fh-stun-bw-icon.png": 9267,
	"./art/frosthaven/icons/conditions/fh-stun-color-icon.png": 906753,
	"./art/frosthaven/icons/conditions/fh-stun-immune-color-icon.png": 673926,
	"./art/frosthaven/icons/conditions/fh-ward-bw-icon.png": 964510,
	"./art/frosthaven/icons/conditions/fh-ward-color-icon.png": 654738,
	"./art/frosthaven/icons/conditions/fh-wound-bw-icon.png": 16181,
	"./art/frosthaven/icons/conditions/fh-wound-color-icon.png": 585506,
	"./art/frosthaven/icons/conditions/fh-wound-immune-color-icon.png": 996335,
	"./art/frosthaven/icons/elements/fh-air-bw-icon.png": 840707,
	"./art/frosthaven/icons/elements/fh-air-color-icon.png": 735395,
	"./art/frosthaven/icons/elements/fh-air-consume-color-icon.png": 971787,
	"./art/frosthaven/icons/elements/fh-consume-bw-icon.png": 330012,
	"./art/frosthaven/icons/elements/fh-consume-color-icon.png": 133301,
	"./art/frosthaven/icons/elements/fh-dark-bw-icon.png": 685551,
	"./art/frosthaven/icons/elements/fh-dark-color-icon.png": 14396,
	"./art/frosthaven/icons/elements/fh-dark-consume-color-icon.png": 680203,
	"./art/frosthaven/icons/elements/fh-earth-bw-icon.png": 830545,
	"./art/frosthaven/icons/elements/fh-earth-color-icon.png": 889374,
	"./art/frosthaven/icons/elements/fh-earth-consume-color-icon.png": 915966,
	"./art/frosthaven/icons/elements/fh-fire-bw-icon.png": 74062,
	"./art/frosthaven/icons/elements/fh-fire-color-icon.png": 721646,
	"./art/frosthaven/icons/elements/fh-fire-consume-color-icon.png": 559602,
	"./art/frosthaven/icons/elements/fh-ice-bw-icon.png": 15068,
	"./art/frosthaven/icons/elements/fh-ice-color-icon.png": 257972,
	"./art/frosthaven/icons/elements/fh-ice-consume-color-icon.png": 282396,
	"./art/frosthaven/icons/elements/fh-light-bw-icon.png": 158575,
	"./art/frosthaven/icons/elements/fh-light-color-icon.png": 435964,
	"./art/frosthaven/icons/elements/fh-light-consume-color-icon.png": 802752,
	"./art/frosthaven/icons/elements/fh-wild-bw-icon.png": 849218,
	"./art/frosthaven/icons/elements/fh-wild-color-icon.png": 493582,
	"./art/frosthaven/icons/elements/fh-wild-consume-color-icon.png": 20003,
	"./art/frosthaven/icons/general/fh-ally-modifier-card-bw-icon.png": 606889,
	"./art/frosthaven/icons/general/fh-attack-bw-icon.png": 894269,
	"./art/frosthaven/icons/general/fh-battle-goal-check-mark-bw-icon.png": 997843,
	"./art/frosthaven/icons/general/fh-building-downtime-bw-icon.png": 425033,
	"./art/frosthaven/icons/general/fh-building-envelope-bw-icon.png": 179986,
	"./art/frosthaven/icons/general/fh-building-operation-bw-icon.png": 351515,
	"./art/frosthaven/icons/general/fh-building-prosperity-bw-icon.png": 430527,
	"./art/frosthaven/icons/general/fh-building-repair-bw-icon.png": 43999,
	"./art/frosthaven/icons/general/fh-building-upgrade-bw-icon.png": 235744,
	"./art/frosthaven/icons/general/fh-building-wrecked-bw-icon.png": 714554,
	"./art/frosthaven/icons/general/fh-damage-bw-icon.png": 393917,
	"./art/frosthaven/icons/general/fh-equip-slot-body-bw-icon.png": 80179,
	"./art/frosthaven/icons/general/fh-equip-slot-dual-hand-bw-icon.png": 665833,
	"./art/frosthaven/icons/general/fh-equip-slot-head-bw-icon.png": 202835,
	"./art/frosthaven/icons/general/fh-equip-slot-item-bw-icon.png": 714842,
	"./art/frosthaven/icons/general/fh-equip-slot-legs-bw-icon.png": 753996,
	"./art/frosthaven/icons/general/fh-equip-slot-single-hand-bw-icon.png": 521729,
	"./art/frosthaven/icons/general/fh-flight-bw-icon.png": 887698,
	"./art/frosthaven/icons/general/fh-flip-back-to-front-color-icon.png": 973987,
	"./art/frosthaven/icons/general/fh-flip-back-to-front-generic-color-icon.png": 770134,
	"./art/frosthaven/icons/general/fh-flip-front-to-back-color-icon.png": 320401,
	"./art/frosthaven/icons/general/fh-frosthaven-identifier-bw-icon.png": 96023,
	"./art/frosthaven/icons/general/fh-heal-bw-icon.png": 56786,
	"./art/frosthaven/icons/general/fh-hex-attack-color-icon.png": 727514,
	"./art/frosthaven/icons/general/fh-hex-empty-color-icon.png": 726661,
	"./art/frosthaven/icons/general/fh-hex-player-color-icon.png": 965814,
	"./art/frosthaven/icons/general/fh-hex-summon-color-icon.png": 214932,
	"./art/frosthaven/icons/general/fh-item-card-bw-icon.png": 653354,
	"./art/frosthaven/icons/general/fh-jump-bw-icon.png": 983576,
	"./art/frosthaven/icons/general/fh-level-crown-bw-icon.png": 572858,
	"./art/frosthaven/icons/general/fh-linked-bw-icon.png": 996130,
	"./art/frosthaven/icons/general/fh-linked-forced-color-icon.png": 700516,
	"./art/frosthaven/icons/general/fh-locked-out-color-icon.png": 632350,
	"./art/frosthaven/icons/general/fh-loot-bw-icon.png": 881033,
	"./art/frosthaven/icons/general/fh-loot-location-color-icon.png": 406979,
	"./art/frosthaven/icons/general/fh-lost-black-card-color-icon.png": 297852,
	"./art/frosthaven/icons/general/fh-lost-color-icon.png": 15635,
	"./art/frosthaven/icons/general/fh-money-bw-icon.png": 613253,
	"./art/frosthaven/icons/general/fh-move-bw-icon.png": 48162,
	"./art/frosthaven/icons/general/fh-non-return-card-color-icon.png": 885302,
	"./art/frosthaven/icons/general/fh-persistent-bonus-color-icon.png": 505227,
	"./art/frosthaven/icons/general/fh-players-2-3-bw-icon.png": 663275,
	"./art/frosthaven/icons/general/fh-players-2-bw-icon.png": 592094,
	"./art/frosthaven/icons/general/fh-players-3-4-bw-icon.png": 467549,
	"./art/frosthaven/icons/general/fh-players-4-bw-icon.png": 195156,
	"./art/frosthaven/icons/general/fh-range-bw-icon.png": 10770,
	"./art/frosthaven/icons/general/fh-recover-card-color-icon.png": 15489,
	"./art/frosthaven/icons/general/fh-retaliate-bw-icon.png": 990648,
	"./art/frosthaven/icons/general/fh-return-card-bw-icon.png": 777232,
	"./art/frosthaven/icons/general/fh-round-bonus-color-icon.png": 320619,
	"./art/frosthaven/icons/general/fh-section-bw-icon.png": 624909,
	"./art/frosthaven/icons/general/fh-shield-bw-icon.png": 977434,
	"./art/frosthaven/icons/general/fh-spent-bw-icon.png": 346713,
	"./art/frosthaven/icons/general/fh-start-location-color-icon.png": 914477,
	"./art/frosthaven/icons/general/fh-tap-card-color-icon.png": 977337,
	"./art/frosthaven/icons/general/fh-target-bw-icon.png": 775925,
	"./art/frosthaven/icons/general/fh-teleport-bw-icon.png": 808340,
	"./art/frosthaven/icons/general/fh-trait-bw-icon.png": 337424,
	"./art/frosthaven/icons/general/fh-treasure-chest-bw-icon.png": 954201,
	"./art/frosthaven/icons/general/fh-xp-bw-icon.png": 790179,
	"./art/frosthaven/icons/loot/fh-arrowvine-bw-icon.png": 624873,
	"./art/frosthaven/icons/loot/fh-axenut-bw-icon.png": 284583,
	"./art/frosthaven/icons/loot/fh-corpsecap-bw-icon.png": 424435,
	"./art/frosthaven/icons/loot/fh-flamefruit-bw-icon.png": 360135,
	"./art/frosthaven/icons/loot/fh-hide-bw-icon.png": 572949,
	"./art/frosthaven/icons/loot/fh-lumber-bw-icon.png": 569417,
	"./art/frosthaven/icons/loot/fh-metal-bw-icon.png": 871387,
	"./art/frosthaven/icons/loot/fh-rockroot-bw-icon.png": 479176,
	"./art/frosthaven/icons/loot/fh-snowthistle-bw-icon.png": 886258,
	"./art/frosthaven/icons/outpost/fh-boat-bw-icon.png": 26050,
	"./art/frosthaven/icons/outpost/fh-climbing-gear-bw-icon.png": 346146,
	"./art/frosthaven/icons/outpost/fh-sled-bw-icon.png": 340446,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-corridor-color-icon.png": 982791,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-difficult-terrain-color-icon.png": 337638,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-door-color-icon.png": 913252,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-hazardous-terrain-color-icon.png": 813772,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-icy-terrain-color-icon.png": 403627,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-objective-color-icon.png": 842854,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-obstacle-color-icon.png": 472974,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-pressure-plate-color-icon.png": 435355,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-trap-color-icon.png": 612354,
	"./art/frosthaven/icons/overlay-tiles/fh-overlay-tile-wall-color-icon.png": 29836,
	"./art/frosthaven/icons/scenario-flowchart/fh-calendar-bw-icon.png": 228579,
	"./art/frosthaven/icons/scenario-flowchart/fh-event-bw-icon.png": 574316,
	"./art/frosthaven/icons/scenario-flowchart/fh-personal-quest-bw-icon.png": 856181,
	"./art/frosthaven/icons/scenario-flowchart/fh-puzzle-bw-icon.png": 508373,
	"./art/frosthaven/icons/scenario-flowchart/fh-random-scenario-bw-icon.png": 455423,
	"./art/frosthaven/icons/scenario-flowchart/fh-town-hall-bw-icon.png": 736296,
	"./art/frosthaven/logos/fh-frosthaven-logo.png": 7659,
	"./art/frosthaven/monsters/images/fh-abael-herder.png": 735496,
	"./art/frosthaven/monsters/images/fh-abael-scout.png": 155925,
	"./art/frosthaven/monsters/images/fh-algox-archer.png": 894656,
	"./art/frosthaven/monsters/images/fh-algox-guard.png": 490547,
	"./art/frosthaven/monsters/images/fh-algox-icespeaker.png": 877487,
	"./art/frosthaven/monsters/images/fh-algox-priest.png": 860418,
	"./art/frosthaven/monsters/images/fh-algox-scout.png": 351332,
	"./art/frosthaven/monsters/images/fh-algox-snowspeaker.png": 745073,
	"./art/frosthaven/monsters/images/fh-algox-stormcaller.png": 165675,
	"./art/frosthaven/monsters/images/fh-ancient-artillery.png": 125671,
	"./art/frosthaven/monsters/images/fh-black-imp.png": 503973,
	"./art/frosthaven/monsters/images/fh-burrowing-blade.png": 477569,
	"./art/frosthaven/monsters/images/fh-chaos-demon.png": 610743,
	"./art/frosthaven/monsters/images/fh-city-guard.png": 356319,
	"./art/frosthaven/monsters/images/fh-deep-terror.png": 206589,
	"./art/frosthaven/monsters/images/fh-earth-demon.png": 804618,
	"./art/frosthaven/monsters/images/fh-elder-ooze.png": 996319,
	"./art/frosthaven/monsters/images/fh-fish-king.png": 973721,
	"./art/frosthaven/monsters/images/fh-flame-demon.png": 737726,
	"./art/frosthaven/monsters/images/fh-flaming-bladespinner.png": 851613,
	"./art/frosthaven/monsters/images/fh-forest-imp.png": 560238,
	"./art/frosthaven/monsters/images/fh-fracture-of-the-deep.png": 491380,
	"./art/frosthaven/monsters/images/fh-frost-demon.png": 385255,
	"./art/frosthaven/monsters/images/fh-frozen-corpse.png": 77488,
	"./art/frosthaven/monsters/images/fh-frozen-fist.png": 550352,
	"./art/frosthaven/monsters/images/fh-harbinger-of-shadow.png": 919873,
	"./art/frosthaven/monsters/images/fh-harrower-infester.png": 90818,
	"./art/frosthaven/monsters/images/fh-hound.png": 178968,
	"./art/frosthaven/monsters/images/fh-ice-wraith.png": 363503,
	"./art/frosthaven/monsters/images/fh-lightning-eel.png": 118133,
	"./art/frosthaven/monsters/images/fh-living-bones.png": 878339,
	"./art/frosthaven/monsters/images/fh-living-doom.png": 330079,
	"./art/frosthaven/monsters/images/fh-living-spirit.png": 953110,
	"./art/frosthaven/monsters/images/fh-lord-of-chaos.png": 398064,
	"./art/frosthaven/monsters/images/fh-lurker-clawcrusher.png": 295394,
	"./art/frosthaven/monsters/images/fh-lurker-mindsnipper.png": 412981,
	"./art/frosthaven/monsters/images/fh-lurker-soldier.png": 965196,
	"./art/frosthaven/monsters/images/fh-lurker-wavethrower.png": 914821,
	"./art/frosthaven/monsters/images/fh-night-demon.png": 954890,
	"./art/frosthaven/monsters/images/fh-ooze.png": 875376,
	"./art/frosthaven/monsters/images/fh-piranha-pig.png": 158417,
	"./art/frosthaven/monsters/images/fh-polar-bear.png": 190344,
	"./art/frosthaven/monsters/images/fh-prince-of-frost.png": 203761,
	"./art/frosthaven/monsters/images/fh-program-director.png": 100896,
	"./art/frosthaven/monsters/images/fh-rending-drake.png": 172869,
	"./art/frosthaven/monsters/images/fh-robotic-boltshooter.png": 840831,
	"./art/frosthaven/monsters/images/fh-ruined-machine.png": 732532,
	"./art/frosthaven/monsters/images/fh-savvas-icestorm.png": 264332,
	"./art/frosthaven/monsters/images/fh-savvas-lavaflow.png": 504885,
	"./art/frosthaven/monsters/images/fh-seeker-of-the-abyss.png": 633638,
	"./art/frosthaven/monsters/images/fh-shrike-fiend.png": 795723,
	"./art/frosthaven/monsters/images/fh-snow-imp.png": 98326,
	"./art/frosthaven/monsters/images/fh-snowdancer.png": 57255,
	"./art/frosthaven/monsters/images/fh-spitting-drake.png": 746471,
	"./art/frosthaven/monsters/images/fh-steel-automaton.png": 254310,
	"./art/frosthaven/monsters/images/fh-sun-demon.png": 583450,
	"./art/frosthaven/monsters/images/fh-the-collector.png": 459763,
	"./art/frosthaven/monsters/images/fh-the-orphan.png": 196670,
	"./art/frosthaven/monsters/images/fh-the-relic.png": 307249,
	"./art/frosthaven/monsters/images/fh-the-render.png": 632002,
	"./art/frosthaven/monsters/images/fh-vermling-priest.png": 174712,
	"./art/frosthaven/monsters/images/fh-vermling-scout.png": 206103,
	"./art/frosthaven/monsters/images/fh-vestige-of-the-imprisoned-god.png": 567107,
	"./art/frosthaven/monsters/images/fh-wind-demon.png": 928050,
	"./art/frosthaven/monsters/standees/fh-abael-herder-standee.png": 777125,
	"./art/frosthaven/monsters/standees/fh-abael-scout-standee.png": 424349,
	"./art/frosthaven/monsters/standees/fh-algox-archer-standee.png": 194325,
	"./art/frosthaven/monsters/standees/fh-algox-guard-standee.png": 915347,
	"./art/frosthaven/monsters/standees/fh-algox-icespeaker-standee.png": 938659,
	"./art/frosthaven/monsters/standees/fh-algox-priest-standee.png": 342812,
	"./art/frosthaven/monsters/standees/fh-algox-scout-standee.png": 202582,
	"./art/frosthaven/monsters/standees/fh-algox-snowspeaker-standee.png": 219598,
	"./art/frosthaven/monsters/standees/fh-algox-stormcaller-standee.png": 902194,
	"./art/frosthaven/monsters/standees/fh-ancient-artillery-standee.png": 403150,
	"./art/frosthaven/monsters/standees/fh-black-imp-standee.png": 27199,
	"./art/frosthaven/monsters/standees/fh-burrowing-blade-standee.png": 88551,
	"./art/frosthaven/monsters/standees/fh-chaos-demon-standee.png": 20665,
	"./art/frosthaven/monsters/standees/fh-city-guard-standee.png": 116462,
	"./art/frosthaven/monsters/standees/fh-deep-terror-standee.png": 728019,
	"./art/frosthaven/monsters/standees/fh-earth-demon-standee.png": 93064,
	"./art/frosthaven/monsters/standees/fh-elder-ooze-standee.png": 191456,
	"./art/frosthaven/monsters/standees/fh-fish-king-standee.png": 819672,
	"./art/frosthaven/monsters/standees/fh-flame-demon-standee.png": 457189,
	"./art/frosthaven/monsters/standees/fh-flaming-bladespinner-standee.png": 295515,
	"./art/frosthaven/monsters/standees/fh-forest-imp-standee.png": 13286,
	"./art/frosthaven/monsters/standees/fh-fracture-of-the-deep-standee.png": 262671,
	"./art/frosthaven/monsters/standees/fh-frost-demon-standee.png": 972557,
	"./art/frosthaven/monsters/standees/fh-frozen-corpse-standee.png": 502632,
	"./art/frosthaven/monsters/standees/fh-harbinger-of-shadow-standee.png": 245317,
	"./art/frosthaven/monsters/standees/fh-harrower-infester-standee.png": 825444,
	"./art/frosthaven/monsters/standees/fh-hound-standee.png": 665034,
	"./art/frosthaven/monsters/standees/fh-ice-wraith-standee.png": 123941,
	"./art/frosthaven/monsters/standees/fh-lightning-eel-standee.png": 232890,
	"./art/frosthaven/monsters/standees/fh-living-bones-standee.png": 278162,
	"./art/frosthaven/monsters/standees/fh-living-doom-standee.png": 497550,
	"./art/frosthaven/monsters/standees/fh-living-spirit-standee.png": 909679,
	"./art/frosthaven/monsters/standees/fh-lord-of-chaos-standee.png": 457302,
	"./art/frosthaven/monsters/standees/fh-lurker-clawcrusher-standee.png": 730693,
	"./art/frosthaven/monsters/standees/fh-lurker-mindsnipper-standee.png": 746026,
	"./art/frosthaven/monsters/standees/fh-lurker-soldier-standee.png": 21654,
	"./art/frosthaven/monsters/standees/fh-lurker-wavethrower-standee.png": 999766,
	"./art/frosthaven/monsters/standees/fh-night-demon-standee.png": 967079,
	"./art/frosthaven/monsters/standees/fh-ooze-standee.png": 21481,
	"./art/frosthaven/monsters/standees/fh-piranha-pig-standee.png": 717015,
	"./art/frosthaven/monsters/standees/fh-polar-bear-standee.png": 98982,
	"./art/frosthaven/monsters/standees/fh-prince-of-frost-standee.png": 454639,
	"./art/frosthaven/monsters/standees/fh-program-director-standee.png": 60024,
	"./art/frosthaven/monsters/standees/fh-rending-drake-standee.png": 912798,
	"./art/frosthaven/monsters/standees/fh-robotic-boltshooter-standee.png": 307444,
	"./art/frosthaven/monsters/standees/fh-ruined-machine-standee.png": 520691,
	"./art/frosthaven/monsters/standees/fh-savvas-icestorm-standee.png": 438174,
	"./art/frosthaven/monsters/standees/fh-savvas-lavaflow-standee.png": 854580,
	"./art/frosthaven/monsters/standees/fh-seeker-of-the-abyss-standee.png": 253452,
	"./art/frosthaven/monsters/standees/fh-shrike-fiend-standee.png": 821869,
	"./art/frosthaven/monsters/standees/fh-snow-imp-standee.png": 952187,
	"./art/frosthaven/monsters/standees/fh-spitting-drake-standee.png": 316916,
	"./art/frosthaven/monsters/standees/fh-steel-automaton-standee.png": 392521,
	"./art/frosthaven/monsters/standees/fh-sun-demon-standee.png": 604987,
	"./art/frosthaven/monsters/standees/fh-the-collector-standee.png": 186007,
	"./art/frosthaven/monsters/standees/fh-the-orphan-standee.png": 66167,
	"./art/frosthaven/monsters/standees/fh-the-relic-standee.png": 515475,
	"./art/frosthaven/monsters/standees/fh-the-render-standee.png": 391391,
	"./art/frosthaven/monsters/standees/fh-vermling-priest-standee.png": 366082,
	"./art/frosthaven/monsters/standees/fh-vermling-scout-standee.png": 655572,
	"./art/frosthaven/monsters/standees/fh-vestige-of-the-imprisoned-god-standee.png": 95124,
	"./art/frosthaven/monsters/standees/fh-wind-demon-standee.png": 333184,
	"./art/frosthaven/punchboards/characters/fh-banner-spear-punchboard-back.png": 966056,
	"./art/frosthaven/punchboards/characters/fh-banner-spear-punchboard-front.png": 160981,
	"./art/frosthaven/punchboards/characters/fh-blinkblade-punchboard-back.png": 388666,
	"./art/frosthaven/punchboards/characters/fh-blinkblade-punchboard-front.png": 204001,
	"./art/frosthaven/punchboards/characters/fh-boneshaper-punchboard-01-back.png": 608376,
	"./art/frosthaven/punchboards/characters/fh-boneshaper-punchboard-01-front.png": 501391,
	"./art/frosthaven/punchboards/characters/fh-boneshaper-punchboard-02-back.png": 542626,
	"./art/frosthaven/punchboards/characters/fh-boneshaper-punchboard-02-front.png": 800297,
	"./art/frosthaven/punchboards/characters/fh-crashing-tide-punchboard-back.png": 902436,
	"./art/frosthaven/punchboards/characters/fh-crashing-tide-punchboard-front.png": 73700,
	"./art/frosthaven/punchboards/characters/fh-deathwalker-punchboard-back.png": 320703,
	"./art/frosthaven/punchboards/characters/fh-deathwalker-punchboard-front.png": 161567,
	"./art/frosthaven/punchboards/characters/fh-deepwraith-punchboard-back.png": 163471,
	"./art/frosthaven/punchboards/characters/fh-deepwraith-punchboard-front.png": 478622,
	"./art/frosthaven/punchboards/characters/fh-drifter-punchboard-back.png": 99883,
	"./art/frosthaven/punchboards/characters/fh-drifter-punchboard-front.png": 326629,
	"./art/frosthaven/punchboards/characters/fh-frozen-fist-punchboard-back.png": 577991,
	"./art/frosthaven/punchboards/characters/fh-frozen-fist-punchboard-front.png": 747462,
	"./art/frosthaven/punchboards/characters/fh-geminate-punchboard-back.png": 406758,
	"./art/frosthaven/punchboards/characters/fh-geminate-punchboard-front.png": 931260,
	"./art/frosthaven/punchboards/characters/fh-hive-punchboard-01-back.png": 434,
	"./art/frosthaven/punchboards/characters/fh-hive-punchboard-01-front.png": 203641,
	"./art/frosthaven/punchboards/characters/fh-hive-punchboard-02-back.png": 947394,
	"./art/frosthaven/punchboards/characters/fh-hive-punchboard-02-front.png": 259940,
	"./art/frosthaven/punchboards/characters/fh-infuser-punchboard-back.png": 846061,
	"./art/frosthaven/punchboards/characters/fh-infuser-punchboard-front.png": 222574,
	"./art/frosthaven/punchboards/characters/fh-metal-mosaic-punchboard-back.png": 51897,
	"./art/frosthaven/punchboards/characters/fh-metal-mosaic-punchboard-front.png": 869173,
	"./art/frosthaven/punchboards/characters/fh-pain-conduit-punchboard-back.png": 99148,
	"./art/frosthaven/punchboards/characters/fh-pain-conduit-punchboard-front.png": 728056,
	"./art/frosthaven/punchboards/characters/fh-pyroclast-punchboard-back.png": 146936,
	"./art/frosthaven/punchboards/characters/fh-pyroclast-punchboard-front.png": 759148,
	"./art/frosthaven/punchboards/characters/fh-shattersong-punchboard-back.png": 910182,
	"./art/frosthaven/punchboards/characters/fh-shattersong-punchboard-front.png": 858639,
	"./art/frosthaven/punchboards/characters/fh-snowdancer-punchboard-back.png": 140501,
	"./art/frosthaven/punchboards/characters/fh-snowdancer-punchboard-front.png": 277601,
	"./art/frosthaven/punchboards/characters/fh-trapper-punchboard-01-back.png": 459651,
	"./art/frosthaven/punchboards/characters/fh-trapper-punchboard-01-front.png": 944046,
	"./art/frosthaven/punchboards/characters/fh-trapper-punchboard-02-back.png": 780514,
	"./art/frosthaven/punchboards/characters/fh-trapper-punchboard-02-front.png": 591754,
	"./art/frosthaven/punchboards/general/fh-punchboard-01-back.png": 556266,
	"./art/frosthaven/punchboards/general/fh-punchboard-01-front.png": 731507,
	"./art/frosthaven/punchboards/general/fh-punchboard-02-back.png": 135570,
	"./art/frosthaven/punchboards/general/fh-punchboard-02-front.png": 393962,
	"./art/frosthaven/punchboards/general/fh-punchboard-03-back.png": 548992,
	"./art/frosthaven/punchboards/general/fh-punchboard-03-front.png": 71187,
	"./art/frosthaven/punchboards/general/fh-punchboard-04-back.png": 879763,
	"./art/frosthaven/punchboards/general/fh-punchboard-04-front.png": 211471,
	"./art/frosthaven/punchboards/general/fh-punchboard-05-back.png": 951402,
	"./art/frosthaven/punchboards/general/fh-punchboard-05-front.png": 886521,
	"./art/frosthaven/punchboards/general/fh-punchboard-06-back.png": 954116,
	"./art/frosthaven/punchboards/general/fh-punchboard-06-front.png": 909488,
	"./art/frosthaven/punchboards/general/fh-punchboard-07-back.png": 340420,
	"./art/frosthaven/punchboards/general/fh-punchboard-07-front.png": 145288,
	"./art/frosthaven/punchboards/general/fh-punchboard-08-back.png": 518968,
	"./art/frosthaven/punchboards/general/fh-punchboard-08-front.png": 758423,
	"./art/frosthaven/punchboards/general/fh-punchboard-09-back.png": 150702,
	"./art/frosthaven/punchboards/general/fh-punchboard-09-front.png": 602102,
	"./art/frosthaven/punchboards/general/fh-punchboard-10-back.png": 898576,
	"./art/frosthaven/punchboards/general/fh-punchboard-10-front.png": 155431,
	"./art/frosthaven/punchboards/general/fh-punchboard-11-back.png": 413783,
	"./art/frosthaven/punchboards/general/fh-punchboard-11-front.png": 438635,
	"./art/frosthaven/punchboards/general/fh-punchboard-12-back.png": 112889,
	"./art/frosthaven/punchboards/general/fh-punchboard-12-front.png": 500866,
	"./art/frosthaven/punchboards/general/fh-punchboard-13-back.png": 768939,
	"./art/frosthaven/punchboards/general/fh-punchboard-13-front.png": 802696,
	"./art/frosthaven/punchboards/general/fh-punchboard-14-back.png": 110571,
	"./art/frosthaven/punchboards/general/fh-punchboard-14-front.png": 402960,
	"./art/frosthaven/punchboards/general/fh-punchboard-15-back.png": 739445,
	"./art/frosthaven/punchboards/general/fh-punchboard-15-front.png": 812289,
	"./art/frosthaven/punchboards/general/fh-punchboard-16-back.png": 5147,
	"./art/frosthaven/punchboards/general/fh-punchboard-16-front.png": 206641,
	"./art/frosthaven/punchboards/general/fh-punchboard-17-back.png": 563268,
	"./art/frosthaven/punchboards/general/fh-punchboard-17-front.png": 300179,
	"./art/frosthaven/punchboards/general/fh-punchboard-18-back.png": 275571,
	"./art/frosthaven/punchboards/general/fh-punchboard-18-front.png": 928274,
	"./art/frosthaven/punchboards/general/fh-punchboard-19-back.png": 372550,
	"./art/frosthaven/punchboards/general/fh-punchboard-19-front.png": 732783,
	"./art/frosthaven/punchboards/general/fh-punchboard-20-back.png": 442021,
	"./art/frosthaven/punchboards/general/fh-punchboard-20-front.png": 437589,
	"./art/frosthaven/punchboards/general/fh-punchboard-21-back.png": 361994,
	"./art/frosthaven/punchboards/general/fh-punchboard-21-front.png": 10733,
	"./art/frosthaven/punchboards/general/fh-punchboard-22-back.png": 843671,
	"./art/frosthaven/punchboards/general/fh-punchboard-22-front.png": 629653,
	"./art/frosthaven/punchboards/general/fh-punchboard-23-back.png": 669274,
	"./art/frosthaven/punchboards/general/fh-punchboard-23-front.png": 573713,
	"./art/frosthaven/punchboards/general/fh-punchboard-24-back.png": 820426,
	"./art/frosthaven/punchboards/general/fh-punchboard-24-front.png": 625950,
	"./art/frosthaven/punchboards/general/fh-punchboard-25-back.png": 156944,
	"./art/frosthaven/punchboards/general/fh-punchboard-25-front.png": 533763,
	"./art/frosthaven/punchboards/general/fh-punchboard-26-back.png": 390777,
	"./art/frosthaven/punchboards/general/fh-punchboard-26-front.png": 611299,
	"./art/frosthaven/punchboards/general/fh-punchboard-27-back.png": 805060,
	"./art/frosthaven/punchboards/general/fh-punchboard-27-front.png": 469946,
	"./art/frosthaven/punchboards/general/fh-punchboard-28-back.png": 669045,
	"./art/frosthaven/punchboards/general/fh-punchboard-28-front.png": 8114,
	"./art/frosthaven/scenario-layout/fh-000-howling-in-the-snow-loot.png": 59954,
	"./art/frosthaven/scenario-layout/fh-000-howling-in-the-snow-map-layout.png": 378763,
	"./art/frosthaven/scenario-layout/fh-000-howling-in-the-snow-scenario-key.png": 564393,
	"./art/frosthaven/scenario-layout/fh-001-a-town-in-flames-loot.png": 207988,
	"./art/frosthaven/scenario-layout/fh-001-a-town-in-flames-map-layout.png": 443855,
	"./art/frosthaven/scenario-layout/fh-001-a-town-in-flames-scenario-key.png": 479896,
	"./art/frosthaven/scenario-layout/fh-002-algox-scouting-loot.png": 313823,
	"./art/frosthaven/scenario-layout/fh-002-algox-scouting-map-layout.png": 814253,
	"./art/frosthaven/scenario-layout/fh-002-algox-scouting-scenario-key.png": 124762,
	"./art/frosthaven/scenario-layout/fh-003-algox-offensive-loot.png": 912654,
	"./art/frosthaven/scenario-layout/fh-003-algox-offensive-map-layout.png": 779253,
	"./art/frosthaven/scenario-layout/fh-003-algox-offensive-scenario-key.png": 159033,
	"./art/frosthaven/scenario-layout/fh-004-heart-of-ice-loot.png": 989740,
	"./art/frosthaven/scenario-layout/fh-004-heart-of-ice-map-layout.png": 149176,
	"./art/frosthaven/scenario-layout/fh-004-heart-of-ice-scenario-key.png": 580882,
	"./art/frosthaven/scenario-layout/fh-005-frozen-crypt-loot.png": 940737,
	"./art/frosthaven/scenario-layout/fh-005-frozen-crypt-map-layout.png": 458916,
	"./art/frosthaven/scenario-layout/fh-005-frozen-crypt-scenario-key.png": 911117,
	"./art/frosthaven/scenario-layout/fh-006-avalanche-loot.png": 236097,
	"./art/frosthaven/scenario-layout/fh-006-avalanche-map-layout.png": 451025,
	"./art/frosthaven/scenario-layout/fh-006-avalanche-scenario-key.png": 163754,
	"./art/frosthaven/scenario-layout/fh-007-edge-of-the-world-loot.png": 993072,
	"./art/frosthaven/scenario-layout/fh-007-edge-of-the-world-map-layout.png": 405979,
	"./art/frosthaven/scenario-layout/fh-007-edge-of-the-world-scenario-key.png": 958397,
	"./art/frosthaven/scenario-layout/fh-008-crystal-trench-loot.png": 82982,
	"./art/frosthaven/scenario-layout/fh-008-crystal-trench-map-layout.png": 382707,
	"./art/frosthaven/scenario-layout/fh-008-crystal-trench-scenario-key.png": 744632,
	"./art/frosthaven/scenario-layout/fh-009-glowing-catacombs-loot.png": 573762,
	"./art/frosthaven/scenario-layout/fh-009-glowing-catacombs-map-layout.png": 565858,
	"./art/frosthaven/scenario-layout/fh-009-glowing-catacombs-scenario-key.png": 102160,
	"./art/frosthaven/scenario-layout/fh-010-crystal-enclosure-loot.png": 475625,
	"./art/frosthaven/scenario-layout/fh-010-crystal-enclosure-map-layout.png": 395197,
	"./art/frosthaven/scenario-layout/fh-010-crystal-enclosure-scenario-key.png": 706454,
	"./art/frosthaven/scenario-layout/fh-011-snowscorn-peak-loot.png": 17266,
	"./art/frosthaven/scenario-layout/fh-011-snowscorn-peak-map-layout.png": 601462,
	"./art/frosthaven/scenario-layout/fh-011-snowscorn-peak-scenario-key.png": 50907,
	"./art/frosthaven/scenario-layout/fh-012-temple-entrance-loot.png": 267840,
	"./art/frosthaven/scenario-layout/fh-012-temple-entrance-map-layout.png": 879103,
	"./art/frosthaven/scenario-layout/fh-012-temple-entrance-scenario-key.png": 414358,
	"./art/frosthaven/scenario-layout/fh-013-frozen-fjord-loot.png": 610854,
	"./art/frosthaven/scenario-layout/fh-013-frozen-fjord-map-layout.png": 141884,
	"./art/frosthaven/scenario-layout/fh-013-frozen-fjord-scenario-key.png": 166830,
	"./art/frosthaven/scenario-layout/fh-014-jagged-shoals-loot.png": 843909,
	"./art/frosthaven/scenario-layout/fh-014-jagged-shoals-map-layout.png": 572119,
	"./art/frosthaven/scenario-layout/fh-014-jagged-shoals-scenario-key-a.png": 872508,
	"./art/frosthaven/scenario-layout/fh-014-jagged-shoals-scenario-key-b.png": 858239,
	"./art/frosthaven/scenario-layout/fh-015-ancient-spire-loot.png": 868968,
	"./art/frosthaven/scenario-layout/fh-015-ancient-spire-map-layout.png": 629318,
	"./art/frosthaven/scenario-layout/fh-015-ancient-spire-scenario-key.png": 44686,
	"./art/frosthaven/scenario-layout/fh-016-derelict-elevator-loot.png": 864766,
	"./art/frosthaven/scenario-layout/fh-016-derelict-elevator-map-layout.png": 803861,
	"./art/frosthaven/scenario-layout/fh-016-derelict-elevator-scenario-key.png": 996143,
	"./art/frosthaven/scenario-layout/fh-017-haunted-vault-loot.png": 170101,
	"./art/frosthaven/scenario-layout/fh-017-haunted-vault-map-layout.png": 97976,
	"./art/frosthaven/scenario-layout/fh-017-haunted-vault-scenario-key.png": 475910,
	"./art/frosthaven/scenario-layout/fh-018-crystal-fields-loot.png": 29180,
	"./art/frosthaven/scenario-layout/fh-018-crystal-fields-map-layout.png": 906556,
	"./art/frosthaven/scenario-layout/fh-018-crystal-fields-scenario-key.png": 502828,
	"./art/frosthaven/scenario-layout/fh-019-skyhall-loot.png": 49898,
	"./art/frosthaven/scenario-layout/fh-019-skyhall-map-layout.png": 553602,
	"./art/frosthaven/scenario-layout/fh-019-skyhall-scenario-key.png": 706676,
	"./art/frosthaven/scenario-layout/fh-020-temple-of-liberation-loot.png": 532552,
	"./art/frosthaven/scenario-layout/fh-020-temple-of-liberation-map-layout.png": 197316,
	"./art/frosthaven/scenario-layout/fh-020-temple-of-liberation-scenario-key.png": 225951,
	"./art/frosthaven/scenario-layout/fh-021-realm-of-the-endless-frost-loot.png": 54333,
	"./art/frosthaven/scenario-layout/fh-021-realm-of-the-endless-frost-map-layout.png": 655956,
	"./art/frosthaven/scenario-layout/fh-021-realm-of-the-endless-frost-scenario-key-a.png": 669776,
	"./art/frosthaven/scenario-layout/fh-021-realm-of-the-endless-frost-scenario-key-b.png": 820485,
	"./art/frosthaven/scenario-layout/fh-022-ice-floes-loot.png": 468147,
	"./art/frosthaven/scenario-layout/fh-022-ice-floes-map-layout.png": 556759,
	"./art/frosthaven/scenario-layout/fh-022-ice-floes-scenario-key-a.png": 159753,
	"./art/frosthaven/scenario-layout/fh-022-ice-floes-scenario-key-b.png": 937467,
	"./art/frosthaven/scenario-layout/fh-023-spire-basement-loot.png": 210930,
	"./art/frosthaven/scenario-layout/fh-023-spire-basement-map-layout.png": 323858,
	"./art/frosthaven/scenario-layout/fh-023-spire-basement-scenario-key.png": 910462,
	"./art/frosthaven/scenario-layout/fh-024-upper-spire-loot.png": 360349,
	"./art/frosthaven/scenario-layout/fh-024-upper-spire-map-layout.png": 824437,
	"./art/frosthaven/scenario-layout/fh-024-upper-spire-scenario-key.png": 891586,
	"./art/frosthaven/scenario-layout/fh-025-rusted-tunnels-loot.png": 592231,
	"./art/frosthaven/scenario-layout/fh-025-rusted-tunnels-map-layout.png": 534056,
	"./art/frosthaven/scenario-layout/fh-025-rusted-tunnels-scenario-key.png": 538989,
	"./art/frosthaven/scenario-layout/fh-026-quatryl-library-loot.png": 53913,
	"./art/frosthaven/scenario-layout/fh-026-quatryl-library-map-layout.png": 90871,
	"./art/frosthaven/scenario-layout/fh-026-quatryl-library-scenario-key.png": 750540,
	"./art/frosthaven/scenario-layout/fh-027-depths-of-delirium-loot.png": 658289,
	"./art/frosthaven/scenario-layout/fh-027-depths-of-delirium-map-layout.png": 515778,
	"./art/frosthaven/scenario-layout/fh-027-depths-of-delirium-scenario-key.png": 498344,
	"./art/frosthaven/scenario-layout/fh-028-summit-meeting-loot.png": 554897,
	"./art/frosthaven/scenario-layout/fh-028-summit-meeting-map-layout.png": 215557,
	"./art/frosthaven/scenario-layout/fh-028-summit-meeting-scenario-key.png": 792237,
	"./art/frosthaven/scenario-layout/fh-029-war-of-the-spire-a-loot.png": 421921,
	"./art/frosthaven/scenario-layout/fh-029-war-of-the-spire-a-map-layout.png": 587504,
	"./art/frosthaven/scenario-layout/fh-029-war-of-the-spire-a-scenario-key.png": 947384,
	"./art/frosthaven/scenario-layout/fh-030-war-of-the-spire-b-loot.png": 953115,
	"./art/frosthaven/scenario-layout/fh-030-war-of-the-spire-b-map-layout.png": 188864,
	"./art/frosthaven/scenario-layout/fh-030-war-of-the-spire-b-scenario-key.png": 367872,
	"./art/frosthaven/scenario-layout/fh-031-crackling-tunnel-loot.png": 727270,
	"./art/frosthaven/scenario-layout/fh-031-crackling-tunnel-map-layout.png": 514323,
	"./art/frosthaven/scenario-layout/fh-031-crackling-tunnel-scenario-key.png": 948652,
	"./art/frosthaven/scenario-layout/fh-032-ravens-roost-loot.png": 909583,
	"./art/frosthaven/scenario-layout/fh-032-ravens-roost-map-layout.png": 666716,
	"./art/frosthaven/scenario-layout/fh-032-ravens-roost-scenario-key-a.png": 888938,
	"./art/frosthaven/scenario-layout/fh-032-ravens-roost-scenario-key-b.png": 768292,
	"./art/frosthaven/scenario-layout/fh-033-thawed-wood-loot.png": 89258,
	"./art/frosthaven/scenario-layout/fh-033-thawed-wood-map-layout.png": 212584,
	"./art/frosthaven/scenario-layout/fh-033-thawed-wood-scenario-key.png": 535007,
	"./art/frosthaven/scenario-layout/fh-034-top-of-the-spire-loot.png": 927598,
	"./art/frosthaven/scenario-layout/fh-034-top-of-the-spire-map-layout.png": 802155,
	"./art/frosthaven/scenario-layout/fh-034-top-of-the-spire-scenario-key.png": 163424,
	"./art/frosthaven/scenario-layout/fh-035-scrap-pit-loot.png": 898126,
	"./art/frosthaven/scenario-layout/fh-035-scrap-pit-map-layout.png": 800666,
	"./art/frosthaven/scenario-layout/fh-035-scrap-pit-scenario-key.png": 685009,
	"./art/frosthaven/scenario-layout/fh-036-buried-ducts-loot.png": 231005,
	"./art/frosthaven/scenario-layout/fh-036-buried-ducts-map-layout.png": 573226,
	"./art/frosthaven/scenario-layout/fh-036-buried-ducts-scenario-key.png": 418299,
	"./art/frosthaven/scenario-layout/fh-037-the-dead-mile-loot.png": 787178,
	"./art/frosthaven/scenario-layout/fh-037-the-dead-mile-map-layout.png": 565640,
	"./art/frosthaven/scenario-layout/fh-037-the-dead-mile-scenario-key.png": 883306,
	"./art/frosthaven/scenario-layout/fh-038-the-way-forward-loot.png": 97166,
	"./art/frosthaven/scenario-layout/fh-038-the-way-forward-map-layout.png": 569925,
	"./art/frosthaven/scenario-layout/fh-038-the-way-forward-scenario-key-a.png": 835454,
	"./art/frosthaven/scenario-layout/fh-038-the-way-forward-scenario-key-b.png": 891536,
	"./art/frosthaven/scenario-layout/fh-039-corrupted-camp-loot.png": 53985,
	"./art/frosthaven/scenario-layout/fh-039-corrupted-camp-map-layout.png": 721662,
	"./art/frosthaven/scenario-layout/fh-039-corrupted-camp-scenario-key.png": 575949,
	"./art/frosthaven/scenario-layout/fh-040-relief-effort-loot.png": 970323,
	"./art/frosthaven/scenario-layout/fh-040-relief-effort-map-layout.png": 35594,
	"./art/frosthaven/scenario-layout/fh-040-relief-effort-scenario-key.png": 231511,
	"./art/frosthaven/scenario-layout/fh-041-unfettered-shard-loot.png": 469473,
	"./art/frosthaven/scenario-layout/fh-041-unfettered-shard-map-layout.png": 665887,
	"./art/frosthaven/scenario-layout/fh-041-unfettered-shard-scenario-key.png": 456240,
	"./art/frosthaven/scenario-layout/fh-042-sunless-trench-loot.png": 749810,
	"./art/frosthaven/scenario-layout/fh-042-sunless-trench-map-layout.png": 363136,
	"./art/frosthaven/scenario-layout/fh-042-sunless-trench-scenario-key.png": 951609,
	"./art/frosthaven/scenario-layout/fh-043-overrun-barricade-loot.png": 87417,
	"./art/frosthaven/scenario-layout/fh-043-overrun-barricade-map-layout.png": 421883,
	"./art/frosthaven/scenario-layout/fh-043-overrun-barricade-scenario-key.png": 905797,
	"./art/frosthaven/scenario-layout/fh-044-nerve-center-loot.png": 793995,
	"./art/frosthaven/scenario-layout/fh-044-nerve-center-map-layout.png": 478785,
	"./art/frosthaven/scenario-layout/fh-044-nerve-center-scenario-key.png": 381920,
	"./art/frosthaven/scenario-layout/fh-045-living-glacier-loot.png": 322419,
	"./art/frosthaven/scenario-layout/fh-045-living-glacier-map-layout.png": 278711,
	"./art/frosthaven/scenario-layout/fh-045-living-glacier-scenario-key.png": 645766,
	"./art/frosthaven/scenario-layout/fh-046-dead-pass-loot.png": 419156,
	"./art/frosthaven/scenario-layout/fh-046-dead-pass-map-layout.png": 172891,
	"./art/frosthaven/scenario-layout/fh-046-dead-pass-scenario-key.png": 765835,
	"./art/frosthaven/scenario-layout/fh-047-carrion-ridge-loot.png": 489663,
	"./art/frosthaven/scenario-layout/fh-047-carrion-ridge-map-layout.png": 520202,
	"./art/frosthaven/scenario-layout/fh-047-carrion-ridge-scenario-key.png": 178286,
	"./art/frosthaven/scenario-layout/fh-048-blizzard-island-loot.png": 126810,
	"./art/frosthaven/scenario-layout/fh-048-blizzard-island-map-layout.png": 670615,
	"./art/frosthaven/scenario-layout/fh-048-blizzard-island-scenario-key.png": 570389,
	"./art/frosthaven/scenario-layout/fh-049-beneath-see-and-stone-loot.png": 853109,
	"./art/frosthaven/scenario-layout/fh-049-beneath-see-and-stone-map-layout.png": 836499,
	"./art/frosthaven/scenario-layout/fh-049-beneath-see-and-stone-scenario-key.png": 754516,
	"./art/frosthaven/scenario-layout/fh-050-explosive-descent-loot.png": 204290,
	"./art/frosthaven/scenario-layout/fh-050-explosive-descent-map-layout.png": 370741,
	"./art/frosthaven/scenario-layout/fh-050-explosive-descent-scenario-key.png": 292218,
	"./art/frosthaven/scenario-layout/fh-051-orphans-halls-loot.png": 398962,
	"./art/frosthaven/scenario-layout/fh-051-orphans-halls-map-layout.png": 841773,
	"./art/frosthaven/scenario-layout/fh-051-orphans-halls-scenario-key.png": 246179,
	"./art/frosthaven/scenario-layout/fh-052-fleeting-permanence-loot.png": 781054,
	"./art/frosthaven/scenario-layout/fh-052-fleeting-permanence-map-layout.png": 299150,
	"./art/frosthaven/scenario-layout/fh-052-fleeting-permanence-scenario-key.png": 292808,
	"./art/frosthaven/scenario-layout/fh-053-underwater-throne-loot.png": 685532,
	"./art/frosthaven/scenario-layout/fh-053-underwater-throne-map-layout.png": 552578,
	"./art/frosthaven/scenario-layout/fh-053-underwater-throne-scenario-key.png": 545180,
	"./art/frosthaven/scenario-layout/fh-054-among-the-wreckage-loot.png": 502435,
	"./art/frosthaven/scenario-layout/fh-054-among-the-wreckage-map-layout.png": 187785,
	"./art/frosthaven/scenario-layout/fh-054-among-the-wreckage-scenario-key.png": 670226,
	"./art/frosthaven/scenario-layout/fh-055-change-of-heart-loot.png": 332368,
	"./art/frosthaven/scenario-layout/fh-055-change-of-heart-map-layout.png": 121033,
	"./art/frosthaven/scenario-layout/fh-055-change-of-heart-scenario-key.png": 351380,
	"./art/frosthaven/scenario-layout/fh-056-call-of-the-harbinger-loot.png": 101056,
	"./art/frosthaven/scenario-layout/fh-056-call-of-the-harbinger-map-layout.png": 987669,
	"./art/frosthaven/scenario-layout/fh-056-call-of-the-harbinger-scenario-key.png": 965343,
	"./art/frosthaven/scenario-layout/fh-057-sanctuary-of-snow-loot.png": 619858,
	"./art/frosthaven/scenario-layout/fh-057-sanctuary-of-snow-map-layout.png": 413779,
	"./art/frosthaven/scenario-layout/fh-057-sanctuary-of-snow-scenario-key.png": 114485,
	"./art/frosthaven/scenario-layout/fh-058-orphans-core-loot.png": 618407,
	"./art/frosthaven/scenario-layout/fh-058-orphans-core-map-layout.png": 337445,
	"./art/frosthaven/scenario-layout/fh-058-orphans-core-scenario-key-a.png": 894944,
	"./art/frosthaven/scenario-layout/fh-058-orphans-core-scenario-key-b.png": 296367,
	"./art/frosthaven/scenario-layout/fh-059-automaton-uprising-loot.png": 543345,
	"./art/frosthaven/scenario-layout/fh-059-automaton-uprising-map-layout.png": 27057,
	"./art/frosthaven/scenario-layout/fh-059-automaton-uprising-scenario-key.png": 182872,
	"./art/frosthaven/scenario-layout/fh-060-uniting-the-crown-loot.png": 431728,
	"./art/frosthaven/scenario-layout/fh-060-uniting-the-crown-map-layout.png": 365192,
	"./art/frosthaven/scenario-layout/fh-060-uniting-the-crown-scenario-key.png": 546100,
	"./art/frosthaven/scenario-layout/fh-061-life-and-death-loot.png": 875118,
	"./art/frosthaven/scenario-layout/fh-061-life-and-death-map-layout.png": 631172,
	"./art/frosthaven/scenario-layout/fh-061-life-and-death-scenario-key.png": 281387,
	"./art/frosthaven/scenario-layout/fh-062-the-unfettered-seal-loot.png": 466809,
	"./art/frosthaven/scenario-layout/fh-062-the-unfettered-seal-map-layout.png": 185406,
	"./art/frosthaven/scenario-layout/fh-062-the-unfettered-seal-scenario-key.png": 521902,
	"./art/frosthaven/scenario-layout/fh-063-the-savvas-seal-loot.png": 581502,
	"./art/frosthaven/scenario-layout/fh-063-the-savvas-seal-map-layout.png": 379466,
	"./art/frosthaven/scenario-layout/fh-063-the-savvas-seal-scenario-key-a.png": 306067,
	"./art/frosthaven/scenario-layout/fh-063-the-savvas-seal-scenario-key-b.png": 809741,
	"./art/frosthaven/scenario-layout/fh-064-the-frosthaven-seal-loot.png": 250413,
	"./art/frosthaven/scenario-layout/fh-064-the-frosthaven-seal-map-layout.png": 370735,
	"./art/frosthaven/scenario-layout/fh-064-the-frosthaven-seal-scenario-key.png": 104979,
	"./art/frosthaven/scenario-layout/fh-065-a-strong-foundation-loot.png": 975865,
	"./art/frosthaven/scenario-layout/fh-065-a-strong-foundation-map-layout.png": 133374,
	"./art/frosthaven/scenario-layout/fh-065-a-strong-foundation-scenario-key.png": 754958,
	"./art/frosthaven/scenario-layout/fh-066-elemental-cores-loot.png": 347520,
	"./art/frosthaven/scenario-layout/fh-066-elemental-cores-map-layout.png": 227364,
	"./art/frosthaven/scenario-layout/fh-066-elemental-cores-scenario-key.png": 237052,
	"./art/frosthaven/scenario-layout/fh-067-core-attunement-loot.png": 246582,
	"./art/frosthaven/scenario-layout/fh-067-core-attunement-map-layout.png": 654904,
	"./art/frosthaven/scenario-layout/fh-067-core-attunement-scenario-key.png": 898895,
	"./art/frosthaven/scenario-layout/fh-068-the-face-of-torment-loot.png": 17519,
	"./art/frosthaven/scenario-layout/fh-068-the-face-of-torment-map-layout.png": 480301,
	"./art/frosthaven/scenario-layout/fh-068-the-face-of-torment-scenario-key.png": 686338,
	"./art/frosthaven/scenario-layout/fh-069-sacred-soil-loot.png": 552882,
	"./art/frosthaven/scenario-layout/fh-069-sacred-soil-map-layout.png": 250737,
	"./art/frosthaven/scenario-layout/fh-069-sacred-soil-scenario-key.png": 157339,
	"./art/frosthaven/scenario-layout/fh-070-the-true-oak-loot.png": 262628,
	"./art/frosthaven/scenario-layout/fh-070-the-true-oak-map-layout.png": 267389,
	"./art/frosthaven/scenario-layout/fh-070-the-true-oak-scenario-key.png": 531157,
	"./art/frosthaven/scenario-layout/fh-071-invasion-of-the-dock-loot.png": 227106,
	"./art/frosthaven/scenario-layout/fh-071-invasion-of-the-dock-map-layout.png": 699027,
	"./art/frosthaven/scenario-layout/fh-071-invasion-of-the-dock-scenario-key.png": 818729,
	"./art/frosthaven/scenario-layout/fh-072-a-giant-block-of-ice-loot.png": 355170,
	"./art/frosthaven/scenario-layout/fh-072-a-giant-block-of-ice-map-layout.png": 727993,
	"./art/frosthaven/scenario-layout/fh-072-a-giant-block-of-ice-scenario-key.png": 650609,
	"./art/frosthaven/scenario-layout/fh-073-flotsam-loot.png": 972520,
	"./art/frosthaven/scenario-layout/fh-073-flotsam-map-layout.png": 556731,
	"./art/frosthaven/scenario-layout/fh-073-flotsam-scenario-key.png": 942520,
	"./art/frosthaven/scenario-layout/fh-074-gaps-in-the-road-loot.png": 573339,
	"./art/frosthaven/scenario-layout/fh-074-gaps-in-the-road-map-layout.png": 31595,
	"./art/frosthaven/scenario-layout/fh-074-gaps-in-the-road-scenario-key.png": 775283,
	"./art/frosthaven/scenario-layout/fh-075-infiltrating-the-lair-loot.png": 502605,
	"./art/frosthaven/scenario-layout/fh-075-infiltrating-the-lair-map-layout.png": 210728,
	"./art/frosthaven/scenario-layout/fh-075-infiltrating-the-lair-scenario-key-a.png": 845554,
	"./art/frosthaven/scenario-layout/fh-075-infiltrating-the-lair-scenario-key-b.png": 195699,
	"./art/frosthaven/scenario-layout/fh-076-apotheosis-loot.png": 769654,
	"./art/frosthaven/scenario-layout/fh-076-apotheosis-map-layout.png": 476386,
	"./art/frosthaven/scenario-layout/fh-076-apotheosis-scenario-key-a.png": 662609,
	"./art/frosthaven/scenario-layout/fh-076-apotheosis-scenario-key-b.png": 511973,
	"./art/frosthaven/scenario-layout/fh-077-fish-kings-ascension-loot.png": 47423,
	"./art/frosthaven/scenario-layout/fh-077-fish-kings-ascension-map-layout.png": 691997,
	"./art/frosthaven/scenario-layout/fh-077-fish-kings-ascension-scenario-key.png": 725694,
	"./art/frosthaven/scenario-layout/fh-078-the-lurker-problem-loot.png": 697496,
	"./art/frosthaven/scenario-layout/fh-078-the-lurker-problem-map-layout.png": 640420,
	"./art/frosthaven/scenario-layout/fh-078-the-lurker-problem-scenario-key-a.png": 591098,
	"./art/frosthaven/scenario-layout/fh-078-the-lurker-problem-scenario-key-b.png": 125305,
	"./art/frosthaven/scenario-layout/fh-079-relic-loot.png": 381957,
	"./art/frosthaven/scenario-layout/fh-079-relic-map-layout.png": 667076,
	"./art/frosthaven/scenario-layout/fh-079-relic-scenario-key-a.png": 792442,
	"./art/frosthaven/scenario-layout/fh-079-relic-scenario-key-b.png": 987496,
	"./art/frosthaven/scenario-layout/fh-080-relic-renewed-loot.png": 13761,
	"./art/frosthaven/scenario-layout/fh-080-relic-renewed-map-layout.png": 65753,
	"./art/frosthaven/scenario-layout/fh-080-relic-renewed-scenario-key.png": 606103,
	"./art/frosthaven/scenario-layout/fh-081-ruinous-research-lab-loot.png": 986978,
	"./art/frosthaven/scenario-layout/fh-081-ruinous-research-lab-map-layout.png": 468371,
	"./art/frosthaven/scenario-layout/fh-081-ruinous-research-lab-scenario-key-a.png": 855131,
	"./art/frosthaven/scenario-layout/fh-081-ruinous-research-lab-scenario-key-b.png": 37158,
	"./art/frosthaven/scenario-layout/fh-082-expedition-north-loot.png": 851436,
	"./art/frosthaven/scenario-layout/fh-082-expedition-north-map-layout.png": 415791,
	"./art/frosthaven/scenario-layout/fh-082-expedition-north-scenario-key.png": 367330,
	"./art/frosthaven/scenario-layout/fh-083-rising-brine-loot.png": 776565,
	"./art/frosthaven/scenario-layout/fh-083-rising-brine-map-layout.png": 130908,
	"./art/frosthaven/scenario-layout/fh-083-rising-brine-scenario-key-a.png": 632472,
	"./art/frosthaven/scenario-layout/fh-083-rising-brine-scenario-key-b.png": 641152,
	"./art/frosthaven/scenario-layout/fh-084-here-there-be-oozes-loot.png": 251007,
	"./art/frosthaven/scenario-layout/fh-084-here-there-be-oozes-map-layout.png": 478271,
	"./art/frosthaven/scenario-layout/fh-084-here-there-be-oozes-scenario-key.png": 599959,
	"./art/frosthaven/scenario-layout/fh-085-deadly-pasttimes-loot.png": 640524,
	"./art/frosthaven/scenario-layout/fh-085-deadly-pasttimes-map-layout.png": 5405,
	"./art/frosthaven/scenario-layout/fh-085-deadly-pasttimes-scenario-key.png": 848931,
	"./art/frosthaven/scenario-layout/fh-086-the-lady-in-white-loot.png": 165335,
	"./art/frosthaven/scenario-layout/fh-086-the-lady-in-white-map-layout.png": 668159,
	"./art/frosthaven/scenario-layout/fh-086-the-lady-in-white-scenario-key.png": 772613,
	"./art/frosthaven/scenario-layout/fh-087-the-collection-loot.png": 200131,
	"./art/frosthaven/scenario-layout/fh-087-the-collection-map-layout.png": 892443,
	"./art/frosthaven/scenario-layout/fh-087-the-collection-scenario-key.png": 864819,
	"./art/frosthaven/scenario-layout/fh-088-collections-capstone-loot.png": 616317,
	"./art/frosthaven/scenario-layout/fh-088-collections-capstone-map-layout.png": 997118,
	"./art/frosthaven/scenario-layout/fh-088-collections-capstone-scenario-key.png": 852575,
	"./art/frosthaven/scenario-layout/fh-089-a-contained-fire-loot.png": 666118,
	"./art/frosthaven/scenario-layout/fh-089-a-contained-fire-map-layout.png": 396070,
	"./art/frosthaven/scenario-layout/fh-089-a-contained-fire-scenario-key.png": 923634,
	"./art/frosthaven/scenario-layout/fh-090-frozen-treasure-loot.png": 83062,
	"./art/frosthaven/scenario-layout/fh-090-frozen-treasure-map-layout.png": 338250,
	"./art/frosthaven/scenario-layout/fh-090-frozen-treasure-scenario-key.png": 594625,
	"./art/frosthaven/scenario-layout/fh-091-shoreline-scramble-loot.png": 655041,
	"./art/frosthaven/scenario-layout/fh-091-shoreline-scramble-map-layout.png": 728547,
	"./art/frosthaven/scenario-layout/fh-091-shoreline-scramble-scenario-key.png": 150441,
	"./art/frosthaven/scenario-layout/fh-092-sinking-ship-loot.png": 894785,
	"./art/frosthaven/scenario-layout/fh-092-sinking-ship-map-layout.png": 853008,
	"./art/frosthaven/scenario-layout/fh-092-sinking-ship-scenario-key.png": 359590,
	"./art/frosthaven/scenario-layout/fh-093-midwinter-brawl-loot.png": 809620,
	"./art/frosthaven/scenario-layout/fh-093-midwinter-brawl-map-layout.png": 743477,
	"./art/frosthaven/scenario-layout/fh-093-midwinter-brawl-scenario-key.png": 513026,
	"./art/frosthaven/scenario-layout/fh-094-a-grand-view-loot.png": 85894,
	"./art/frosthaven/scenario-layout/fh-094-a-grand-view-map-layout.png": 73833,
	"./art/frosthaven/scenario-layout/fh-094-a-grand-view-scenario-key.png": 609325,
	"./art/frosthaven/scenario-layout/fh-095-to-bury-the-dead-loot.png": 361051,
	"./art/frosthaven/scenario-layout/fh-095-to-bury-the-dead-map-layout.png": 161774,
	"./art/frosthaven/scenario-layout/fh-095-to-bury-the-dead-scenario-key.png": 412807,
	"./art/frosthaven/scenario-layout/fh-096-underground-station-loot.png": 417785,
	"./art/frosthaven/scenario-layout/fh-096-underground-station-map-layout.png": 175423,
	"./art/frosthaven/scenario-layout/fh-096-underground-station-scenario-key.png": 150466,
	"./art/frosthaven/scenario-layout/fh-097-program-control-nexus-loot.png": 109056,
	"./art/frosthaven/scenario-layout/fh-097-program-control-nexus-map-layout.png": 485536,
	"./art/frosthaven/scenario-layout/fh-097-program-control-nexus-scenario-key-a.png": 471566,
	"./art/frosthaven/scenario-layout/fh-097-program-control-nexus-scenario-key-b.png": 498008,
	"./art/frosthaven/scenario-layout/fh-098-collapsing-vent-loot.png": 318045,
	"./art/frosthaven/scenario-layout/fh-098-collapsing-vent-map-layout.png": 211376,
	"./art/frosthaven/scenario-layout/fh-098-collapsing-vent-scenario-key.png": 478748,
	"./art/frosthaven/scenario-layout/fh-099-prison-break-loot.png": 268847,
	"./art/frosthaven/scenario-layout/fh-099-prison-break-map-layout.png": 857834,
	"./art/frosthaven/scenario-layout/fh-099-prison-break-scenario-key-a.png": 29206,
	"./art/frosthaven/scenario-layout/fh-099-prison-break-scenario-key-b.png": 904986,
	"./art/frosthaven/scenario-layout/fh-100-inside-the-swarm-loot.png": 724951,
	"./art/frosthaven/scenario-layout/fh-100-inside-the-swarm-map-layout.png": 944480,
	"./art/frosthaven/scenario-layout/fh-100-inside-the-swarm-scenario-key-a.png": 754086,
	"./art/frosthaven/scenario-layout/fh-100-inside-the-swarm-scenario-key-b.png": 740353,
	"./art/frosthaven/scenario-layout/fh-101-harrower-library-loot.png": 810478,
	"./art/frosthaven/scenario-layout/fh-101-harrower-library-map-layout.png": 382955,
	"./art/frosthaven/scenario-layout/fh-101-harrower-library-scenario-key-a.png": 778032,
	"./art/frosthaven/scenario-layout/fh-101-harrower-library-scenario-key-b.png": 8735,
	"./art/frosthaven/scenario-layout/fh-102-into-the-black-loot.png": 288895,
	"./art/frosthaven/scenario-layout/fh-102-into-the-black-map-layout.png": 94396,
	"./art/frosthaven/scenario-layout/fh-102-into-the-black-scenario-key.png": 163353,
	"./art/frosthaven/scenario-layout/fh-103-the-lead-door-loot.png": 183166,
	"./art/frosthaven/scenario-layout/fh-103-the-lead-door-map-layout.png": 286616,
	"./art/frosthaven/scenario-layout/fh-103-the-lead-door-scenario-key.png": 282633,
	"./art/frosthaven/scenario-layout/fh-104-ruins-of-the-solstice-loot.png": 362405,
	"./art/frosthaven/scenario-layout/fh-104-ruins-of-the-solstice-map-layout.png": 435028,
	"./art/frosthaven/scenario-layout/fh-104-ruins-of-the-solstice-scenario-key.png": 636861,
	"./art/frosthaven/scenario-layout/fh-105-ruins-of-the-equinox-loot.png": 601393,
	"./art/frosthaven/scenario-layout/fh-105-ruins-of-the-equinox-map-layout.png": 312812,
	"./art/frosthaven/scenario-layout/fh-105-ruins-of-the-equinox-scenario-key.png": 897738,
	"./art/frosthaven/scenario-layout/fh-106-the-tempus-forge-loot.png": 532734,
	"./art/frosthaven/scenario-layout/fh-106-the-tempus-forge-map-layout.png": 39513,
	"./art/frosthaven/scenario-layout/fh-106-the-tempus-forge-scenario-key-a.png": 994303,
	"./art/frosthaven/scenario-layout/fh-106-the-tempus-forge-scenario-key-b.png": 889767,
	"./art/frosthaven/scenario-layout/fh-107-my-private-empire-loot.png": 184289,
	"./art/frosthaven/scenario-layout/fh-107-my-private-empire-map-layout.png": 105803,
	"./art/frosthaven/scenario-layout/fh-107-my-private-empire-scenario-key-a.png": 907128,
	"./art/frosthaven/scenario-layout/fh-107-my-private-empire-scenario-key-b.png": 146614,
	"./art/frosthaven/scenario-layout/fh-108-lustrous-pit-loot.png": 266436,
	"./art/frosthaven/scenario-layout/fh-108-lustrous-pit-map-layout.png": 83555,
	"./art/frosthaven/scenario-layout/fh-108-lustrous-pit-scenario-key.png": 212877,
	"./art/frosthaven/scenario-layout/fh-109-furious-factory-loot.png": 475182,
	"./art/frosthaven/scenario-layout/fh-109-furious-factory-map-layout.png": 313759,
	"./art/frosthaven/scenario-layout/fh-109-furious-factory-scenario-key-a.png": 124677,
	"./art/frosthaven/scenario-layout/fh-109-furious-factory-scenario-key-b.png": 594527,
	"./art/frosthaven/scenario-layout/fh-110-guardians-temple-loot.png": 910320,
	"./art/frosthaven/scenario-layout/fh-110-guardians-temple-map-layout.png": 417627,
	"./art/frosthaven/scenario-layout/fh-110-guardians-temple-scenario-key.png": 740402,
	"./art/frosthaven/scenario-layout/fh-111-ice-cave-loot.png": 235171,
	"./art/frosthaven/scenario-layout/fh-111-ice-cave-map-layout.png": 360185,
	"./art/frosthaven/scenario-layout/fh-111-ice-cave-scenario-key-a.png": 481409,
	"./art/frosthaven/scenario-layout/fh-111-ice-cave-scenario-key-b.png": 841992,
	"./art/frosthaven/scenario-layout/fh-112-raised-by-wolves-loot.png": 856321,
	"./art/frosthaven/scenario-layout/fh-112-raised-by-wolves-map-layout.png": 926198,
	"./art/frosthaven/scenario-layout/fh-112-raised-by-wolves-scenario-key.png": 742675,
	"./art/frosthaven/scenario-layout/fh-113-lush-grotto-loot.png": 567160,
	"./art/frosthaven/scenario-layout/fh-113-lush-grotto-map-layout.png": 162275,
	"./art/frosthaven/scenario-layout/fh-113-lush-grotto-scenario-key.png": 303034,
	"./art/frosthaven/scenario-layout/fh-114-work-freeze-loot.png": 460283,
	"./art/frosthaven/scenario-layout/fh-114-work-freeze-map-layout.png": 206230,
	"./art/frosthaven/scenario-layout/fh-114-work-freeze-scenario-key.png": 173018,
	"./art/frosthaven/scenario-layout/fh-115-pylon-problems-loot.png": 872472,
	"./art/frosthaven/scenario-layout/fh-115-pylon-problems-map-layout.png": 624033,
	"./art/frosthaven/scenario-layout/fh-115-pylon-problems-scenario-key.png": 321848,
	"./art/frosthaven/scenario-layout/fh-116-caravan-guards-loot.png": 1452,
	"./art/frosthaven/scenario-layout/fh-116-caravan-guards-map-layout.png": 800253,
	"./art/frosthaven/scenario-layout/fh-116-caravan-guards-scenario-key.png": 585861,
	"./art/frosthaven/scenario-layout/fh-117-a-waiting-game-loot.png": 756772,
	"./art/frosthaven/scenario-layout/fh-117-a-waiting-game-map-layout.png": 101395,
	"./art/frosthaven/scenario-layout/fh-117-a-waiting-game-scenario-key.png": 8703,
	"./art/frosthaven/scenario-layout/fh-118-lurker-necromancy-loot.png": 939083,
	"./art/frosthaven/scenario-layout/fh-118-lurker-necromancy-map-layout.png": 654650,
	"./art/frosthaven/scenario-layout/fh-118-lurker-necromancy-scenario-key.png": 754655,
	"./art/frosthaven/scenario-layout/fh-119-radiant-dust-loot.png": 367066,
	"./art/frosthaven/scenario-layout/fh-119-radiant-dust-map-layout.png": 248711,
	"./art/frosthaven/scenario-layout/fh-119-radiant-dust-scenario-key.png": 251166,
	"./art/frosthaven/scenario-layout/fh-120-under-the-influence-loot.png": 814273,
	"./art/frosthaven/scenario-layout/fh-120-under-the-influence-map-layout.png": 121651,
	"./art/frosthaven/scenario-layout/fh-120-under-the-influence-scenario-key-a.png": 430157,
	"./art/frosthaven/scenario-layout/fh-120-under-the-influence-scenario-key-b.png": 988178,
	"./art/frosthaven/scenario-layout/fh-121-black-memories-loot.png": 243773,
	"./art/frosthaven/scenario-layout/fh-121-black-memories-map-layout.png": 605125,
	"./art/frosthaven/scenario-layout/fh-121-black-memories-scenario-key.png": 395926,
	"./art/frosthaven/scenario-layout/fh-122-the-eternal-crave-loot.png": 8794,
	"./art/frosthaven/scenario-layout/fh-122-the-eternal-crave-map-layout.png": 964942,
	"./art/frosthaven/scenario-layout/fh-122-the-eternal-crave-scenario-key.png": 896194,
	"./art/frosthaven/scenario-layout/fh-123-the-titan-loot.png": 790664,
	"./art/frosthaven/scenario-layout/fh-123-the-titan-map-layout.png": 540078,
	"./art/frosthaven/scenario-layout/fh-123-the-titan-scenario-key.png": 182265,
	"./art/frosthaven/scenario-layout/fh-124-a-growing-problem-loot.png": 733811,
	"./art/frosthaven/scenario-layout/fh-124-a-growing-problem-map-layout.png": 857017,
	"./art/frosthaven/scenario-layout/fh-124-a-growing-problem-scenario-key.png": 165288,
	"./art/frosthaven/scenario-layout/fh-125-the-longest-second-loot.png": 894391,
	"./art/frosthaven/scenario-layout/fh-125-the-longest-second-map-layout.png": 343440,
	"./art/frosthaven/scenario-layout/fh-125-the-longest-second-scenario-key.png": 263071,
	"./art/frosthaven/scenario-layout/fh-126-joseph-the-lion-loot.png": 60518,
	"./art/frosthaven/scenario-layout/fh-126-joseph-the-lion-map-layout.png": 19155,
	"./art/frosthaven/scenario-layout/fh-126-joseph-the-lion-scenario-key.png": 421362,
	"./art/frosthaven/scenario-layout/fh-127-derelict-freighter-loot.png": 567382,
	"./art/frosthaven/scenario-layout/fh-127-derelict-freighter-map-layout.png": 886405,
	"./art/frosthaven/scenario-layout/fh-127-derelict-freighter-scenario-key-a.png": 102932,
	"./art/frosthaven/scenario-layout/fh-127-derelict-freighter-scenario-key-b.png": 27209,
	"./art/frosthaven/scenario-layout/fh-128-a-tall-drunken-tale-loot.png": 283418,
	"./art/frosthaven/scenario-layout/fh-128-a-tall-drunken-tale-map-layout.png": 942288,
	"./art/frosthaven/scenario-layout/fh-128-a-tall-drunken-tale-scenario-key.png": 879619,
	"./art/frosthaven/scenario-layout/fh-129-how-to-lay-an-ambush-loot.png": 549283,
	"./art/frosthaven/scenario-layout/fh-129-how-to-lay-an-ambush-map-layout.png": 156432,
	"./art/frosthaven/scenario-layout/fh-129-how-to-lay-an-ambush-scenario-key-a.png": 425551,
	"./art/frosthaven/scenario-layout/fh-129-how-to-lay-an-ambush-scenario-key-b.png": 207166,
	"./art/frosthaven/scenario-layout/fh-130-and-then-a-stream-loot.png": 957032,
	"./art/frosthaven/scenario-layout/fh-130-and-then-a-stream-map-layout.png": 475528,
	"./art/frosthaven/scenario-layout/fh-130-and-then-a-stream-scenario-key-a.png": 991083,
	"./art/frosthaven/scenario-layout/fh-130-and-then-a-stream-scenario-key-b.png": 661783,
	"./art/frosthaven/scenario-layout/fh-131-the-dancing-iceberg-loot.png": 680780,
	"./art/frosthaven/scenario-layout/fh-131-the-dancing-iceberg-map-layout.png": 171241,
	"./art/frosthaven/scenario-layout/fh-131-the-dancing-iceberg-scenario-key.png": 365297,
	"./art/frosthaven/scenario-layout/fh-132-temple-of-feline-power-loot.png": 612099,
	"./art/frosthaven/scenario-layout/fh-132-temple-of-feline-power-map-layout.png": 549152,
	"./art/frosthaven/scenario-layout/fh-132-temple-of-feline-power-scenario-key.png": 19439,
	"./art/frosthaven/scenario-layout/fh-133-bolt-loot.png": 472264,
	"./art/frosthaven/scenario-layout/fh-133-bolt-map-layout.png": 781703,
	"./art/frosthaven/scenario-layout/fh-133-bolt-scenario-key.png": 821399,
	"./art/frosthaven/scenario-layout/fh-134-tower-of-knowledge-loot.png": 74382,
	"./art/frosthaven/scenario-layout/fh-134-tower-of-knowledge-map-layout.png": 62441,
	"./art/frosthaven/scenario-layout/fh-134-tower-of-knowledge-scenario-key-a.png": 672658,
	"./art/frosthaven/scenario-layout/fh-134-tower-of-knowledge-scenario-key-b.png": 704583,
	"./art/frosthaven/scenario-layout/fh-135-belaras-keep-loot.png": 923742,
	"./art/frosthaven/scenario-layout/fh-135-belaras-keep-map-layout.png": 937424,
	"./art/frosthaven/scenario-layout/fh-135-belaras-keep-scenario-key-a.png": 419840,
	"./art/frosthaven/scenario-layout/fh-135-belaras-keep-scenario-key-b.png": 718562,
	"./art/frosthaven/scenario-layout/fh-136-abandoned-hideout-loot.png": 770930,
	"./art/frosthaven/scenario-layout/fh-136-abandoned-hideout-map-layout.png": 193255,
	"./art/frosthaven/scenario-layout/fh-136-abandoned-hideout-scenario-key.png": 246858,
	"./art/frosthaven/scenario-layout/fh-137-pirate-queens-haul-loot.png": 412756,
	"./art/frosthaven/scenario-layout/fh-137-pirate-queens-haul-map-layout.png": 252087,
	"./art/frosthaven/scenario-layout/fh-137-pirate-queens-haul-scenario-key-a.png": 554356,
	"./art/frosthaven/scenario-layout/fh-137-pirate-queens-haul-scenario-key-b.png": 162529,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-brummix-tracks.png": 329623,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-bug-in-jar.png": 701694,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-charged-core.png": 822743,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-coral-crown-1.png": 753370,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-coral-crown-2.png": 361221,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-coral-crown-3.png": 162865,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-coral-crown-4.png": 661843,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-coral-crown-5.png": 246642,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-coral-crown-6.png": 816861,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-coral-crown.png": 798348,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-crown-united.png": 840748,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-destroyer-of-the-icespeakers.png": 160806,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-destroyer-of-the-snowspeakers.png": 463604,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-empty-jar.png": 706871,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-firepepper.png": 66079,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-friend-of-the-fish-king.png": 494258,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-friend-of-the-frostspeakers.png": 222727,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-friend-of-the-icespeakers.png": 286960,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-friend-of-the-snowspeakers.png": 991372,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-harvest-festival.png": 904230,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-into-the-forest.png": 542302,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-lockout.png": 104748,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-overlay-w.png": 316658,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-overlay-x.png": 885785,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-overlay-y.png": 75798,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-overlay-z.png": 756362,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-shard-seeker.png": 775287,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-uncharged-core.png": 656438,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-unfettered-allies.png": 694200,
	"./art/frosthaven/stickers/individual/campaign-stickers/fh-unfettered-deactivated.png": 317484,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-air-sticker.png": 706860,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-bless-sticker.png": 411978,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-curse-sticker.png": 697186,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-dark-sticker.png": 430945,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-earth-sticker.png": 682255,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-fire-sticker.png": 121286,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-hex-attack-sticker.png": 341131,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-ice-sticker.png": 892530,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-immobilize-sticker.png": 739858,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-jump-sticker.png": 204831,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-light-sticker.png": 760056,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-muddle-sticker.png": 663334,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-plus-one-sticker.png": 615310,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-poison-sticker.png": 658367,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-regenerate-sticker.png": 892458,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-strengthen-sticker.png": 482648,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-ward-sticker.png": 641891,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-wild-sticker.png": 747144,
	"./art/frosthaven/stickers/individual/enhancement-stickers/fh-wound-sticker.png": 116699,
	"./art/frosthaven/stickers/individual/location-stickers/fh-000-howling-in-the-snow.png": 701671,
	"./art/frosthaven/stickers/individual/location-stickers/fh-001-a-town-in-flames.png": 664910,
	"./art/frosthaven/stickers/individual/location-stickers/fh-002-algox-scouting.png": 210753,
	"./art/frosthaven/stickers/individual/location-stickers/fh-003-algox-offensive.png": 960009,
	"./art/frosthaven/stickers/individual/location-stickers/fh-004-heart-of-ice.png": 294623,
	"./art/frosthaven/stickers/individual/location-stickers/fh-005-frozen-crypt.png": 904249,
	"./art/frosthaven/stickers/individual/location-stickers/fh-006-avalanche.png": 454468,
	"./art/frosthaven/stickers/individual/location-stickers/fh-007-edge-of-the-world.png": 842194,
	"./art/frosthaven/stickers/individual/location-stickers/fh-008-crystal-trench.png": 336309,
	"./art/frosthaven/stickers/individual/location-stickers/fh-009-glowing-catacombs.png": 219956,
	"./art/frosthaven/stickers/individual/location-stickers/fh-010-crystal-enclosure.png": 808000,
	"./art/frosthaven/stickers/individual/location-stickers/fh-011-snowscorn-peak.png": 921849,
	"./art/frosthaven/stickers/individual/location-stickers/fh-012-temple-entrance.png": 504797,
	"./art/frosthaven/stickers/individual/location-stickers/fh-013-frozen-fjord.png": 398250,
	"./art/frosthaven/stickers/individual/location-stickers/fh-014-jagged-shoals.png": 156536,
	"./art/frosthaven/stickers/individual/location-stickers/fh-015-ancient-spire.png": 696296,
	"./art/frosthaven/stickers/individual/location-stickers/fh-016-derelict-elevator.png": 379560,
	"./art/frosthaven/stickers/individual/location-stickers/fh-017-haunted-vault.png": 130154,
	"./art/frosthaven/stickers/individual/location-stickers/fh-018-crystal-fields.png": 846217,
	"./art/frosthaven/stickers/individual/location-stickers/fh-019-skyhall.png": 125645,
	"./art/frosthaven/stickers/individual/location-stickers/fh-020-temple-of-liberation.png": 28073,
	"./art/frosthaven/stickers/individual/location-stickers/fh-021-realm-of-endless-frost.png": 166351,
	"./art/frosthaven/stickers/individual/location-stickers/fh-022-ice-floes.png": 170641,
	"./art/frosthaven/stickers/individual/location-stickers/fh-023-spire-basement.png": 381542,
	"./art/frosthaven/stickers/individual/location-stickers/fh-024-upper-spire.png": 371284,
	"./art/frosthaven/stickers/individual/location-stickers/fh-025-rusted-tunnels.png": 266398,
	"./art/frosthaven/stickers/individual/location-stickers/fh-026-quatryl-library.png": 29414,
	"./art/frosthaven/stickers/individual/location-stickers/fh-027-depths-of-delirium.png": 384879,
	"./art/frosthaven/stickers/individual/location-stickers/fh-028-summit-meeting.png": 775036,
	"./art/frosthaven/stickers/individual/location-stickers/fh-029-war-of-the-spire-a.png": 788289,
	"./art/frosthaven/stickers/individual/location-stickers/fh-030-war-of-the-spire-b.png": 906665,
	"./art/frosthaven/stickers/individual/location-stickers/fh-031-crackling-tunnel.png": 117803,
	"./art/frosthaven/stickers/individual/location-stickers/fh-032-ravens-roost.png": 14152,
	"./art/frosthaven/stickers/individual/location-stickers/fh-033-thawed-wood.png": 868243,
	"./art/frosthaven/stickers/individual/location-stickers/fh-034-top-of-the-spire.png": 487239,
	"./art/frosthaven/stickers/individual/location-stickers/fh-035-scrap-pit.png": 937499,
	"./art/frosthaven/stickers/individual/location-stickers/fh-036-buried-ducts.png": 766494,
	"./art/frosthaven/stickers/individual/location-stickers/fh-037-the-dead-mile.png": 554777,
	"./art/frosthaven/stickers/individual/location-stickers/fh-038-the-way-forward.png": 58765,
	"./art/frosthaven/stickers/individual/location-stickers/fh-039-corrupted-camp.png": 407707,
	"./art/frosthaven/stickers/individual/location-stickers/fh-040-relief-effort.png": 596561,
	"./art/frosthaven/stickers/individual/location-stickers/fh-041-unfettered-shard.png": 377794,
	"./art/frosthaven/stickers/individual/location-stickers/fh-042-sunless-trench.png": 381074,
	"./art/frosthaven/stickers/individual/location-stickers/fh-043-overrun-barricade.png": 994637,
	"./art/frosthaven/stickers/individual/location-stickers/fh-044-nerve-center.png": 952673,
	"./art/frosthaven/stickers/individual/location-stickers/fh-045-living-glacier.png": 235570,
	"./art/frosthaven/stickers/individual/location-stickers/fh-046-dead-pass.png": 99997,
	"./art/frosthaven/stickers/individual/location-stickers/fh-047-carrion-ridge.png": 83728,
	"./art/frosthaven/stickers/individual/location-stickers/fh-048-blizzard-island.png": 538839,
	"./art/frosthaven/stickers/individual/location-stickers/fh-049-beneath-sea-and-stone.png": 331707,
	"./art/frosthaven/stickers/individual/location-stickers/fh-050-explosive-descent.png": 907211,
	"./art/frosthaven/stickers/individual/location-stickers/fh-051-orphans-halls.png": 881920,
	"./art/frosthaven/stickers/individual/location-stickers/fh-052-fleeting-permanence.png": 332310,
	"./art/frosthaven/stickers/individual/location-stickers/fh-053-underwater-throne.png": 122520,
	"./art/frosthaven/stickers/individual/location-stickers/fh-054-among-the-wreckage.png": 184466,
	"./art/frosthaven/stickers/individual/location-stickers/fh-055-change-of-heart.png": 599845,
	"./art/frosthaven/stickers/individual/location-stickers/fh-056-call-of-the-harbinger.png": 210943,
	"./art/frosthaven/stickers/individual/location-stickers/fh-057-sanctuary-of-snow.png": 80859,
	"./art/frosthaven/stickers/individual/location-stickers/fh-058-orphans-core.png": 996633,
	"./art/frosthaven/stickers/individual/location-stickers/fh-059-automaton-uprising.png": 955913,
	"./art/frosthaven/stickers/individual/location-stickers/fh-060-uniting-the-crown.png": 949077,
	"./art/frosthaven/stickers/individual/location-stickers/fh-061-life-and-death.png": 791763,
	"./art/frosthaven/stickers/individual/location-stickers/fh-062-the-unfettered-seal.png": 157321,
	"./art/frosthaven/stickers/individual/location-stickers/fh-063-the-savvas-seal.png": 466346,
	"./art/frosthaven/stickers/individual/location-stickers/fh-064-the-frosthaven-seal.png": 340942,
	"./art/frosthaven/stickers/individual/location-stickers/fh-065-a-strong-foundation.png": 239318,
	"./art/frosthaven/stickers/individual/location-stickers/fh-066-elemental-cores.png": 969862,
	"./art/frosthaven/stickers/individual/location-stickers/fh-067-core-attunement.png": 450344,
	"./art/frosthaven/stickers/individual/location-stickers/fh-068-the-face-of-torment.png": 788367,
	"./art/frosthaven/stickers/individual/location-stickers/fh-069-sacred-soil.png": 996435,
	"./art/frosthaven/stickers/individual/location-stickers/fh-070-the-true-oak.png": 761953,
	"./art/frosthaven/stickers/individual/location-stickers/fh-071-invasion-of-the-dock.png": 477995,
	"./art/frosthaven/stickers/individual/location-stickers/fh-072-a-giant-block-of-ice.png": 324663,
	"./art/frosthaven/stickers/individual/location-stickers/fh-073-flotsam.png": 683170,
	"./art/frosthaven/stickers/individual/location-stickers/fh-074-gaps-in-the-road.png": 245953,
	"./art/frosthaven/stickers/individual/location-stickers/fh-075-infiltrating-the-lair.png": 156367,
	"./art/frosthaven/stickers/individual/location-stickers/fh-076-apotheosis.png": 432754,
	"./art/frosthaven/stickers/individual/location-stickers/fh-077-fish-kings-ascension.png": 227554,
	"./art/frosthaven/stickers/individual/location-stickers/fh-078-the-lurker-problem.png": 231801,
	"./art/frosthaven/stickers/individual/location-stickers/fh-079-relic.png": 47465,
	"./art/frosthaven/stickers/individual/location-stickers/fh-080-relic-renewed.png": 324677,
	"./art/frosthaven/stickers/individual/location-stickers/fh-081-ruinous-research-lab.png": 340524,
	"./art/frosthaven/stickers/individual/location-stickers/fh-082-expedition-north.png": 28480,
	"./art/frosthaven/stickers/individual/location-stickers/fh-083-rising-brine.png": 896165,
	"./art/frosthaven/stickers/individual/location-stickers/fh-084-here-there-be-oozes.png": 440258,
	"./art/frosthaven/stickers/individual/location-stickers/fh-085-deadly-pastimes.png": 520324,
	"./art/frosthaven/stickers/individual/location-stickers/fh-086-the-lady-in-white.png": 199283,
	"./art/frosthaven/stickers/individual/location-stickers/fh-087-the-collection.png": 981607,
	"./art/frosthaven/stickers/individual/location-stickers/fh-088-collections-capstone.png": 185647,
	"./art/frosthaven/stickers/individual/location-stickers/fh-089-a-contained-fire.png": 926623,
	"./art/frosthaven/stickers/individual/location-stickers/fh-090-frozen-treasure.png": 455411,
	"./art/frosthaven/stickers/individual/location-stickers/fh-091-shoreline-scramble.png": 443452,
	"./art/frosthaven/stickers/individual/location-stickers/fh-092-sinking-ship.png": 198825,
	"./art/frosthaven/stickers/individual/location-stickers/fh-093-midwinter-brawl.png": 62255,
	"./art/frosthaven/stickers/individual/location-stickers/fh-094-a-grand-view.png": 681521,
	"./art/frosthaven/stickers/individual/location-stickers/fh-095-to-bury-the-dead.png": 769579,
	"./art/frosthaven/stickers/individual/location-stickers/fh-096-underground-station.png": 375201,
	"./art/frosthaven/stickers/individual/location-stickers/fh-097-program-control-nexus.png": 903131,
	"./art/frosthaven/stickers/individual/location-stickers/fh-098-collapsing-vent.png": 543270,
	"./art/frosthaven/stickers/individual/location-stickers/fh-099-prison-break.png": 953207,
	"./art/frosthaven/stickers/individual/location-stickers/fh-100-inside-the-swarm.png": 127299,
	"./art/frosthaven/stickers/individual/location-stickers/fh-101-harrower-library.png": 452860,
	"./art/frosthaven/stickers/individual/location-stickers/fh-102-into-the-black.png": 526100,
	"./art/frosthaven/stickers/individual/location-stickers/fh-103-the-lead-door.png": 768798,
	"./art/frosthaven/stickers/individual/location-stickers/fh-104-ruins-of-the-solstice.png": 680273,
	"./art/frosthaven/stickers/individual/location-stickers/fh-105-ruins-of-the-equinox.png": 587672,
	"./art/frosthaven/stickers/individual/location-stickers/fh-106-the-tempus-forge.png": 552301,
	"./art/frosthaven/stickers/individual/location-stickers/fh-107-my-private-empire.png": 8144,
	"./art/frosthaven/stickers/individual/location-stickers/fh-108-lustrous-pit.png": 768420,
	"./art/frosthaven/stickers/individual/location-stickers/fh-109-furious-factory.png": 181117,
	"./art/frosthaven/stickers/individual/location-stickers/fh-110-guardians-temple.png": 149743,
	"./art/frosthaven/stickers/individual/location-stickers/fh-111-ice-cave.png": 239820,
	"./art/frosthaven/stickers/individual/location-stickers/fh-112-raised-by-wolves.png": 249404,
	"./art/frosthaven/stickers/individual/location-stickers/fh-113-lush-grotto.png": 620494,
	"./art/frosthaven/stickers/individual/location-stickers/fh-114-work-freeze.png": 863841,
	"./art/frosthaven/stickers/individual/location-stickers/fh-115-pylon-problems.png": 176093,
	"./art/frosthaven/stickers/individual/location-stickers/fh-116-caravan-guards.png": 472810,
	"./art/frosthaven/stickers/individual/location-stickers/fh-117-a-waiting-game.png": 674795,
	"./art/frosthaven/stickers/individual/location-stickers/fh-118-lurker-necromancy.png": 866715,
	"./art/frosthaven/stickers/individual/location-stickers/fh-119-radiant-dust.png": 127095,
	"./art/frosthaven/stickers/individual/location-stickers/fh-120-under-the-influence.png": 78676,
	"./art/frosthaven/stickers/individual/location-stickers/fh-121-black-memories.png": 968471,
	"./art/frosthaven/stickers/individual/location-stickers/fh-122-the-eternal-crave.png": 451757,
	"./art/frosthaven/stickers/individual/location-stickers/fh-123-the-titan.png": 589104,
	"./art/frosthaven/stickers/individual/location-stickers/fh-124-a-growing-problem.png": 589086,
	"./art/frosthaven/stickers/individual/location-stickers/fh-125-the-longest-second.png": 191583,
	"./art/frosthaven/stickers/individual/location-stickers/fh-126-joseph-the-lion.png": 59166,
	"./art/frosthaven/stickers/individual/location-stickers/fh-127-derelict-freighter.png": 916536,
	"./art/frosthaven/stickers/individual/location-stickers/fh-128-a-tall-drunken-tale.png": 635129,
	"./art/frosthaven/stickers/individual/location-stickers/fh-129-how-to-lay-an-ambush.png": 552439,
	"./art/frosthaven/stickers/individual/location-stickers/fh-130-and-then-a-stream.png": 717686,
	"./art/frosthaven/stickers/individual/location-stickers/fh-131-the-dancing-iceberg.png": 99819,
	"./art/frosthaven/stickers/individual/location-stickers/fh-132-temple-of-feline-power.png": 508030,
	"./art/frosthaven/stickers/individual/location-stickers/fh-133-bolt.png": 71194,
	"./art/frosthaven/stickers/individual/location-stickers/fh-134-tower-of-knowledge.png": 330558,
	"./art/frosthaven/stickers/individual/location-stickers/fh-135-belaras-keep.png": 44130,
	"./art/frosthaven/stickers/individual/location-stickers/fh-136-abandoned-hideout.png": 351697,
	"./art/frosthaven/stickers/individual/location-stickers/fh-137-pirate-queens-haul.png": 551645,
	"./art/frosthaven/stickers/individual/location-stickers/fh-42-temple-l3.png": 976019,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-12-hunting-lodge-l1.png": 683808,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-12-hunting-lodge-l2.png": 585075,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-12-hunting-lodge-l3.png": 849606,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-12-hunting-lodge-l4.png": 734780,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-17-logging-camp-l1.png": 395431,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-17-logging-camp-l2.png": 73037,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-17-logging-camp-l3.png": 638490,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-17-logging-camp-l4.png": 356267,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-21-inn-l0.png": 765233,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-21-inn-l1.png": 281805,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-21-inn-l2.png": 883087,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-21-inn-l3.png": 510609,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-arrowvine.png": 759296,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-axenut.png": 362248,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-corpsecap.png": 785570,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-flamefruit.png": 653891,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-l0.png": 280668,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-l1.png": 287805,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-l2.png": 770550,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-l3.png": 878500,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-l4.png": 137231,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-rockroot.png": 193405,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-24-garden-snowthistle.png": 154198,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-34-craftsman-l2.png": 281691,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-34-craftsman-l3.png": 925519,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-34-craftsman-l4.png": 134048,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-34-craftsman-l5.png": 460865,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-34-craftsman-l6.png": 155078,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-34-craftsman-l7.png": 250664,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-34-craftsman-l8.png": 342967,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-34-craftsman-l9.png": 461780,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-35-alchemist-l2.png": 392826,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-35-alchemist-l3.png": 623135,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-37-trading-post-l0.png": 236822,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-37-trading-post-l1.png": 380375,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-37-trading-post-l2.png": 301179,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-37-trading-post-l3.png": 860865,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-37-trading-post-l4.png": 105257,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-39-jeweler-l0.png": 689913,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-39-jeweler-l1.png": 180189,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-39-jeweler-l2.png": 611345,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-39-jeweler-l3.png": 495422,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-42-temple-l0.png": 418460,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-42-temple-l1.png": 935443,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-42-temple-l2.png": 836978,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-42-temple-l3.png": 572822,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-44-enhancer-l0.png": 119013,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-44-enhancer-l1.png": 594322,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-44-enhancer-l2.png": 405031,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-44-enhancer-l3.png": 153136,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-44-enhancer-l4.png": 374560,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-5-mining-camp-l1.png": 810158,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-5-mining-camp-l2.png": 601637,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-5-mining-camp-l3.png": 444755,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-5-mining-camp-l4.png": 68846,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-65-metal-depot-l0.png": 732588,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-65-metal-depot-l1.png": 754604,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-65-metal-depot-l2.png": 500398,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-67-lumber-depot-l0.png": 999968,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-67-lumber-depot-l1.png": 139372,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-67-lumber-depot-l2.png": 657398,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-72-hide-depot-l0.png": 28655,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-72-hide-depot-l1.png": 175227,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-72-hide-depot-l2.png": 637055,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-74-tavern-l0.png": 673837,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-74-tavern-l1.png": 871184,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-74-tavern-l2.png": 724954,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-74-tavern-l3.png": 502994,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-81-hall-of-revelry-l0.png": 183187,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-81-hall-of-revelry-l1.png": 410572,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-81-hall-of-revelry-l2.png": 910974,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-83-library-l0.png": 888198,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-83-library-l1.png": 852125,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-83-library-l2.png": 139624,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-83-library-l3.png": 325988,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-85-capenter-l0.png": 920890,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-85-capenter-l1.png": 797596,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-85-capenter-l2.png": 747118,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-88-stables-l0.png": 663152,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-88-stables-l1.png": 958190,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-88-stables-l2.png": 314351,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-88-stables-l3.png": 434068,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-88-stables-l4.png": 306985,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-90-town-hall-l0.png": 311454,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-90-town-hall-l1.png": 233531,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-90-town-hall-l2.png": 7289,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-90-town-hall-l3.png": 65652,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-98-barracks-l2.png": 123429,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-98-barracks-l3.png": 482168,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-98-barracks-l4.png": 911394,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-blue-well.png": 475462,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-boat.png": 927344,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-climbing-gear.png": 812864,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-ice-spike.png": 721644,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-portcullis.png": 874002,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-red-well.png": 500362,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-sled.png": 586452,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-stage.png": 329697,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-statue.png": 673732,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-wall-j.png": 159352,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-wall-k.png": 843747,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-wall-l.png": 847309,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-wall-m.png": 675081,
	"./art/frosthaven/stickers/individual/outpost-stickers/fh-wall-n.png": 917865,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-1-p8.png": 433196,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-10-p62.png": 316907,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-11-p62.png": 157619,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-12-p62.png": 874889,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-13-p67.png": 670592,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-14-p67.png": 537797,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-15-p68.png": 893764,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-2-p8.png": 243742,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-3-p8.png": 608775,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-4-p12.png": 240047,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-5-p17.png": 440187,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-6-p33.png": 919951,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-7-p36.png": 715679,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-8-p48.png": 50083,
	"./art/frosthaven/stickers/individual/rule-stickers/fh-rule-sticker-9-p55.png": 528110,
	"./art/frosthaven/stickers/sheets/die-lines/fh-campaign-stickers-dl.png": 216391,
	"./art/frosthaven/stickers/sheets/die-lines/fh-enhancement-stickers-dl.png": 129892,
	"./art/frosthaven/stickers/sheets/die-lines/fh-location-stickers-1-dl.png": 486463,
	"./art/frosthaven/stickers/sheets/die-lines/fh-location-stickers-2-dl.png": 46550,
	"./art/frosthaven/stickers/sheets/die-lines/fh-location-stickers-3-dl.png": 614187,
	"./art/frosthaven/stickers/sheets/die-lines/fh-location-stickers-4-dl.png": 487182,
	"./art/frosthaven/stickers/sheets/die-lines/fh-location-stickers-5-dl.png": 413224,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-21-inn-dl.png": 433241,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-24a-garden-dl.png": 370155,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-24b-garden-dl.png": 453758,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-37-trading-post-dl.png": 91029,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-39-jeweler-dl.png": 860464,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-42-temple-dl.png": 785968,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-44-enhancer-dl.png": 669633,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-65-metal-depot-dl.png": 367349,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-67-lumber-depot-dl.png": 798823,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-72-hide-depot-dl.png": 477465,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-74-tavern-dl.png": 418380,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-81-hall-of-revelry-1-dl.png": 288929,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-81-hall-of-revelry-2-dl.png": 9848,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-83-library-dl.png": 519479,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-85-carpenter-dl.png": 923250,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-88-stables-dl.png": 483602,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-90-town-hall-dl.png": 561528,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-large-1-dl.png": 360704,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-large-2-dl.png": 8865,
	"./art/frosthaven/stickers/sheets/die-lines/fh-outpost-stickers-large-3-dl.png": 288841,
	"./art/frosthaven/stickers/sheets/die-lines/fh-puzzle-book-dl.png": 113030,
	"./art/frosthaven/stickers/sheets/die-lines/fh-removable-sticker-set-1-dl.png": 217432,
	"./art/frosthaven/stickers/sheets/die-lines/fh-removable-sticker-set-2-dl.png": 15789,
	"./art/frosthaven/stickers/sheets/die-lines/fh-rules-sticker-set-1-dl.png": 686558,
	"./art/frosthaven/stickers/sheets/die-lines/fh-rules-sticker-set-2-dl.png": 75159,
	"./art/frosthaven/stickers/sheets/die-lines/fh-wax-seal-stickers-dl.png": 816028,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-campaign-stickers-ndl.png": 245307,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-enhancement-stickers-ndl.png": 731827,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-location-stickers-1-ndl.png": 880271,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-location-stickers-2-ndl.png": 924988,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-location-stickers-3-ndl.png": 196943,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-location-stickers-4-ndl.png": 366032,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-location-stickers-5-ndl.png": 367434,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-21-inn-ndl.png": 489573,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-24a-garden-ndl.png": 238659,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-24b-garden-ndl.png": 266870,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-37-trading-post-ndl.png": 656825,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-39-jeweler-ndl.png": 32257,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-42-temple-ndl.png": 427845,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-44-enhancer-ndl.png": 775921,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-65-metal-depot-ndl.png": 696254,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-67-lumber-depot-ndl.png": 838968,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-72-hide-depot-ndl.png": 272598,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-74-tavern-ndl.png": 319785,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-81-hall-of-revelry-1-ndl.png": 883893,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-81-hall-of-revelry-2-ndl.png": 863174,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-83-library-ndl.png": 457170,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-85-carpenter-ndl.png": 692318,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-88-stables-ndl.png": 566269,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-90-town-hall-ndl.png": 844243,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-large-1-ndl.png": 253079,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-large-2-ndl.png": 999159,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-outpost-stickers-large-3-ndl.png": 402684,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-puzzle-book-ndl.png": 928083,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-removable-sticker-set-1-ndl.png": 655228,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-removable-sticker-set-2-ndl.png": 931207,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-rules-sticker-set-1-ndl.png": 493438,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-rules-sticker-set-2-ndl.png": 351285,
	"./art/frosthaven/stickers/sheets/no-die-lines/fh-wax-seal-stickers-ndl.png": 792226,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-01.png": 219860,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-02.png": 36846,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-03.png": 74473,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-04.png": 822377,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-05.png": 669215,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-06.png": 406958,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-07.png": 218662,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-08.png": 802035,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-09.png": 521939,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-10.png": 367301,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-11.png": 218409,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-12.png": 612631,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-13.png": 636802,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-14.png": 373939,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-15.png": 142502,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-16.png": 126034,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-17.png": 647281,
	"./attack-modifiers/crimson-scales/AA/cs-am-aa-back.png": 338290,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-01.png": 673588,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-02.png": 602828,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-03.png": 410503,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-04.png": 899084,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-05.png": 574746,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-06.png": 810369,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-07.png": 783417,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-08.png": 220914,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-09.png": 792949,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-10.png": 163203,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-11.png": 172995,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-12.png": 897908,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-13.png": 884795,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-14.png": 750280,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-15.png": 84324,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-16.png": 620032,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-17.png": 824670,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-18.png": 540324,
	"./attack-modifiers/crimson-scales/BK/cs-am-bk-back.png": 364907,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-01.png": 717069,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-02.png": 671790,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-03.png": 36519,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-04.png": 89883,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-05.png": 538715,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-06.png": 323540,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-07.png": 396149,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-08.png": 171917,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-09.png": 852090,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-10.png": 176342,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-11.png": 319212,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-12.png": 639254,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-13.png": 210311,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-14.png": 304089,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-15.png": 453415,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-16.png": 995961,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-17.png": 73063,
	"./attack-modifiers/crimson-scales/BM/cs-am-bm-back.png": 786617,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-01.png": 739405,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-02.png": 99828,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-03.png": 944645,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-04.png": 469144,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-05.png": 264711,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-06.png": 107670,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-07.png": 135857,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-08.png": 163918,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-09.png": 474674,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-10.png": 383100,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-11.png": 899603,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-12.png": 452416,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-13.png": 188830,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-14.png": 825569,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-15.png": 41815,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-16.png": 129513,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-17.png": 777911,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-18.png": 487847,
	"./attack-modifiers/crimson-scales/CG/cs-am-cg-back.png": 363467,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-01.png": 103750,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-02.png": 428341,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-03.png": 415853,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-04.png": 210871,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-05.png": 685745,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-06.png": 887631,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-07.png": 321916,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-08.png": 731628,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-09.png": 188168,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-10.png": 114793,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-11.png": 673001,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-12.png": 977572,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-13.png": 242011,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-14.png": 934771,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-15.png": 323465,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-16.png": 415814,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-17.png": 634166,
	"./attack-modifiers/crimson-scales/CT/cs-am-ct-back.png": 275157,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-01.png": 471512,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-02.png": 267248,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-03.png": 143175,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-04.png": 397290,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-05.png": 759061,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-06.png": 880083,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-07.png": 820397,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-08.png": 864649,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-09.png": 100630,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-10.png": 174123,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-11.png": 23018,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-12.png": 7039,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-13.png": 361664,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-14.png": 810531,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-15.png": 653692,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-16.png": 115920,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-17.png": 236131,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-18.png": 363897,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-19.png": 415642,
	"./attack-modifiers/crimson-scales/FK/cs-am-fk-back.png": 817481,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-01.png": 445473,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-02.png": 984225,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-03.png": 281708,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-04.png": 756139,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-05.png": 396055,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-06.png": 793892,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-07.png": 817211,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-08.png": 383878,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-09.png": 693083,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-10.png": 223748,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-11.png": 463536,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-12.png": 786400,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-13.png": 166265,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-14.png": 40405,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-15.png": 527534,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-16.png": 338276,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-17.png": 710278,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-18.png": 647370,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-19.png": 204138,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-20.png": 629401,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-21.png": 100581,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-22.png": 881740,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-23.png": 857448,
	"./attack-modifiers/crimson-scales/HO/cs-am-ho-back.png": 337170,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-01.png": 701612,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-02.png": 949829,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-03.png": 956591,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-04.png": 178853,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-05.png": 315487,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-06.png": 297078,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-07.png": 758408,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-08.png": 73630,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-09.png": 73572,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-10.png": 532905,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-11.png": 392643,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-12.png": 42848,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-13.png": 818159,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-14.png": 793354,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-15.png": 820229,
	"./attack-modifiers/crimson-scales/HP/cs-am-hp-back.png": 499329,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-01.png": 881860,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-02.png": 362917,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-03.png": 350072,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-04.png": 590139,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-05.png": 90404,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-06.png": 745034,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-07.png": 173919,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-08.png": 801562,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-09.png": 718015,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-10.png": 855336,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-11.png": 945270,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-12.png": 62958,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-13.png": 58010,
	"./attack-modifiers/crimson-scales/LU/cs-am-lu-back.png": 53415,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-01.png": 197420,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-02.png": 346036,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-03.png": 420627,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-04.png": 597944,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-05.png": 62033,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-06.png": 169177,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-07.png": 952384,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-08.png": 290480,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-09.png": 947606,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-10.png": 967036,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-11.png": 656898,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-12.png": 229645,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-13.png": 623833,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-14.png": 26131,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-15.png": 38181,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-16.png": 771395,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-17.png": 614259,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-18.png": 727641,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-19.png": 547695,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-20.png": 660327,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-21.png": 654222,
	"./attack-modifiers/crimson-scales/MF/cs-am-mf-back.png": 973831,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-01.png": 746746,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-02.png": 87082,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-03.png": 469354,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-04.png": 141734,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-05.png": 346758,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-06.png": 298514,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-07.png": 436120,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-08.png": 427752,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-09.png": 441050,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-10.png": 53270,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-11.png": 790552,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-12.png": 817049,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-13.png": 367670,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-14.png": 265788,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-15.png": 623136,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-16.png": 376891,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-17.png": 915055,
	"./attack-modifiers/crimson-scales/QA/cs-am-qa-back.png": 402115,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-01.png": 855312,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-02.png": 201860,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-03.png": 754195,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-04.png": 712803,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-05.png": 736108,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-06.png": 950919,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-07.png": 196976,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-08.png": 957551,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-09.png": 780198,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-10.png": 946353,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-11.png": 833540,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-12.png": 763739,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-13.png": 113675,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-14.png": 447185,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-15.png": 933848,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-16.png": 197617,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-17.png": 790922,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-18.png": 980703,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-19.png": 961758,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-20.png": 631818,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-21.png": 116065,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-22.png": 245834,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-23.png": 914417,
	"./attack-modifiers/crimson-scales/RM/cs-am-rm-back.png": 165284,
	"./attack-modifiers/crimson-scales/RM/cs-pe-rm-01.png": 56197,
	"./attack-modifiers/crimson-scales/RM/cs-pe-rm-02.png": 388510,
	"./attack-modifiers/crimson-scales/RM/cs-pe-rm-03.png": 445412,
	"./attack-modifiers/crimson-scales/RM/cs-pe-rm-back.png": 257746,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-01.png": 722491,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-02.png": 802852,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-03.png": 536874,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-04.png": 136949,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-05.png": 726248,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-06.png": 598406,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-07.png": 922236,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-08.png": 21818,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-09.png": 156744,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-10.png": 837585,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-11.png": 323886,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-12.png": 116657,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-13.png": 977226,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-14.png": 634683,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-15.png": 165294,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-16.png": 932575,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-17.png": 438663,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-18.png": 32615,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-19.png": 579145,
	"./attack-modifiers/crimson-scales/SP/cs-am-sp-back.png": 364984,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-01.png": 199603,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-02.png": 377484,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-03.png": 585837,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-04.png": 177609,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-05.png": 596528,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-06.png": 479513,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-07.png": 947635,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-08.png": 32233,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-09.png": 260945,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-10.png": 520577,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-11.png": 719234,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-12.png": 879672,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-13.png": 381270,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-14.png": 937161,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-15.png": 719456,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-16.png": 75589,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-17.png": 997391,
	"./attack-modifiers/crimson-scales/ST/cs-am-st-back.png": 496583,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-01.png": 71089,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-02.png": 672163,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-03.png": 842661,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-04.png": 153865,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-05.png": 733172,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-06.png": 766623,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-07.png": 343111,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-08.png": 770534,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-09.png": 938408,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-10.png": 255486,
	"./attack-modifiers/crimson-scales/base/monster-mod/cs-am-mm-back.png": 582394,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-01.png": 847448,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-02.png": 884107,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-03.png": 827566,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-04.png": 667232,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-05.png": 947012,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-06.png": 115563,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-07.png": 230935,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-08.png": 690172,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-09.png": 44738,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-10.png": 609772,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-11.png": 201738,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-12.png": 273214,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-13.png": 798256,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-14.png": 585324,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-15.png": 929940,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-16.png": 536664,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-17.png": 969735,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-18.png": 205408,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-19.png": 376087,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-20.png": 472469,
	"./attack-modifiers/crimson-scales/base/monster/cs-am-m-back.png": 670053,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-01.png": 51925,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-02.png": 168039,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-03.png": 749594,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-04.png": 474686,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-05.png": 405329,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-06.png": 190410,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-07.png": 554679,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-08.png": 129571,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-09.png": 885888,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-10.png": 105343,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-11.png": 420786,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-12.png": 575225,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-13.png": 74041,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-14.png": 15010,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-15.png": 305635,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-16.png": 279894,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-17.png": 339580,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-18.png": 68668,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-19.png": 601439,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-20.png": 630344,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-21.png": 598700,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-22.png": 291722,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-23.png": 338775,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-24.png": 4398,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-25.png": 292804,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-26.png": 295864,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-27.png": 404537,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-28.png": 546862,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-29.png": 871,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-30.png": 21823,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-31.png": 873333,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-32.png": 458777,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-33.png": 383901,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-34.png": 171997,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-35.png": 823047,
	"./attack-modifiers/crimson-scales/base/player-mod/cs-am-pm-back.png": 782401,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-01.png": 211203,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-02.png": 699498,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-03.png": 228977,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-04.png": 268400,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-05.png": 245581,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-06.png": 373793,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-07.png": 225788,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-08.png": 834668,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-09.png": 216939,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-10.png": 266687,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-11.png": 674448,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-12.png": 295113,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-13.png": 812810,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-14.png": 870008,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-15.png": 190531,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-16.png": 633123,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-17.png": 455814,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-18.png": 813146,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-19.png": 182060,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-20.png": 190777,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p1-back.png": 144392,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-01.png": 448351,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-02.png": 404475,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-03.png": 829235,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-04.png": 328059,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-05.png": 405105,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-06.png": 62576,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-07.png": 832975,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-08.png": 802293,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-09.png": 769197,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-10.png": 84513,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-11.png": 62420,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-12.png": 22829,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-13.png": 223530,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-14.png": 514496,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-15.png": 219728,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-16.png": 193543,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-17.png": 754934,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-18.png": 741158,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-19.png": 185915,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-20.png": 352402,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p2-back.png": 713977,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-01.png": 845899,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-02.png": 472863,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-03.png": 447572,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-04.png": 503869,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-05.png": 898867,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-06.png": 33670,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-07.png": 25373,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-08.png": 623938,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-09.png": 528677,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-10.png": 229781,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-11.png": 912293,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-12.png": 698112,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-13.png": 853225,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-14.png": 261554,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-15.png": 602573,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-16.png": 557072,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-17.png": 318844,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-18.png": 855749,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-19.png": 225094,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-20.png": 667901,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p3-back.png": 57690,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-01.png": 22185,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-02.png": 864801,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-03.png": 723268,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-04.png": 466345,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-05.png": 768598,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-06.png": 649403,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-07.png": 945783,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-08.png": 360829,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-09.png": 265211,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-10.png": 703494,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-11.png": 720980,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-12.png": 158216,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-13.png": 56321,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-14.png": 917168,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-15.png": 778429,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-16.png": 766469,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-17.png": 260660,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-18.png": 353872,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-19.png": 964999,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-20.png": 196591,
	"./attack-modifiers/crimson-scales/base/player/cs-am-p4-back.png": 557849,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-01.png": 361098,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-02.png": 502839,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-03.png": 116009,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-04.png": 958175,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-05.png": 827351,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-06.png": 147097,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-07.png": 611256,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-08.png": 294202,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-09.png": 410597,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-10.png": 490391,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-11.png": 496891,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-12.png": 716057,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-13.png": 686310,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-14.png": 316124,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-15.png": 810625,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-16.png": 28554,
	"./attack-modifiers/crimson-scales/party/cs-am-pa-back.png": 958549,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-01.png": 297734,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-02.png": 499899,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-03.png": 888463,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-04.png": 50559,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-05.png": 166244,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-06.png": 944133,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-07.png": 672862,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-08.png": 863617,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-09.png": 795073,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-10.png": 782814,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-11.png": 908633,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-12.png": 676293,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-13.png": 275306,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-14.png": 497220,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-15.png": 260506,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-16.png": 797666,
	"./attack-modifiers/crimson-scales/sanctuary/cs-am-sa-back.png": 762786,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-01.png": 964272,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-02.png": 475504,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-03.png": 846208,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-04.png": 707702,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-05.png": 826096,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-06.png": 130662,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-07.png": 165855,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-08.png": 132341,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-09.png": 435465,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-10.png": 194466,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-11.png": 761181,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-12.png": 119702,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-13.png": 371517,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-14.png": 859197,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-15.png": 355645,
	"./attack-modifiers/forgotten-circles/DR/fc-am-dr-back.png": 33225,
	"./attack-modifiers/forgotten-circles/ZZ/zz.txt": 39610,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-01.png": 206134,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-02.png": 269877,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-03.png": 562896,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-04.png": 405660,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-05.png": 578490,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-06.png": 791864,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-07.png": 646138,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-08.png": 884300,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-09.png": 162495,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-10.png": 624614,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-11.png": 474281,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-12.png": 597777,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-13.png": 414823,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-14.png": 890940,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-15.png": 758488,
	"./attack-modifiers/frosthaven/BB/fh-am-bb-back.png": 36367,
	"./attack-modifiers/frosthaven/BB/fh-pe-bb-01.png": 356471,
	"./attack-modifiers/frosthaven/BB/fh-pe-bb-02.png": 748271,
	"./attack-modifiers/frosthaven/BB/fh-pe-bb-03.png": 953600,
	"./attack-modifiers/frosthaven/BB/fh-pe-bb-back.png": 427789,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-01.png": 30022,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-02.png": 904313,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-03.png": 42260,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-04.png": 682952,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-05.png": 622737,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-06.png": 859727,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-07.png": 696866,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-08.png": 516215,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-09.png": 65693,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-10.png": 499420,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-11.png": 121644,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-12.png": 745901,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-13.png": 66397,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-14.png": 734887,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-15.png": 619192,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-16.png": 415977,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-17.png": 40888,
	"./attack-modifiers/frosthaven/BN/fh-am-bn-back.png": 226196,
	"./attack-modifiers/frosthaven/BN/fh-pe-bn-01.png": 833742,
	"./attack-modifiers/frosthaven/BN/fh-pe-bn-02.png": 623497,
	"./attack-modifiers/frosthaven/BN/fh-pe-bn-03.png": 934432,
	"./attack-modifiers/frosthaven/BN/fh-pe-bn-back.png": 799228,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-01.png": 8789,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-02.png": 903293,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-03.png": 804357,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-04.png": 838333,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-05.png": 487966,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-06.png": 691020,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-07.png": 961208,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-08.png": 590412,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-09.png": 646971,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-10.png": 189189,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-11.png": 615307,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-12.png": 104054,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-13.png": 433584,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-14.png": 346485,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-15.png": 186039,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-16.png": 356008,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-17.png": 306271,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-18.png": 617662,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-19.png": 396436,
	"./attack-modifiers/frosthaven/BO/fh-am-bo-back.png": 651262,
	"./attack-modifiers/frosthaven/BO/fh-pe-bo-01.png": 358397,
	"./attack-modifiers/frosthaven/BO/fh-pe-bo-02.png": 983485,
	"./attack-modifiers/frosthaven/BO/fh-pe-bo-03.png": 443824,
	"./attack-modifiers/frosthaven/BO/fh-pe-bo-back.png": 359572,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-01.png": 469872,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-02.png": 128795,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-03.png": 9633,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-04.png": 918372,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-05.png": 318482,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-06.png": 417601,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-07.png": 514676,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-08.png": 18056,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-09.png": 472434,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-10.png": 661516,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-11.png": 770157,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-12.png": 568621,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-13.png": 374926,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-14.png": 400613,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-15.png": 27678,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-16.png": 550155,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-17.png": 114855,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-18.png": 469400,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-19.png": 213646,
	"./attack-modifiers/frosthaven/CR/fh-am-cr-back.png": 506685,
	"./attack-modifiers/frosthaven/CR/fh-pe-cr-01.png": 634511,
	"./attack-modifiers/frosthaven/CR/fh-pe-cr-02.png": 687702,
	"./attack-modifiers/frosthaven/CR/fh-pe-cr-03.png": 319633,
	"./attack-modifiers/frosthaven/CR/fh-pe-cr-back.png": 834194,
	"./attack-modifiers/frosthaven/DF/fh-am-df-01.png": 516546,
	"./attack-modifiers/frosthaven/DF/fh-am-df-02.png": 756625,
	"./attack-modifiers/frosthaven/DF/fh-am-df-03.png": 131935,
	"./attack-modifiers/frosthaven/DF/fh-am-df-04.png": 958494,
	"./attack-modifiers/frosthaven/DF/fh-am-df-05.png": 291194,
	"./attack-modifiers/frosthaven/DF/fh-am-df-06.png": 65391,
	"./attack-modifiers/frosthaven/DF/fh-am-df-07.png": 5303,
	"./attack-modifiers/frosthaven/DF/fh-am-df-08.png": 853749,
	"./attack-modifiers/frosthaven/DF/fh-am-df-09.png": 843530,
	"./attack-modifiers/frosthaven/DF/fh-am-df-10.png": 537649,
	"./attack-modifiers/frosthaven/DF/fh-am-df-11.png": 276946,
	"./attack-modifiers/frosthaven/DF/fh-am-df-12.png": 904731,
	"./attack-modifiers/frosthaven/DF/fh-am-df-13.png": 814090,
	"./attack-modifiers/frosthaven/DF/fh-am-df-14.png": 765581,
	"./attack-modifiers/frosthaven/DF/fh-am-df-15.png": 289061,
	"./attack-modifiers/frosthaven/DF/fh-am-df-16.png": 591967,
	"./attack-modifiers/frosthaven/DF/fh-am-df-17.png": 165136,
	"./attack-modifiers/frosthaven/DF/fh-am-df-18.png": 473247,
	"./attack-modifiers/frosthaven/DF/fh-am-df-19.png": 478461,
	"./attack-modifiers/frosthaven/DF/fh-am-df-back.png": 973502,
	"./attack-modifiers/frosthaven/DF/fh-pe-df-01.png": 369906,
	"./attack-modifiers/frosthaven/DF/fh-pe-df-02.png": 921475,
	"./attack-modifiers/frosthaven/DF/fh-pe-df-03.png": 615536,
	"./attack-modifiers/frosthaven/DF/fh-pe-df-back.png": 156650,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-01.png": 31293,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-02.png": 790919,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-03.png": 232748,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-04.png": 861921,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-05.png": 342811,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-06.png": 179964,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-07.png": 208588,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-08.png": 391625,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-09.png": 337158,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-10.png": 414213,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-11.png": 479369,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-12.png": 841011,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-13.png": 763086,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-14.png": 83864,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-15.png": 424681,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-16.png": 435681,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-17.png": 611279,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-18.png": 254447,
	"./attack-modifiers/frosthaven/DT/fh-am-dt-back.png": 222326,
	"./attack-modifiers/frosthaven/DT/fh-pe-dt-01.png": 351093,
	"./attack-modifiers/frosthaven/DT/fh-pe-dt-02.png": 102802,
	"./attack-modifiers/frosthaven/DT/fh-pe-dt-03.png": 691674,
	"./attack-modifiers/frosthaven/DT/fh-pe-dt-back.png": 328433,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-01.png": 979739,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-02.png": 953540,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-03.png": 12129,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-04.png": 179641,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-05.png": 79274,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-06.png": 980727,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-07.png": 339962,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-08.png": 620622,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-09.png": 582120,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-10.png": 46516,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-11.png": 663971,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-12.png": 409972,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-13.png": 321600,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-14.png": 65166,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-15.png": 861065,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-16.png": 751654,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-17.png": 793436,
	"./attack-modifiers/frosthaven/DW/fh-am-dw-back.png": 318845,
	"./attack-modifiers/frosthaven/DW/fh-pe-dw-01.png": 723534,
	"./attack-modifiers/frosthaven/DW/fh-pe-dw-02.png": 177710,
	"./attack-modifiers/frosthaven/DW/fh-pe-dw-03.png": 995162,
	"./attack-modifiers/frosthaven/DW/fh-pe-dw-back.png": 372439,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-01.png": 297578,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-02.png": 563477,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-03.png": 897355,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-04.png": 586387,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-05.png": 905102,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-06.png": 763408,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-07.png": 500371,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-08.png": 527391,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-09.png": 660196,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-10.png": 17465,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-11.png": 711105,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-12.png": 38879,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-13.png": 316508,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-14.png": 738112,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-15.png": 419943,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-16.png": 392298,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-17.png": 12778,
	"./attack-modifiers/frosthaven/FF/fh-am-ff-back.png": 595801,
	"./attack-modifiers/frosthaven/FF/fh-pe-ff-01.png": 901804,
	"./attack-modifiers/frosthaven/FF/fh-pe-ff-02.png": 52244,
	"./attack-modifiers/frosthaven/FF/fh-pe-ff-03.png": 451651,
	"./attack-modifiers/frosthaven/FF/fh-pe-ff-back.png": 709448,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-01.png": 108730,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-02.png": 625144,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-03.png": 516622,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-04.png": 114980,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-05.png": 886406,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-06.png": 639874,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-07.png": 566867,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-08.png": 668007,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-09.png": 671179,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-10.png": 900651,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-11.png": 510231,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-12.png": 336552,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-13.png": 644993,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-14.png": 936030,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-15.png": 335870,
	"./attack-modifiers/frosthaven/GE/fh-am-ge-back.png": 958341,
	"./attack-modifiers/frosthaven/GE/fh-pe-ge-01.png": 450074,
	"./attack-modifiers/frosthaven/GE/fh-pe-ge-02.png": 638176,
	"./attack-modifiers/frosthaven/GE/fh-pe-ge-03.png": 447729,
	"./attack-modifiers/frosthaven/GE/fh-pe-ge-back.png": 310681,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-01.png": 226948,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-02.png": 231553,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-03.png": 898573,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-04.png": 178472,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-05.png": 772994,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-06.png": 721829,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-07.png": 960560,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-08.png": 868974,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-09.png": 677823,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-10.png": 101963,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-11.png": 32265,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-12.png": 577343,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-13.png": 703865,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-14.png": 713020,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-15.png": 553699,
	"./attack-modifiers/frosthaven/HV/fh-am-hv-back.png": 547874,
	"./attack-modifiers/frosthaven/HV/fh-pe-hv-01.png": 528381,
	"./attack-modifiers/frosthaven/HV/fh-pe-hv-02.png": 969437,
	"./attack-modifiers/frosthaven/HV/fh-pe-hv-03.png": 608726,
	"./attack-modifiers/frosthaven/HV/fh-pe-hv-back.png": 923217,
	"./attack-modifiers/frosthaven/IF/fh-am-if-01.png": 261345,
	"./attack-modifiers/frosthaven/IF/fh-am-if-02.png": 991368,
	"./attack-modifiers/frosthaven/IF/fh-am-if-03.png": 627269,
	"./attack-modifiers/frosthaven/IF/fh-am-if-04.png": 350234,
	"./attack-modifiers/frosthaven/IF/fh-am-if-05.png": 832592,
	"./attack-modifiers/frosthaven/IF/fh-am-if-06.png": 641655,
	"./attack-modifiers/frosthaven/IF/fh-am-if-07.png": 963527,
	"./attack-modifiers/frosthaven/IF/fh-am-if-08.png": 195561,
	"./attack-modifiers/frosthaven/IF/fh-am-if-09.png": 273797,
	"./attack-modifiers/frosthaven/IF/fh-am-if-10.png": 349677,
	"./attack-modifiers/frosthaven/IF/fh-am-if-11.png": 633753,
	"./attack-modifiers/frosthaven/IF/fh-am-if-12.png": 676008,
	"./attack-modifiers/frosthaven/IF/fh-am-if-13.png": 2825,
	"./attack-modifiers/frosthaven/IF/fh-am-if-14.png": 900373,
	"./attack-modifiers/frosthaven/IF/fh-am-if-15.png": 123617,
	"./attack-modifiers/frosthaven/IF/fh-am-if-16.png": 385544,
	"./attack-modifiers/frosthaven/IF/fh-am-if-17.png": 927622,
	"./attack-modifiers/frosthaven/IF/fh-am-if-18.png": 51137,
	"./attack-modifiers/frosthaven/IF/fh-am-if-19.png": 831434,
	"./attack-modifiers/frosthaven/IF/fh-am-if-20.png": 245938,
	"./attack-modifiers/frosthaven/IF/fh-am-if-back.png": 585346,
	"./attack-modifiers/frosthaven/IF/fh-pe-if-01.png": 411847,
	"./attack-modifiers/frosthaven/IF/fh-pe-if-02.png": 90422,
	"./attack-modifiers/frosthaven/IF/fh-pe-if-03.png": 164437,
	"./attack-modifiers/frosthaven/IF/fh-pe-if-back.png": 347650,
	"./attack-modifiers/frosthaven/ME/fh-am-me-01.png": 942834,
	"./attack-modifiers/frosthaven/ME/fh-am-me-02.png": 672999,
	"./attack-modifiers/frosthaven/ME/fh-am-me-03.png": 270424,
	"./attack-modifiers/frosthaven/ME/fh-am-me-04.png": 386978,
	"./attack-modifiers/frosthaven/ME/fh-am-me-05.png": 621826,
	"./attack-modifiers/frosthaven/ME/fh-am-me-06.png": 62030,
	"./attack-modifiers/frosthaven/ME/fh-am-me-07.png": 844544,
	"./attack-modifiers/frosthaven/ME/fh-am-me-08.png": 732421,
	"./attack-modifiers/frosthaven/ME/fh-am-me-09.png": 410204,
	"./attack-modifiers/frosthaven/ME/fh-am-me-10.png": 96942,
	"./attack-modifiers/frosthaven/ME/fh-am-me-11.png": 663851,
	"./attack-modifiers/frosthaven/ME/fh-am-me-12.png": 811581,
	"./attack-modifiers/frosthaven/ME/fh-am-me-13.png": 84297,
	"./attack-modifiers/frosthaven/ME/fh-am-me-14.png": 881240,
	"./attack-modifiers/frosthaven/ME/fh-am-me-15.png": 971098,
	"./attack-modifiers/frosthaven/ME/fh-am-me-16.png": 849563,
	"./attack-modifiers/frosthaven/ME/fh-am-me-back.png": 974676,
	"./attack-modifiers/frosthaven/ME/fh-pe-me-01.png": 772818,
	"./attack-modifiers/frosthaven/ME/fh-pe-me-02.png": 556363,
	"./attack-modifiers/frosthaven/ME/fh-pe-me-03.png": 82715,
	"./attack-modifiers/frosthaven/ME/fh-pe-me-back.png": 259512,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-01.png": 402443,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-02.png": 913751,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-03.png": 480902,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-04.png": 855564,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-05.png": 469424,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-06.png": 398847,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-07.png": 908247,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-08.png": 991303,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-09.png": 342979,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-10.png": 105038,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-11.png": 381123,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-12.png": 192291,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-13.png": 141510,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-14.png": 177658,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-15.png": 652558,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-16.png": 3604,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-17.png": 301514,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-18.png": 236597,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-19.png": 759018,
	"./attack-modifiers/frosthaven/PC/fh-am-pc-back.png": 583151,
	"./attack-modifiers/frosthaven/PC/fh-pe-pc-01.png": 75652,
	"./attack-modifiers/frosthaven/PC/fh-pe-pc-02.png": 277920,
	"./attack-modifiers/frosthaven/PC/fh-pe-pc-03.png": 98579,
	"./attack-modifiers/frosthaven/PC/fh-pe-pc-back.png": 95211,
	"./attack-modifiers/frosthaven/PY/fh-am-py-01.png": 637323,
	"./attack-modifiers/frosthaven/PY/fh-am-py-02.png": 24794,
	"./attack-modifiers/frosthaven/PY/fh-am-py-03.png": 342981,
	"./attack-modifiers/frosthaven/PY/fh-am-py-04.png": 591175,
	"./attack-modifiers/frosthaven/PY/fh-am-py-05.png": 587301,
	"./attack-modifiers/frosthaven/PY/fh-am-py-06.png": 184941,
	"./attack-modifiers/frosthaven/PY/fh-am-py-07.png": 657481,
	"./attack-modifiers/frosthaven/PY/fh-am-py-08.png": 934622,
	"./attack-modifiers/frosthaven/PY/fh-am-py-09.png": 740046,
	"./attack-modifiers/frosthaven/PY/fh-am-py-10.png": 457703,
	"./attack-modifiers/frosthaven/PY/fh-am-py-11.png": 4439,
	"./attack-modifiers/frosthaven/PY/fh-am-py-12.png": 80994,
	"./attack-modifiers/frosthaven/PY/fh-am-py-13.png": 184866,
	"./attack-modifiers/frosthaven/PY/fh-am-py-14.png": 116425,
	"./attack-modifiers/frosthaven/PY/fh-am-py-15.png": 82232,
	"./attack-modifiers/frosthaven/PY/fh-am-py-16.png": 213255,
	"./attack-modifiers/frosthaven/PY/fh-am-py-back.png": 831393,
	"./attack-modifiers/frosthaven/PY/fh-pe-py-01.png": 975523,
	"./attack-modifiers/frosthaven/PY/fh-pe-py-02.png": 232849,
	"./attack-modifiers/frosthaven/PY/fh-pe-py-03.png": 909106,
	"./attack-modifiers/frosthaven/PY/fh-pe-py-back.png": 288750,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-01.png": 349446,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-02.png": 836330,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-03.png": 709673,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-04.png": 380321,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-05.png": 719150,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-06.png": 309643,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-07.png": 986858,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-08.png": 543575,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-09.png": 11862,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-10.png": 283147,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-11.png": 715470,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-12.png": 121582,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-13.png": 207749,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-14.png": 666960,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-15.png": 85571,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-16.png": 813537,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-17.png": 662538,
	"./attack-modifiers/frosthaven/SD/fh-am-sd-back.png": 921695,
	"./attack-modifiers/frosthaven/SD/fh-pe-sd-01.png": 967847,
	"./attack-modifiers/frosthaven/SD/fh-pe-sd-02.png": 546101,
	"./attack-modifiers/frosthaven/SD/fh-pe-sd-03.png": 32812,
	"./attack-modifiers/frosthaven/SD/fh-pe-sd-back.png": 342441,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-01.png": 781817,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-02.png": 560706,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-03.png": 50332,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-04.png": 230258,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-05.png": 699032,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-06.png": 538459,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-07.png": 975079,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-08.png": 779836,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-09.png": 717861,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-10.png": 873620,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-11.png": 321466,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-12.png": 713235,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-13.png": 58097,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-14.png": 745573,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-15.png": 721796,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-16.png": 403137,
	"./attack-modifiers/frosthaven/SH/fh-am-sh-back.png": 307446,
	"./attack-modifiers/frosthaven/SH/fh-pe-sh-01.png": 898155,
	"./attack-modifiers/frosthaven/SH/fh-pe-sh-02.png": 182938,
	"./attack-modifiers/frosthaven/SH/fh-pe-sh-03.png": 567037,
	"./attack-modifiers/frosthaven/SH/fh-pe-sh-back.png": 681534,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-01.png": 788412,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-02.png": 142182,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-03.png": 152044,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-04.png": 487833,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-05.png": 790428,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-06.png": 156714,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-07.png": 404366,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-08.png": 981523,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-09.png": 435486,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-10.png": 273550,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-11.png": 813570,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-12.png": 700327,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-13.png": 881030,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-14.png": 292766,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-15.png": 900441,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-16.png": 253569,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-17.png": 313577,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-18.png": 561197,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-19.png": 827065,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-20.png": 532254,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-21.png": 745279,
	"./attack-modifiers/frosthaven/TA/fh-am-ta-back.png": 806206,
	"./attack-modifiers/frosthaven/TA/fh-pe-ta-01.png": 601914,
	"./attack-modifiers/frosthaven/TA/fh-pe-ta-02.png": 720373,
	"./attack-modifiers/frosthaven/TA/fh-pe-ta-03.png": 2497,
	"./attack-modifiers/frosthaven/TA/fh-pe-ta-back.png": 716679,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-01.png": 973768,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-02.png": 457212,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-03.png": 324510,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-04.png": 963100,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-05.png": 782017,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-06.png": 195174,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-07.png": 26857,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-08.png": 530320,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-09.png": 775244,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-10.png": 203727,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-11.png": 749584,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-12.png": 487968,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-13.png": 857709,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-14.png": 758601,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-15.png": 616614,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-16.png": 152957,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-17.png": 448381,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-18.png": 82991,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-19.png": 668750,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-20.png": 214363,
	"./attack-modifiers/frosthaven/base/ally/fh-am-a-back.png": 450413,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-01.png": 658572,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-02.png": 139080,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-03.png": 172602,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-04.png": 539511,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-05.png": 423309,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-06.png": 77576,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-07.png": 617515,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-08.png": 376313,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-09.png": 424762,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-10.png": 351158,
	"./attack-modifiers/frosthaven/base/monster-mod/fh-am-mm-back.png": 230011,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-01.png": 719920,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-02.png": 393809,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-03.png": 205530,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-04.png": 36646,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-05.png": 243967,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-06.png": 954174,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-07.png": 100352,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-08.png": 136666,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-09.png": 238003,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-10.png": 969753,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-11.png": 216305,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-12.png": 608676,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-13.png": 320606,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-14.png": 91221,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-15.png": 493068,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-16.png": 722263,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-17.png": 519068,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-18.png": 7057,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-19.png": 618375,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-20.png": 567036,
	"./attack-modifiers/frosthaven/base/monster/fh-am-m-back.png": 543407,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-01.png": 526259,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-02.png": 731406,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-03.png": 998739,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-04.png": 635515,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-05.png": 902098,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-06.png": 794522,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-07.png": 859245,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-08.png": 744883,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-09.png": 570749,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-10.png": 545831,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-11.png": 589625,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-12.png": 301547,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-13.png": 745864,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-14.png": 703387,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-15.png": 802161,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-16.png": 505995,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-17.png": 400482,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-18.png": 726907,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-19.png": 455705,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-20.png": 619899,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-21.png": 568103,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-22.png": 638046,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-23.png": 127284,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-24.png": 736570,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-25.png": 291606,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-26.png": 199752,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-27.png": 451562,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-28.png": 896108,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-29.png": 185857,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-30.png": 380260,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-31.png": 579767,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-32.png": 462536,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-33.png": 636537,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-34.png": 472492,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-35.png": 46296,
	"./attack-modifiers/frosthaven/base/player-mod/fh-am-pm-back.png": 281503,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-01.png": 908485,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-02.png": 207612,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-03.png": 771799,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-04.png": 705344,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-05.png": 257223,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-06.png": 917473,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-07.png": 802450,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-08.png": 821853,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-09.png": 302225,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-10.png": 766993,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-11.png": 482735,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-12.png": 226718,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-13.png": 749145,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-14.png": 230525,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-15.png": 423529,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-16.png": 777015,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-17.png": 232653,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-18.png": 729875,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-19.png": 325449,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-20.png": 206392,
	"./attack-modifiers/frosthaven/base/player/fh-am-p1-back.png": 666930,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-01.png": 879405,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-02.png": 397231,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-03.png": 839465,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-04.png": 38729,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-05.png": 671073,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-06.png": 726319,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-07.png": 668741,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-08.png": 645296,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-09.png": 128529,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-10.png": 518473,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-11.png": 738814,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-12.png": 797620,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-13.png": 706506,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-14.png": 792853,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-15.png": 530972,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-16.png": 526781,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-17.png": 867652,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-18.png": 764485,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-19.png": 513759,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-20.png": 653039,
	"./attack-modifiers/frosthaven/base/player/fh-am-p2-back.png": 944587,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-01.png": 313350,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-02.png": 128167,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-03.png": 805727,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-04.png": 84519,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-05.png": 925106,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-06.png": 750669,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-07.png": 327077,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-08.png": 524984,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-09.png": 728576,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-10.png": 78135,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-11.png": 423270,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-12.png": 179360,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-13.png": 230125,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-14.png": 864068,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-15.png": 199507,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-16.png": 57590,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-17.png": 238178,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-18.png": 103553,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-19.png": 345373,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-20.png": 62651,
	"./attack-modifiers/frosthaven/base/player/fh-am-p3-back.png": 950928,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-01.png": 441582,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-02.png": 96020,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-03.png": 847432,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-04.png": 550491,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-05.png": 360231,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-06.png": 545726,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-07.png": 26036,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-08.png": 626914,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-09.png": 588567,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-10.png": 753710,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-11.png": 532400,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-12.png": 731549,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-13.png": 764142,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-14.png": 110930,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-15.png": 771690,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-16.png": 106453,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-17.png": 496140,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-18.png": 954398,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-19.png": 859812,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-20.png": 101052,
	"./attack-modifiers/frosthaven/base/player/fh-am-p4-back.png": 319824,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-01.png": 254662,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-02.png": 700564,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-03.png": 623972,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-04.png": 452097,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-05.png": 292989,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-06.png": 282074,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-07.png": 864776,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-08.png": 511702,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-09.png": 383340,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-10.png": 890198,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-11.png": 36722,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-12.png": 584349,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-13.png": 764366,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-14.png": 841753,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-15.png": 250258,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-16.png": 46033,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-17.png": 580668,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-18.png": 580364,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-19.png": 537529,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-20.png": 380440,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-21.png": 530930,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-22.png": 255079,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-23.png": 607439,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-24.png": 498522,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-25.png": 992634,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-26.png": 366851,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-27.png": 396939,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-28.png": 815021,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-29.png": 583247,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-30.png": 131090,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-31.png": 551602,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-32.png": 455707,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-33.png": 719099,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-34.png": 173661,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-35.png": 149235,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-36.png": 170697,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-37.png": 415895,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-38.png": 923381,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-39.png": 714335,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-40.png": 809277,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-41.png": 655842,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-42.png": 418091,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-43.png": 84855,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-44.png": 539437,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-45.png": 587948,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-46.png": 748296,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-47.png": 509881,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-48.png": 701368,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-49.png": 991810,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-50.png": 284382,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-51.png": 687842,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-52.png": 837490,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-53.png": 30909,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-54.png": 799,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-55.png": 122027,
	"./attack-modifiers/frosthaven/base/town-guard/fh-am-tg-back.png": 785171,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-01.png": 947596,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-02.png": 697658,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-03.png": 863061,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-04.png": 988765,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-05.png": 342081,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-06.png": 765991,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-07.png": 62038,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-08.png": 740798,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-09.png": 84525,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-10.png": 992877,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-11.png": 9852,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-12.png": 905986,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-13.png": 81573,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-14.png": 474865,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-15.png": 425809,
	"./attack-modifiers/gloomhaven/BE/gh-am-be-back.png": 975577,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-01.png": 134682,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-02.png": 929398,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-03.png": 931125,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-04.png": 250028,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-05.png": 729618,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-06.png": 721555,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-07.png": 297012,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-08.png": 887017,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-09.png": 564108,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-10.png": 326424,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-11.png": 499885,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-12.png": 308683,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-13.png": 239810,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-14.png": 208440,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-15.png": 883791,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-16.png": 115262,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-17.png": 35554,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-18.png": 987550,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-19.png": 423004,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-20.png": 6637,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-21.png": 284446,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-22.png": 509745,
	"./attack-modifiers/gloomhaven/BR/gh-am-br-back.png": 521399,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-01.png": 894672,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-02.png": 794265,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-03.png": 205542,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-04.png": 818963,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-05.png": 88272,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-06.png": 347484,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-07.png": 934102,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-08.png": 698597,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-09.png": 531271,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-10.png": 464964,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-11.png": 655220,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-12.png": 678721,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-13.png": 513833,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-14.png": 345098,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-15.png": 347247,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-16.png": 165761,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-17.png": 201160,
	"./attack-modifiers/gloomhaven/BS/gh-am-bs-back.png": 401158,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-01.png": 282558,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-02.png": 509194,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-03.png": 479836,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-04.png": 807465,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-05.png": 131077,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-06.png": 390089,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-07.png": 373585,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-08.png": 896305,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-09.png": 88567,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-10.png": 354995,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-11.png": 814239,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-12.png": 560612,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-13.png": 961005,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-14.png": 617466,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-15.png": 471828,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-16.png": 551081,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-17.png": 631861,
	"./attack-modifiers/gloomhaven/BT/gh-am-bt-back.png": 393692,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-01.png": 168941,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-02.png": 149006,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-03.png": 608490,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-04.png": 834369,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-05.png": 196702,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-06.png": 651233,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-07.png": 888133,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-08.png": 486990,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-09.png": 647332,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-10.png": 725671,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-11.png": 154555,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-12.png": 674689,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-13.png": 550885,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-14.png": 606970,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-15.png": 466674,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-16.png": 556622,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-17.png": 443953,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-18.png": 833467,
	"./attack-modifiers/gloomhaven/CH/gh-am-ch-back.png": 234344,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-01.png": 694553,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-02.png": 430904,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-03.png": 167567,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-04.png": 944135,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-05.png": 870211,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-06.png": 863423,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-07.png": 283977,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-08.png": 596356,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-09.png": 109719,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-10.png": 128268,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-11.png": 560034,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-12.png": 452704,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-13.png": 131284,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-14.png": 478450,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-15.png": 934578,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-16.png": 562610,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-17.png": 191790,
	"./attack-modifiers/gloomhaven/DS/gh-am-ds-back.png": 120527,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-01.png": 162013,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-02.png": 610952,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-03.png": 801074,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-04.png": 172487,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-05.png": 70427,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-06.png": 607248,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-07.png": 840130,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-08.png": 75614,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-09.png": 106221,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-10.png": 535270,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-11.png": 981204,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-12.png": 803939,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-13.png": 65388,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-14.png": 527625,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-15.png": 708998,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-16.png": 244039,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-17.png": 805190,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-18.png": 769205,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-19.png": 124173,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-20.png": 207707,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-21.png": 686032,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-22.png": 746394,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-23.png": 257166,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-24.png": 227499,
	"./attack-modifiers/gloomhaven/EL/gh-am-el-back.png": 31975,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-01.png": 814667,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-02.png": 206509,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-03.png": 838506,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-04.png": 419109,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-05.png": 847439,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-06.png": 79589,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-07.png": 700262,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-08.png": 311218,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-09.png": 945356,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-10.png": 198776,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-11.png": 457461,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-12.png": 237338,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-13.png": 628570,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-14.png": 154178,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-15.png": 279845,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-16.png": 492543,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-17.png": 76180,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-18.png": 485840,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-19.png": 838200,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-20.png": 781959,
	"./attack-modifiers/gloomhaven/MT/gh-am-mt-back.png": 178422,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-01.png": 824149,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-02.png": 899135,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-03.png": 614126,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-04.png": 797660,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-05.png": 695278,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-06.png": 572282,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-07.png": 847657,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-08.png": 321487,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-09.png": 910158,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-10.png": 566653,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-11.png": 739248,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-12.png": 378025,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-13.png": 491778,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-14.png": 434568,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-15.png": 233187,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-16.png": 411291,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-17.png": 514753,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-18.png": 827443,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-19.png": 285083,
	"./attack-modifiers/gloomhaven/NS/gh-am-ns-back.png": 272273,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-01.png": 526903,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-02.png": 143323,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-03.png": 618083,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-04.png": 805986,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-05.png": 438799,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-06.png": 110538,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-07.png": 60783,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-08.png": 640074,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-09.png": 835923,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-10.png": 968287,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-11.png": 342447,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-12.png": 40632,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-13.png": 780895,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-14.png": 378607,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-15.png": 505032,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-16.png": 134656,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-17.png": 758436,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-18.png": 786001,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-19.png": 429413,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-20.png": 692661,
	"./attack-modifiers/gloomhaven/PH/gh-am-ph-back.png": 177157,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-01.png": 257228,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-02.png": 495379,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-03.png": 789661,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-04.png": 511166,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-05.png": 212188,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-06.png": 545347,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-07.png": 835239,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-08.png": 38868,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-09.png": 533311,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-10.png": 953392,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-11.png": 154812,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-12.png": 208709,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-13.png": 624318,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-14.png": 897350,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-15.png": 848521,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-16.png": 907664,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-17.png": 165968,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-18.png": 181458,
	"./attack-modifiers/gloomhaven/QM/gh-am-qm-back.png": 640004,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-01.png": 996375,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-02.png": 869078,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-03.png": 127148,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-04.png": 279666,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-05.png": 342433,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-06.png": 699532,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-07.png": 787582,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-08.png": 242093,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-09.png": 927115,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-10.png": 58811,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-11.png": 111338,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-12.png": 302840,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-13.png": 656679,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-14.png": 739586,
	"./attack-modifiers/gloomhaven/SB/gh-am-sb-back.png": 173014,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-01.png": 49086,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-02.png": 109495,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-03.png": 261743,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-04.png": 889634,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-05.png": 247964,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-06.png": 320390,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-07.png": 563420,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-08.png": 445695,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-09.png": 590054,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-10.png": 681480,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-11.png": 341735,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-12.png": 934859,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-13.png": 688055,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-14.png": 176735,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-15.png": 937542,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-16.png": 375732,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-17.png": 181743,
	"./attack-modifiers/gloomhaven/SC/gh-am-sc-back.png": 295577,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-01.png": 920271,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-02.png": 793041,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-03.png": 591621,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-04.png": 158631,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-05.png": 901937,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-06.png": 337276,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-07.png": 881402,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-08.png": 533015,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-09.png": 810446,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-10.png": 181500,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-11.png": 316375,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-12.png": 125028,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-13.png": 131277,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-14.png": 736557,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-15.png": 576565,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-16.png": 498257,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-17.png": 604808,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-18.png": 797772,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-19.png": 567982,
	"./attack-modifiers/gloomhaven/SK/gh-am-sk-back.png": 646935,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-01.png": 206633,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-02.png": 506332,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-03.png": 718733,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-04.png": 888760,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-05.png": 427102,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-06.png": 768760,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-07.png": 201894,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-08.png": 801532,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-09.png": 517648,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-10.png": 640221,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-11.png": 458048,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-12.png": 244883,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-13.png": 585937,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-14.png": 954909,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-15.png": 452084,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-16.png": 159841,
	"./attack-modifiers/gloomhaven/SS/gh-am-ss-back.png": 306178,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-01.png": 644411,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-02.png": 399868,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-03.png": 578926,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-04.png": 747863,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-05.png": 520541,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-06.png": 904171,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-07.png": 722798,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-08.png": 381394,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-09.png": 636723,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-10.png": 830875,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-11.png": 234979,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-12.png": 469353,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-13.png": 750594,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-14.png": 403513,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-15.png": 802126,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-16.png": 791652,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-17.png": 5858,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-18.png": 538921,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-19.png": 792683,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-20.png": 34531,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-21.png": 391337,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-22.png": 344103,
	"./attack-modifiers/gloomhaven/SU/gh-am-su-back.png": 193414,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-01.png": 300567,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-02.png": 448886,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-03.png": 388946,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-04.png": 914811,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-05.png": 568099,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-06.png": 104445,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-07.png": 189790,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-08.png": 983658,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-09.png": 398337,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-10.png": 121093,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-11.png": 784557,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-12.png": 621152,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-13.png": 653651,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-14.png": 749573,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-15.png": 668664,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-16.png": 656540,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-17.png": 58946,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-18.png": 335652,
	"./attack-modifiers/gloomhaven/SW/gh-am-sw-back.png": 742637,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-01.png": 970137,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-02.png": 985259,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-03.png": 448224,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-04.png": 922255,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-05.png": 100527,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-06.png": 237815,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-07.png": 849920,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-08.png": 819503,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-09.png": 218801,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-10.png": 605686,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-11.png": 662868,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-12.png": 140245,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-13.png": 556746,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-14.png": 197583,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-15.png": 265316,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-16.png": 556094,
	"./attack-modifiers/gloomhaven/TI/gh-am-ti-back.png": 666623,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-01.png": 672496,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-02.png": 809060,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-03.png": 737298,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-04.png": 404350,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-05.png": 909004,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-06.png": 761936,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-07.png": 656462,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-08.png": 228316,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-09.png": 138751,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-10.png": 341312,
	"./attack-modifiers/gloomhaven/base/monster-mod/gh-am-mm-back.png": 692874,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-01.png": 259503,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-02.png": 508377,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-03.png": 429441,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-04.png": 16944,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-05.png": 616941,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-06.png": 111737,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-07.png": 172922,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-08.png": 534650,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-09.png": 929784,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-10.png": 838391,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-11.png": 480677,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-12.png": 644610,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-13.png": 386208,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-14.png": 308167,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-15.png": 882769,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-16.png": 485435,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-17.png": 623526,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-18.png": 532849,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-19.png": 877959,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-20.png": 224351,
	"./attack-modifiers/gloomhaven/base/monster/gh-am-m-back.png": 395820,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-01.png": 472351,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-02.png": 332270,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-03.png": 881790,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-04.png": 742079,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-05.png": 897302,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-06.png": 432204,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-07.png": 467795,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-08.png": 706469,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-09.png": 212390,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-10.png": 62928,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-11.png": 591615,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-12.png": 428285,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-13.png": 819774,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-14.png": 660950,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-15.png": 432901,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-16.png": 544205,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-17.png": 882060,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-18.png": 810520,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-19.png": 92453,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-20.png": 721017,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-21.png": 823351,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-22.png": 717164,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-23.png": 122414,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-24.png": 96991,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-25.png": 756661,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-26.png": 57159,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-27.png": 553187,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-28.png": 880972,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-29.png": 482563,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-30.png": 785181,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-31.png": 384627,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-32.png": 424082,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-33.png": 745091,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-34.png": 436224,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-35.png": 804594,
	"./attack-modifiers/gloomhaven/base/player-mod/gh-am-pm-back.png": 950842,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-01.png": 785416,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-02.png": 914111,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-03.png": 753139,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-04.png": 517390,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-05.png": 66716,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-06.png": 725401,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-07.png": 890433,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-08.png": 907346,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-09.png": 849730,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-10.png": 57985,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-11.png": 342697,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-12.png": 191405,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-13.png": 86148,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-14.png": 324814,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-15.png": 676914,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-16.png": 597763,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-17.png": 770841,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-18.png": 402390,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-19.png": 741209,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-20.png": 799235,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p1-back.png": 715383,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-01.png": 875745,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-02.png": 492722,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-03.png": 265783,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-04.png": 308988,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-05.png": 493094,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-06.png": 352349,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-07.png": 102346,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-08.png": 517900,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-09.png": 572236,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-10.png": 269568,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-11.png": 277299,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-12.png": 839322,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-13.png": 703049,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-14.png": 422152,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-15.png": 827341,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-16.png": 148349,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-17.png": 927738,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-18.png": 439080,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-19.png": 705783,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-20.png": 556098,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p2-back.png": 560031,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-01.png": 558457,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-02.png": 707940,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-03.png": 805357,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-04.png": 914251,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-05.png": 889557,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-06.png": 281356,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-07.png": 662703,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-08.png": 286203,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-09.png": 133077,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-10.png": 776395,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-11.png": 280853,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-12.png": 990489,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-13.png": 625392,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-14.png": 317819,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-15.png": 885530,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-16.png": 342347,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-17.png": 296433,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-18.png": 619303,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-19.png": 116703,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-20.png": 718493,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p3-back.png": 493413,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-01.png": 825015,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-02.png": 147043,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-03.png": 996818,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-04.png": 696121,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-05.png": 89479,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-06.png": 119185,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-07.png": 734899,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-08.png": 895350,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-09.png": 396731,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-10.png": 313562,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-11.png": 11022,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-12.png": 877884,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-13.png": 852028,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-14.png": 522268,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-15.png": 126716,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-16.png": 813290,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-17.png": 434397,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-18.png": 16584,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-19.png": 989822,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-20.png": 255188,
	"./attack-modifiers/gloomhaven/base/player/gh-am-p4-back.png": 657561,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-01.png": 663735,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-02.png": 274301,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-03.png": 298564,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-04.png": 168236,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-05.png": 581246,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-06.png": 188131,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-07.png": 451228,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-08.png": 293119,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-09.png": 17109,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-10.png": 104720,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-11.png": 58624,
	"./attack-modifiers/jaws-of-the-lion/DE/jl-am-de-back.png": 823486,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-01.png": 748682,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-02.png": 144879,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-03.png": 335950,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-04.png": 190319,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-05.png": 807021,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-06.png": 880415,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-07.png": 391077,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-08.png": 747911,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-09.png": 975773,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-10.png": 111421,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-11.png": 165618,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-12.png": 503794,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-13.png": 536691,
	"./attack-modifiers/jaws-of-the-lion/HA/jl-am-ha-back.png": 183699,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-01.png": 10021,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-02.png": 638920,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-03.png": 956965,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-04.png": 883558,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-05.png": 39400,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-06.png": 989394,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-07.png": 248011,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-08.png": 192599,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-09.png": 923310,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-10.png": 939025,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-11.png": 712935,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-12.png": 721764,
	"./attack-modifiers/jaws-of-the-lion/RG/jl-am-rg-back.png": 508452,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-01.png": 655272,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-02.png": 995514,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-03.png": 854685,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-04.png": 889162,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-05.png": 103282,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-06.png": 607464,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-07.png": 876410,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-08.png": 303984,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-09.png": 676046,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-10.png": 484403,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-11.png": 45689,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-12.png": 6978,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-13.png": 166816,
	"./attack-modifiers/jaws-of-the-lion/VW/jl-am-vw-back.png": 323742,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-01.png": 66471,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-02.png": 274783,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-03.png": 192109,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-04.png": 966253,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-05.png": 669886,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-06.png": 378226,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-07.png": 325990,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-08.png": 158803,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-09.png": 288874,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-10.png": 878509,
	"./attack-modifiers/jaws-of-the-lion/base/monster-mod/jl-am-mm-back.png": 751976,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-01.png": 199297,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-02.png": 477696,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-03.png": 101197,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-04.png": 421132,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-05.png": 989845,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-06.png": 704861,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-07.png": 464268,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-08.png": 897440,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-09.png": 471810,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-10.png": 516551,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-11.png": 395365,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-12.png": 556798,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-13.png": 445509,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-14.png": 798169,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-15.png": 645489,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-16.png": 365240,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-17.png": 745409,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-18.png": 246733,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-19.png": 858650,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-20.png": 678075,
	"./attack-modifiers/jaws-of-the-lion/base/monster/jl-am-m-back.png": 536903,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-01.png": 784112,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-02.png": 806793,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-03.png": 180810,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-04.png": 142979,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-05.png": 841041,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-06.png": 123328,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-07.png": 356720,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-08.png": 773177,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-09.png": 478710,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-10.png": 512755,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-11.png": 5425,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-12.png": 79436,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-13.png": 365452,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-14.png": 52316,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-15.png": 230422,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-16.png": 680051,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-17.png": 950949,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-18.png": 199608,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-19.png": 371466,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-20.png": 821930,
	"./attack-modifiers/jaws-of-the-lion/base/player-mod/jl-am-pm-back.png": 462997,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-01.png": 497099,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-02.png": 262555,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-03.png": 617683,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-04.png": 987798,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-05.png": 109650,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-06.png": 605673,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-07.png": 833339,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-08.png": 286252,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-09.png": 40147,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-10.png": 515949,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-11.png": 134282,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-12.png": 111788,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-13.png": 202004,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-14.png": 96769,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-15.png": 671021,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-16.png": 707465,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-17.png": 975793,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-18.png": 192319,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-19.png": 919018,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-20.png": 440951,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-21.png": 586993,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-22.png": 147048,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-23.png": 738750,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-24.png": 227464,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-25.png": 501551,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-26.png": 711742,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-27.png": 549409,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-28.png": 257131,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-29.png": 317262,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-30.png": 371304,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-31.png": 540791,
	"./attack-modifiers/trail-of-ashes/IN/toa-am-in-back.png": 64610,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-01.png": 425778,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-02.png": 3789,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-03.png": 928670,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-04.png": 349623,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-05.png": 469592,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-06.png": 374981,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-07.png": 900025,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-08.png": 282624,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-09.png": 818764,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-10.png": 875071,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-11.png": 282988,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-12.png": 954293,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-13.png": 944884,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-14.png": 822413,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-15.png": 44665,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-16.png": 945867,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-17.png": 289403,
	"./attack-modifiers/trail-of-ashes/RH/toa-am-rh-back.png": 695323,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-01.png": 881566,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-02.png": 347221,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-03.png": 812964,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-04.png": 909765,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-05.png": 11748,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-06.png": 529677,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-07.png": 379658,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-08.png": 434342,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-09.png": 893828,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-10.png": 433476,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-11.png": 607088,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-12.png": 739848,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-13.png": 87621,
	"./attack-modifiers/trail-of-ashes/SR/toa-am-sr-back.png": 921394,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-01.png": 225043,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-02.png": 298788,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-03.png": 279786,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-04.png": 743927,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-05.png": 646731,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-06.png": 551824,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-07.png": 26308,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-08.png": 490151,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-09.png": 853666,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-10.png": 589962,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-11.png": 423721,
	"./attack-modifiers/trail-of-ashes/TP/toa-am-tp-back.png": 603655,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-01.png": 524644,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-02.png": 778681,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-03.png": 32611,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-04.png": 476447,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-05.png": 654638,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-06.png": 265162,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-07.png": 135313,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-08.png": 932052,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-09.png": 88911,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-10.png": 517488,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-11.png": 432612,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-12.png": 682647,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-13.png": 8306,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-14.png": 852077,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-15.png": 511693,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-16.png": 325433,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-17.png": 352474,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-18.png": 42624,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-19.png": 634541,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-20.png": 169326,
	"./attack-modifiers/trail-of-ashes/TR/toa-am-tr-back.png": 888862,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-01.png": 243977,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-02.png": 343482,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-03.png": 216352,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-04.png": 908757,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-05.png": 333910,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-06.png": 49293,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-07.png": 440350,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-08.png": 868450,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-09.png": 576888,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-10.png": 915879,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-11.png": 431583,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-12.png": 77481,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-13.png": 67030,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-14.png": 61173,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-15.png": 440210,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-16.png": 952096,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-17.png": 747700,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-18.png": 907330,
	"./attack-modifiers/trail-of-ashes/VQ/toa-am-vq-back.png": 188647,
	"./battle-goals/frosthaven/fh-accountant.png": 913519,
	"./battle-goals/frosthaven/fh-acrobat.png": 342868,
	"./battle-goals/frosthaven/fh-ascetic.png": 755917,
	"./battle-goals/frosthaven/fh-assassin.png": 166643,
	"./battle-goals/frosthaven/fh-assistant.png": 139992,
	"./battle-goals/frosthaven/fh-bastion.png": 518932,
	"./battle-goals/frosthaven/fh-battle-goals-back.png": 916082,
	"./battle-goals/frosthaven/fh-bully.png": 913775,
	"./battle-goals/frosthaven/fh-cleaner.png": 57176,
	"./battle-goals/frosthaven/fh-closer.png": 736608,
	"./battle-goals/frosthaven/fh-conservator.png": 685069,
	"./battle-goals/frosthaven/fh-daredevil.png": 265087,
	"./battle-goals/frosthaven/fh-dawdler.png": 422802,
	"./battle-goals/frosthaven/fh-diehard.png": 8993,
	"./battle-goals/frosthaven/fh-duelist.png": 528070,
	"./battle-goals/frosthaven/fh-dynamo.png": 860282,
	"./battle-goals/frosthaven/fh-egoist.png": 35081,
	"./battle-goals/frosthaven/fh-executioner.png": 84968,
	"./battle-goals/frosthaven/fh-exterminator.png": 441457,
	"./battle-goals/frosthaven/fh-gambler.png": 618631,
	"./battle-goals/frosthaven/fh-hunter.png": 10265,
	"./battle-goals/frosthaven/fh-insomniac.png": 357385,
	"./battle-goals/frosthaven/fh-layabout.png": 666082,
	"./battle-goals/frosthaven/fh-masochist.png": 17359,
	"./battle-goals/frosthaven/fh-miser.png": 308398,
	"./battle-goals/frosthaven/fh-mugger.png": 958296,
	"./battle-goals/frosthaven/fh-opener.png": 439387,
	"./battle-goals/frosthaven/fh-optimist.png": 536785,
	"./battle-goals/frosthaven/fh-overachiever.png": 76262,
	"./battle-goals/frosthaven/fh-pacifist.png": 247812,
	"./battle-goals/frosthaven/fh-pauper.png": 854323,
	"./battle-goals/frosthaven/fh-peacemonger.png": 462032,
	"./battle-goals/frosthaven/fh-pedestrian.png": 769992,
	"./battle-goals/frosthaven/fh-perfectionist.png": 959569,
	"./battle-goals/frosthaven/fh-pickpocket.png": 912480,
	"./battle-goals/frosthaven/fh-pincusion.png": 766325,
	"./battle-goals/frosthaven/fh-plebeian.png": 501986,
	"./battle-goals/frosthaven/fh-prepper.png": 390237,
	"./battle-goals/frosthaven/fh-prohibitionist.png": 339236,
	"./battle-goals/frosthaven/fh-promoter.png": 673329,
	"./battle-goals/frosthaven/fh-rambler.png": 748025,
	"./battle-goals/frosthaven/fh-ravager.png": 576529,
	"./battle-goals/frosthaven/fh-recluse.png": 743165,
	"./battle-goals/frosthaven/fh-ritualist.png": 25005,
	"./battle-goals/frosthaven/fh-sadist.png": 877184,
	"./battle-goals/frosthaven/fh-scrambler.png": 559619,
	"./battle-goals/frosthaven/fh-shirker.png": 163090,
	"./battle-goals/frosthaven/fh-slayer.png": 594474,
	"./battle-goals/frosthaven/fh-sleeper.png": 162137,
	"./battle-goals/frosthaven/fh-slowpoke.png": 186921,
	"./battle-goals/frosthaven/fh-sluggard.png": 638273,
	"./battle-goals/frosthaven/fh-specialist.png": 225911,
	"./battle-goals/frosthaven/fh-straggler.png": 847975,
	"./battle-goals/frosthaven/fh-streamliner.png": 726217,
	"./battle-goals/frosthaven/fh-tormentor.png": 283969,
	"./battle-goals/frosthaven/fh-vanguard.png": 251582,
	"./battle-goals/frosthaven/fh-wallflower.png": 612716,
	"./battle-goals/frosthaven/fh-wastrel.png": 751213,
	"./battle-goals/frosthaven/fh-weakling.png": 128813,
	"./battle-goals/frosthaven/fh-workhorse.png": 740371,
	"./battle-goals/frosthaven/fh-zealot.png": 377743,
	"./battle-goals/gloomhaven/gh-aggressor.png": 961274,
	"./battle-goals/gloomhaven/gh-battle-goals-back.png": 28253,
	"./battle-goals/gloomhaven/gh-diehard.png": 983740,
	"./battle-goals/gloomhaven/gh-dynamo.png": 389258,
	"./battle-goals/gloomhaven/gh-executioner.png": 131680,
	"./battle-goals/gloomhaven/gh-explorer.png": 298734,
	"./battle-goals/gloomhaven/gh-fast-healer.png": 166336,
	"./battle-goals/gloomhaven/gh-hoarder.png": 951623,
	"./battle-goals/gloomhaven/gh-hunter.png": 535897,
	"./battle-goals/gloomhaven/gh-indigent.png": 645643,
	"./battle-goals/gloomhaven/gh-layabout.png": 77799,
	"./battle-goals/gloomhaven/gh-masochist.png": 685458,
	"./battle-goals/gloomhaven/gh-neutralizer.png": 933909,
	"./battle-goals/gloomhaven/gh-opener.png": 849166,
	"./battle-goals/gloomhaven/gh-pacifist.png": 98874,
	"./battle-goals/gloomhaven/gh-plunderer.png": 396888,
	"./battle-goals/gloomhaven/gh-professional.png": 617732,
	"./battle-goals/gloomhaven/gh-protector.png": 795707,
	"./battle-goals/gloomhaven/gh-purist.png": 221765,
	"./battle-goals/gloomhaven/gh-sadist.png": 168009,
	"./battle-goals/gloomhaven/gh-scrambler.png": 560222,
	"./battle-goals/gloomhaven/gh-straggler.png": 265024,
	"./battle-goals/gloomhaven/gh-streamliner.png": 106080,
	"./battle-goals/gloomhaven/gh-workhorse.png": 590431,
	"./battle-goals/gloomhaven/gh-zealot.png": 11322,
	"./battle-goals/jaws-of-the-lion/jl-acrobat.png": 765121,
	"./battle-goals/jaws-of-the-lion/jl-agoraphobe.png": 354424,
	"./battle-goals/jaws-of-the-lion/jl-altruist.png": 60116,
	"./battle-goals/jaws-of-the-lion/jl-assistant.png": 956016,
	"./battle-goals/jaws-of-the-lion/jl-battle-goals-back.png": 76545,
	"./battle-goals/jaws-of-the-lion/jl-challenger.png": 223624,
	"./battle-goals/jaws-of-the-lion/jl-closer.png": 723493,
	"./battle-goals/jaws-of-the-lion/jl-conservator.png": 303268,
	"./battle-goals/jaws-of-the-lion/jl-diehard.png": 690972,
	"./battle-goals/jaws-of-the-lion/jl-egoist.png": 186105,
	"./battle-goals/jaws-of-the-lion/jl-fast-healer.png": 643155,
	"./battle-goals/jaws-of-the-lion/jl-gambler.png": 437554,
	"./battle-goals/jaws-of-the-lion/jl-hothead.png": 790298,
	"./battle-goals/jaws-of-the-lion/jl-insomniac.png": 551439,
	"./battle-goals/jaws-of-the-lion/jl-masochist.png": 830798,
	"./battle-goals/jaws-of-the-lion/jl-mugger.png": 680776,
	"./battle-goals/jaws-of-the-lion/jl-opener.png": 500511,
	"./battle-goals/jaws-of-the-lion/jl-pacifist.png": 627847,
	"./battle-goals/jaws-of-the-lion/jl-pickpocket.png": 45671,
	"./battle-goals/jaws-of-the-lion/jl-pincushion.png": 405930,
	"./battle-goals/jaws-of-the-lion/jl-plebeian.png": 593117,
	"./battle-goals/jaws-of-the-lion/jl-prohibitionist.png": 946536,
	"./battle-goals/jaws-of-the-lion/jl-ravager.png": 373123,
	"./battle-goals/jaws-of-the-lion/jl-recluse.png": 6695,
	"./battle-goals/jaws-of-the-lion/jl-sadist.png": 757140,
	"./battle-goals/jaws-of-the-lion/jl-scrambler.png": 618970,
	"./battle-goals/jaws-of-the-lion/jl-shadow.png": 463338,
	"./battle-goals/jaws-of-the-lion/jl-shirker.png": 171515,
	"./battle-goals/jaws-of-the-lion/jl-specialist.png": 777469,
	"./battle-goals/jaws-of-the-lion/jl-straggler.png": 577962,
	"./battle-goals/jaws-of-the-lion/jl-trailblazer.png": 849885,
	"./battle-goals/jaws-of-the-lion/jl-transmitter.png": 357963,
	"./battle-goals/jaws-of-the-lion/jl-weakling.png": 656160,
	"./books/ZZ/zz.txt": 437625,
	"./books/frosthaven/fh-puzzle-book.pdf": 482211,
	"./books/frosthaven/fh-rule-book.pdf": 573700,
	"./books/frosthaven/fh-scenario-book-102-121.pdf": 615439,
	"./books/frosthaven/fh-scenario-book-122-141.pdf": 398635,
	"./books/frosthaven/fh-scenario-book-142-166.pdf": 451034,
	"./books/frosthaven/fh-scenario-book-2-21.pdf": 777542,
	"./books/frosthaven/fh-scenario-book-22-41.pdf": 288245,
	"./books/frosthaven/fh-scenario-book-42-61.pdf": 864873,
	"./books/frosthaven/fh-scenario-book-62-81.pdf": 387220,
	"./books/frosthaven/fh-scenario-book-82-101.pdf": 373071,
	"./books/frosthaven/fh-section-book-102-121.pdf": 174289,
	"./books/frosthaven/fh-section-book-122-141.pdf": 856674,
	"./books/frosthaven/fh-section-book-142-161.pdf": 802974,
	"./books/frosthaven/fh-section-book-162-181.pdf": 579724,
	"./books/frosthaven/fh-section-book-182-197.pdf": 863312,
	"./books/frosthaven/fh-section-book-2-21.pdf": 79370,
	"./books/frosthaven/fh-section-book-22-41.pdf": 294269,
	"./books/frosthaven/fh-section-book-42-61.pdf": 238450,
	"./books/frosthaven/fh-section-book-62-81.pdf": 766773,
	"./books/frosthaven/fh-section-book-82-101.pdf": 861839,
	"./books/frosthaven/fh-solo-scenario-book.pdf": 216664,
	"./books/frosthaven/fh-starting-guide.pdf": 621770,
	"./challenge-cards/ZZ/zz.txt": 143296,
	"./challenge-cards/frosthaven/fh-ch-01.png": 154675,
	"./challenge-cards/frosthaven/fh-ch-02.png": 564259,
	"./challenge-cards/frosthaven/fh-ch-03.png": 62488,
	"./challenge-cards/frosthaven/fh-ch-04.png": 705856,
	"./challenge-cards/frosthaven/fh-ch-05.png": 705385,
	"./challenge-cards/frosthaven/fh-ch-06.png": 132506,
	"./challenge-cards/frosthaven/fh-ch-07.png": 5334,
	"./challenge-cards/frosthaven/fh-ch-08.png": 81909,
	"./challenge-cards/frosthaven/fh-ch-09.png": 873388,
	"./challenge-cards/frosthaven/fh-ch-10.png": 697439,
	"./challenge-cards/frosthaven/fh-ch-11.png": 317197,
	"./challenge-cards/frosthaven/fh-ch-12.png": 51852,
	"./challenge-cards/frosthaven/fh-ch-13.png": 241017,
	"./challenge-cards/frosthaven/fh-ch-14.png": 13301,
	"./challenge-cards/frosthaven/fh-ch-15.png": 532200,
	"./challenge-cards/frosthaven/fh-ch-16.png": 989093,
	"./challenge-cards/frosthaven/fh-ch-17.png": 219999,
	"./challenge-cards/frosthaven/fh-ch-18.png": 147371,
	"./challenge-cards/frosthaven/fh-ch-19.png": 907511,
	"./challenge-cards/frosthaven/fh-ch-20.png": 867019,
	"./challenge-cards/frosthaven/fh-ch-21.png": 430781,
	"./challenge-cards/frosthaven/fh-ch-22.png": 132170,
	"./challenge-cards/frosthaven/fh-ch-23.png": 168242,
	"./challenge-cards/frosthaven/fh-ch-24.png": 433458,
	"./challenge-cards/frosthaven/fh-ch-25.png": 973166,
	"./challenge-cards/frosthaven/fh-ch-26.png": 543404,
	"./challenge-cards/frosthaven/fh-ch-27.png": 338569,
	"./challenge-cards/frosthaven/fh-ch-28.png": 70217,
	"./challenge-cards/frosthaven/fh-ch-29.png": 111295,
	"./challenge-cards/frosthaven/fh-ch-30.png": 434870,
	"./challenge-cards/frosthaven/fh-ch-31.png": 751636,
	"./challenge-cards/frosthaven/fh-ch-32.png": 102789,
	"./challenge-cards/frosthaven/fh-ch-33.png": 339130,
	"./challenge-cards/frosthaven/fh-ch-34.png": 652875,
	"./challenge-cards/frosthaven/fh-ch-35.png": 759604,
	"./challenge-cards/frosthaven/fh-ch-36.png": 810399,
	"./challenge-cards/frosthaven/fh-ch-37.png": 185159,
	"./challenge-cards/frosthaven/fh-ch-38.png": 320464,
	"./challenge-cards/frosthaven/fh-ch-39.png": 274210,
	"./challenge-cards/frosthaven/fh-ch-40.png": 848690,
	"./challenge-cards/frosthaven/fh-ch-41.png": 599077,
	"./challenge-cards/frosthaven/fh-ch-42.png": 925472,
	"./challenge-cards/frosthaven/fh-ch-43.png": 740727,
	"./challenge-cards/frosthaven/fh-ch-44.png": 372327,
	"./challenge-cards/frosthaven/fh-ch-45.png": 104668,
	"./challenge-cards/frosthaven/fh-ch-back.png": 12784,
	"./character-ability-cards/crimson-scales/AA/cs-aa-back.png": 924239,
	"./character-ability-cards/crimson-scales/AA/cs-alate-dispersion.png": 555664,
	"./character-ability-cards/crimson-scales/AA/cs-anti-venom.png": 627543,
	"./character-ability-cards/crimson-scales/AA/cs-assimilate-adversaries.png": 138715,
	"./character-ability-cards/crimson-scales/AA/cs-birthing-chambers.png": 764588,
	"./character-ability-cards/crimson-scales/AA/cs-burning-stingers.png": 695738,
	"./character-ability-cards/crimson-scales/AA/cs-burrow-under.png": 152521,
	"./character-ability-cards/crimson-scales/AA/cs-clad-in-spikes.png": 715900,
	"./character-ability-cards/crimson-scales/AA/cs-coordinated-infestation.png": 374346,
	"./character-ability-cards/crimson-scales/AA/cs-corrosive-spittle.png": 161322,
	"./character-ability-cards/crimson-scales/AA/cs-divide-and-conquer.png": 250005,
	"./character-ability-cards/crimson-scales/AA/cs-encasing-webs.png": 871469,
	"./character-ability-cards/crimson-scales/AA/cs-erupting-mandibles.png": 289936,
	"./character-ability-cards/crimson-scales/AA/cs-ferocious-proliferation.png": 494404,
	"./character-ability-cards/crimson-scales/AA/cs-frantic-migration.png": 608550,
	"./character-ability-cards/crimson-scales/AA/cs-horned-carapace.png": 539542,
	"./character-ability-cards/crimson-scales/AA/cs-lacerating-horde.png": 15698,
	"./character-ability-cards/crimson-scales/AA/cs-maddening-chatter.png": 626991,
	"./character-ability-cards/crimson-scales/AA/cs-march-of-multitudes.png": 394738,
	"./character-ability-cards/crimson-scales/AA/cs-nurture-the-weak.png": 575064,
	"./character-ability-cards/crimson-scales/AA/cs-overwhelming-swarm.png": 600766,
	"./character-ability-cards/crimson-scales/AA/cs-primal-pheromones.png": 156003,
	"./character-ability-cards/crimson-scales/AA/cs-repel-intruders.png": 435816,
	"./character-ability-cards/crimson-scales/AA/cs-retribution-of-the-hive.png": 982345,
	"./character-ability-cards/crimson-scales/AA/cs-seek-nourishment.png": 882728,
	"./character-ability-cards/crimson-scales/AA/cs-sentry-swarm.png": 927032,
	"./character-ability-cards/crimson-scales/AA/cs-shelter-the-nest.png": 813923,
	"./character-ability-cards/crimson-scales/AA/cs-stalk-the-prey.png": 415575,
	"./character-ability-cards/crimson-scales/AA/cs-steelsilk-weaver.png": 639966,
	"./character-ability-cards/crimson-scales/AA/cs-supreme-authority.png": 776509,
	"./character-ability-cards/crimson-scales/AA/cs-violent-outlash.png": 402034,
	"./character-ability-cards/crimson-scales/BK/cs-acquire-funding.png": 255766,
	"./character-ability-cards/crimson-scales/BK/cs-advanced-research.png": 399572,
	"./character-ability-cards/crimson-scales/BK/cs-antibiotic-boost.png": 761014,
	"./character-ability-cards/crimson-scales/BK/cs-astronomical-strike.png": 613600,
	"./character-ability-cards/crimson-scales/BK/cs-befuddling-serum.png": 41481,
	"./character-ability-cards/crimson-scales/BK/cs-bk-back.png": 795676,
	"./character-ability-cards/crimson-scales/BK/cs-blinding-lightwaves.png": 769083,
	"./character-ability-cards/crimson-scales/BK/cs-cell-regeneration.png": 273392,
	"./character-ability-cards/crimson-scales/BK/cs-contagious-malady.png": 670907,
	"./character-ability-cards/crimson-scales/BK/cs-corrosive-combustion.png": 746796,
	"./character-ability-cards/crimson-scales/BK/cs-critical-hypothesis.png": 135609,
	"./character-ability-cards/crimson-scales/BK/cs-critical-observation.png": 177921,
	"./character-ability-cards/crimson-scales/BK/cs-dynamic-balance.png": 61083,
	"./character-ability-cards/crimson-scales/BK/cs-electromagnetism.png": 759672,
	"./character-ability-cards/crimson-scales/BK/cs-elevated-chemicals.png": 153165,
	"./character-ability-cards/crimson-scales/BK/cs-elevated-intake.png": 715572,
	"./character-ability-cards/crimson-scales/BK/cs-elixir-of-life.png": 791519,
	"./character-ability-cards/crimson-scales/BK/cs-enviromental-survey.png": 611367,
	"./character-ability-cards/crimson-scales/BK/cs-exothermic-cocktail.png": 345095,
	"./character-ability-cards/crimson-scales/BK/cs-frozen-explosion.png": 488151,
	"./character-ability-cards/crimson-scales/BK/cs-leftover-tonic.png": 775802,
	"./character-ability-cards/crimson-scales/BK/cs-magnetic-field.png": 419572,
	"./character-ability-cards/crimson-scales/BK/cs-molecular-hydroblast.png": 58318,
	"./character-ability-cards/crimson-scales/BK/cs-nourishing-formula.png": 212952,
	"./character-ability-cards/crimson-scales/BK/cs-nutrient-overdose.png": 165336,
	"./character-ability-cards/crimson-scales/BK/cs-preliminary-research.png": 993931,
	"./character-ability-cards/crimson-scales/BK/cs-strength-elixir.png": 524736,
	"./character-ability-cards/crimson-scales/BK/cs-transformation-libation.png": 629579,
	"./character-ability-cards/crimson-scales/BK/cs-ultraviolet-rays.png": 158971,
	"./character-ability-cards/crimson-scales/BK/cs-versatile-concoction.png": 370084,
	"./character-ability-cards/crimson-scales/BK/cs-weather-forecast.png": 774818,
	"./character-ability-cards/crimson-scales/BM/cs-airborne-skyrocket.png": 646493,
	"./character-ability-cards/crimson-scales/BM/cs-ballistic-barrage.png": 145136,
	"./character-ability-cards/crimson-scales/BM/cs-barbed-armor.png": 802091,
	"./character-ability-cards/crimson-scales/BM/cs-bm-back.png": 225001,
	"./character-ability-cards/crimson-scales/BM/cs-chain-grapnel.png": 390342,
	"./character-ability-cards/crimson-scales/BM/cs-consistent-firing.png": 996626,
	"./character-ability-cards/crimson-scales/BM/cs-defense-mechanism.png": 359865,
	"./character-ability-cards/crimson-scales/BM/cs-distant-retribution.png": 549128,
	"./character-ability-cards/crimson-scales/BM/cs-double-cannons.png": 836215,
	"./character-ability-cards/crimson-scales/BM/cs-exploding-cannonball.png": 185713,
	"./character-ability-cards/crimson-scales/BM/cs-forceful-bolt.png": 961696,
	"./character-ability-cards/crimson-scales/BM/cs-grappling-hook.png": 734632,
	"./character-ability-cards/crimson-scales/BM/cs-hurried-repairs.png": 163179,
	"./character-ability-cards/crimson-scales/BM/cs-ignited-launch.png": 503177,
	"./character-ability-cards/crimson-scales/BM/cs-man-the-cannon.png": 306510,
	"./character-ability-cards/crimson-scales/BM/cs-meteoric-blast.png": 861637,
	"./character-ability-cards/crimson-scales/BM/cs-pillars-of-smoke.png": 955670,
	"./character-ability-cards/crimson-scales/BM/cs-powerful-buckshot.png": 741731,
	"./character-ability-cards/crimson-scales/BM/cs-prolific-perforation.png": 686485,
	"./character-ability-cards/crimson-scales/BM/cs-quadruple-cannons.png": 20056,
	"./character-ability-cards/crimson-scales/BM/cs-rapid-fire.png": 222376,
	"./character-ability-cards/crimson-scales/BM/cs-rolling-into-position.png": 878497,
	"./character-ability-cards/crimson-scales/BM/cs-sharpened-focus.png": 752074,
	"./character-ability-cards/crimson-scales/BM/cs-stationary-enhancements.png": 195504,
	"./character-ability-cards/crimson-scales/BM/cs-supercharged-gunpowder.png": 8307,
	"./character-ability-cards/crimson-scales/BM/cs-superior-upgrade.png": 761847,
	"./character-ability-cards/crimson-scales/BM/cs-twin-blast.png": 972715,
	"./character-ability-cards/crimson-scales/BM/cs-unbreakable-position.png": 137125,
	"./character-ability-cards/crimson-scales/BM/cs-unexpected-bombshell.png": 347997,
	"./character-ability-cards/crimson-scales/CG/cs-agonizing-clamp.png": 336881,
	"./character-ability-cards/crimson-scales/CG/cs-cg-back.png": 853371,
	"./character-ability-cards/crimson-scales/CG/cs-champion-of-chains.png": 580267,
	"./character-ability-cards/crimson-scales/CG/cs-chokehold.png": 21682,
	"./character-ability-cards/crimson-scales/CG/cs-clamping-snare.png": 831141,
	"./character-ability-cards/crimson-scales/CG/cs-dizzying-release.png": 438815,
	"./character-ability-cards/crimson-scales/CG/cs-double-ko.png": 205122,
	"./character-ability-cards/crimson-scales/CG/cs-drag-through-dirt.png": 519588,
	"./character-ability-cards/crimson-scales/CG/cs-follow-the-chains.png": 136157,
	"./character-ability-cards/crimson-scales/CG/cs-ganging-up.png": 677238,
	"./character-ability-cards/crimson-scales/CG/cs-impending-power.png": 207607,
	"./character-ability-cards/crimson-scales/CG/cs-iron-thrust.png": 89926,
	"./character-ability-cards/crimson-scales/CG/cs-latch-and-tow.png": 919359,
	"./character-ability-cards/crimson-scales/CG/cs-locking-links.png": 100480,
	"./character-ability-cards/crimson-scales/CG/cs-merciless-beatdown.png": 454073,
	"./character-ability-cards/crimson-scales/CG/cs-meteor-hammer.png": 790854,
	"./character-ability-cards/crimson-scales/CG/cs-pivot-and-smash.png": 164114,
	"./character-ability-cards/crimson-scales/CG/cs-roundhouse-swing.png": 279738,
	"./character-ability-cards/crimson-scales/CG/cs-rusty-spikes.png": 275358,
	"./character-ability-cards/crimson-scales/CG/cs-slamming-shove.png": 184434,
	"./character-ability-cards/crimson-scales/CG/cs-spiked-knuckles.png": 212020,
	"./character-ability-cards/crimson-scales/CG/cs-suffering-steel.png": 717794,
	"./character-ability-cards/crimson-scales/CG/cs-sweeping-collision.png": 905106,
	"./character-ability-cards/crimson-scales/CG/cs-syndicated-assault.png": 736380,
	"./character-ability-cards/crimson-scales/CG/cs-tighten-the-chains.png": 188786,
	"./character-ability-cards/crimson-scales/CG/cs-titanic-chainwhip.png": 192851,
	"./character-ability-cards/crimson-scales/CG/cs-unending-torment.png": 299727,
	"./character-ability-cards/crimson-scales/CG/cs-untouchable-keeper.png": 456061,
	"./character-ability-cards/crimson-scales/CG/cs-vigorous-sway.png": 639580,
	"./character-ability-cards/crimson-scales/CG/cs-wrapped-in-metal.png": 316905,
	"./character-ability-cards/crimson-scales/CT/cs-agile-predator.png": 30343,
	"./character-ability-cards/crimson-scales/CT/cs-catastrophic-cattle.png": 753974,
	"./character-ability-cards/crimson-scales/CT/cs-ceremonial-dance.png": 247297,
	"./character-ability-cards/crimson-scales/CT/cs-chest-thumper.png": 21126,
	"./character-ability-cards/crimson-scales/CT/cs-ct-back.png": 974212,
	"./character-ability-cards/crimson-scales/CT/cs-hunters-mark.png": 85617,
	"./character-ability-cards/crimson-scales/CT/cs-impervious-armor.png": 60472,
	"./character-ability-cards/crimson-scales/CT/cs-majestic-mass.png": 20532,
	"./character-ability-cards/crimson-scales/CT/cs-master-the-reins.png": 852198,
	"./character-ability-cards/crimson-scales/CT/cs-medicine-shield.png": 61966,
	"./character-ability-cards/crimson-scales/CT/cs-mounded-sight.png": 835369,
	"./character-ability-cards/crimson-scales/CT/cs-one-with-nature.png": 77918,
	"./character-ability-cards/crimson-scales/CT/cs-outrun-the-enemy.png": 286046,
	"./character-ability-cards/crimson-scales/CT/cs-piercing-darts.png": 858504,
	"./character-ability-cards/crimson-scales/CT/cs-pipe-tomahawk.png": 713735,
	"./character-ability-cards/crimson-scales/CT/cs-positive-reinforcement.png": 212753,
	"./character-ability-cards/crimson-scales/CT/cs-prepared-rations.png": 237172,
	"./character-ability-cards/crimson-scales/CT/cs-regal-beast.png": 977430,
	"./character-ability-cards/crimson-scales/CT/cs-resurrection.png": 650291,
	"./character-ability-cards/crimson-scales/CT/cs-skinning-knife.png": 870048,
	"./character-ability-cards/crimson-scales/CT/cs-slow-and-steady.png": 594084,
	"./character-ability-cards/crimson-scales/CT/cs-sniffing-hound.png": 363649,
	"./character-ability-cards/crimson-scales/CT/cs-soul-whisperer.png": 821761,
	"./character-ability-cards/crimson-scales/CT/cs-spiked-muzzle.png": 262052,
	"./character-ability-cards/crimson-scales/CT/cs-strapping-bullwhip.png": 70392,
	"./character-ability-cards/crimson-scales/CT/cs-sucker-punch.png": 885292,
	"./character-ability-cards/crimson-scales/CT/cs-take-the-reins.png": 796215,
	"./character-ability-cards/crimson-scales/CT/cs-tribal-blessing.png": 782131,
	"./character-ability-cards/crimson-scales/CT/cs-venomous-mayhem.png": 346719,
	"./character-ability-cards/crimson-scales/CT/cs-war-paint.png": 476324,
	"./character-ability-cards/crimson-scales/FK/cs-backdraft.png": 662874,
	"./character-ability-cards/crimson-scales/FK/cs-cauterize-wound.png": 178920,
	"./character-ability-cards/crimson-scales/FK/cs-collective-combat.png": 605501,
	"./character-ability-cards/crimson-scales/FK/cs-combat-medic.png": 92678,
	"./character-ability-cards/crimson-scales/FK/cs-combined-effort.png": 471771,
	"./character-ability-cards/crimson-scales/FK/cs-controlled-aggression.png": 193359,
	"./character-ability-cards/crimson-scales/FK/cs-coordinated-attack.png": 413027,
	"./character-ability-cards/crimson-scales/FK/cs-crew-integrity.png": 521976,
	"./character-ability-cards/crimson-scales/FK/cs-fiery-charisma.png": 497443,
	"./character-ability-cards/crimson-scales/FK/cs-fire-whirl.png": 937749,
	"./character-ability-cards/crimson-scales/FK/cs-fk-back.png": 462348,
	"./character-ability-cards/crimson-scales/FK/cs-flaming-axe.png": 691746,
	"./character-ability-cards/crimson-scales/FK/cs-flashover.png": 77971,
	"./character-ability-cards/crimson-scales/FK/cs-forcible-entry.png": 843653,
	"./character-ability-cards/crimson-scales/FK/cs-heavy-irons.png": 977851,
	"./character-ability-cards/crimson-scales/FK/cs-hook-and-ladder.png": 783762,
	"./character-ability-cards/crimson-scales/FK/cs-incident-commander.png": 228417,
	"./character-ability-cards/crimson-scales/FK/cs-jack-of-all-trades.png": 627060,
	"./character-ability-cards/crimson-scales/FK/cs-kindled-tonic.png": 95133,
	"./character-ability-cards/crimson-scales/FK/cs-ladder-assault.png": 945833,
	"./character-ability-cards/crimson-scales/FK/cs-light-irons.png": 483415,
	"./character-ability-cards/crimson-scales/FK/cs-loyal-companion.png": 278794,
	"./character-ability-cards/crimson-scales/FK/cs-mutual-aid.png": 228061,
	"./character-ability-cards/crimson-scales/FK/cs-playing-with-fire.png": 171847,
	"./character-ability-cards/crimson-scales/FK/cs-practical-tools.png": 158225,
	"./character-ability-cards/crimson-scales/FK/cs-rapid-response.png": 82968,
	"./character-ability-cards/crimson-scales/FK/cs-rolling-flames.png": 25582,
	"./character-ability-cards/crimson-scales/FK/cs-search-and-rescue.png": 415245,
	"./character-ability-cards/crimson-scales/FK/cs-searing-blaze.png": 870234,
	"./character-ability-cards/crimson-scales/FK/cs-trauma-care.png": 320532,
	"./character-ability-cards/crimson-scales/HO/cs-borrowed-vitality.png": 37619,
	"./character-ability-cards/crimson-scales/HO/cs-channel-the-void.png": 163024,
	"./character-ability-cards/crimson-scales/HO/cs-empowered-assault.png": 134703,
	"./character-ability-cards/crimson-scales/HO/cs-enduring-darkness.png": 829971,
	"./character-ability-cards/crimson-scales/HO/cs-enervating-strike.png": 466314,
	"./character-ability-cards/crimson-scales/HO/cs-entropy-unleashed.png": 295212,
	"./character-ability-cards/crimson-scales/HO/cs-find-an-opening.png": 116557,
	"./character-ability-cards/crimson-scales/HO/cs-gateway-to-the-abyss.png": 765677,
	"./character-ability-cards/crimson-scales/HO/cs-greed-before-need.png": 257921,
	"./character-ability-cards/crimson-scales/HO/cs-ho-back.png": 682270,
	"./character-ability-cards/crimson-scales/HO/cs-hollow-embrace.png": 807496,
	"./character-ability-cards/crimson-scales/HO/cs-implosion.png": 73981,
	"./character-ability-cards/crimson-scales/HO/cs-majestic-malevolence.png": 105741,
	"./character-ability-cards/crimson-scales/HO/cs-nether-binding.png": 408307,
	"./character-ability-cards/crimson-scales/HO/cs-nether-blades.png": 518717,
	"./character-ability-cards/crimson-scales/HO/cs-no-escape.png": 960721,
	"./character-ability-cards/crimson-scales/HO/cs-obliterate.png": 40124,
	"./character-ability-cards/crimson-scales/HO/cs-one-with-nothingness.png": 585912,
	"./character-ability-cards/crimson-scales/HO/cs-prescient-voidmastery.png": 426995,
	"./character-ability-cards/crimson-scales/HO/cs-reaching-darkness.png": 55607,
	"./character-ability-cards/crimson-scales/HO/cs-ruinous-barrage.png": 560312,
	"./character-ability-cards/crimson-scales/HO/cs-sever-reality.png": 172387,
	"./character-ability-cards/crimson-scales/HO/cs-shrouded-grasp.png": 315735,
	"./character-ability-cards/crimson-scales/HO/cs-stalking-quarry.png": 490013,
	"./character-ability-cards/crimson-scales/HO/cs-tendrils-of-night.png": 412308,
	"./character-ability-cards/crimson-scales/HO/cs-touch-of-the-void.png": 131190,
	"./character-ability-cards/crimson-scales/HO/cs-untethered-advance.png": 39210,
	"./character-ability-cards/crimson-scales/HO/cs-void-enhanced-armory.png": 779157,
	"./character-ability-cards/crimson-scales/HO/cs-void-step.png": 258645,
	"./character-ability-cards/crimson-scales/HO/cs-withering-deluge.png": 885196,
	"./character-ability-cards/crimson-scales/HP/cs-aspiration.png": 747466,
	"./character-ability-cards/crimson-scales/HP/cs-beacon-of-hope.png": 231729,
	"./character-ability-cards/crimson-scales/HP/cs-bringer-of-miracles.png": 647497,
	"./character-ability-cards/crimson-scales/HP/cs-chains-of-light.png": 414471,
	"./character-ability-cards/crimson-scales/HP/cs-devotion.png": 461677,
	"./character-ability-cards/crimson-scales/HP/cs-devout-assistance.png": 209045,
	"./character-ability-cards/crimson-scales/HP/cs-divine-allegiance.png": 105902,
	"./character-ability-cards/crimson-scales/HP/cs-encouraged-conviction.png": 600270,
	"./character-ability-cards/crimson-scales/HP/cs-expansive-permanence.png": 983425,
	"./character-ability-cards/crimson-scales/HP/cs-faith-calling.png": 203437,
	"./character-ability-cards/crimson-scales/HP/cs-grace.png": 245677,
	"./character-ability-cards/crimson-scales/HP/cs-harsh-rebuke.png": 294467,
	"./character-ability-cards/crimson-scales/HP/cs-hp-back.png": 466656,
	"./character-ability-cards/crimson-scales/HP/cs-impetuous-inquisition.png": 735400,
	"./character-ability-cards/crimson-scales/HP/cs-inner-reflection.png": 572225,
	"./character-ability-cards/crimson-scales/HP/cs-inspired-remedy.png": 531614,
	"./character-ability-cards/crimson-scales/HP/cs-lamentation.png": 144486,
	"./character-ability-cards/crimson-scales/HP/cs-meditation.png": 782707,
	"./character-ability-cards/crimson-scales/HP/cs-oaks-embrace.png": 837179,
	"./character-ability-cards/crimson-scales/HP/cs-ordination.png": 63696,
	"./character-ability-cards/crimson-scales/HP/cs-penitence.png": 35500,
	"./character-ability-cards/crimson-scales/HP/cs-prosperous-concord.png": 902353,
	"./character-ability-cards/crimson-scales/HP/cs-restoring-faith.png": 849464,
	"./character-ability-cards/crimson-scales/HP/cs-revered-protector.png": 954141,
	"./character-ability-cards/crimson-scales/HP/cs-righteous-atonement.png": 387499,
	"./character-ability-cards/crimson-scales/HP/cs-rooted-subjugation.png": 497691,
	"./character-ability-cards/crimson-scales/HP/cs-sacred-death.png": 647690,
	"./character-ability-cards/crimson-scales/HP/cs-salvation.png": 763664,
	"./character-ability-cards/crimson-scales/HP/cs-soul-strike.png": 567747,
	"./character-ability-cards/crimson-scales/HP/cs-soulful-salvation.png": 272107,
	"./character-ability-cards/crimson-scales/HP/cs-spiritual-gains.png": 106373,
	"./character-ability-cards/crimson-scales/HP/cs-standing-ground.png": 309226,
	"./character-ability-cards/crimson-scales/HP/cs-symphony-of-oppression.png": 818693,
	"./character-ability-cards/crimson-scales/HP/cs-unruly-repentance.png": 732085,
	"./character-ability-cards/crimson-scales/HP/cs-unstoppable-force.png": 370504,
	"./character-ability-cards/crimson-scales/HP/cs-vengeful-veneration.png": 876373,
	"./character-ability-cards/crimson-scales/HP/cs-vital-bond.png": 48379,
	"./character-ability-cards/crimson-scales/HP/cs-vocal-sermon.png": 428227,
	"./character-ability-cards/crimson-scales/HP/cs-weakened-will.png": 716447,
	"./character-ability-cards/crimson-scales/LU/cs-blackened-rage.png": 773570,
	"./character-ability-cards/crimson-scales/LU/cs-blazing-pincers.png": 51699,
	"./character-ability-cards/crimson-scales/LU/cs-burning-sparks.png": 654988,
	"./character-ability-cards/crimson-scales/LU/cs-chilling-wave.png": 890567,
	"./character-ability-cards/crimson-scales/LU/cs-colorful-wavelengths.png": 225581,
	"./character-ability-cards/crimson-scales/LU/cs-darkened-overcast.png": 404563,
	"./character-ability-cards/crimson-scales/LU/cs-dominating-illumination.png": 931485,
	"./character-ability-cards/crimson-scales/LU/cs-empowering-rays.png": 105458,
	"./character-ability-cards/crimson-scales/LU/cs-encompassing-aura.png": 976516,
	"./character-ability-cards/crimson-scales/LU/cs-flickering-lights.png": 612848,
	"./character-ability-cards/crimson-scales/LU/cs-floodlight.png": 594384,
	"./character-ability-cards/crimson-scales/LU/cs-frosty-glimmer.png": 911147,
	"./character-ability-cards/crimson-scales/LU/cs-gamma-energy.png": 179639,
	"./character-ability-cards/crimson-scales/LU/cs-heat-waves.png": 396823,
	"./character-ability-cards/crimson-scales/LU/cs-imposing-brilliance.png": 244431,
	"./character-ability-cards/crimson-scales/LU/cs-light-the-way.png": 807922,
	"./character-ability-cards/crimson-scales/LU/cs-lu-back.png": 641518,
	"./character-ability-cards/crimson-scales/LU/cs-luminescence.png": 877945,
	"./character-ability-cards/crimson-scales/LU/cs-moonbeam.png": 835812,
	"./character-ability-cards/crimson-scales/LU/cs-optical-refraction.png": 441481,
	"./character-ability-cards/crimson-scales/LU/cs-photonic-defense.png": 422688,
	"./character-ability-cards/crimson-scales/LU/cs-radiant-glare.png": 669536,
	"./character-ability-cards/crimson-scales/LU/cs-shadow-claws.png": 119766,
	"./character-ability-cards/crimson-scales/LU/cs-shimmering-scuttle.png": 699125,
	"./character-ability-cards/crimson-scales/LU/cs-shining-diversion.png": 699664,
	"./character-ability-cards/crimson-scales/LU/cs-soft-glow.png": 420512,
	"./character-ability-cards/crimson-scales/LU/cs-solid-light.png": 598159,
	"./character-ability-cards/crimson-scales/LU/cs-sparkling-glow.png": 371898,
	"./character-ability-cards/crimson-scales/LU/cs-torrid-radiation.png": 785370,
	"./character-ability-cards/crimson-scales/LU/cs-trickling-sting.png": 707347,
	"./character-ability-cards/crimson-scales/LU/cs-violent-flash.png": 193139,
	"./character-ability-cards/crimson-scales/MF/cs-airborne-spores.png": 695480,
	"./character-ability-cards/crimson-scales/MF/cs-anticoagulant.png": 449470,
	"./character-ability-cards/crimson-scales/MF/cs-blood-thinner.png": 719623,
	"./character-ability-cards/crimson-scales/MF/cs-bogstep.png": 10232,
	"./character-ability-cards/crimson-scales/MF/cs-complex-toxicology.png": 279831,
	"./character-ability-cards/crimson-scales/MF/cs-compound-toxin.png": 664975,
	"./character-ability-cards/crimson-scales/MF/cs-copperneck-berries.png": 430228,
	"./character-ability-cards/crimson-scales/MF/cs-death-sentence.png": 42939,
	"./character-ability-cards/crimson-scales/MF/cs-fireroot-sap.png": 852833,
	"./character-ability-cards/crimson-scales/MF/cs-ground-solvent.png": 143052,
	"./character-ability-cards/crimson-scales/MF/cs-hide-and-seek.png": 94667,
	"./character-ability-cards/crimson-scales/MF/cs-lashing-vines.png": 701939,
	"./character-ability-cards/crimson-scales/MF/cs-lingering-swamp-moss.png": 682254,
	"./character-ability-cards/crimson-scales/MF/cs-mf-back.png": 502243,
	"./character-ability-cards/crimson-scales/MF/cs-mudslide.png": 317623,
	"./character-ability-cards/crimson-scales/MF/cs-neurotoxin.png": 70935,
	"./character-ability-cards/crimson-scales/MF/cs-paralytic-agent.png": 644589,
	"./character-ability-cards/crimson-scales/MF/cs-personal-poison.png": 495071,
	"./character-ability-cards/crimson-scales/MF/cs-potent-mixture.png": 577068,
	"./character-ability-cards/crimson-scales/MF/cs-radiant-forest-fungi.png": 547871,
	"./character-ability-cards/crimson-scales/MF/cs-serpents-kiss.png": 611713,
	"./character-ability-cards/crimson-scales/MF/cs-sinkhole.png": 564890,
	"./character-ability-cards/crimson-scales/MF/cs-sludge-bomb.png": 869719,
	"./character-ability-cards/crimson-scales/MF/cs-still-river-algae.png": 316265,
	"./character-ability-cards/crimson-scales/MF/cs-tainted-waters.png": 286672,
	"./character-ability-cards/crimson-scales/MF/cs-throwing-daggers.png": 518274,
	"./character-ability-cards/crimson-scales/MF/cs-twist-the-blade.png": 88744,
	"./character-ability-cards/crimson-scales/MF/cs-volatile-tonic.png": 969056,
	"./character-ability-cards/crimson-scales/MF/cs-whitefire-balm.png": 962194,
	"./character-ability-cards/crimson-scales/MF/cs-wild-stings.png": 403442,
	"./character-ability-cards/crimson-scales/QA/cs-annihilating-contraption.png": 116343,
	"./character-ability-cards/crimson-scales/QA/cs-double-barrel-railcaster.png": 460911,
	"./character-ability-cards/crimson-scales/QA/cs-elemental-condenser.png": 230721,
	"./character-ability-cards/crimson-scales/QA/cs-energy-transmission.png": 567611,
	"./character-ability-cards/crimson-scales/QA/cs-fragmentation-grenade.png": 805680,
	"./character-ability-cards/crimson-scales/QA/cs-galvanic-coil.png": 983670,
	"./character-ability-cards/crimson-scales/QA/cs-gravity-inverter-module.png": 433263,
	"./character-ability-cards/crimson-scales/QA/cs-improvised-exosuit.png": 970342,
	"./character-ability-cards/crimson-scales/QA/cs-improvised-mortar.png": 508678,
	"./character-ability-cards/crimson-scales/QA/cs-instant-relocation-matrix.png": 948545,
	"./character-ability-cards/crimson-scales/QA/cs-jury-rigged-machine.png": 496089,
	"./character-ability-cards/crimson-scales/QA/cs-launch-skywards.png": 89426,
	"./character-ability-cards/crimson-scales/QA/cs-march-of-machines.png": 603929,
	"./character-ability-cards/crimson-scales/QA/cs-oscillating-projector.png": 639841,
	"./character-ability-cards/crimson-scales/QA/cs-particle-ray-beam.png": 467648,
	"./character-ability-cards/crimson-scales/QA/cs-perfected-exosuit.png": 250275,
	"./character-ability-cards/crimson-scales/QA/cs-phase-field-emitter.png": 321735,
	"./character-ability-cards/crimson-scales/QA/cs-power-modulation.png": 965867,
	"./character-ability-cards/crimson-scales/QA/cs-qa-back.png": 632483,
	"./character-ability-cards/crimson-scales/QA/cs-ransack-clutter.png": 714655,
	"./character-ability-cards/crimson-scales/QA/cs-recycle-parts.png": 359369,
	"./character-ability-cards/crimson-scales/QA/cs-reinforce-armor.png": 855896,
	"./character-ability-cards/crimson-scales/QA/cs-remote-control.png": 710395,
	"./character-ability-cards/crimson-scales/QA/cs-repurpose-leftovers.png": 121246,
	"./character-ability-cards/crimson-scales/QA/cs-retrofit-weapons.png": 851893,
	"./character-ability-cards/crimson-scales/QA/cs-salvage-grappler.png": 556591,
	"./character-ability-cards/crimson-scales/QA/cs-seeker-missiles.png": 487746,
	"./character-ability-cards/crimson-scales/QA/cs-trajectory-diverter.png": 303580,
	"./character-ability-cards/crimson-scales/QA/cs-trudging-bulwark.png": 993805,
	"./character-ability-cards/crimson-scales/RM/cs-belly-of-the-beast.png": 53689,
	"./character-ability-cards/crimson-scales/RM/cs-berserk-barrage.png": 655290,
	"./character-ability-cards/crimson-scales/RM/cs-burning-bile.png": 513785,
	"./character-ability-cards/crimson-scales/RM/cs-caustic-claws.png": 882230,
	"./character-ability-cards/crimson-scales/RM/cs-cornered-animal.png": 482726,
	"./character-ability-cards/crimson-scales/RM/cs-corrosive-spew.png": 851414,
	"./character-ability-cards/crimson-scales/RM/cs-devour-whole.png": 863837,
	"./character-ability-cards/crimson-scales/RM/cs-easy-prey.png": 809585,
	"./character-ability-cards/crimson-scales/RM/cs-fatal-frenzy.png": 826692,
	"./character-ability-cards/crimson-scales/RM/cs-feast-of-flesh.png": 810079,
	"./character-ability-cards/crimson-scales/RM/cs-feral-lunge.png": 573131,
	"./character-ability-cards/crimson-scales/RM/cs-ferocious-fling.png": 559268,
	"./character-ability-cards/crimson-scales/RM/cs-fight-or-flight.png": 956143,
	"./character-ability-cards/crimson-scales/RM/cs-heartripper.png": 466307,
	"./character-ability-cards/crimson-scales/RM/cs-indomitable-craving.png": 988450,
	"./character-ability-cards/crimson-scales/RM/cs-lie-in-wait.png": 306483,
	"./character-ability-cards/crimson-scales/RM/cs-nourishing-meal.png": 466139,
	"./character-ability-cards/crimson-scales/RM/cs-pouncing-predator.png": 715462,
	"./character-ability-cards/crimson-scales/RM/cs-ravenous-roar.png": 147047,
	"./character-ability-cards/crimson-scales/RM/cs-reckless-attack.png": 797653,
	"./character-ability-cards/crimson-scales/RM/cs-rend-and-mutilate.png": 247283,
	"./character-ability-cards/crimson-scales/RM/cs-rip-and-tear.png": 749423,
	"./character-ability-cards/crimson-scales/RM/cs-rm-back.png": 266626,
	"./character-ability-cards/crimson-scales/RM/cs-savage-stalker.png": 599931,
	"./character-ability-cards/crimson-scales/RM/cs-scrape-and-scrounge.png": 156568,
	"./character-ability-cards/crimson-scales/RM/cs-seize.png": 737946,
	"./character-ability-cards/crimson-scales/RM/cs-slake-thirst.png": 609848,
	"./character-ability-cards/crimson-scales/RM/cs-strip-the-flesh.png": 518773,
	"./character-ability-cards/crimson-scales/RM/cs-survival-instincts.png": 467061,
	"./character-ability-cards/crimson-scales/RM/cs-terrifying-howl.png": 218538,
	"./character-ability-cards/crimson-scales/RM/cs-voracious-hunter.png": 995738,
	"./character-ability-cards/crimson-scales/SP/cs-burning-pit.png": 889652,
	"./character-ability-cards/crimson-scales/SP/cs-chilling-slice.png": 672142,
	"./character-ability-cards/crimson-scales/SP/cs-circle-of-lifeless.png": 259844,
	"./character-ability-cards/crimson-scales/SP/cs-confidence-ritual.png": 566158,
	"./character-ability-cards/crimson-scales/SP/cs-death-is-not-defeat.png": 225497,
	"./character-ability-cards/crimson-scales/SP/cs-decaying-daggers.png": 780129,
	"./character-ability-cards/crimson-scales/SP/cs-dimmed-defense.png": 23567,
	"./character-ability-cards/crimson-scales/SP/cs-eternal-endurance.png": 255267,
	"./character-ability-cards/crimson-scales/SP/cs-ethereal-canine.png": 157261,
	"./character-ability-cards/crimson-scales/SP/cs-fear-the-reaper.png": 996062,
	"./character-ability-cards/crimson-scales/SP/cs-fierce-loyalty.png": 622416,
	"./character-ability-cards/crimson-scales/SP/cs-flurry-of-madness.png": 17693,
	"./character-ability-cards/crimson-scales/SP/cs-forceful-apparition.png": 473253,
	"./character-ability-cards/crimson-scales/SP/cs-horde-of-bones.png": 13848,
	"./character-ability-cards/crimson-scales/SP/cs-horrific-nightmare.png": 258180,
	"./character-ability-cards/crimson-scales/SP/cs-incorporeal-transport.png": 429159,
	"./character-ability-cards/crimson-scales/SP/cs-midnight-feast.png": 18838,
	"./character-ability-cards/crimson-scales/SP/cs-rise-from-ashes.png": 656640,
	"./character-ability-cards/crimson-scales/SP/cs-shamanistic-guard.png": 965957,
	"./character-ability-cards/crimson-scales/SP/cs-shrieking-spirit.png": 359494,
	"./character-ability-cards/crimson-scales/SP/cs-smoky-shroud.png": 947393,
	"./character-ability-cards/crimson-scales/SP/cs-soul-harvest.png": 95210,
	"./character-ability-cards/crimson-scales/SP/cs-sp-back.png": 45827,
	"./character-ability-cards/crimson-scales/SP/cs-spirit-barrage.png": 972304,
	"./character-ability-cards/crimson-scales/SP/cs-spiritual-energy.png": 720675,
	"./character-ability-cards/crimson-scales/SP/cs-spread-disease.png": 275919,
	"./character-ability-cards/crimson-scales/SP/cs-toxic-charm.png": 752418,
	"./character-ability-cards/crimson-scales/SP/cs-unholy-sacrifice.png": 932558,
	"./character-ability-cards/crimson-scales/SP/cs-whistling-winds.png": 522396,
	"./character-ability-cards/crimson-scales/SP/cs-white-glow.png": 278977,
	"./character-ability-cards/crimson-scales/ST/cs-absolute-magnitude.png": 178012,
	"./character-ability-cards/crimson-scales/ST/cs-absorbing-light.png": 66715,
	"./character-ability-cards/crimson-scales/ST/cs-aligned-constellations.png": 436417,
	"./character-ability-cards/crimson-scales/ST/cs-blue-moon.png": 115054,
	"./character-ability-cards/crimson-scales/ST/cs-celestial-maneuver.png": 425308,
	"./character-ability-cards/crimson-scales/ST/cs-crashing-flare.png": 912082,
	"./character-ability-cards/crimson-scales/ST/cs-defying-gravity.png": 488426,
	"./character-ability-cards/crimson-scales/ST/cs-diamond-rings.png": 897844,
	"./character-ability-cards/crimson-scales/ST/cs-earthshine.png": 152573,
	"./character-ability-cards/crimson-scales/ST/cs-eonic-blast.png": 588938,
	"./character-ability-cards/crimson-scales/ST/cs-equinox.png": 612152,
	"./character-ability-cards/crimson-scales/ST/cs-force-field.png": 269159,
	"./character-ability-cards/crimson-scales/ST/cs-gravitational-flip.png": 256238,
	"./character-ability-cards/crimson-scales/ST/cs-interplanar-voyager.png": 207160,
	"./character-ability-cards/crimson-scales/ST/cs-light-pollution.png": 144951,
	"./character-ability-cards/crimson-scales/ST/cs-lost-in-the-stars.png": 668483,
	"./character-ability-cards/crimson-scales/ST/cs-lucky-stars.png": 459636,
	"./character-ability-cards/crimson-scales/ST/cs-luminous-blitz.png": 689309,
	"./character-ability-cards/crimson-scales/ST/cs-pierce-the-firmament.png": 139689,
	"./character-ability-cards/crimson-scales/ST/cs-plasmatic-power.png": 745562,
	"./character-ability-cards/crimson-scales/ST/cs-proportional-exchange.png": 328484,
	"./character-ability-cards/crimson-scales/ST/cs-shifting-chasma.png": 734559,
	"./character-ability-cards/crimson-scales/ST/cs-shooting-stars.png": 123912,
	"./character-ability-cards/crimson-scales/ST/cs-solar-eclipse.png": 460503,
	"./character-ability-cards/crimson-scales/ST/cs-st-back.png": 129862,
	"./character-ability-cards/crimson-scales/ST/cs-starstruck.png": 430307,
	"./character-ability-cards/crimson-scales/ST/cs-stone-meteorite.png": 124354,
	"./character-ability-cards/crimson-scales/ST/cs-sungaze.png": 340623,
	"./character-ability-cards/crimson-scales/ST/cs-supernova.png": 863488,
	"./character-ability-cards/crimson-scales/ST/cs-wish-upon-a-star.png": 931896,
	"./character-ability-cards/forgotten-circles/DR/fc-anguish-and-salvation.png": 882146,
	"./character-ability-cards/forgotten-circles/DR/fc-anticipate-intricacies.png": 139821,
	"./character-ability-cards/forgotten-circles/DR/fc-bad-omen.png": 170263,
	"./character-ability-cards/forgotten-circles/DR/fc-call-of-the-nether.png": 101226,
	"./character-ability-cards/forgotten-circles/DR/fc-careful-attunement.png": 698134,
	"./character-ability-cards/forgotten-circles/DR/fc-clairvoyance.png": 732141,
	"./character-ability-cards/forgotten-circles/DR/fc-cleansing-rite.png": 610815,
	"./character-ability-cards/forgotten-circles/DR/fc-curative-flux.png": 342994,
	"./character-ability-cards/forgotten-circles/DR/fc-cursed-ground.png": 666969,
	"./character-ability-cards/forgotten-circles/DR/fc-deep-contemplation.png": 60588,
	"./character-ability-cards/forgotten-circles/DR/fc-dimensional-divide.png": 185078,
	"./character-ability-cards/forgotten-circles/DR/fc-dimensional-transfer.png": 139021,
	"./character-ability-cards/forgotten-circles/DR/fc-dr-back.png": 866166,
	"./character-ability-cards/forgotten-circles/DR/fc-duality-shards.png": 483961,
	"./character-ability-cards/forgotten-circles/DR/fc-enfeebling-hex.png": 833541,
	"./character-ability-cards/forgotten-circles/DR/fc-envision-the-course.png": 694429,
	"./character-ability-cards/forgotten-circles/DR/fc-ethereal-vortex.png": 838329,
	"./character-ability-cards/forgotten-circles/DR/fc-gift-of-the-void.png": 366631,
	"./character-ability-cards/forgotten-circles/DR/fc-hand-of-destiny.png": 282698,
	"./character-ability-cards/forgotten-circles/DR/fc-inspiration-from-beyond.png": 642471,
	"./character-ability-cards/forgotten-circles/DR/fc-otherworldly-journey.png": 947991,
	"./character-ability-cards/forgotten-circles/DR/fc-peer-into-battle.png": 703131,
	"./character-ability-cards/forgotten-circles/DR/fc-planar-fissure.png": 357857,
	"./character-ability-cards/forgotten-circles/DR/fc-preordain-the-path.png": 252461,
	"./character-ability-cards/forgotten-circles/DR/fc-protective-aura.png": 348819,
	"./character-ability-cards/forgotten-circles/DR/fc-ray-of-light.png": 125126,
	"./character-ability-cards/forgotten-circles/DR/fc-revitalizing-fount.png": 836881,
	"./character-ability-cards/forgotten-circles/DR/fc-seal-their-fate.png": 123416,
	"./character-ability-cards/forgotten-circles/DR/fc-void-snare.png": 792848,
	"./character-ability-cards/forgotten-circles/ZZ/zz.txt": 120617,
	"./character-ability-cards/frosthaven/BB/fh-bb-back.png": 317311,
	"./character-ability-cards/frosthaven/BB/fh-blurry-jab.png": 953984,
	"./character-ability-cards/frosthaven/BB/fh-borrowed-time.png": 508281,
	"./character-ability-cards/frosthaven/BB/fh-breakneck-speed.png": 708355,
	"./character-ability-cards/frosthaven/BB/fh-cascading-reaction.png": 459224,
	"./character-ability-cards/frosthaven/BB/fh-double-time.png": 441687,
	"./character-ability-cards/frosthaven/BB/fh-drive-recharge.png": 316194,
	"./character-ability-cards/frosthaven/BB/fh-experimental-adjustment.png": 443034,
	"./character-ability-cards/frosthaven/BB/fh-fastest-alive.png": 745633,
	"./character-ability-cards/frosthaven/BB/fh-flashing-flurry.png": 515319,
	"./character-ability-cards/frosthaven/BB/fh-fractured-timeline.png": 864020,
	"./character-ability-cards/frosthaven/BB/fh-hit-and-run.png": 817496,
	"./character-ability-cards/frosthaven/BB/fh-kinetic-transfer.png": 646042,
	"./character-ability-cards/frosthaven/BB/fh-make-it-count.png": 896848,
	"./character-ability-cards/frosthaven/BB/fh-overdrive.png": 411733,
	"./character-ability-cards/frosthaven/BB/fh-phasing-blades.png": 15332,
	"./character-ability-cards/frosthaven/BB/fh-potential-energy.png": 409823,
	"./character-ability-cards/frosthaven/BB/fh-power-leak.png": 614741,
	"./character-ability-cards/frosthaven/BB/fh-precision-timing.png": 726743,
	"./character-ability-cards/frosthaven/BB/fh-quantum-uncertainty.png": 128258,
	"./character-ability-cards/frosthaven/BB/fh-reckless-augmentation.png": 613809,
	"./character-ability-cards/frosthaven/BB/fh-reverse-the-flow.png": 445990,
	"./character-ability-cards/frosthaven/BB/fh-rushed-to-the-end.png": 386425,
	"./character-ability-cards/frosthaven/BB/fh-sand-in-the-hourglass.png": 401135,
	"./character-ability-cards/frosthaven/BB/fh-sap-speed.png": 510750,
	"./character-ability-cards/frosthaven/BB/fh-stab-them-all.png": 470443,
	"./character-ability-cards/frosthaven/BB/fh-systems-reboot.png": 843851,
	"./character-ability-cards/frosthaven/BB/fh-temporal-displacement.png": 585263,
	"./character-ability-cards/frosthaven/BB/fh-the-knifes-edge.png": 256190,
	"./character-ability-cards/frosthaven/BB/fh-twin-strike.png": 4140,
	"./character-ability-cards/frosthaven/BN/fh-air-support.png": 139880,
	"./character-ability-cards/frosthaven/BN/fh-at-all-costs.png": 755986,
	"./character-ability-cards/frosthaven/BN/fh-barricade.png": 243992,
	"./character-ability-cards/frosthaven/BN/fh-bn-back.png": 205979,
	"./character-ability-cards/frosthaven/BN/fh-boldening-blow.png": 259169,
	"./character-ability-cards/frosthaven/BN/fh-bolstering-shout.png": 597130,
	"./character-ability-cards/frosthaven/BN/fh-combined-effort.png": 89293,
	"./character-ability-cards/frosthaven/BN/fh-deflecting-maneuver.png": 928986,
	"./character-ability-cards/frosthaven/BN/fh-driving-inspiration.png": 961210,
	"./character-ability-cards/frosthaven/BN/fh-explosive-epicenter.png": 457250,
	"./character-ability-cards/frosthaven/BN/fh-hail-of-spears.png": 101389,
	"./character-ability-cards/frosthaven/BN/fh-head-of-the-hammer.png": 119577,
	"./character-ability-cards/frosthaven/BN/fh-hold-the-line.png": 881997,
	"./character-ability-cards/frosthaven/BN/fh-incendiary-throw.png": 913506,
	"./character-ability-cards/frosthaven/BN/fh-javelin.png": 17799,
	"./character-ability-cards/frosthaven/BN/fh-lead-from-afar.png": 502355,
	"./character-ability-cards/frosthaven/BN/fh-let-them-come.png": 604031,
	"./character-ability-cards/frosthaven/BN/fh-meat-grinder.png": 539499,
	"./character-ability-cards/frosthaven/BN/fh-pincer-movement.png": 166699,
	"./character-ability-cards/frosthaven/BN/fh-pinning-charge.png": 368411,
	"./character-ability-cards/frosthaven/BN/fh-rallying-cry.png": 922248,
	"./character-ability-cards/frosthaven/BN/fh-regroup.png": 583861,
	"./character-ability-cards/frosthaven/BN/fh-resolved-courage.png": 587105,
	"./character-ability-cards/frosthaven/BN/fh-set-for-the-charge.png": 963445,
	"./character-ability-cards/frosthaven/BN/fh-sweeping-aid.png": 533055,
	"./character-ability-cards/frosthaven/BN/fh-take-no-prisoners.png": 199871,
	"./character-ability-cards/frosthaven/BN/fh-taunting-howl.png": 159468,
	"./character-ability-cards/frosthaven/BN/fh-tip-of-the-spear.png": 366847,
	"./character-ability-cards/frosthaven/BN/fh-tri-thrust.png": 798933,
	"./character-ability-cards/frosthaven/BN/fh-unbreakable-wall.png": 537129,
	"./character-ability-cards/frosthaven/BO/fh-angry-spirits.png": 169827,
	"./character-ability-cards/frosthaven/BO/fh-approach-oblivion.png": 939264,
	"./character-ability-cards/frosthaven/BO/fh-behold-the-shrouded-sun.png": 426603,
	"./character-ability-cards/frosthaven/BO/fh-bo-back.png": 487640,
	"./character-ability-cards/frosthaven/BO/fh-bone-dagger.png": 37209,
	"./character-ability-cards/frosthaven/BO/fh-command-the-wretched.png": 487783,
	"./character-ability-cards/frosthaven/BO/fh-critical-failure.png": 99092,
	"./character-ability-cards/frosthaven/BO/fh-damned-horde.png": 200100,
	"./character-ability-cards/frosthaven/BO/fh-dark-tidings.png": 256565,
	"./character-ability-cards/frosthaven/BO/fh-decaying-will.png": 401312,
	"./character-ability-cards/frosthaven/BO/fh-endless-numbers.png": 725187,
	"./character-ability-cards/frosthaven/BO/fh-eternal-torment.png": 63243,
	"./character-ability-cards/frosthaven/BO/fh-exploding-corpse.png": 950642,
	"./character-ability-cards/frosthaven/BO/fh-fell-remedy.png": 229550,
	"./character-ability-cards/frosthaven/BO/fh-flesh-shield.png": 245746,
	"./character-ability-cards/frosthaven/BO/fh-flow-of-the-black-river.png": 744611,
	"./character-ability-cards/frosthaven/BO/fh-grave-digging.png": 519623,
	"./character-ability-cards/frosthaven/BO/fh-life-in-death.png": 691726,
	"./character-ability-cards/frosthaven/BO/fh-malicious-conversion.png": 655637,
	"./character-ability-cards/frosthaven/BO/fh-putrid-cloud.png": 865735,
	"./character-ability-cards/frosthaven/BO/fh-recycled-limbs.png": 916677,
	"./character-ability-cards/frosthaven/BO/fh-returned-servant.png": 608498,
	"./character-ability-cards/frosthaven/BO/fh-rotting-multitude.png": 333232,
	"./character-ability-cards/frosthaven/BO/fh-solid-bones.png": 539941,
	"./character-ability-cards/frosthaven/BO/fh-soul-claim.png": 125005,
	"./character-ability-cards/frosthaven/BO/fh-transfer-of-essence.png": 185381,
	"./character-ability-cards/frosthaven/BO/fh-twisted-decree.png": 198515,
	"./character-ability-cards/frosthaven/BO/fh-unearthed-horror.png": 998994,
	"./character-ability-cards/frosthaven/BO/fh-unforgivable-methods.png": 662526,
	"./character-ability-cards/frosthaven/BO/fh-unholy-prowess.png": 817005,
	"./character-ability-cards/frosthaven/BO/fh-wailing-from-beyond.png": 630967,
	"./character-ability-cards/frosthaven/BO/fh-wrath-of-the-turned-earth.png": 687697,
	"./character-ability-cards/frosthaven/CR/fh-blood-in-the-water.png": 400505,
	"./character-ability-cards/frosthaven/CR/fh-chaotic-refraction.png": 512717,
	"./character-ability-cards/frosthaven/CR/fh-clean-sweep.png": 100921,
	"./character-ability-cards/frosthaven/CR/fh-cleansing-swell.png": 866559,
	"./character-ability-cards/frosthaven/CR/fh-cr-back.png": 440687,
	"./character-ability-cards/frosthaven/CR/fh-crashing-surge.png": 176464,
	"./character-ability-cards/frosthaven/CR/fh-cresting-force.png": 300766,
	"./character-ability-cards/frosthaven/CR/fh-crush-armor.png": 981434,
	"./character-ability-cards/frosthaven/CR/fh-death-on-all-sides.png": 783686,
	"./character-ability-cards/frosthaven/CR/fh-down-to-the-depths.png": 220457,
	"./character-ability-cards/frosthaven/CR/fh-drown-beneath-the-waves.png": 776117,
	"./character-ability-cards/frosthaven/CR/fh-dug-in.png": 933914,
	"./character-ability-cards/frosthaven/CR/fh-ebb-and-flow.png": 319956,
	"./character-ability-cards/frosthaven/CR/fh-endless-cycle.png": 625004,
	"./character-ability-cards/frosthaven/CR/fh-high-tide.png": 57729,
	"./character-ability-cards/frosthaven/CR/fh-low-tide.png": 294233,
	"./character-ability-cards/frosthaven/CR/fh-mighty-claws.png": 503077,
	"./character-ability-cards/frosthaven/CR/fh-overwhelming-wave.png": 448314,
	"./character-ability-cards/frosthaven/CR/fh-pool-of-power.png": 359915,
	"./character-ability-cards/frosthaven/CR/fh-powerful-pincer.png": 742565,
	"./character-ability-cards/frosthaven/CR/fh-rancid-brine.png": 87705,
	"./character-ability-cards/frosthaven/CR/fh-rising-flood.png": 2229,
	"./character-ability-cards/frosthaven/CR/fh-sharp-chitin.png": 339165,
	"./character-ability-cards/frosthaven/CR/fh-shuck.png": 994359,
	"./character-ability-cards/frosthaven/CR/fh-skitter.png": 899825,
	"./character-ability-cards/frosthaven/CR/fh-smashing-torrent.png": 432775,
	"./character-ability-cards/frosthaven/CR/fh-sodden-soil.png": 730088,
	"./character-ability-cards/frosthaven/CR/fh-soft-flesh.png": 740907,
	"./character-ability-cards/frosthaven/CR/fh-submerge.png": 81830,
	"./character-ability-cards/frosthaven/CR/fh-tidal-blast.png": 469939,
	"./character-ability-cards/frosthaven/CR/fh-twilight-grasp.png": 522308,
	"./character-ability-cards/frosthaven/CR/fh-undertow.png": 599420,
	"./character-ability-cards/frosthaven/DF/fh-accurate-strikes.png": 702280,
	"./character-ability-cards/frosthaven/DF/fh-against-all-odds.png": 471456,
	"./character-ability-cards/frosthaven/DF/fh-bloodletting.png": 438331,
	"./character-ability-cards/frosthaven/DF/fh-break-through.png": 666338,
	"./character-ability-cards/frosthaven/DF/fh-chunk-of-flesh.png": 235604,
	"./character-ability-cards/frosthaven/DF/fh-consume-stamina.png": 665562,
	"./character-ability-cards/frosthaven/DF/fh-continuous-health.png": 357417,
	"./character-ability-cards/frosthaven/DF/fh-crushing-weight.png": 643425,
	"./character-ability-cards/frosthaven/DF/fh-deadly-shot.png": 374321,
	"./character-ability-cards/frosthaven/DF/fh-destructive-fury.png": 556153,
	"./character-ability-cards/frosthaven/DF/fh-df-back.png": 182933,
	"./character-ability-cards/frosthaven/DF/fh-draining-arrows.png": 395686,
	"./character-ability-cards/frosthaven/DF/fh-dual-bow.png": 846878,
	"./character-ability-cards/frosthaven/DF/fh-ever-forward.png": 320672,
	"./character-ability-cards/frosthaven/DF/fh-everlasting.png": 837428,
	"./character-ability-cards/frosthaven/DF/fh-fierce-barrage.png": 966054,
	"./character-ability-cards/frosthaven/DF/fh-fortitude.png": 308319,
	"./character-ability-cards/frosthaven/DF/fh-gift-of-the-prey.png": 436884,
	"./character-ability-cards/frosthaven/DF/fh-inevitable-conclusion.png": 752270,
	"./character-ability-cards/frosthaven/DF/fh-like-the-wind.png": 214344,
	"./character-ability-cards/frosthaven/DF/fh-no-remorse.png": 668518,
	"./character-ability-cards/frosthaven/DF/fh-precision-aim.png": 792371,
	"./character-ability-cards/frosthaven/DF/fh-prudent-preparation.png": 314979,
	"./character-ability-cards/frosthaven/DF/fh-relentless.png": 246444,
	"./character-ability-cards/frosthaven/DF/fh-shockwave.png": 562345,
	"./character-ability-cards/frosthaven/DF/fh-survivalist.png": 533062,
	"./character-ability-cards/frosthaven/DF/fh-sustained-momentum.png": 828243,
	"./character-ability-cards/frosthaven/DF/fh-unbreakable.png": 755654,
	"./character-ability-cards/frosthaven/DF/fh-unending-fight.png": 800796,
	"./character-ability-cards/frosthaven/DF/fh-use-every-part.png": 506906,
	"./character-ability-cards/frosthaven/DF/fh-vile-assault.png": 78009,
	"./character-ability-cards/frosthaven/DF/fh-violent-inheritance.png": 232919,
	"./character-ability-cards/frosthaven/DT/fh-black-night-of-the-deep.png": 644673,
	"./character-ability-cards/frosthaven/DT/fh-black-scythe.png": 969178,
	"./character-ability-cards/frosthaven/DT/fh-claw-of-doom.png": 341499,
	"./character-ability-cards/frosthaven/DT/fh-consume-the-helpless.png": 672561,
	"./character-ability-cards/frosthaven/DT/fh-crippling-terror.png": 354819,
	"./character-ability-cards/frosthaven/DT/fh-crushing-darkness.png": 492672,
	"./character-ability-cards/frosthaven/DT/fh-death-spiral.png": 302538,
	"./character-ability-cards/frosthaven/DT/fh-dire-frenzy.png": 569774,
	"./character-ability-cards/frosthaven/DT/fh-dt-back.png": 304453,
	"./character-ability-cards/frosthaven/DT/fh-extra-decoration.png": 654223,
	"./character-ability-cards/frosthaven/DT/fh-grim-trophies.png": 817901,
	"./character-ability-cards/frosthaven/DT/fh-hasten-the-end.png": 486017,
	"./character-ability-cards/frosthaven/DT/fh-haunting-brutality.png": 99572,
	"./character-ability-cards/frosthaven/DT/fh-hollow-aura.png": 1509,
	"./character-ability-cards/frosthaven/DT/fh-ink-cloud.png": 661482,
	"./character-ability-cards/frosthaven/DT/fh-lacerating-stabs.png": 250232,
	"./character-ability-cards/frosthaven/DT/fh-lie-in-wait.png": 427067,
	"./character-ability-cards/frosthaven/DT/fh-mantle-of-dread.png": 928762,
	"./character-ability-cards/frosthaven/DT/fh-morbid-camouflage.png": 310219,
	"./character-ability-cards/frosthaven/DT/fh-pinning-spines.png": 799723,
	"./character-ability-cards/frosthaven/DT/fh-rip-from-the-bone.png": 985243,
	"./character-ability-cards/frosthaven/DT/fh-skewer-the-flesh.png": 882310,
	"./character-ability-cards/frosthaven/DT/fh-skull-collection.png": 211219,
	"./character-ability-cards/frosthaven/DT/fh-slipping-into-death.png": 551434,
	"./character-ability-cards/frosthaven/DT/fh-soul-hunger.png": 403841,
	"./character-ability-cards/frosthaven/DT/fh-staring-into-the-abyss.png": 85675,
	"./character-ability-cards/frosthaven/DT/fh-succumb-to-fear.png": 487216,
	"./character-ability-cards/frosthaven/DT/fh-the-remorseless-deep.png": 896616,
	"./character-ability-cards/frosthaven/DT/fh-tumultuous-panic.png": 498754,
	"./character-ability-cards/frosthaven/DT/fh-unseen-horror.png": 957307,
	"./character-ability-cards/frosthaven/DW/fh-anger-of-the-dead.png": 781109,
	"./character-ability-cards/frosthaven/DW/fh-black-barrage.png": 470342,
	"./character-ability-cards/frosthaven/DW/fh-black-lance.png": 457977,
	"./character-ability-cards/frosthaven/DW/fh-call-of-doom.png": 348686,
	"./character-ability-cards/frosthaven/DW/fh-call-to-the-abyss.png": 454290,
	"./character-ability-cards/frosthaven/DW/fh-dark-fog.png": 400087,
	"./character-ability-cards/frosthaven/DW/fh-dead-bolt.png": 42570,
	"./character-ability-cards/frosthaven/DW/fh-deepening-despair.png": 541549,
	"./character-ability-cards/frosthaven/DW/fh-dominate.png": 636014,
	"./character-ability-cards/frosthaven/DW/fh-dw-back.png": 369378,
	"./character-ability-cards/frosthaven/DW/fh-eclipse.png": 417121,
	"./character-ability-cards/frosthaven/DW/fh-fleeting-dusk.png": 223875,
	"./character-ability-cards/frosthaven/DW/fh-fluid-night.png": 451341,
	"./character-ability-cards/frosthaven/DW/fh-forceful-spirits.png": 802094,
	"./character-ability-cards/frosthaven/DW/fh-frozen-in-fear.png": 350764,
	"./character-ability-cards/frosthaven/DW/fh-hungry-grasps.png": 59517,
	"./character-ability-cards/frosthaven/DW/fh-lashing-tendrils.png": 237067,
	"./character-ability-cards/frosthaven/DW/fh-lingering-rot.png": 234543,
	"./character-ability-cards/frosthaven/DW/fh-medium.png": 339071,
	"./character-ability-cards/frosthaven/DW/fh-proliferation-of-the-abyss.png": 978371,
	"./character-ability-cards/frosthaven/DW/fh-pulled-across.png": 829020,
	"./character-ability-cards/frosthaven/DW/fh-rest-in-the-shade.png": 384910,
	"./character-ability-cards/frosthaven/DW/fh-restless-spirits.png": 737279,
	"./character-ability-cards/frosthaven/DW/fh-ritual-sacrifice.png": 133523,
	"./character-ability-cards/frosthaven/DW/fh-shadow-step.png": 339022,
	"./character-ability-cards/frosthaven/DW/fh-strength-of-the-abyss.png": 468814,
	"./character-ability-cards/frosthaven/DW/fh-sunless-apparition.png": 111112,
	"./character-ability-cards/frosthaven/DW/fh-the-night-takes-shape.png": 473832,
	"./character-ability-cards/frosthaven/DW/fh-vengeful-storm.png": 956216,
	"./character-ability-cards/frosthaven/DW/fh-wave-of-anguish.png": 29918,
	"./character-ability-cards/frosthaven/DW/fh-when-your-time-comes.png": 613492,
	"./character-ability-cards/frosthaven/FF/fh-bring-down-the-mountain.png": 859510,
	"./character-ability-cards/frosthaven/FF/fh-cold-boulder.png": 751688,
	"./character-ability-cards/frosthaven/FF/fh-crushing-crystals.png": 380697,
	"./character-ability-cards/frosthaven/FF/fh-draw-of-the-bedrock.png": 323783,
	"./character-ability-cards/frosthaven/FF/fh-draw-strength.png": 471199,
	"./character-ability-cards/frosthaven/FF/fh-encased-punch.png": 846635,
	"./character-ability-cards/frosthaven/FF/fh-ff-back.png": 197382,
	"./character-ability-cards/frosthaven/FF/fh-freezing-shell.png": 203103,
	"./character-ability-cards/frosthaven/FF/fh-frost-eruption.png": 476023,
	"./character-ability-cards/frosthaven/FF/fh-frozen-over.png": 553031,
	"./character-ability-cards/frosthaven/FF/fh-frozen-spike.png": 91622,
	"./character-ability-cards/frosthaven/FF/fh-fury-of-the-mountain.png": 197965,
	"./character-ability-cards/frosthaven/FF/fh-gift-of-the-mountain.png": 717838,
	"./character-ability-cards/frosthaven/FF/fh-glacier-slam.png": 840146,
	"./character-ability-cards/frosthaven/FF/fh-ice-blast.png": 903105,
	"./character-ability-cards/frosthaven/FF/fh-ice-uppercut.png": 320335,
	"./character-ability-cards/frosthaven/FF/fh-lacerating-eruption.png": 876699,
	"./character-ability-cards/frosthaven/FF/fh-one-with-the-mountain.png": 561071,
	"./character-ability-cards/frosthaven/FF/fh-packed-solid.png": 293070,
	"./character-ability-cards/frosthaven/FF/fh-piercing-pummel.png": 135484,
	"./character-ability-cards/frosthaven/FF/fh-preserved-fury.png": 947834,
	"./character-ability-cards/frosthaven/FF/fh-primal-bellow.png": 147210,
	"./character-ability-cards/frosthaven/FF/fh-seeing-stars.png": 662775,
	"./character-ability-cards/frosthaven/FF/fh-shard-launch.png": 258013,
	"./character-ability-cards/frosthaven/FF/fh-shattering-blow.png": 461924,
	"./character-ability-cards/frosthaven/FF/fh-the-mountains-fist.png": 113590,
	"./character-ability-cards/frosthaven/FF/fh-thick-frost.png": 161559,
	"./character-ability-cards/frosthaven/FF/fh-voice-from-below.png": 309479,
	"./character-ability-cards/frosthaven/GE/fh-accelerated-metabolism.png": 343493,
	"./character-ability-cards/frosthaven/GE/fh-alluring-pheromones.png": 37955,
	"./character-ability-cards/frosthaven/GE/fh-changelings-boon.png": 948034,
	"./character-ability-cards/frosthaven/GE/fh-chitinous-horde.png": 591584,
	"./character-ability-cards/frosthaven/GE/fh-corrosive-acids.png": 483604,
	"./character-ability-cards/frosthaven/GE/fh-drag-down.png": 649647,
	"./character-ability-cards/frosthaven/GE/fh-dragonfly-surge.png": 489350,
	"./character-ability-cards/frosthaven/GE/fh-draining-pincers.png": 266673,
	"./character-ability-cards/frosthaven/GE/fh-feeding-frenzy.png": 601010,
	"./character-ability-cards/frosthaven/GE/fh-firefly-swarm.png": 586273,
	"./character-ability-cards/frosthaven/GE/fh-flailing-tendrils.png": 283945,
	"./character-ability-cards/frosthaven/GE/fh-formless-grace.png": 313947,
	"./character-ability-cards/frosthaven/GE/fh-ge-back.png": 515897,
	"./character-ability-cards/frosthaven/GE/fh-hail-of-thorns.png": 631205,
	"./character-ability-cards/frosthaven/GE/fh-harbinger-of-ruin.png": 996604,
	"./character-ability-cards/frosthaven/GE/fh-harvest-the-essence.png": 315361,
	"./character-ability-cards/frosthaven/GE/fh-hirudotherapy.png": 632902,
	"./character-ability-cards/frosthaven/GE/fh-hornbeetle-carapace.png": 874439,
	"./character-ability-cards/frosthaven/GE/fh-hornet-stingers.png": 707143,
	"./character-ability-cards/frosthaven/GE/fh-icebound-quills.png": 331444,
	"./character-ability-cards/frosthaven/GE/fh-into-my-embrace.png": 92235,
	"./character-ability-cards/frosthaven/GE/fh-locust-host.png": 649603,
	"./character-ability-cards/frosthaven/GE/fh-luminous-descent.png": 116754,
	"./character-ability-cards/frosthaven/GE/fh-mandible-storm.png": 171818,
	"./character-ability-cards/frosthaven/GE/fh-mind-spike.png": 352088,
	"./character-ability-cards/frosthaven/GE/fh-oscillating-entity.png": 212524,
	"./character-ability-cards/frosthaven/GE/fh-reckless-jab.png": 153602,
	"./character-ability-cards/frosthaven/GE/fh-reshape-the-guise.png": 120198,
	"./character-ability-cards/frosthaven/GE/fh-scarab-flight.png": 834349,
	"./character-ability-cards/frosthaven/GE/fh-selfless-offering.png": 231407,
	"./character-ability-cards/frosthaven/GE/fh-smoldering-hatred.png": 128171,
	"./character-ability-cards/frosthaven/GE/fh-thresh-and-flail.png": 779129,
	"./character-ability-cards/frosthaven/GE/fh-two-pronged-entrapment.png": 226763,
	"./character-ability-cards/frosthaven/GE/fh-venomous-barbs.png": 752982,
	"./character-ability-cards/frosthaven/GE/fh-voice-of-salvation.png": 979446,
	"./character-ability-cards/frosthaven/HV/fh-aimed-assault.png": 290469,
	"./character-ability-cards/frosthaven/HV/fh-burning-slash.png": 816831,
	"./character-ability-cards/frosthaven/HV/fh-code-geminate.png": 326703,
	"./character-ability-cards/frosthaven/HV/fh-coiled-limbs.png": 810346,
	"./character-ability-cards/frosthaven/HV/fh-disassemble.png": 79295,
	"./character-ability-cards/frosthaven/HV/fh-divergent-destruction.png": 169792,
	"./character-ability-cards/frosthaven/HV/fh-faceless-entity.png": 406970,
	"./character-ability-cards/frosthaven/HV/fh-force-field.png": 701602,
	"./character-ability-cards/frosthaven/HV/fh-heavy-metal.png": 253024,
	"./character-ability-cards/frosthaven/HV/fh-high-impact-projectiles.png": 482112,
	"./character-ability-cards/frosthaven/HV/fh-hijack.png": 81935,
	"./character-ability-cards/frosthaven/HV/fh-hunter-killer.png": 180992,
	"./character-ability-cards/frosthaven/HV/fh-hv-back.png": 623537,
	"./character-ability-cards/frosthaven/HV/fh-interference.png": 388525,
	"./character-ability-cards/frosthaven/HV/fh-launch-pod.png": 83355,
	"./character-ability-cards/frosthaven/HV/fh-long-range-missile.png": 891097,
	"./character-ability-cards/frosthaven/HV/fh-mortar-shells.png": 370535,
	"./character-ability-cards/frosthaven/HV/fh-net-dispersal.png": 963497,
	"./character-ability-cards/frosthaven/HV/fh-plague-protocol.png": 38166,
	"./character-ability-cards/frosthaven/HV/fh-plated-defense.png": 517152,
	"./character-ability-cards/frosthaven/HV/fh-prepare-for-deployment.png": 587880,
	"./character-ability-cards/frosthaven/HV/fh-rapid-fire.png": 979370,
	"./character-ability-cards/frosthaven/HV/fh-reaper-function.png": 156143,
	"./character-ability-cards/frosthaven/HV/fh-reassemble.png": 682599,
	"./character-ability-cards/frosthaven/HV/fh-recall.png": 258204,
	"./character-ability-cards/frosthaven/HV/fh-reconstructive-aid.png": 271304,
	"./character-ability-cards/frosthaven/HV/fh-remote-control.png": 583499,
	"./character-ability-cards/frosthaven/HV/fh-shocking-pulse.png": 52683,
	"./character-ability-cards/frosthaven/HV/fh-spinning-blades.png": 814971,
	"./character-ability-cards/frosthaven/HV/fh-swarming-bulwark.png": 683520,
	"./character-ability-cards/frosthaven/HV/fh-triage-program.png": 862831,
	"./character-ability-cards/frosthaven/IF/fh-ancient-rites-of-power.png": 374671,
	"./character-ability-cards/frosthaven/IF/fh-battle-prowess.png": 110745,
	"./character-ability-cards/frosthaven/IF/fh-boon-of-the-tempest.png": 502227,
	"./character-ability-cards/frosthaven/IF/fh-bounty-of-the-earth.png": 122038,
	"./character-ability-cards/frosthaven/IF/fh-caress-of-the-night.png": 288878,
	"./character-ability-cards/frosthaven/IF/fh-coalescing-darkness.png": 644455,
	"./character-ability-cards/frosthaven/IF/fh-crystalline-aegis.png": 723058,
	"./character-ability-cards/frosthaven/IF/fh-desperate-throw.png": 847606,
	"./character-ability-cards/frosthaven/IF/fh-diamondization.png": 404829,
	"./character-ability-cards/frosthaven/IF/fh-emerald-edge.png": 858811,
	"./character-ability-cards/frosthaven/IF/fh-formless-bladestorm.png": 147821,
	"./character-ability-cards/frosthaven/IF/fh-gale-barrage.png": 5235,
	"./character-ability-cards/frosthaven/IF/fh-gemstone-resonance.png": 88592,
	"./character-ability-cards/frosthaven/IF/fh-guide-the-flow.png": 676999,
	"./character-ability-cards/frosthaven/IF/fh-if-back.png": 764493,
	"./character-ability-cards/frosthaven/IF/fh-imbue-with-life.png": 477260,
	"./character-ability-cards/frosthaven/IF/fh-malachite-shockwave.png": 107853,
	"./character-ability-cards/frosthaven/IF/fh-obsidian-spear.png": 304936,
	"./character-ability-cards/frosthaven/IF/fh-onyx-shards.png": 997162,
	"./character-ability-cards/frosthaven/IF/fh-propulsive-tailwind.png": 994897,
	"./character-ability-cards/frosthaven/IF/fh-reinforced-riposte.png": 426162,
	"./character-ability-cards/frosthaven/IF/fh-remote-impact.png": 643884,
	"./character-ability-cards/frosthaven/IF/fh-rising-momentum.png": 271250,
	"./character-ability-cards/frosthaven/IF/fh-sky-splitting-strike.png": 975434,
	"./character-ability-cards/frosthaven/IF/fh-slashing-cyclone.png": 66931,
	"./character-ability-cards/frosthaven/IF/fh-stoic-vigilance.png": 481725,
	"./character-ability-cards/frosthaven/IF/fh-swift-pivot.png": 645570,
	"./character-ability-cards/frosthaven/IF/fh-torrential-cleave.png": 381470,
	"./character-ability-cards/frosthaven/IF/fh-unstoppable-impulse.png": 435812,
	"./character-ability-cards/frosthaven/IF/fh-untether-the-shackles.png": 254731,
	"./character-ability-cards/frosthaven/IF/fh-veil-of-protection.png": 759104,
	"./character-ability-cards/frosthaven/ME/fh-ancient-drill.png": 420274,
	"./character-ability-cards/frosthaven/ME/fh-beam-axe.png": 477386,
	"./character-ability-cards/frosthaven/ME/fh-bronze-plating.png": 428382,
	"./character-ability-cards/frosthaven/ME/fh-cryogenic-hibernation.png": 733043,
	"./character-ability-cards/frosthaven/ME/fh-curious-gear.png": 440323,
	"./character-ability-cards/frosthaven/ME/fh-curious-machinery.png": 602399,
	"./character-ability-cards/frosthaven/ME/fh-electrical-discharge.png": 825419,
	"./character-ability-cards/frosthaven/ME/fh-energy-conversion.png": 183477,
	"./character-ability-cards/frosthaven/ME/fh-heat-conduction.png": 638806,
	"./character-ability-cards/frosthaven/ME/fh-heated-drill.png": 438988,
	"./character-ability-cards/frosthaven/ME/fh-magnetic-field.png": 601085,
	"./character-ability-cards/frosthaven/ME/fh-me-back.png": 5827,
	"./character-ability-cards/frosthaven/ME/fh-memory-drive.png": 17413,
	"./character-ability-cards/frosthaven/ME/fh-piston-barrage.png": 474407,
	"./character-ability-cards/frosthaven/ME/fh-polarity-shift.png": 316424,
	"./character-ability-cards/frosthaven/ME/fh-power-core.png": 697399,
	"./character-ability-cards/frosthaven/ME/fh-pressure-build-up.png": 722433,
	"./character-ability-cards/frosthaven/ME/fh-processing.png": 983753,
	"./character-ability-cards/frosthaven/ME/fh-radiation.png": 96348,
	"./character-ability-cards/frosthaven/ME/fh-recursion.png": 655945,
	"./character-ability-cards/frosthaven/ME/fh-release-valve.png": 988222,
	"./character-ability-cards/frosthaven/ME/fh-rocket-boots.png": 239955,
	"./character-ability-cards/frosthaven/ME/fh-scalding-blast.png": 864914,
	"./character-ability-cards/frosthaven/ME/fh-steam-armor.png": 237967,
	"./character-ability-cards/frosthaven/ME/fh-steam-core.png": 371138,
	"./character-ability-cards/frosthaven/ME/fh-steel-piston.png": 187118,
	"./character-ability-cards/frosthaven/ME/fh-stress-vents.png": 949929,
	"./character-ability-cards/frosthaven/ME/fh-super-heat-transfer.png": 570762,
	"./character-ability-cards/frosthaven/ME/fh-unstable-core.png": 906630,
	"./character-ability-cards/frosthaven/PC/fh-blood-ritual.png": 3307,
	"./character-ability-cards/frosthaven/PC/fh-burned-at-both-ends.png": 721793,
	"./character-ability-cards/frosthaven/PC/fh-chained-by-despair.png": 841397,
	"./character-ability-cards/frosthaven/PC/fh-chained-by-spite.png": 775742,
	"./character-ability-cards/frosthaven/PC/fh-cleansing-fire.png": 765525,
	"./character-ability-cards/frosthaven/PC/fh-delayed-malady.png": 578582,
	"./character-ability-cards/frosthaven/PC/fh-down-to-the-dirt.png": 525539,
	"./character-ability-cards/frosthaven/PC/fh-explosive-wounds.png": 689561,
	"./character-ability-cards/frosthaven/PC/fh-hopelessness.png": 119346,
	"./character-ability-cards/frosthaven/PC/fh-infection-purge.png": 211651,
	"./character-ability-cards/frosthaven/PC/fh-line-of-transference.png": 17444,
	"./character-ability-cards/frosthaven/PC/fh-mirrored-misery.png": 256344,
	"./character-ability-cards/frosthaven/PC/fh-pc-back.png": 921834,
	"./character-ability-cards/frosthaven/PC/fh-penance.png": 430483,
	"./character-ability-cards/frosthaven/PC/fh-phantom-limb.png": 650954,
	"./character-ability-cards/frosthaven/PC/fh-pleasure-in-pain.png": 798306,
	"./character-ability-cards/frosthaven/PC/fh-redemption.png": 321873,
	"./character-ability-cards/frosthaven/PC/fh-reject-the-gift.png": 791685,
	"./character-ability-cards/frosthaven/PC/fh-reprisal.png": 121390,
	"./character-ability-cards/frosthaven/PC/fh-reversal-of-fate.png": 170737,
	"./character-ability-cards/frosthaven/PC/fh-scarred-effigy.png": 521178,
	"./character-ability-cards/frosthaven/PC/fh-shared-affliction.png": 448238,
	"./character-ability-cards/frosthaven/PC/fh-swift-vengeance.png": 402047,
	"./character-ability-cards/frosthaven/PC/fh-the-agony-of-others.png": 158716,
	"./character-ability-cards/frosthaven/PC/fh-the-end-of-everything.png": 6274,
	"./character-ability-cards/frosthaven/PC/fh-transferred-injury.png": 797056,
	"./character-ability-cards/frosthaven/PC/fh-unending-torment.png": 465775,
	"./character-ability-cards/frosthaven/PC/fh-unstable-effigy.png": 792062,
	"./character-ability-cards/frosthaven/PC/fh-wave-of-anguish.png": 345150,
	"./character-ability-cards/frosthaven/PC/fh-wracked-with-pain.png": 427104,
	"./character-ability-cards/frosthaven/PY/fh-calamity.png": 834710,
	"./character-ability-cards/frosthaven/PY/fh-cinder-lance.png": 436507,
	"./character-ability-cards/frosthaven/PY/fh-cloud-of-ash.png": 409461,
	"./character-ability-cards/frosthaven/PY/fh-cooling.png": 529357,
	"./character-ability-cards/frosthaven/PY/fh-deep-fury.png": 479970,
	"./character-ability-cards/frosthaven/PY/fh-erupting-rage.png": 370908,
	"./character-ability-cards/frosthaven/PY/fh-eruption.png": 629434,
	"./character-ability-cards/frosthaven/PY/fh-feed-the-beast.png": 646121,
	"./character-ability-cards/frosthaven/PY/fh-flowing-fire.png": 405415,
	"./character-ability-cards/frosthaven/PY/fh-force-of-the-earth.png": 710872,
	"./character-ability-cards/frosthaven/PY/fh-hand-of-flame.png": 657797,
	"./character-ability-cards/frosthaven/PY/fh-hardened-spike.png": 925314,
	"./character-ability-cards/frosthaven/PY/fh-heat-wave.png": 742530,
	"./character-ability-cards/frosthaven/PY/fh-igneous-path.png": 387641,
	"./character-ability-cards/frosthaven/PY/fh-lava-bomb.png": 78051,
	"./character-ability-cards/frosthaven/PY/fh-liquid-stone.png": 299782,
	"./character-ability-cards/frosthaven/PY/fh-living-magma.png": 536878,
	"./character-ability-cards/frosthaven/PY/fh-magma-orbs.png": 590342,
	"./character-ability-cards/frosthaven/PY/fh-melted-armor.png": 283811,
	"./character-ability-cards/frosthaven/PY/fh-metamorphic-rock.png": 519850,
	"./character-ability-cards/frosthaven/PY/fh-obsidian-shield.png": 829202,
	"./character-ability-cards/frosthaven/PY/fh-py-back.png": 610633,
	"./character-ability-cards/frosthaven/PY/fh-quenched-rage.png": 811804,
	"./character-ability-cards/frosthaven/PY/fh-rain-of-fire.png": 971707,
	"./character-ability-cards/frosthaven/PY/fh-return-to-the-source.png": 93394,
	"./character-ability-cards/frosthaven/PY/fh-searing-smoke.png": 189468,
	"./character-ability-cards/frosthaven/PY/fh-stone-armor.png": 834836,
	"./character-ability-cards/frosthaven/PY/fh-swelter.png": 151197,
	"./character-ability-cards/frosthaven/PY/fh-under-pressure.png": 628417,
	"./character-ability-cards/frosthaven/PY/fh-wildfire.png": 24041,
	"./character-ability-cards/frosthaven/SD/fh-birds-in-a-tempest.png": 631952,
	"./character-ability-cards/frosthaven/SD/fh-biting-frost.png": 76367,
	"./character-ability-cards/frosthaven/SD/fh-blinding-vortex.png": 325847,
	"./character-ability-cards/frosthaven/SD/fh-blizzard.png": 391387,
	"./character-ability-cards/frosthaven/SD/fh-chilling-impact.png": 544857,
	"./character-ability-cards/frosthaven/SD/fh-cold-snap.png": 560512,
	"./character-ability-cards/frosthaven/SD/fh-cold-therapy.png": 989637,
	"./character-ability-cards/frosthaven/SD/fh-cross-winds.png": 36601,
	"./character-ability-cards/frosthaven/SD/fh-enticing-breeze.png": 712844,
	"./character-ability-cards/frosthaven/SD/fh-freezing-storm.png": 171138,
	"./character-ability-cards/frosthaven/SD/fh-frigid-growth.png": 245813,
	"./character-ability-cards/frosthaven/SD/fh-frozen-brand.png": 619427,
	"./character-ability-cards/frosthaven/SD/fh-gathering-force.png": 851789,
	"./character-ability-cards/frosthaven/SD/fh-lifting-gust.png": 128011,
	"./character-ability-cards/frosthaven/SD/fh-natures-breath.png": 760450,
	"./character-ability-cards/frosthaven/SD/fh-polar-vortex.png": 46538,
	"./character-ability-cards/frosthaven/SD/fh-refreshing-flurry.png": 615579,
	"./character-ability-cards/frosthaven/SD/fh-sd-back.png": 935088,
	"./character-ability-cards/frosthaven/SD/fh-shifting-snow.png": 859439,
	"./character-ability-cards/frosthaven/SD/fh-snowball.png": 243001,
	"./character-ability-cards/frosthaven/SD/fh-snowblind.png": 326984,
	"./character-ability-cards/frosthaven/SD/fh-storm-wall.png": 777574,
	"./character-ability-cards/frosthaven/SD/fh-surging-blow.png": 807416,
	"./character-ability-cards/frosthaven/SD/fh-the-endless-white.png": 153025,
	"./character-ability-cards/frosthaven/SD/fh-the-spirits-call.png": 137585,
	"./character-ability-cards/frosthaven/SD/fh-tornado.png": 84191,
	"./character-ability-cards/frosthaven/SD/fh-whipping-gale.png": 572179,
	"./character-ability-cards/frosthaven/SD/fh-white-winds.png": 728396,
	"./character-ability-cards/frosthaven/SD/fh-whiteout.png": 705207,
	"./character-ability-cards/frosthaven/SD/fh-winds-of-change.png": 963668,
	"./character-ability-cards/frosthaven/SD/fh-zephyr-barrier.png": 366238,
	"./character-ability-cards/frosthaven/SH/fh-barbaric-yawp.png": 270487,
	"./character-ability-cards/frosthaven/SH/fh-befuddling-bellow.png": 875858,
	"./character-ability-cards/frosthaven/SH/fh-calamitous-yawp.png": 818862,
	"./character-ability-cards/frosthaven/SH/fh-cloaking-refraction.png": 954251,
	"./character-ability-cards/frosthaven/SH/fh-concentrated-blast.png": 638038,
	"./character-ability-cards/frosthaven/SH/fh-devastating-shout.png": 509833,
	"./character-ability-cards/frosthaven/SH/fh-din-of-battle.png": 996445,
	"./character-ability-cards/frosthaven/SH/fh-elemental-pulse.png": 405096,
	"./character-ability-cards/frosthaven/SH/fh-empowering-note.png": 306955,
	"./character-ability-cards/frosthaven/SH/fh-empowering-pulse.png": 571644,
	"./character-ability-cards/frosthaven/SH/fh-feedback.png": 138218,
	"./character-ability-cards/frosthaven/SH/fh-forceful-vibrations.png": 910396,
	"./character-ability-cards/frosthaven/SH/fh-foreboding-tremors.png": 474239,
	"./character-ability-cards/frosthaven/SH/fh-future-sense.png": 592090,
	"./character-ability-cards/frosthaven/SH/fh-heartening-harmony.png": 491981,
	"./character-ability-cards/frosthaven/SH/fh-illuminative-tone.png": 614513,
	"./character-ability-cards/frosthaven/SH/fh-lifting-voice.png": 586364,
	"./character-ability-cards/frosthaven/SH/fh-precious-gems.png": 622392,
	"./character-ability-cards/frosthaven/SH/fh-resonant-frequency.png": 505400,
	"./character-ability-cards/frosthaven/SH/fh-sh-back.png": 786100,
	"./character-ability-cards/frosthaven/SH/fh-shape-the-path.png": 445008,
	"./character-ability-cards/frosthaven/SH/fh-shrieking-chakram.png": 99966,
	"./character-ability-cards/frosthaven/SH/fh-soft-spots.png": 694718,
	"./character-ability-cards/frosthaven/SH/fh-sonic-shock.png": 361917,
	"./character-ability-cards/frosthaven/SH/fh-sound-therapy.png": 123859,
	"./character-ability-cards/frosthaven/SH/fh-stealth-vibrations.png": 171394,
	"./character-ability-cards/frosthaven/SH/fh-transparency.png": 783844,
	"./character-ability-cards/frosthaven/SH/fh-unrelenting-wail.png": 387247,
	"./character-ability-cards/frosthaven/SH/fh-unsustainable-wave.png": 792601,
	"./character-ability-cards/frosthaven/SH/fh-violent-vibrations.png": 659124,
	"./character-ability-cards/frosthaven/TA/fh-boar-catcher.png": 182054,
	"./character-ability-cards/frosthaven/TA/fh-cage-of-thorns.png": 603208,
	"./character-ability-cards/frosthaven/TA/fh-caltrops.png": 61548,
	"./character-ability-cards/frosthaven/TA/fh-dangerous-cargo.png": 775289,
	"./character-ability-cards/frosthaven/TA/fh-dangerous-ground.png": 584494,
	"./character-ability-cards/frosthaven/TA/fh-dismantle.png": 729115,
	"./character-ability-cards/frosthaven/TA/fh-electrified-net.png": 748177,
	"./character-ability-cards/frosthaven/TA/fh-enticing-bait.png": 81085,
	"./character-ability-cards/frosthaven/TA/fh-exploding-decoy.png": 315375,
	"./character-ability-cards/frosthaven/TA/fh-extra-teeth.png": 952207,
	"./character-ability-cards/frosthaven/TA/fh-flurry-of-nails.png": 801905,
	"./character-ability-cards/frosthaven/TA/fh-foxhole.png": 80290,
	"./character-ability-cards/frosthaven/TA/fh-furry-facade.png": 711638,
	"./character-ability-cards/frosthaven/TA/fh-grasping-hazards.png": 263501,
	"./character-ability-cards/frosthaven/TA/fh-honeypot.png": 405936,
	"./character-ability-cards/frosthaven/TA/fh-improvised-improvement.png": 387025,
	"./character-ability-cards/frosthaven/TA/fh-lure-of-the-snare.png": 827022,
	"./character-ability-cards/frosthaven/TA/fh-magnetic-shards.png": 1206,
	"./character-ability-cards/frosthaven/TA/fh-mother-of-all-traps.png": 632666,
	"./character-ability-cards/frosthaven/TA/fh-path-of-pain.png": 9561,
	"./character-ability-cards/frosthaven/TA/fh-persistent-pitfalls.png": 772874,
	"./character-ability-cards/frosthaven/TA/fh-proficient-hunter.png": 384578,
	"./character-ability-cards/frosthaven/TA/fh-pyrotechnics.png": 823175,
	"./character-ability-cards/frosthaven/TA/fh-spike-pit.png": 192207,
	"./character-ability-cards/frosthaven/TA/fh-spike-strip.png": 627448,
	"./character-ability-cards/frosthaven/TA/fh-spring-loaded.png": 334419,
	"./character-ability-cards/frosthaven/TA/fh-stalkers-spoils.png": 354492,
	"./character-ability-cards/frosthaven/TA/fh-ta-back.png": 629599,
	"./character-ability-cards/frosthaven/TA/fh-unavoidable-outcome.png": 191918,
	"./character-ability-cards/gloomhaven/BE/gh-be-back.png": 402631,
	"./character-ability-cards/gloomhaven/BE/gh-blood-pact.png": 397167,
	"./character-ability-cards/gloomhaven/BE/gh-bone-breaker.png": 851917,
	"./character-ability-cards/gloomhaven/BE/gh-bounce-back.png": 231254,
	"./character-ability-cards/gloomhaven/BE/gh-break-the-chains.png": 649552,
	"./character-ability-cards/gloomhaven/BE/gh-burning-hatred.png": 239314,
	"./character-ability-cards/gloomhaven/BE/gh-careless-charge.png": 305577,
	"./character-ability-cards/gloomhaven/BE/gh-cauterize.png": 371876,
	"./character-ability-cards/gloomhaven/BE/gh-dazing-wound.png": 545804,
	"./character-ability-cards/gloomhaven/BE/gh-defiance-of-death.png": 747325,
	"./character-ability-cards/gloomhaven/BE/gh-devil-horns.png": 267701,
	"./character-ability-cards/gloomhaven/BE/gh-fatal-fury.png": 333751,
	"./character-ability-cards/gloomhaven/BE/gh-final-fight.png": 111236,
	"./character-ability-cards/gloomhaven/BE/gh-flurry-of-axes.png": 887458,
	"./character-ability-cards/gloomhaven/BE/gh-from-the-brink.png": 78739,
	"./character-ability-cards/gloomhaven/BE/gh-furious-aid.png": 91111,
	"./character-ability-cards/gloomhaven/BE/gh-glass-hammer.png": 359770,
	"./character-ability-cards/gloomhaven/BE/gh-growing-rage.png": 563611,
	"./character-ability-cards/gloomhaven/BE/gh-immortality.png": 665209,
	"./character-ability-cards/gloomhaven/BE/gh-numb-the-pain.png": 396346,
	"./character-ability-cards/gloomhaven/BE/gh-reckless-offensive.png": 539883,
	"./character-ability-cards/gloomhaven/BE/gh-resolute-stand.png": 891893,
	"./character-ability-cards/gloomhaven/BE/gh-seeing-red.png": 545133,
	"./character-ability-cards/gloomhaven/BE/gh-shiny-distraction.png": 808411,
	"./character-ability-cards/gloomhaven/BE/gh-spiked-armor.png": 604374,
	"./character-ability-cards/gloomhaven/BE/gh-strength-in-agony.png": 608929,
	"./character-ability-cards/gloomhaven/BE/gh-the-maw-of-madness.png": 730900,
	"./character-ability-cards/gloomhaven/BE/gh-unbridled-power.png": 656854,
	"./character-ability-cards/gloomhaven/BE/gh-unstoppable-destruction.png": 943072,
	"./character-ability-cards/gloomhaven/BE/gh-vengeful-barrage.png": 579555,
	"./character-ability-cards/gloomhaven/BR/gh-balanced-measure.png": 481733,
	"./character-ability-cards/gloomhaven/BR/gh-br-back.png": 528208,
	"./character-ability-cards/gloomhaven/BR/gh-brute-force.png": 822418,
	"./character-ability-cards/gloomhaven/BR/gh-crippling-offensive.png": 595079,
	"./character-ability-cards/gloomhaven/BR/gh-defensive-tactics.png": 998641,
	"./character-ability-cards/gloomhaven/BR/gh-devastating-hack.png": 532252,
	"./character-ability-cards/gloomhaven/BR/gh-eye-for-an-eye.png": 14541,
	"./character-ability-cards/gloomhaven/BR/gh-face-your-end.png": 105933,
	"./character-ability-cards/gloomhaven/BR/gh-fatal-advance.png": 399617,
	"./character-ability-cards/gloomhaven/BR/gh-frenzied-onslaught.png": 57955,
	"./character-ability-cards/gloomhaven/BR/gh-grab-and-go.png": 325075,
	"./character-ability-cards/gloomhaven/BR/gh-hook-and-chain.png": 249358,
	"./character-ability-cards/gloomhaven/BR/gh-immovable-phalanx.png": 655368,
	"./character-ability-cards/gloomhaven/BR/gh-juggernaut.png": 580115,
	"./character-ability-cards/gloomhaven/BR/gh-king-of-the-hill.png": 557154,
	"./character-ability-cards/gloomhaven/BR/gh-leaping-cleave.png": 751095,
	"./character-ability-cards/gloomhaven/BR/gh-overwhelming-assault.png": 819795,
	"./character-ability-cards/gloomhaven/BR/gh-provoking-roar.png": 700907,
	"./character-ability-cards/gloomhaven/BR/gh-quietus.png": 235834,
	"./character-ability-cards/gloomhaven/BR/gh-selfish-retribution.png": 99305,
	"./character-ability-cards/gloomhaven/BR/gh-shield-bash.png": 487317,
	"./character-ability-cards/gloomhaven/BR/gh-skewer.png": 551483,
	"./character-ability-cards/gloomhaven/BR/gh-skirmishing-maneuver.png": 17380,
	"./character-ability-cards/gloomhaven/BR/gh-spare-dagger.png": 850909,
	"./character-ability-cards/gloomhaven/BR/gh-sweeping-blow.png": 212410,
	"./character-ability-cards/gloomhaven/BR/gh-trample.png": 533186,
	"./character-ability-cards/gloomhaven/BR/gh-unstoppable-charge.png": 3744,
	"./character-ability-cards/gloomhaven/BR/gh-wall-of-doom.png": 317521,
	"./character-ability-cards/gloomhaven/BR/gh-warding-strength.png": 766141,
	"./character-ability-cards/gloomhaven/BR/gh-whirlwind.png": 115624,
	"./character-ability-cards/gloomhaven/BS/gh-armed-and-dangerous.png": 764546,
	"./character-ability-cards/gloomhaven/BS/gh-bioluminescence.png": 495209,
	"./character-ability-cards/gloomhaven/BS/gh-blood-drain.png": 146247,
	"./character-ability-cards/gloomhaven/BS/gh-bone-daggers.png": 560260,
	"./character-ability-cards/gloomhaven/BS/gh-bs-back.png": 556047,
	"./character-ability-cards/gloomhaven/BS/gh-call-of-the-grave.png": 192454,
	"./character-ability-cards/gloomhaven/BS/gh-corrupting-parasites.png": 563942,
	"./character-ability-cards/gloomhaven/BS/gh-cyclone-of-blades.png": 635202,
	"./character-ability-cards/gloomhaven/BS/gh-death-march.png": 525343,
	"./character-ability-cards/gloomhaven/BS/gh-deflecting-blades.png": 802977,
	"./character-ability-cards/gloomhaven/BS/gh-endless-biting.png": 464367,
	"./character-ability-cards/gloomhaven/BS/gh-engulfing-stingers.png": 509366,
	"./character-ability-cards/gloomhaven/BS/gh-focused-scourge.png": 537166,
	"./character-ability-cards/gloomhaven/BS/gh-fury-of-the-horde.png": 629584,
	"./character-ability-cards/gloomhaven/BS/gh-grasping-advance.png": 898433,
	"./character-ability-cards/gloomhaven/BS/gh-hive-mind.png": 269506,
	"./character-ability-cards/gloomhaven/BS/gh-incubation.png": 156694,
	"./character-ability-cards/gloomhaven/BS/gh-infest.png": 819822,
	"./character-ability-cards/gloomhaven/BS/gh-oasis.png": 896580,
	"./character-ability-cards/gloomhaven/BS/gh-omniscient-assault.png": 360668,
	"./character-ability-cards/gloomhaven/BS/gh-overwhelming-offensive.png": 351074,
	"./character-ability-cards/gloomhaven/BS/gh-putrid-grubs.png": 888555,
	"./character-ability-cards/gloomhaven/BS/gh-repulsive-host.png": 852653,
	"./character-ability-cards/gloomhaven/BS/gh-scattered-defense.png": 390628,
	"./character-ability-cards/gloomhaven/BS/gh-sunstroke.png": 942319,
	"./character-ability-cards/gloomhaven/BS/gh-swarming-minions.png": 751558,
	"./character-ability-cards/gloomhaven/BS/gh-the-storms-edge.png": 11452,
	"./character-ability-cards/gloomhaven/BS/gh-tomb-of-the-immortal.png": 268699,
	"./character-ability-cards/gloomhaven/BS/gh-unstoppable-army.png": 202914,
	"./character-ability-cards/gloomhaven/BS/gh-vampiric-tempest.png": 438650,
	"./character-ability-cards/gloomhaven/BS/gh-wasteland.png": 77872,
	"./character-ability-cards/gloomhaven/BT/gh-ancient-ward.png": 482589,
	"./character-ability-cards/gloomhaven/BT/gh-bear-reference-back.png": 384905,
	"./character-ability-cards/gloomhaven/BT/gh-bear-reference.png": 351581,
	"./character-ability-cards/gloomhaven/BT/gh-blood-hunger.png": 668124,
	"./character-ability-cards/gloomhaven/BT/gh-borrowed-essence.png": 843670,
	"./character-ability-cards/gloomhaven/BT/gh-bt-back.png": 399486,
	"./character-ability-cards/gloomhaven/BT/gh-concentrated-rage.png": 713189,
	"./character-ability-cards/gloomhaven/BT/gh-disappearing-wounds.png": 913401,
	"./character-ability-cards/gloomhaven/BT/gh-disorienting-roar.png": 502913,
	"./character-ability-cards/gloomhaven/BT/gh-earthen-spikes.png": 160104,
	"./character-ability-cards/gloomhaven/BT/gh-energizing-strike.png": 264111,
	"./character-ability-cards/gloomhaven/BT/gh-focused-aggression.png": 743906,
	"./character-ability-cards/gloomhaven/BT/gh-forceful-swipe.png": 119697,
	"./character-ability-cards/gloomhaven/BT/gh-howling-bolts.png": 558555,
	"./character-ability-cards/gloomhaven/BT/gh-jaws-of-death.png": 196335,
	"./character-ability-cards/gloomhaven/BT/gh-lash-out.png": 810668,
	"./character-ability-cards/gloomhaven/BT/gh-maul.png": 119911,
	"./character-ability-cards/gloomhaven/BT/gh-natural-remedy.png": 121868,
	"./character-ability-cards/gloomhaven/BT/gh-patch-fur.png": 34331,
	"./character-ability-cards/gloomhaven/BT/gh-primal-blessing.png": 735986,
	"./character-ability-cards/gloomhaven/BT/gh-punch-through.png": 179635,
	"./character-ability-cards/gloomhaven/BT/gh-rampage.png": 822419,
	"./character-ability-cards/gloomhaven/BT/gh-relentless-ally.png": 53751,
	"./character-ability-cards/gloomhaven/BT/gh-soaring-ally.png": 726604,
	"./character-ability-cards/gloomhaven/BT/gh-spirit-swap.png": 588904,
	"./character-ability-cards/gloomhaven/BT/gh-stone-sigil.png": 46336,
	"./character-ability-cards/gloomhaven/BT/gh-storm-sigil.png": 621548,
	"./character-ability-cards/gloomhaven/BT/gh-tribal-sigil.png": 205038,
	"./character-ability-cards/gloomhaven/BT/gh-tyrannical-force.png": 536980,
	"./character-ability-cards/gloomhaven/BT/gh-unstoppable-beast.png": 70630,
	"./character-ability-cards/gloomhaven/BT/gh-venomous-ally.png": 384420,
	"./character-ability-cards/gloomhaven/BT/gh-vicious-ally.png": 437498,
	"./character-ability-cards/gloomhaven/CH/gh-avalanche.png": 36375,
	"./character-ability-cards/gloomhaven/CH/gh-backup-ammunition.png": 548309,
	"./character-ability-cards/gloomhaven/CH/gh-blind-destruction.png": 495458,
	"./character-ability-cards/gloomhaven/CH/gh-blunt-force.png": 516871,
	"./character-ability-cards/gloomhaven/CH/gh-brutal-momentum.png": 465724,
	"./character-ability-cards/gloomhaven/CH/gh-cataclysm.png": 731561,
	"./character-ability-cards/gloomhaven/CH/gh-ch-back.png": 2847,
	"./character-ability-cards/gloomhaven/CH/gh-clear-the-way.png": 888171,
	"./character-ability-cards/gloomhaven/CH/gh-crater.png": 423127,
	"./character-ability-cards/gloomhaven/CH/gh-crushing-grasp.png": 957452,
	"./character-ability-cards/gloomhaven/CH/gh-dig-pit.png": 830031,
	"./character-ability-cards/gloomhaven/CH/gh-dirt-tornado.png": 854143,
	"./character-ability-cards/gloomhaven/CH/gh-earthen-clod.png": 565862,
	"./character-ability-cards/gloomhaven/CH/gh-explosive-punch.png": 717127,
	"./character-ability-cards/gloomhaven/CH/gh-forceful-storm.png": 564790,
	"./character-ability-cards/gloomhaven/CH/gh-heaving-swing.png": 292038,
	"./character-ability-cards/gloomhaven/CH/gh-kinetic-assault.png": 881498,
	"./character-ability-cards/gloomhaven/CH/gh-lumbering-bash.png": 43303,
	"./character-ability-cards/gloomhaven/CH/gh-massive-boulder.png": 109603,
	"./character-ability-cards/gloomhaven/CH/gh-meteor.png": 111741,
	"./character-ability-cards/gloomhaven/CH/gh-natures-lift.png": 5577,
	"./character-ability-cards/gloomhaven/CH/gh-opposing-strike.png": 372195,
	"./character-ability-cards/gloomhaven/CH/gh-petrify.png": 55239,
	"./character-ability-cards/gloomhaven/CH/gh-pulverize.png": 139664,
	"./character-ability-cards/gloomhaven/CH/gh-rock-slide.png": 59935,
	"./character-ability-cards/gloomhaven/CH/gh-rock-tunnel.png": 631390,
	"./character-ability-cards/gloomhaven/CH/gh-rocky-end.png": 178020,
	"./character-ability-cards/gloomhaven/CH/gh-rumbling-advance.png": 652659,
	"./character-ability-cards/gloomhaven/CH/gh-sentient-growth.png": 905219,
	"./character-ability-cards/gloomhaven/CH/gh-stone-pummel.png": 880396,
	"./character-ability-cards/gloomhaven/CH/gh-unstable-upheaval.png": 90530,
	"./character-ability-cards/gloomhaven/DS/gh-a-moments-peace.png": 784578,
	"./character-ability-cards/gloomhaven/DS/gh-camouflage.png": 223009,
	"./character-ability-cards/gloomhaven/DS/gh-crashing-wave.png": 739103,
	"./character-ability-cards/gloomhaven/DS/gh-crippling-noose.png": 379518,
	"./character-ability-cards/gloomhaven/DS/gh-darkened-skies.png": 293097,
	"./character-ability-cards/gloomhaven/DS/gh-detonation.png": 851872,
	"./character-ability-cards/gloomhaven/DS/gh-ds-back.png": 376706,
	"./character-ability-cards/gloomhaven/DS/gh-expose.png": 188735,
	"./character-ability-cards/gloomhaven/DS/gh-felling-swoop.png": 576230,
	"./character-ability-cards/gloomhaven/DS/gh-feral-instincts.png": 941614,
	"./character-ability-cards/gloomhaven/DS/gh-flight-of-flame.png": 116756,
	"./character-ability-cards/gloomhaven/DS/gh-foot-snare.png": 448336,
	"./character-ability-cards/gloomhaven/DS/gh-fresh-kill.png": 84445,
	"./character-ability-cards/gloomhaven/DS/gh-frightening-curse.png": 741115,
	"./character-ability-cards/gloomhaven/DS/gh-impending-end.png": 715228,
	"./character-ability-cards/gloomhaven/DS/gh-inescapable-fate.png": 725965,
	"./character-ability-cards/gloomhaven/DS/gh-lead-to-slaughter.png": 993658,
	"./character-ability-cards/gloomhaven/DS/gh-multi-pronged-assault.png": 243824,
	"./character-ability-cards/gloomhaven/DS/gh-natures-hunger.png": 431418,
	"./character-ability-cards/gloomhaven/DS/gh-predator-and-prey.png": 952544,
	"./character-ability-cards/gloomhaven/DS/gh-press-the-attack.png": 996246,
	"./character-ability-cards/gloomhaven/DS/gh-race-to-the-grave.png": 4869,
	"./character-ability-cards/gloomhaven/DS/gh-rain-of-arrows.png": 309030,
	"./character-ability-cards/gloomhaven/DS/gh-relentless-offensive.png": 55729,
	"./character-ability-cards/gloomhaven/DS/gh-rising-momentum.png": 259251,
	"./character-ability-cards/gloomhaven/DS/gh-sap-life.png": 723784,
	"./character-ability-cards/gloomhaven/DS/gh-singular-focus.png": 854007,
	"./character-ability-cards/gloomhaven/DS/gh-solid-bow.png": 71114,
	"./character-ability-cards/gloomhaven/DS/gh-swift-trickery.png": 848054,
	"./character-ability-cards/gloomhaven/DS/gh-the-hunt-begins.png": 422337,
	"./character-ability-cards/gloomhaven/DS/gh-vital-charge.png": 219781,
	"./character-ability-cards/gloomhaven/DS/gh-wild-command.png": 935371,
	"./character-ability-cards/gloomhaven/EL/gh-boiling-arc.png": 736025,
	"./character-ability-cards/gloomhaven/EL/gh-brilliant-flash.png": 135798,
	"./character-ability-cards/gloomhaven/EL/gh-burial.png": 491355,
	"./character-ability-cards/gloomhaven/EL/gh-chain-lightning.png": 857281,
	"./character-ability-cards/gloomhaven/EL/gh-crystallizing-blast.png": 252930,
	"./character-ability-cards/gloomhaven/EL/gh-el-back.png": 486010,
	"./character-ability-cards/gloomhaven/EL/gh-elemental-aegis.png": 929289,
	"./character-ability-cards/gloomhaven/EL/gh-encompassing-shadow.png": 197579,
	"./character-ability-cards/gloomhaven/EL/gh-eternal-equilibrium.png": 751833,
	"./character-ability-cards/gloomhaven/EL/gh-ethereal-manifestation.png": 537412,
	"./character-ability-cards/gloomhaven/EL/gh-eye-of-the-hurricane.png": 261421,
	"./character-ability-cards/gloomhaven/EL/gh-formless-power.png": 573783,
	"./character-ability-cards/gloomhaven/EL/gh-frigid-torrent.png": 920807,
	"./character-ability-cards/gloomhaven/EL/gh-gravel-vortex.png": 905004,
	"./character-ability-cards/gloomhaven/EL/gh-ice-spikes.png": 526863,
	"./character-ability-cards/gloomhaven/EL/gh-infernal-vortex.png": 477060,
	"./character-ability-cards/gloomhaven/EL/gh-lava-eruption.png": 716972,
	"./character-ability-cards/gloomhaven/EL/gh-malleable-evocation.png": 437018,
	"./character-ability-cards/gloomhaven/EL/gh-obsidian-shards.png": 339977,
	"./character-ability-cards/gloomhaven/EL/gh-pragmatic-reinforcement.png": 642772,
	"./character-ability-cards/gloomhaven/EL/gh-primal-duality.png": 22363,
	"./character-ability-cards/gloomhaven/EL/gh-pure-augmentation.png": 863644,
	"./character-ability-cards/gloomhaven/EL/gh-raw-enhancement.png": 38423,
	"./character-ability-cards/gloomhaven/EL/gh-shaping-the-ether.png": 377553,
	"./character-ability-cards/gloomhaven/EL/gh-simulacrum.png": 962120,
	"./character-ability-cards/gloomhaven/EL/gh-stoking-hail.png": 45450,
	"./character-ability-cards/gloomhaven/EL/gh-tremulant-cyclone.png": 367299,
	"./character-ability-cards/gloomhaven/EL/gh-vengeance.png": 17136,
	"./character-ability-cards/gloomhaven/EL/gh-volatile-consumption.png": 16242,
	"./character-ability-cards/gloomhaven/EL/gh-winters-edge.png": 584486,
	"./character-ability-cards/gloomhaven/MT/gh-brain-leech.png": 144265,
	"./character-ability-cards/gloomhaven/MT/gh-corrupting-embrace.png": 485837,
	"./character-ability-cards/gloomhaven/MT/gh-cranium-overload.png": 429300,
	"./character-ability-cards/gloomhaven/MT/gh-dark-frenzy.png": 85466,
	"./character-ability-cards/gloomhaven/MT/gh-domination.png": 215719,
	"./character-ability-cards/gloomhaven/MT/gh-empathetic-assault.png": 234808,
	"./character-ability-cards/gloomhaven/MT/gh-fearsome-blade.png": 975649,
	"./character-ability-cards/gloomhaven/MT/gh-feedback-loop.png": 389978,
	"./character-ability-cards/gloomhaven/MT/gh-frigid-apparition.png": 320868,
	"./character-ability-cards/gloomhaven/MT/gh-frozen-mind.png": 599586,
	"./character-ability-cards/gloomhaven/MT/gh-gnawing-horde.png": 13278,
	"./character-ability-cards/gloomhaven/MT/gh-hostile-takeover.png": 821639,
	"./character-ability-cards/gloomhaven/MT/gh-into-the-night.png": 463158,
	"./character-ability-cards/gloomhaven/MT/gh-many-as-one.png": 755154,
	"./character-ability-cards/gloomhaven/MT/gh-mass-hysteria.png": 730458,
	"./character-ability-cards/gloomhaven/MT/gh-mt-back.png": 21399,
	"./character-ability-cards/gloomhaven/MT/gh-parasitic-influence.png": 726492,
	"./character-ability-cards/gloomhaven/MT/gh-perverse-edge.png": 989469,
	"./character-ability-cards/gloomhaven/MT/gh-phantasmal-killer.png": 8213,
	"./character-ability-cards/gloomhaven/MT/gh-pilfer.png": 820808,
	"./character-ability-cards/gloomhaven/MT/gh-possession.png": 224719,
	"./character-ability-cards/gloomhaven/MT/gh-psychic-projection.png": 369370,
	"./character-ability-cards/gloomhaven/MT/gh-scurry.png": 522133,
	"./character-ability-cards/gloomhaven/MT/gh-shared-nightmare.png": 995815,
	"./character-ability-cards/gloomhaven/MT/gh-silent-scream.png": 424834,
	"./character-ability-cards/gloomhaven/MT/gh-submissive-affliction.png": 180839,
	"./character-ability-cards/gloomhaven/MT/gh-the-minds-weakness.png": 988798,
	"./character-ability-cards/gloomhaven/MT/gh-vicious-blood.png": 628202,
	"./character-ability-cards/gloomhaven/MT/gh-withering-claw.png": 731908,
	"./character-ability-cards/gloomhaven/MT/gh-wretched-creature.png": 622537,
	"./character-ability-cards/gloomhaven/NS/gh-angel-of-death.png": 747557,
	"./character-ability-cards/gloomhaven/NS/gh-armor-of-the-night.png": 397643,
	"./character-ability-cards/gloomhaven/NS/gh-black-arrow.png": 228005,
	"./character-ability-cards/gloomhaven/NS/gh-black-knives.png": 708560,
	"./character-ability-cards/gloomhaven/NS/gh-claws-of-the-night.png": 771206,
	"./character-ability-cards/gloomhaven/NS/gh-cloak-of-shade.png": 847985,
	"./character-ability-cards/gloomhaven/NS/gh-concealed-dominance.png": 222145,
	"./character-ability-cards/gloomhaven/NS/gh-dancing-shadows.png": 806814,
	"./character-ability-cards/gloomhaven/NS/gh-dark-cloud.png": 599384,
	"./character-ability-cards/gloomhaven/NS/gh-doomed-breeze.png": 221115,
	"./character-ability-cards/gloomhaven/NS/gh-empowering-void.png": 270683,
	"./character-ability-cards/gloomhaven/NS/gh-enervating-wound.png": 822258,
	"./character-ability-cards/gloomhaven/NS/gh-eyes-of-the-night.png": 999418,
	"./character-ability-cards/gloomhaven/NS/gh-gloom-darts.png": 590215,
	"./character-ability-cards/gloomhaven/NS/gh-grim-sustenance.png": 41129,
	"./character-ability-cards/gloomhaven/NS/gh-lurking-ruin.png": 189181,
	"./character-ability-cards/gloomhaven/NS/gh-nightfall.png": 993679,
	"./character-ability-cards/gloomhaven/NS/gh-ns-back.png": 294659,
	"./character-ability-cards/gloomhaven/NS/gh-prepare-for-the-kill.png": 671598,
	"./character-ability-cards/gloomhaven/NS/gh-quiet-frenzy.png": 351929,
	"./character-ability-cards/gloomhaven/NS/gh-silent-force.png": 694938,
	"./character-ability-cards/gloomhaven/NS/gh-smoke-step.png": 915954,
	"./character-ability-cards/gloomhaven/NS/gh-soulfire.png": 737379,
	"./character-ability-cards/gloomhaven/NS/gh-spirit-of-the-night.png": 898469,
	"./character-ability-cards/gloomhaven/NS/gh-swallowed-by-fear.png": 665911,
	"./character-ability-cards/gloomhaven/NS/gh-terror-blade.png": 306647,
	"./character-ability-cards/gloomhaven/NS/gh-unseen-dread.png": 64468,
	"./character-ability-cards/gloomhaven/NS/gh-voice-of-the-night.png": 38478,
	"./character-ability-cards/gloomhaven/NS/gh-wings-of-the-night.png": 571065,
	"./character-ability-cards/gloomhaven/PH/gh-accelerated-end.png": 709035,
	"./character-ability-cards/gloomhaven/PH/gh-airborne-toxin.png": 157320,
	"./character-ability-cards/gloomhaven/PH/gh-baneful-hex.png": 988321,
	"./character-ability-cards/gloomhaven/PH/gh-biting-gnats.png": 728683,
	"./character-ability-cards/gloomhaven/PH/gh-black-tides.png": 223142,
	"./character-ability-cards/gloomhaven/PH/gh-blistering-vortex.png": 298052,
	"./character-ability-cards/gloomhaven/PH/gh-convert-the-flock.png": 461080,
	"./character-ability-cards/gloomhaven/PH/gh-creeping-curse.png": 448115,
	"./character-ability-cards/gloomhaven/PH/gh-epidemic.png": 76050,
	"./character-ability-cards/gloomhaven/PH/gh-fetid-flurry.png": 416162,
	"./character-ability-cards/gloomhaven/PH/gh-foul-wind.png": 121704,
	"./character-ability-cards/gloomhaven/PH/gh-gathering-doom.png": 816241,
	"./character-ability-cards/gloomhaven/PH/gh-grasping-vermin.png": 869516,
	"./character-ability-cards/gloomhaven/PH/gh-grim-bargain.png": 159538,
	"./character-ability-cards/gloomhaven/PH/gh-mass-extinction.png": 232897,
	"./character-ability-cards/gloomhaven/PH/gh-nightmarish-affliction.png": 148169,
	"./character-ability-cards/gloomhaven/PH/gh-paralyzing-bite.png": 429448,
	"./character-ability-cards/gloomhaven/PH/gh-ph-back.png": 440943,
	"./character-ability-cards/gloomhaven/PH/gh-rot-maggots.png": 50179,
	"./character-ability-cards/gloomhaven/PH/gh-scattered-terror.png": 868910,
	"./character-ability-cards/gloomhaven/PH/gh-spread-the-plague.png": 969681,
	"./character-ability-cards/gloomhaven/PH/gh-spreading-scourge.png": 475013,
	"./character-ability-cards/gloomhaven/PH/gh-stinging-cloud.png": 297590,
	"./character-ability-cards/gloomhaven/PH/gh-storm-of-wings.png": 512314,
	"./character-ability-cards/gloomhaven/PH/gh-succumb-to-the-gift.png": 327608,
	"./character-ability-cards/gloomhaven/PH/gh-under-the-skin.png": 310062,
	"./character-ability-cards/gloomhaven/PH/gh-vile-pestilence.png": 389778,
	"./character-ability-cards/gloomhaven/PH/gh-virulent-strain.png": 711170,
	"./character-ability-cards/gloomhaven/PH/gh-willing-sacrifice.png": 946607,
	"./character-ability-cards/gloomhaven/PH/gh-winged-congregation.png": 376901,
	"./character-ability-cards/gloomhaven/PH/gh-wretched-swarm.png": 952613,
	"./character-ability-cards/gloomhaven/QM/gh-bag-of-holding.png": 399110,
	"./character-ability-cards/gloomhaven/QM/gh-bladed-boomerang.png": 987334,
	"./character-ability-cards/gloomhaven/QM/gh-catastrophic-bomb.png": 953383,
	"./character-ability-cards/gloomhaven/QM/gh-cleaving-axe.png": 923159,
	"./character-ability-cards/gloomhaven/QM/gh-continual-supply.png": 135473,
	"./character-ability-cards/gloomhaven/QM/gh-crippling-bow.png": 828765,
	"./character-ability-cards/gloomhaven/QM/gh-crushing-hammer.png": 512355,
	"./character-ability-cards/gloomhaven/QM/gh-fortified-position.png": 212698,
	"./character-ability-cards/gloomhaven/QM/gh-giant-club.png": 974249,
	"./character-ability-cards/gloomhaven/QM/gh-hastened-step.png": 942749,
	"./character-ability-cards/gloomhaven/QM/gh-impaling-spear.png": 630937,
	"./character-ability-cards/gloomhaven/QM/gh-iron-bulwark.png": 596999,
	"./character-ability-cards/gloomhaven/QM/gh-oversized-pack.png": 269737,
	"./character-ability-cards/gloomhaven/QM/gh-portable-ballista.png": 166152,
	"./character-ability-cards/gloomhaven/QM/gh-proficiency.png": 756647,
	"./character-ability-cards/gloomhaven/QM/gh-qm-back.png": 620674,
	"./character-ability-cards/gloomhaven/QM/gh-quiver-of-arrows.png": 26271,
	"./character-ability-cards/gloomhaven/QM/gh-reforge.png": 130527,
	"./character-ability-cards/gloomhaven/QM/gh-refreshment.png": 840879,
	"./character-ability-cards/gloomhaven/QM/gh-reinforced-steel.png": 260853,
	"./character-ability-cards/gloomhaven/QM/gh-reserved-energy.png": 270628,
	"./character-ability-cards/gloomhaven/QM/gh-restock.png": 98450,
	"./character-ability-cards/gloomhaven/QM/gh-scroll-of-annihilation.png": 634230,
	"./character-ability-cards/gloomhaven/QM/gh-scroll-of-blizzards.png": 907539,
	"./character-ability-cards/gloomhaven/QM/gh-scroll-of-judgment.png": 554210,
	"./character-ability-cards/gloomhaven/QM/gh-scroll-of-lightning.png": 952532,
	"./character-ability-cards/gloomhaven/QM/gh-scroll-of-recall.png": 744599,
	"./character-ability-cards/gloomhaven/QM/gh-sharpening-kit.png": 72433,
	"./character-ability-cards/gloomhaven/QM/gh-side-pouch.png": 408719,
	"./character-ability-cards/gloomhaven/SB/gh-amputate.png": 718129,
	"./character-ability-cards/gloomhaven/SB/gh-battlefield-medicine.png": 908834,
	"./character-ability-cards/gloomhaven/SB/gh-bedside-manner.png": 335961,
	"./character-ability-cards/gloomhaven/SB/gh-blood-transfusion.png": 973984,
	"./character-ability-cards/gloomhaven/SB/gh-bloody-saw.png": 291942,
	"./character-ability-cards/gloomhaven/SB/gh-booster-shot.png": 208462,
	"./character-ability-cards/gloomhaven/SB/gh-curative-mixture.png": 924223,
	"./character-ability-cards/gloomhaven/SB/gh-do-no-harm.png": 170320,
	"./character-ability-cards/gloomhaven/SB/gh-euthanize.png": 680769,
	"./character-ability-cards/gloomhaven/SB/gh-first-aid.png": 218496,
	"./character-ability-cards/gloomhaven/SB/gh-gentlemans-anger.png": 505883,
	"./character-ability-cards/gloomhaven/SB/gh-grisly-trauma.png": 54397,
	"./character-ability-cards/gloomhaven/SB/gh-hamstring.png": 783015,
	"./character-ability-cards/gloomhaven/SB/gh-hand-of-the-surgeon.png": 867992,
	"./character-ability-cards/gloomhaven/SB/gh-hold-back-the-pain.png": 151377,
	"./character-ability-cards/gloomhaven/SB/gh-large-medical-pack.png": 684358,
	"./character-ability-cards/gloomhaven/SB/gh-master-physician.png": 360781,
	"./character-ability-cards/gloomhaven/SB/gh-medical-pack.png": 579404,
	"./character-ability-cards/gloomhaven/SB/gh-mobile-response.png": 6258,
	"./character-ability-cards/gloomhaven/SB/gh-precaution.png": 866119,
	"./character-ability-cards/gloomhaven/SB/gh-prep-for-surgery.png": 549866,
	"./character-ability-cards/gloomhaven/SB/gh-prescription.png": 31099,
	"./character-ability-cards/gloomhaven/SB/gh-prevention-is-key.png": 64618,
	"./character-ability-cards/gloomhaven/SB/gh-regenerative-tissue.png": 56891,
	"./character-ability-cards/gloomhaven/SB/gh-research-the-cure.png": 157616,
	"./character-ability-cards/gloomhaven/SB/gh-sb-back.png": 797727,
	"./character-ability-cards/gloomhaven/SB/gh-surgeons-satchel.png": 444100,
	"./character-ability-cards/gloomhaven/SB/gh-syringe.png": 633537,
	"./character-ability-cards/gloomhaven/SB/gh-teamwork.png": 345513,
	"./character-ability-cards/gloomhaven/SB/gh-triage.png": 506144,
	"./character-ability-cards/gloomhaven/SB/gh-vaccine.png": 361771,
	"./character-ability-cards/gloomhaven/SB/gh-vital-strike.png": 902269,
	"./character-ability-cards/gloomhaven/SC/gh-backstab.png": 931139,
	"./character-ability-cards/gloomhaven/SC/gh-burning-oil.png": 308985,
	"./character-ability-cards/gloomhaven/SC/gh-crippling-poison.png": 618768,
	"./character-ability-cards/gloomhaven/SC/gh-cull-the-weak.png": 639216,
	"./character-ability-cards/gloomhaven/SC/gh-duelists-advance.png": 890250,
	"./character-ability-cards/gloomhaven/SC/gh-flanking-strike.png": 731032,
	"./character-ability-cards/gloomhaven/SC/gh-flintlock.png": 115175,
	"./character-ability-cards/gloomhaven/SC/gh-flurry-of-blades.png": 440174,
	"./character-ability-cards/gloomhaven/SC/gh-gruesome-advantage.png": 371749,
	"./character-ability-cards/gloomhaven/SC/gh-hidden-daggers.png": 168179,
	"./character-ability-cards/gloomhaven/SC/gh-long-con.png": 538940,
	"./character-ability-cards/gloomhaven/SC/gh-open-wound.png": 482989,
	"./character-ability-cards/gloomhaven/SC/gh-pains-end.png": 763678,
	"./character-ability-cards/gloomhaven/SC/gh-quick-hands.png": 160663,
	"./character-ability-cards/gloomhaven/SC/gh-sc-back.png": 492381,
	"./character-ability-cards/gloomhaven/SC/gh-single-out.png": 856013,
	"./character-ability-cards/gloomhaven/SC/gh-sinister-opportunity.png": 477766,
	"./character-ability-cards/gloomhaven/SC/gh-smoke-bomb.png": 401179,
	"./character-ability-cards/gloomhaven/SC/gh-special-mixture.png": 209622,
	"./character-ability-cards/gloomhaven/SC/gh-spring-the-trap.png": 893096,
	"./character-ability-cards/gloomhaven/SC/gh-stick-to-the-shadows.png": 642429,
	"./character-ability-cards/gloomhaven/SC/gh-stiletto-storm.png": 60624,
	"./character-ability-cards/gloomhaven/SC/gh-swift-bow.png": 754354,
	"./character-ability-cards/gloomhaven/SC/gh-thiefs-knack.png": 477669,
	"./character-ability-cards/gloomhaven/SC/gh-throwing-knives.png": 764612,
	"./character-ability-cards/gloomhaven/SC/gh-tricksters-reversal.png": 783509,
	"./character-ability-cards/gloomhaven/SC/gh-venom-shiv.png": 304039,
	"./character-ability-cards/gloomhaven/SC/gh-visage-of-the-inevitable.png": 116016,
	"./character-ability-cards/gloomhaven/SC/gh-watch-it-burn.png": 587606,
	"./character-ability-cards/gloomhaven/SK/gh-angelic-ascension.png": 272088,
	"./character-ability-cards/gloomhaven/SK/gh-beacon-of-light.png": 217233,
	"./character-ability-cards/gloomhaven/SK/gh-bright-aegis.png": 373484,
	"./character-ability-cards/gloomhaven/SK/gh-brilliant-prayer.png": 167089,
	"./character-ability-cards/gloomhaven/SK/gh-burning-flash.png": 613211,
	"./character-ability-cards/gloomhaven/SK/gh-cautious-advance.png": 230991,
	"./character-ability-cards/gloomhaven/SK/gh-cleansing-force.png": 48606,
	"./character-ability-cards/gloomhaven/SK/gh-daybreak.png": 156908,
	"./character-ability-cards/gloomhaven/SK/gh-dazzling-charge.png": 492921,
	"./character-ability-cards/gloomhaven/SK/gh-defensive-stance.png": 31426,
	"./character-ability-cards/gloomhaven/SK/gh-divine-intervention.png": 687586,
	"./character-ability-cards/gloomhaven/SK/gh-empowering-command.png": 480268,
	"./character-ability-cards/gloomhaven/SK/gh-engulfing-radiance.png": 323015,
	"./character-ability-cards/gloomhaven/SK/gh-glorious-bolt.png": 995249,
	"./character-ability-cards/gloomhaven/SK/gh-hammer-blow.png": 563414,
	"./character-ability-cards/gloomhaven/SK/gh-holy-strike.png": 289110,
	"./character-ability-cards/gloomhaven/SK/gh-illuminate-the-target.png": 38539,
	"./character-ability-cards/gloomhaven/SK/gh-inspiring-sanctity.png": 477897,
	"./character-ability-cards/gloomhaven/SK/gh-lay-on-hands.png": 477811,
	"./character-ability-cards/gloomhaven/SK/gh-mobilizing-axiom.png": 482707,
	"./character-ability-cards/gloomhaven/SK/gh-path-of-glory.png": 688307,
	"./character-ability-cards/gloomhaven/SK/gh-practical-plans.png": 606727,
	"./character-ability-cards/gloomhaven/SK/gh-protective-blessing.png": 229266,
	"./character-ability-cards/gloomhaven/SK/gh-purifying-aura.png": 693911,
	"./character-ability-cards/gloomhaven/SK/gh-righteous-strength.png": 607623,
	"./character-ability-cards/gloomhaven/SK/gh-scales-of-justice.png": 780074,
	"./character-ability-cards/gloomhaven/SK/gh-sk-back.png": 805034,
	"./character-ability-cards/gloomhaven/SK/gh-supportive-chant.png": 75557,
	"./character-ability-cards/gloomhaven/SK/gh-tactical-order.png": 109441,
	"./character-ability-cards/gloomhaven/SK/gh-unwavering-mandate.png": 488820,
	"./character-ability-cards/gloomhaven/SK/gh-weapon-of-purity.png": 384254,
	"./character-ability-cards/gloomhaven/SS/gh-booming-proclamation.png": 741402,
	"./character-ability-cards/gloomhaven/SS/gh-call-to-action.png": 504874,
	"./character-ability-cards/gloomhaven/SS/gh-captivating-performance.png": 547782,
	"./character-ability-cards/gloomhaven/SS/gh-change-tempo.png": 26922,
	"./character-ability-cards/gloomhaven/SS/gh-commanding-presence.png": 478814,
	"./character-ability-cards/gloomhaven/SS/gh-crippling-chorus.png": 892275,
	"./character-ability-cards/gloomhaven/SS/gh-defensive-ditty.png": 352635,
	"./character-ability-cards/gloomhaven/SS/gh-disorienting-dirge.png": 561405,
	"./character-ability-cards/gloomhaven/SS/gh-echoing-aria.png": 929738,
	"./character-ability-cards/gloomhaven/SS/gh-inspiring-anthem.png": 46043,
	"./character-ability-cards/gloomhaven/SS/gh-marching-beat.png": 470027,
	"./character-ability-cards/gloomhaven/SS/gh-melody-and-harmony.png": 958137,
	"./character-ability-cards/gloomhaven/SS/gh-mobilizing-measure.png": 159809,
	"./character-ability-cards/gloomhaven/SS/gh-nightmare-serenade.png": 645815,
	"./character-ability-cards/gloomhaven/SS/gh-nimble-knife.png": 242690,
	"./character-ability-cards/gloomhaven/SS/gh-power-ballad.png": 13439,
	"./character-ability-cards/gloomhaven/SS/gh-provoke-terror.png": 635958,
	"./character-ability-cards/gloomhaven/SS/gh-pull-the-strings.png": 849832,
	"./character-ability-cards/gloomhaven/SS/gh-shadow-puppets.png": 837183,
	"./character-ability-cards/gloomhaven/SS/gh-singing-arrow.png": 904711,
	"./character-ability-cards/gloomhaven/SS/gh-song-of-speed.png": 995672,
	"./character-ability-cards/gloomhaven/SS/gh-soothing-lullaby.png": 470014,
	"./character-ability-cards/gloomhaven/SS/gh-ss-back.png": 421009,
	"./character-ability-cards/gloomhaven/SS/gh-throw-voice.png": 20204,
	"./character-ability-cards/gloomhaven/SS/gh-tranquil-trill.png": 446629,
	"./character-ability-cards/gloomhaven/SS/gh-tuning-the-outcome.png": 729155,
	"./character-ability-cards/gloomhaven/SS/gh-unending-chant.png": 649357,
	"./character-ability-cards/gloomhaven/SS/gh-warding-dagger.png": 833453,
	"./character-ability-cards/gloomhaven/SS/gh-wistful-wounding.png": 285207,
	"./character-ability-cards/gloomhaven/SU/gh-biting-wind.png": 372199,
	"./character-ability-cards/gloomhaven/SU/gh-black-fire.png": 489849,
	"./character-ability-cards/gloomhaven/SU/gh-bonded-might.png": 669856,
	"./character-ability-cards/gloomhaven/SU/gh-conjured-aid.png": 96721,
	"./character-ability-cards/gloomhaven/SU/gh-divided-mind.png": 561287,
	"./character-ability-cards/gloomhaven/SU/gh-earthen-steed.png": 415861,
	"./character-ability-cards/gloomhaven/SU/gh-endless-spikes.png": 645744,
	"./character-ability-cards/gloomhaven/SU/gh-ethereal-vines.png": 975898,
	"./character-ability-cards/gloomhaven/SU/gh-forged-ferocity.png": 101456,
	"./character-ability-cards/gloomhaven/SU/gh-grasping-the-void.png": 3346,
	"./character-ability-cards/gloomhaven/SU/gh-horned-majesty.png": 268034,
	"./character-ability-cards/gloomhaven/SU/gh-inexorable-momentum.png": 681025,
	"./character-ability-cards/gloomhaven/SU/gh-interplanar-mastery.png": 204023,
	"./character-ability-cards/gloomhaven/SU/gh-intervening-apparitions.png": 972008,
	"./character-ability-cards/gloomhaven/SU/gh-leathery-wings.png": 999872,
	"./character-ability-cards/gloomhaven/SU/gh-living-mountain.png": 256018,
	"./character-ability-cards/gloomhaven/SU/gh-living-night.png": 273170,
	"./character-ability-cards/gloomhaven/SU/gh-mighty-bond.png": 223900,
	"./character-ability-cards/gloomhaven/SU/gh-negative-energy.png": 190166,
	"./character-ability-cards/gloomhaven/SU/gh-oozing-manifestation.png": 508804,
	"./character-ability-cards/gloomhaven/SU/gh-otherworldly-rage.png": 653914,
	"./character-ability-cards/gloomhaven/SU/gh-staff-of-visions.png": 140612,
	"./character-ability-cards/gloomhaven/SU/gh-strength-in-numbers.png": 40490,
	"./character-ability-cards/gloomhaven/SU/gh-su-back.png": 151926,
	"./character-ability-cards/gloomhaven/SU/gh-tear-the-fabric.png": 891471,
	"./character-ability-cards/gloomhaven/SU/gh-unending-dominance.png": 545185,
	"./character-ability-cards/gloomhaven/SU/gh-unwavering-hand.png": 692818,
	"./character-ability-cards/gloomhaven/SU/gh-volatile-flame.png": 524795,
	"./character-ability-cards/gloomhaven/SU/gh-wild-animation.png": 180327,
	"./character-ability-cards/gloomhaven/SW/gh-aid-from-the-ether.png": 281599,
	"./character-ability-cards/gloomhaven/SW/gh-black-hole.png": 12345,
	"./character-ability-cards/gloomhaven/SW/gh-chromatic-explosion.png": 406213,
	"./character-ability-cards/gloomhaven/SW/gh-cold-fire.png": 849627,
	"./character-ability-cards/gloomhaven/SW/gh-cold-front.png": 629389,
	"./character-ability-cards/gloomhaven/SW/gh-crackling-air.png": 438470,
	"./character-ability-cards/gloomhaven/SW/gh-elemental-aid.png": 299691,
	"./character-ability-cards/gloomhaven/SW/gh-engulfed-in-flames.png": 147291,
	"./character-ability-cards/gloomhaven/SW/gh-fire-orbs.png": 561315,
	"./character-ability-cards/gloomhaven/SW/gh-flame-strike.png": 28808,
	"./character-ability-cards/gloomhaven/SW/gh-flashing-burst.png": 335574,
	"./character-ability-cards/gloomhaven/SW/gh-forked-beam.png": 651697,
	"./character-ability-cards/gloomhaven/SW/gh-freezing-nova.png": 228099,
	"./character-ability-cards/gloomhaven/SW/gh-frost-armor.png": 675528,
	"./character-ability-cards/gloomhaven/SW/gh-frozen-night.png": 880586,
	"./character-ability-cards/gloomhaven/SW/gh-hardened-spikes.png": 896769,
	"./character-ability-cards/gloomhaven/SW/gh-icy-blast.png": 18906,
	"./character-ability-cards/gloomhaven/SW/gh-impaling-eruption.png": 650125,
	"./character-ability-cards/gloomhaven/SW/gh-inferno.png": 530867,
	"./character-ability-cards/gloomhaven/SW/gh-living-torch.png": 315178,
	"./character-ability-cards/gloomhaven/SW/gh-mana-bolt.png": 964565,
	"./character-ability-cards/gloomhaven/SW/gh-reviving-ether.png": 866593,
	"./character-ability-cards/gloomhaven/SW/gh-ride-the-wind.png": 816018,
	"./character-ability-cards/gloomhaven/SW/gh-spirit-of-doom.png": 728590,
	"./character-ability-cards/gloomhaven/SW/gh-stone-fists.png": 386889,
	"./character-ability-cards/gloomhaven/SW/gh-sw-back.png": 779416,
	"./character-ability-cards/gloomhaven/SW/gh-twin-restoration.png": 511847,
	"./character-ability-cards/gloomhaven/SW/gh-zephyr-wings.png": 832240,
	"./character-ability-cards/gloomhaven/TI/gh-auto-turret.png": 132306,
	"./character-ability-cards/gloomhaven/TI/gh-chimeric-formula.png": 839852,
	"./character-ability-cards/gloomhaven/TI/gh-crank-bow.png": 236910,
	"./character-ability-cards/gloomhaven/TI/gh-curative-aerosol.png": 263156,
	"./character-ability-cards/gloomhaven/TI/gh-dangerous-contraption.png": 5779,
	"./character-ability-cards/gloomhaven/TI/gh-disintegration-beam.png": 378610,
	"./character-ability-cards/gloomhaven/TI/gh-disorienting-flash.png": 59105,
	"./character-ability-cards/gloomhaven/TI/gh-energizing-tonic.png": 246626,
	"./character-ability-cards/gloomhaven/TI/gh-enhancement-field.png": 842933,
	"./character-ability-cards/gloomhaven/TI/gh-flamethrower.png": 578358,
	"./character-ability-cards/gloomhaven/TI/gh-gas-canister.png": 53980,
	"./character-ability-cards/gloomhaven/TI/gh-harmless-contraption.png": 74561,
	"./character-ability-cards/gloomhaven/TI/gh-harsh-stimulants.png": 129025,
	"./character-ability-cards/gloomhaven/TI/gh-hook-gun.png": 731425,
	"./character-ability-cards/gloomhaven/TI/gh-ink-bomb.png": 651127,
	"./character-ability-cards/gloomhaven/TI/gh-jet-propulsion.png": 560078,
	"./character-ability-cards/gloomhaven/TI/gh-lethal-injection.png": 871229,
	"./character-ability-cards/gloomhaven/TI/gh-micro-bots.png": 208925,
	"./character-ability-cards/gloomhaven/TI/gh-murderous-contraption.png": 25688,
	"./character-ability-cards/gloomhaven/TI/gh-net-shooter.png": 931491,
	"./character-ability-cards/gloomhaven/TI/gh-noxious-vials.png": 61669,
	"./character-ability-cards/gloomhaven/TI/gh-potent-potables.png": 173558,
	"./character-ability-cards/gloomhaven/TI/gh-proximity-mine.png": 727869,
	"./character-ability-cards/gloomhaven/TI/gh-reinvigorating-elixir.png": 154161,
	"./character-ability-cards/gloomhaven/TI/gh-restorative-mist.png": 654250,
	"./character-ability-cards/gloomhaven/TI/gh-reviving-shock.png": 250009,
	"./character-ability-cards/gloomhaven/TI/gh-stamina-booster.png": 411148,
	"./character-ability-cards/gloomhaven/TI/gh-stun-shot.png": 855134,
	"./character-ability-cards/gloomhaven/TI/gh-ti-back.png": 388851,
	"./character-ability-cards/gloomhaven/TI/gh-tinkerers-tools.png": 859985,
	"./character-ability-cards/gloomhaven/TI/gh-toxic-bolt.png": 653747,
	"./character-ability-cards/gloomhaven/TI/gh-volatile-concoction.png": 159056,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-a-explosive-blitz.png": 361506,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-a-implode.png": 199303,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-a-knock-out-the-support.png": 317811,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-a-one-two-punch.png": 128818,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-a-piston-punch.png": 935,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-a-the-big-one.png": 201822,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-b-one-two-punch.png": 369239,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-b-the-big-one.png": 413835,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-collateral-damage.png": 996664,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-crash-protocol.png": 758274,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-crushing-weight.png": 834507,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-de-back.png": 748934,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-de-halt-back.png": 185352,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-de-halt-front.png": 578788,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-de-player-reference-back.png": 938225,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-de-player-reference-front.png": 425654,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-drill-fist.png": 458587,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-dust-cloud.png": 192849,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-explode.png": 181317,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-explosive-blitz.png": 805384,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-extra-fuel.png": 978868,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-fire-bombs.png": 730280,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-gut-punch.png": 432393,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-implode.png": 208730,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-insult-to-injury.png": 709734,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-knock-out-the-support.png": 342656,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-level.png": 874937,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-lobbed-charge.png": 601460,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-mech-suit.png": 83051,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-micro-missiles.png": 862075,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-nowhere-to-run.png": 362227,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-one-two-punch.png": 695194,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-piston-punch.png": 762857,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-remote-detonation.png": 439485,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-robotic-enhancement.png": 217524,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-rubble.png": 400562,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-the-big-one.png": 545511,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-the-bigger-one.png": 423796,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-wholesale-destruction.png": 492556,
	"./character-ability-cards/jaws-of-the-lion/DE/jl-windup.png": 919256,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-a-center-mass.png": 330715,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-a-close-cuts.png": 101228,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-a-disorienting-barrage.png": 778935,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-a-double-throw.png": 108195,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-a-second-wind.png": 262914,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-a-stopping-power.png": 941701,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-b-center-mass.png": 198923,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-b-close-cuts.png": 537530,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-bombardment.png": 115465,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-brutalize.png": 995441,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-camaraderie.png": 708323,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-care-package.png": 778901,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-center-mass.png": 872397,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-close-cuts.png": 792281,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-disorienting-barrage.png": 383929,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-double-throw.png": 721605,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-excessive-force.png": 334573,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-executioners-axe.png": 844659,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-extra-lift.png": 113168,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-fancy-hat.png": 554172,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-fearsome-efficiency.png": 216360,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-follow-through.png": 696824,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-ha-back.png": 388836,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-ha-halt-back.png": 613891,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-ha-halt-front.png": 819133,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-ha-player-reference-back.png": 412315,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-ha-player-reference-front.png": 438243,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-heart-seeker.png": 423354,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-overwatch.png": 28754,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-power-pitch.png": 194470,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-quick-turnaround.png": 788931,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-repeat-shot.png": 256825,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-retrieval.png": 948971,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-ricochet.png": 10862,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-ripped-from-the-flesh.png": 948528,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-second-wind.png": 265863,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-sharpened-blades.png": 524197,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-shrapnel.png": 162789,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-stopping-power.png": 155226,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-the-favorite.png": 334972,
	"./character-ability-cards/jaws-of-the-lion/HA/jl-the-new-favorite.png": 37737,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-a-blinding-sickle.png": 79973,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-a-desert-night.png": 796605,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-a-flaming-sickle.png": 807117,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-a-shield-spikes.png": 638453,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-a-shocking-advance.png": 562526,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-a-twirling-stabs.png": 41063,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-b-desert-night.png": 695226,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-b-flaming-sickle.png": 143902,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-barbaric-instincts.png": 713739,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-blade-dance.png": 627661,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-blinding-sickle.png": 3282,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-burn-away-the-dark.png": 660402,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-desert-night.png": 439674,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-fierce-brilliance.png": 872033,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-flame-shroud.png": 198166,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-flaming-sickle.png": 703254,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-flying-sickle.png": 474685,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-harvest-sickle.png": 393750,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-healing-sands.png": 406356,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-honorable-fury.png": 385371,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-horns-of-the-beast.png": 795762,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-no-fear.png": 458784,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-precision-strike.png": 890282,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-prismatic-sickle.png": 332228,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-radiant-sickle.png": 329424,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-rg-back.png": 652628,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-rg-halt-back.png": 271175,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-rg-halt-front.png": 212013,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-rg-player-reference-back.png": 235155,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-rg-player-reference-front.png": 435048,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-sand-devil.png": 632599,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-shield-of-the-desert.png": 542120,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-shield-spikes.png": 665630,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-shocking-advance.png": 700435,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-soaring-shield.png": 402454,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-strangling-chain.png": 853661,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-swift-strength.png": 362863,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-twirling-stabs.png": 941543,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-vicious-ballet.png": 425640,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-warmth-of-the-sun.png": 668157,
	"./character-ability-cards/jaws-of-the-lion/RG/jl-warrior-of-the-sun.png": 278870,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-a-black-boon.png": 987801,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-a-gift-of-the-void.png": 606989,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-a-lure-of-the-void.png": 788375,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-a-suggestion.png": 646426,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-a-turn-out-the-lights.png": 791500,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-a-wicked-scratch.png": 321341,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-b-lure-of-the-void.png": 397147,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-b-wicked-scratch.png": 352189,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-black-boon.png": 153030,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-close-to-the-abyss.png": 593186,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-cold-embrace.png": 84340,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-commanding-presence.png": 190165,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-crushing-cold.png": 395116,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-empowered-link.png": 355941,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-eye-of-the-void.png": 227505,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-freeze-the-soul.png": 491907,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-gift-of-the-void.png": 102328,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-give-and-take.png": 746259,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-grasp-of-doom.png": 682241,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-hateful-blast.png": 632573,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-lull-into-oblivion.png": 902170,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-lure-of-the-void.png": 198519,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-master-influence.png": 484148,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-possessed-by-fate.png": 28562,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-resigned-frenzy.png": 7657,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-sap-warmth.png": 410015,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-savage-instinct.png": 850601,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-signs-of-the-void.png": 653493,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-spirit-hunger.png": 613919,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-stand-fast.png": 183218,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-suggestion.png": 624780,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-surge-of-power.png": 109943,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-taunting-fate.png": 579511,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-the-last-journey.png": 859061,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-turn-out-the-lights.png": 403484,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-vw-back.png": 613981,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-vw-halt-back.png": 479736,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-vw-halt-front.png": 211415,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-vw-player-reference-back.png": 8510,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-vw-player-reference-front.png": 175630,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-wicked-scratch.png": 496818,
	"./character-ability-cards/jaws-of-the-lion/VW/jl-withering-conviction.png": 270489,
	"./character-ability-cards/trail-of-ashes/IN/toa-alone-in-the-end.png": 185804,
	"./character-ability-cards/trail-of-ashes/IN/toa-ancestral-blade.png": 103523,
	"./character-ability-cards/trail-of-ashes/IN/toa-ancient-banner.png": 342509,
	"./character-ability-cards/trail-of-ashes/IN/toa-aukotus-defiant-resolve.png": 698519,
	"./character-ability-cards/trail-of-ashes/IN/toa-awnus-retribution.png": 234905,
	"./character-ability-cards/trail-of-ashes/IN/toa-blood-of-champions.png": 146455,
	"./character-ability-cards/trail-of-ashes/IN/toa-farseers-pilum.png": 847272,
	"./character-ability-cards/trail-of-ashes/IN/toa-firebrand.png": 584502,
	"./character-ability-cards/trail-of-ashes/IN/toa-gift-of-the-dying.png": 770588,
	"./character-ability-cards/trail-of-ashes/IN/toa-gols-tonic.png": 478565,
	"./character-ability-cards/trail-of-ashes/IN/toa-hafs-reverence.png": 147553,
	"./character-ability-cards/trail-of-ashes/IN/toa-hands-of-three-tribes.png": 356200,
	"./character-ability-cards/trail-of-ashes/IN/toa-in-back.png": 877889,
	"./character-ability-cards/trail-of-ashes/IN/toa-kous-favor.png": 891664,
	"./character-ability-cards/trail-of-ashes/IN/toa-makus-deadly-aim.png": 810370,
	"./character-ability-cards/trail-of-ashes/IN/toa-matriarchs-dominance.png": 924474,
	"./character-ability-cards/trail-of-ashes/IN/toa-memory-of-the-hunt.png": 914935,
	"./character-ability-cards/trail-of-ashes/IN/toa-pakhs-lunge.png": 925860,
	"./character-ability-cards/trail-of-ashes/IN/toa-remnants-of-the-broken.png": 559479,
	"./character-ability-cards/trail-of-ashes/IN/toa-savvas-coreglass-knife.png": 846844,
	"./character-ability-cards/trail-of-ashes/IN/toa-the-arms-of-oxcepi.png": 218987,
	"./character-ability-cards/trail-of-ashes/IN/toa-the-grave-beckons.png": 380310,
	"./character-ability-cards/trail-of-ashes/IN/toa-tomegs-shield-arm.png": 19353,
	"./character-ability-cards/trail-of-ashes/IN/toa-vadis-last-stand.png": 204424,
	"./character-ability-cards/trail-of-ashes/IN/toa-vaskas-cunning.png": 427376,
	"./character-ability-cards/trail-of-ashes/IN/toa-vengeance-of-aksut.png": 681646,
	"./character-ability-cards/trail-of-ashes/IN/toa-vital-tether.png": 80106,
	"./character-ability-cards/trail-of-ashes/IN/toa-war-drums.png": 285835,
	"./character-ability-cards/trail-of-ashes/IN/toa-warborns-shout.png": 68301,
	"./character-ability-cards/trail-of-ashes/IN/toa-wielded-memory.png": 930481,
	"./character-ability-cards/trail-of-ashes/IN/toa-will-of-the-huntress.png": 593297,
	"./character-ability-cards/trail-of-ashes/RH/toa-a-balance-struck.png": 514715,
	"./character-ability-cards/trail-of-ashes/RH/toa-biting-cold.png": 511350,
	"./character-ability-cards/trail-of-ashes/RH/toa-blazing-streak.png": 243466,
	"./character-ability-cards/trail-of-ashes/RH/toa-bonechill.png": 907113,
	"./character-ability-cards/trail-of-ashes/RH/toa-bulwark-of-ether.png": 49025,
	"./character-ability-cards/trail-of-ashes/RH/toa-cold-snap.png": 812512,
	"./character-ability-cards/trail-of-ashes/RH/toa-cryoseism.png": 791469,
	"./character-ability-cards/trail-of-ashes/RH/toa-frostbite.png": 912493,
	"./character-ability-cards/trail-of-ashes/RH/toa-frozen-grasp.png": 615173,
	"./character-ability-cards/trail-of-ashes/RH/toa-glacial-cocoon.png": 445201,
	"./character-ability-cards/trail-of-ashes/RH/toa-hearthbolt.png": 668567,
	"./character-ability-cards/trail-of-ashes/RH/toa-heat-transfer.png": 758393,
	"./character-ability-cards/trail-of-ashes/RH/toa-heatwave.png": 293646,
	"./character-ability-cards/trail-of-ashes/RH/toa-homeostasis.png": 896920,
	"./character-ability-cards/trail-of-ashes/RH/toa-kleptotherapy.png": 881720,
	"./character-ability-cards/trail-of-ashes/RH/toa-pressure-spike.png": 384301,
	"./character-ability-cards/trail-of-ashes/RH/toa-pressure-wave.png": 471029,
	"./character-ability-cards/trail-of-ashes/RH/toa-raging-fire.png": 949393,
	"./character-ability-cards/trail-of-ashes/RH/toa-rapid-flux.png": 547576,
	"./character-ability-cards/trail-of-ashes/RH/toa-rh-back.png": 451616,
	"./character-ability-cards/trail-of-ashes/RH/toa-rimeshock.png": 88946,
	"./character-ability-cards/trail-of-ashes/RH/toa-scorched-path.png": 832179,
	"./character-ability-cards/trail-of-ashes/RH/toa-snap-freeze.png": 573149,
	"./character-ability-cards/trail-of-ashes/RH/toa-spreading-flames.png": 700915,
	"./character-ability-cards/trail-of-ashes/RH/toa-steamburst.png": 213788,
	"./character-ability-cards/trail-of-ashes/RH/toa-thermal-weaving.png": 580519,
	"./character-ability-cards/trail-of-ashes/RH/toa-thermotherapy.png": 129886,
	"./character-ability-cards/trail-of-ashes/RH/toa-torrid-blast.png": 100402,
	"./character-ability-cards/trail-of-ashes/RH/toa-unyielding-charge.png": 497266,
	"./character-ability-cards/trail-of-ashes/RH/toa-wreathed-in-flame.png": 282855,
	"./character-ability-cards/trail-of-ashes/SR/toa-amassed-formation.png": 680057,
	"./character-ability-cards/trail-of-ashes/SR/toa-cinnabar-seeding.png": 964765,
	"./character-ability-cards/trail-of-ashes/SR/toa-corundum-shell.png": 810058,
	"./character-ability-cards/trail-of-ashes/SR/toa-crystal-growth.png": 182662,
	"./character-ability-cards/trail-of-ashes/SR/toa-diamond-skin.png": 872027,
	"./character-ability-cards/trail-of-ashes/SR/toa-geode-barrage.png": 230703,
	"./character-ability-cards/trail-of-ashes/SR/toa-glistening-facets.png": 729008,
	"./character-ability-cards/trail-of-ashes/SR/toa-impaling-spike.png": 122515,
	"./character-ability-cards/trail-of-ashes/SR/toa-jubilant-recovery.png": 137784,
	"./character-ability-cards/trail-of-ashes/SR/toa-lightbury-quartz.png": 131737,
	"./character-ability-cards/trail-of-ashes/SR/toa-luminous-glow.png": 751352,
	"./character-ability-cards/trail-of-ashes/SR/toa-penetrating-fragments.png": 56727,
	"./character-ability-cards/trail-of-ashes/SR/toa-perforating-bore.png": 16884,
	"./character-ability-cards/trail-of-ashes/SR/toa-prismatic-ward.png": 890824,
	"./character-ability-cards/trail-of-ashes/SR/toa-radiating-crust.png": 326457,
	"./character-ability-cards/trail-of-ashes/SR/toa-rapid-calcification.png": 496582,
	"./character-ability-cards/trail-of-ashes/SR/toa-reciprocal-resonance.png": 750064,
	"./character-ability-cards/trail-of-ashes/SR/toa-reflecting-surface.png": 539885,
	"./character-ability-cards/trail-of-ashes/SR/toa-remineralize.png": 158945,
	"./character-ability-cards/trail-of-ashes/SR/toa-ruinous-shard.png": 117430,
	"./character-ability-cards/trail-of-ashes/SR/toa-searing-stone.png": 437893,
	"./character-ability-cards/trail-of-ashes/SR/toa-seismic-shockwave.png": 453302,
	"./character-ability-cards/trail-of-ashes/SR/toa-serrated-razor.png": 577900,
	"./character-ability-cards/trail-of-ashes/SR/toa-spiked-carapace.png": 683452,
	"./character-ability-cards/trail-of-ashes/SR/toa-splinter-burst.png": 539480,
	"./character-ability-cards/trail-of-ashes/SR/toa-sr-back.png": 285343,
	"./character-ability-cards/trail-of-ashes/SR/toa-triboluminescence.png": 458963,
	"./character-ability-cards/trail-of-ashes/SR/toa-turbulent-absorption.png": 164308,
	"./character-ability-cards/trail-of-ashes/SR/toa-unyielding-stalagmite.png": 416776,
	"./character-ability-cards/trail-of-ashes/SR/toa-violent-shatter.png": 36985,
	"./character-ability-cards/trail-of-ashes/SR/toa-vital-outburst.png": 420408,
	"./character-ability-cards/trail-of-ashes/TP/toa-aerial-dominance.png": 807618,
	"./character-ability-cards/trail-of-ashes/TP/toa-air-current.png": 499092,
	"./character-ability-cards/trail-of-ashes/TP/toa-arc-reaction.png": 539807,
	"./character-ability-cards/trail-of-ashes/TP/toa-arcblast.png": 563990,
	"./character-ability-cards/trail-of-ashes/TP/toa-breakneck-blitz.png": 875655,
	"./character-ability-cards/trail-of-ashes/TP/toa-channeled-energy.png": 197323,
	"./character-ability-cards/trail-of-ashes/TP/toa-electric-current.png": 763454,
	"./character-ability-cards/trail-of-ashes/TP/toa-electromagnetic-pulse.png": 572369,
	"./character-ability-cards/trail-of-ashes/TP/toa-electrostatic-bypass.png": 83750,
	"./character-ability-cards/trail-of-ashes/TP/toa-energy-siphon.png": 352044,
	"./character-ability-cards/trail-of-ashes/TP/toa-flash-of-lightning.png": 703272,
	"./character-ability-cards/trail-of-ashes/TP/toa-hard-target.png": 212174,
	"./character-ability-cards/trail-of-ashes/TP/toa-hurricane.png": 820312,
	"./character-ability-cards/trail-of-ashes/TP/toa-jetstream-gust.png": 869972,
	"./character-ability-cards/trail-of-ashes/TP/toa-lightbender.png": 407873,
	"./character-ability-cards/trail-of-ashes/TP/toa-nimble-resilience.png": 758824,
	"./character-ability-cards/trail-of-ashes/TP/toa-protective-gale.png": 143094,
	"./character-ability-cards/trail-of-ashes/TP/toa-radiant-explosion.png": 617729,
	"./character-ability-cards/trail-of-ashes/TP/toa-rejuvenating-charge.png": 812329,
	"./character-ability-cards/trail-of-ashes/TP/toa-rushing-wind.png": 209127,
	"./character-ability-cards/trail-of-ashes/TP/toa-scorching-arcbolt.png": 97087,
	"./character-ability-cards/trail-of-ashes/TP/toa-shock-therapy.png": 125582,
	"./character-ability-cards/trail-of-ashes/TP/toa-spark-conduit.png": 595260,
	"./character-ability-cards/trail-of-ashes/TP/toa-static-shock.png": 699030,
	"./character-ability-cards/trail-of-ashes/TP/toa-storm-lightning.png": 518636,
	"./character-ability-cards/trail-of-ashes/TP/toa-stormy-retribution.png": 707258,
	"./character-ability-cards/trail-of-ashes/TP/toa-surging-storm.png": 453172,
	"./character-ability-cards/trail-of-ashes/TP/toa-swift-strike.png": 899862,
	"./character-ability-cards/trail-of-ashes/TP/toa-tp-back.png": 352662,
	"./character-ability-cards/trail-of-ashes/TP/toa-voltaic-burst.png": 218714,
	"./character-ability-cards/trail-of-ashes/TR/toa-barbed-onslaught.png": 957611,
	"./character-ability-cards/trail-of-ashes/TR/toa-bed-of-roses.png": 599290,
	"./character-ability-cards/trail-of-ashes/TR/toa-black-rose.png": 598519,
	"./character-ability-cards/trail-of-ashes/TR/toa-branched-slam.png": 4672,
	"./character-ability-cards/trail-of-ashes/TR/toa-bright-skies.png": 873533,
	"./character-ability-cards/trail-of-ashes/TR/toa-cover-of-green.png": 946640,
	"./character-ability-cards/trail-of-ashes/TR/toa-dawns-gift.png": 357223,
	"./character-ability-cards/trail-of-ashes/TR/toa-devoured-by-thorns.png": 535287,
	"./character-ability-cards/trail-of-ashes/TR/toa-encased-in-thorns.png": 967827,
	"./character-ability-cards/trail-of-ashes/TR/toa-extended-branch.png": 811734,
	"./character-ability-cards/trail-of-ashes/TR/toa-fissive-eruption.png": 31740,
	"./character-ability-cards/trail-of-ashes/TR/toa-floral-burst.png": 93662,
	"./character-ability-cards/trail-of-ashes/TR/toa-impaling-command.png": 324877,
	"./character-ability-cards/trail-of-ashes/TR/toa-jagged-clutch.png": 802321,
	"./character-ability-cards/trail-of-ashes/TR/toa-lashing-thorns.png": 795971,
	"./character-ability-cards/trail-of-ashes/TR/toa-midsummer.png": 49345,
	"./character-ability-cards/trail-of-ashes/TR/toa-natures-fury.png": 279349,
	"./character-ability-cards/trail-of-ashes/TR/toa-outward-spurs.png": 161465,
	"./character-ability-cards/trail-of-ashes/TR/toa-photosynthesis.png": 291374,
	"./character-ability-cards/trail-of-ashes/TR/toa-prickly-situation.png": 178081,
	"./character-ability-cards/trail-of-ashes/TR/toa-rabid-undergrowth.png": 467994,
	"./character-ability-cards/trail-of-ashes/TR/toa-ravaged-earth.png": 981905,
	"./character-ability-cards/trail-of-ashes/TR/toa-shrewd-overgrowth.png": 835433,
	"./character-ability-cards/trail-of-ashes/TR/toa-solar-flare.png": 471966,
	"./character-ability-cards/trail-of-ashes/TR/toa-spiked-embrace.png": 876351,
	"./character-ability-cards/trail-of-ashes/TR/toa-superradiance.png": 691162,
	"./character-ability-cards/trail-of-ashes/TR/toa-thornstride.png": 97420,
	"./character-ability-cards/trail-of-ashes/TR/toa-tr-back.png": 307566,
	"./character-ability-cards/trail-of-ashes/TR/toa-twisted-thistle.png": 305818,
	"./character-ability-cards/trail-of-ashes/TR/toa-violent-sprout.png": 51171,
	"./character-ability-cards/trail-of-ashes/TR/toa-welcome-to-the-jungle.png": 545092,
	"./character-ability-cards/trail-of-ashes/VQ/toa-beckoning-of-the-beast.png": 453523,
	"./character-ability-cards/trail-of-ashes/VQ/toa-blackout.png": 29956,
	"./character-ability-cards/trail-of-ashes/VQ/toa-blasphemous-charge.png": 879632,
	"./character-ability-cards/trail-of-ashes/VQ/toa-blazing-torment.png": 721253,
	"./character-ability-cards/trail-of-ashes/VQ/toa-bringer-of-grief.png": 377263,
	"./character-ability-cards/trail-of-ashes/VQ/toa-brutal-awakening.png": 110675,
	"./character-ability-cards/trail-of-ashes/VQ/toa-condemnation.png": 747280,
	"./character-ability-cards/trail-of-ashes/VQ/toa-crazed-leap.png": 674708,
	"./character-ability-cards/trail-of-ashes/VQ/toa-demons-aid.png": 30989,
	"./character-ability-cards/trail-of-ashes/VQ/toa-embrace-the-chaos.png": 542772,
	"./character-ability-cards/trail-of-ashes/VQ/toa-extended-horns.png": 619339,
	"./character-ability-cards/trail-of-ashes/VQ/toa-fatal-retribution.png": 202206,
	"./character-ability-cards/trail-of-ashes/VQ/toa-fiendish-power.png": 31544,
	"./character-ability-cards/trail-of-ashes/VQ/toa-first-to-strike.png": 502861,
	"./character-ability-cards/trail-of-ashes/VQ/toa-forged-from-fire.png": 945818,
	"./character-ability-cards/trail-of-ashes/VQ/toa-gravedigger.png": 805515,
	"./character-ability-cards/trail-of-ashes/VQ/toa-infused-charge.png": 785753,
	"./character-ability-cards/trail-of-ashes/VQ/toa-life-in-death.png": 144366,
	"./character-ability-cards/trail-of-ashes/VQ/toa-living-nightmare.png": 199440,
	"./character-ability-cards/trail-of-ashes/VQ/toa-malicious-defamation.png": 163750,
	"./character-ability-cards/trail-of-ashes/VQ/toa-out-of-the-shadows.png": 504882,
	"./character-ability-cards/trail-of-ashes/VQ/toa-raging-pandemonium.png": 518189,
	"./character-ability-cards/trail-of-ashes/VQ/toa-sadistic-swipe.png": 614428,
	"./character-ability-cards/trail-of-ashes/VQ/toa-searing-coals.png": 924287,
	"./character-ability-cards/trail-of-ashes/VQ/toa-shared-suffering.png": 995790,
	"./character-ability-cards/trail-of-ashes/VQ/toa-silent-finisher.png": 991434,
	"./character-ability-cards/trail-of-ashes/VQ/toa-sinister-enslavement.png": 951958,
	"./character-ability-cards/trail-of-ashes/VQ/toa-siphoning-life.png": 595626,
	"./character-ability-cards/trail-of-ashes/VQ/toa-slaughter-the-weak.png": 587717,
	"./character-ability-cards/trail-of-ashes/VQ/toa-torn-apart.png": 310425,
	"./character-ability-cards/trail-of-ashes/VQ/toa-tumultuous-uproar.png": 563788,
	"./character-ability-cards/trail-of-ashes/VQ/toa-unending-misery.png": 279579,
	"./character-ability-cards/trail-of-ashes/VQ/toa-unnatural-control.png": 203404,
	"./character-ability-cards/trail-of-ashes/VQ/toa-unstoppable-surge.png": 915919,
	"./character-ability-cards/trail-of-ashes/VQ/toa-utter-catastrophe.png": 536269,
	"./character-ability-cards/trail-of-ashes/VQ/toa-vengeance-incarnate.png": 898710,
	"./character-ability-cards/trail-of-ashes/VQ/toa-vq-back.png": 489234,
	"./character-ability-cards/trail-of-ashes/VQ/toa-wall-of-flames.png": 162814,
	"./character-ability-cards/trail-of-ashes/VQ/toa-wings-of-hell.png": 770368,
	"./character-mats/crimson-scales/cs-amber-aegis-back.png": 864650,
	"./character-mats/crimson-scales/cs-amber-aegis.png": 278765,
	"./character-mats/crimson-scales/cs-artificer-back.png": 321704,
	"./character-mats/crimson-scales/cs-artificer.png": 583125,
	"./character-mats/crimson-scales/cs-bombard-back.png": 212831,
	"./character-mats/crimson-scales/cs-bombard.png": 76780,
	"./character-mats/crimson-scales/cs-brightspark-back.png": 605490,
	"./character-mats/crimson-scales/cs-brightspark.png": 190481,
	"./character-mats/crimson-scales/cs-chainguard-back.png": 984705,
	"./character-mats/crimson-scales/cs-chainguard.png": 651191,
	"./character-mats/crimson-scales/cs-chieftain-back.png": 152140,
	"./character-mats/crimson-scales/cs-chieftain.png": 538980,
	"./character-mats/crimson-scales/cs-fire-knight-back.png": 344378,
	"./character-mats/crimson-scales/cs-fire-knight.png": 442838,
	"./character-mats/crimson-scales/cs-hierophant-back.png": 787718,
	"./character-mats/crimson-scales/cs-hierophant.png": 969595,
	"./character-mats/crimson-scales/cs-hollowpact-back.png": 297160,
	"./character-mats/crimson-scales/cs-hollowpact.png": 285104,
	"./character-mats/crimson-scales/cs-luminary-back.png": 819014,
	"./character-mats/crimson-scales/cs-luminary.png": 586351,
	"./character-mats/crimson-scales/cs-mirefoot-back.png": 940624,
	"./character-mats/crimson-scales/cs-mirefoot.png": 141935,
	"./character-mats/crimson-scales/cs-ruinmaw-back.png": 555124,
	"./character-mats/crimson-scales/cs-ruinmaw.png": 363929,
	"./character-mats/crimson-scales/cs-spirit-caller-back.png": 588116,
	"./character-mats/crimson-scales/cs-spirit-caller.png": 553687,
	"./character-mats/crimson-scales/cs-starslinger-back.png": 598672,
	"./character-mats/crimson-scales/cs-starslinger.png": 787898,
	"./character-mats/forgotten-circles/fc-diviner-back.png": 110185,
	"./character-mats/forgotten-circles/fc-diviner.png": 553497,
	"./character-mats/frosthaven/fh-banner-spear-back.png": 385888,
	"./character-mats/frosthaven/fh-banner-spear.png": 923438,
	"./character-mats/frosthaven/fh-blinkblade-back.png": 50889,
	"./character-mats/frosthaven/fh-blinkblade.png": 68607,
	"./character-mats/frosthaven/fh-boneshaper-back.png": 719847,
	"./character-mats/frosthaven/fh-boneshaper.png": 70621,
	"./character-mats/frosthaven/fh-crashing-tide-back.png": 269428,
	"./character-mats/frosthaven/fh-crashing-tide.png": 368738,
	"./character-mats/frosthaven/fh-deathwalker-back.png": 138886,
	"./character-mats/frosthaven/fh-deathwalker.png": 633682,
	"./character-mats/frosthaven/fh-deepwraith-back.png": 477452,
	"./character-mats/frosthaven/fh-deepwraith.png": 214425,
	"./character-mats/frosthaven/fh-drifter-back.png": 816462,
	"./character-mats/frosthaven/fh-drifter.png": 733032,
	"./character-mats/frosthaven/fh-frozen-fist-back.png": 191205,
	"./character-mats/frosthaven/fh-frozen-fist.png": 907402,
	"./character-mats/frosthaven/fh-geminate-back.png": 369345,
	"./character-mats/frosthaven/fh-geminate.png": 968537,
	"./character-mats/frosthaven/fh-hive-back.png": 638270,
	"./character-mats/frosthaven/fh-hive.png": 457397,
	"./character-mats/frosthaven/fh-infuser-back.png": 547936,
	"./character-mats/frosthaven/fh-infuser.png": 108918,
	"./character-mats/frosthaven/fh-metal-mosaic-back.png": 251400,
	"./character-mats/frosthaven/fh-metal-mosaic.png": 471517,
	"./character-mats/frosthaven/fh-pain-conduit-back.png": 709452,
	"./character-mats/frosthaven/fh-pain-conduit.png": 274818,
	"./character-mats/frosthaven/fh-pyroclast-back.png": 743222,
	"./character-mats/frosthaven/fh-pyroclast.png": 246390,
	"./character-mats/frosthaven/fh-shattersong-back.png": 724278,
	"./character-mats/frosthaven/fh-shattersong.png": 948139,
	"./character-mats/frosthaven/fh-snowdancer-back.png": 674033,
	"./character-mats/frosthaven/fh-snowdancer.png": 247449,
	"./character-mats/frosthaven/fh-trapper-back.png": 391549,
	"./character-mats/frosthaven/fh-trapper.png": 908135,
	"./character-mats/gloomhaven/gh-beast-tyrant-back.png": 925005,
	"./character-mats/gloomhaven/gh-beast-tyrant.png": 674259,
	"./character-mats/gloomhaven/gh-berserker-back.png": 610745,
	"./character-mats/gloomhaven/gh-berserker.png": 72327,
	"./character-mats/gloomhaven/gh-bladeswarm-back.png": 566591,
	"./character-mats/gloomhaven/gh-bladeswarm.png": 587280,
	"./character-mats/gloomhaven/gh-brute-back.png": 849221,
	"./character-mats/gloomhaven/gh-brute.png": 23950,
	"./character-mats/gloomhaven/gh-cragheart-back.png": 643341,
	"./character-mats/gloomhaven/gh-cragheart.png": 807327,
	"./character-mats/gloomhaven/gh-doomstalker-back.png": 546825,
	"./character-mats/gloomhaven/gh-doomstalker.png": 785058,
	"./character-mats/gloomhaven/gh-elementalist-back.png": 29559,
	"./character-mats/gloomhaven/gh-elementalist.png": 744081,
	"./character-mats/gloomhaven/gh-mindthief-back.png": 906246,
	"./character-mats/gloomhaven/gh-mindthief.png": 29368,
	"./character-mats/gloomhaven/gh-nightshroud-back.png": 511718,
	"./character-mats/gloomhaven/gh-nightshroud.png": 81302,
	"./character-mats/gloomhaven/gh-plagueherald-back.png": 477729,
	"./character-mats/gloomhaven/gh-plagueherald.png": 179713,
	"./character-mats/gloomhaven/gh-quartermaster-back.png": 870463,
	"./character-mats/gloomhaven/gh-quartermaster.png": 36944,
	"./character-mats/gloomhaven/gh-sawbones-back.png": 416049,
	"./character-mats/gloomhaven/gh-sawbones.png": 25714,
	"./character-mats/gloomhaven/gh-scoundrel-back.png": 650770,
	"./character-mats/gloomhaven/gh-scoundrel.png": 896705,
	"./character-mats/gloomhaven/gh-soothsinger-back.png": 937431,
	"./character-mats/gloomhaven/gh-soothsinger.png": 418022,
	"./character-mats/gloomhaven/gh-spellweaver-back.png": 992351,
	"./character-mats/gloomhaven/gh-spellweaver.png": 233067,
	"./character-mats/gloomhaven/gh-summoner-back.png": 730970,
	"./character-mats/gloomhaven/gh-summoner.png": 805521,
	"./character-mats/gloomhaven/gh-sunkeeper-back.png": 489821,
	"./character-mats/gloomhaven/gh-sunkeeper.png": 374629,
	"./character-mats/gloomhaven/gh-tinkerer-back.png": 584931,
	"./character-mats/gloomhaven/gh-tinkerer.png": 313118,
	"./character-mats/jaws-of-the-lion/jl-demolitionist-back.png": 556905,
	"./character-mats/jaws-of-the-lion/jl-demolitionist-front.png": 234094,
	"./character-mats/jaws-of-the-lion/jl-hatchet-back.png": 618549,
	"./character-mats/jaws-of-the-lion/jl-hatchet-front.png": 563024,
	"./character-mats/jaws-of-the-lion/jl-red-guard-back.png": 995350,
	"./character-mats/jaws-of-the-lion/jl-red-guard-front.png": 15839,
	"./character-mats/jaws-of-the-lion/jl-voidwarden-back.png": 291593,
	"./character-mats/jaws-of-the-lion/jl-voidwarden-front.png": 977367,
	"./character-mats/trail-of-ashes/toa-incarnate-back.png": 690344,
	"./character-mats/trail-of-ashes/toa-incarnate.png": 27895,
	"./character-mats/trail-of-ashes/toa-rimehearth-back.png": 618624,
	"./character-mats/trail-of-ashes/toa-rimehearth.png": 952019,
	"./character-mats/trail-of-ashes/toa-shardrender-back.png": 454614,
	"./character-mats/trail-of-ashes/toa-shardrender.png": 183689,
	"./character-mats/trail-of-ashes/toa-tempest-back.png": 317864,
	"./character-mats/trail-of-ashes/toa-tempest.png": 522184,
	"./character-mats/trail-of-ashes/toa-thornreaper-back.png": 257658,
	"./character-mats/trail-of-ashes/toa-thornreaper.png": 780716,
	"./character-mats/trail-of-ashes/toa-vanquisher-back.png": 657027,
	"./character-mats/trail-of-ashes/toa-vanquisher.png": 530312,
	"./character-perks/crimson-scales/cs-amber-aegis-perks.png": 347853,
	"./character-perks/crimson-scales/cs-artificer-perks.png": 129708,
	"./character-perks/crimson-scales/cs-bombard-perks.png": 286341,
	"./character-perks/crimson-scales/cs-brightspark-perks.png": 655114,
	"./character-perks/crimson-scales/cs-chainguard-perks.png": 312645,
	"./character-perks/crimson-scales/cs-chieftain-perks.png": 830950,
	"./character-perks/crimson-scales/cs-fire-knight-perks.png": 882780,
	"./character-perks/crimson-scales/cs-hierophant-perks.png": 467244,
	"./character-perks/crimson-scales/cs-hollowpact-perks.png": 114383,
	"./character-perks/crimson-scales/cs-luminary-perks.png": 401641,
	"./character-perks/crimson-scales/cs-mirefoot-perks.png": 180612,
	"./character-perks/crimson-scales/cs-party-sheet.png": 149358,
	"./character-perks/crimson-scales/cs-ruinmaw-perks.png": 490532,
	"./character-perks/crimson-scales/cs-spirit-caller-perks.png": 811490,
	"./character-perks/crimson-scales/cs-starslinger-perks.png": 435353,
	"./character-perks/forgotten-circles/fc-diviner-perks-orig.png": 581699,
	"./character-perks/forgotten-circles/fc-diviner-perks.png": 153734,
	"./character-perks/frosthaven/fh-banner-spear-perks.png": 613351,
	"./character-perks/frosthaven/fh-blinkblade-perks.png": 54470,
	"./character-perks/frosthaven/fh-boneshaper-perks.png": 978331,
	"./character-perks/frosthaven/fh-crashing-tide-perks.png": 810254,
	"./character-perks/frosthaven/fh-deathwalker-perks.png": 329107,
	"./character-perks/frosthaven/fh-deepwraith-perks.png": 766195,
	"./character-perks/frosthaven/fh-drifter-perks.png": 643699,
	"./character-perks/frosthaven/fh-frozen-fist-perks.png": 147019,
	"./character-perks/frosthaven/fh-geminate-perks.png": 582898,
	"./character-perks/frosthaven/fh-hive-perks.png": 780667,
	"./character-perks/frosthaven/fh-infuser-perks.png": 815119,
	"./character-perks/frosthaven/fh-metal-mosaic-perks.png": 904710,
	"./character-perks/frosthaven/fh-pain-conduit-perks.png": 244185,
	"./character-perks/frosthaven/fh-pyroclast-perks.png": 1672,
	"./character-perks/frosthaven/fh-shattersong-perks.png": 992328,
	"./character-perks/frosthaven/fh-snowdancer-perks.png": 49841,
	"./character-perks/frosthaven/fh-trapper-perks.png": 760676,
	"./character-perks/gloomhaven/gh-beast-tyrant-perks-orig.png": 664042,
	"./character-perks/gloomhaven/gh-beast-tyrant-perks.png": 354621,
	"./character-perks/gloomhaven/gh-berserker-perks-orig.png": 317829,
	"./character-perks/gloomhaven/gh-berserker-perks.png": 14690,
	"./character-perks/gloomhaven/gh-bladeswarm-perks-orig.png": 878250,
	"./character-perks/gloomhaven/gh-bladeswarm-perks.png": 254172,
	"./character-perks/gloomhaven/gh-brute-perks-orig.png": 659888,
	"./character-perks/gloomhaven/gh-brute-perks.png": 244801,
	"./character-perks/gloomhaven/gh-cragheart-perks-orig.png": 642605,
	"./character-perks/gloomhaven/gh-cragheart-perks.png": 523780,
	"./character-perks/gloomhaven/gh-doomstalker-perks-orig.png": 909282,
	"./character-perks/gloomhaven/gh-doomstalker-perks.png": 409698,
	"./character-perks/gloomhaven/gh-elementalist-perks-orig.png": 826707,
	"./character-perks/gloomhaven/gh-elementalist-perks.png": 867518,
	"./character-perks/gloomhaven/gh-mindthief-perks-orig.png": 290685,
	"./character-perks/gloomhaven/gh-mindthief-perks.png": 821567,
	"./character-perks/gloomhaven/gh-nightshroud-perks-orig.png": 296417,
	"./character-perks/gloomhaven/gh-nightshroud-perks.png": 83383,
	"./character-perks/gloomhaven/gh-party-sheet-orig.png": 385796,
	"./character-perks/gloomhaven/gh-party-sheet.png": 779717,
	"./character-perks/gloomhaven/gh-plagueherald-perks-orig.png": 577411,
	"./character-perks/gloomhaven/gh-plagueherald-perks.png": 951140,
	"./character-perks/gloomhaven/gh-quartermaster-perks-orig.png": 893248,
	"./character-perks/gloomhaven/gh-quartermaster-perks.png": 391376,
	"./character-perks/gloomhaven/gh-sawbones-perks-orig.png": 234745,
	"./character-perks/gloomhaven/gh-sawbones-perks.png": 81438,
	"./character-perks/gloomhaven/gh-scoundrel-perks-orig.png": 200954,
	"./character-perks/gloomhaven/gh-scoundrel-perks.png": 447752,
	"./character-perks/gloomhaven/gh-soothsinger-perks-orig.png": 120498,
	"./character-perks/gloomhaven/gh-soothsinger-perks.png": 180568,
	"./character-perks/gloomhaven/gh-spellweaver-perks-orig.png": 446639,
	"./character-perks/gloomhaven/gh-spellweaver-perks.png": 143953,
	"./character-perks/gloomhaven/gh-summoner-perks-orig.png": 946591,
	"./character-perks/gloomhaven/gh-summoner-perks.png": 369505,
	"./character-perks/gloomhaven/gh-sunkeeper-perks-orig.png": 142680,
	"./character-perks/gloomhaven/gh-sunkeeper-perks.png": 381722,
	"./character-perks/gloomhaven/gh-tinkerer-perks-orig.png": 547821,
	"./character-perks/gloomhaven/gh-tinkerer-perks.png": 388336,
	"./character-perks/jaws-of-the-lion/jl-demolitionist-perks.png": 497173,
	"./character-perks/jaws-of-the-lion/jl-hatchet-perks.png": 727402,
	"./character-perks/jaws-of-the-lion/jl-red-guard-perks.png": 194877,
	"./character-perks/jaws-of-the-lion/jl-voidwarden-perks.png": 943122,
	"./character-perks/trail-of-ashes/toa-incarnate-perks.png": 55642,
	"./character-perks/trail-of-ashes/toa-rimehearth-perks.png": 943453,
	"./character-perks/trail-of-ashes/toa-shardrender-perks.png": 155883,
	"./character-perks/trail-of-ashes/toa-tempest-perks.png": 733787,
	"./character-perks/trail-of-ashes/toa-thornreaper-perks.png": 418509,
	"./character-perks/trail-of-ashes/toa-vanquisher-perks.png": 214257,
	"./charts/ZZ/zz.txt": 528857,
	"./charts/frosthaven/die-lines/fh-alchemy-chart-page-1-dl.png": 292054,
	"./charts/frosthaven/die-lines/fh-alchemy-chart-page-2-dl.png": 524758,
	"./charts/frosthaven/die-lines/fh-alchemy-chart-page-3-dl.png": 861201,
	"./charts/frosthaven/die-lines/fh-campaign-sheet-dl.png": 720108,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-1-1-dl.png": 362448,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-1-2-dl.png": 59129,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-1-3-dl.png": 525172,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-1-4-dl.png": 779496,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-2-1-dl.png": 272717,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-2-2-dl.png": 189354,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-2-3-dl.png": 666458,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-2-4-dl.png": 751637,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-3-1-dl.png": 70467,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-3-2-dl.png": 115878,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-3-3-dl.png": 389380,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-3-4-dl.png": 963933,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-4-1-dl.png": 834820,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-4-2-dl.png": 575318,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-4-3-dl.png": 171941,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-4-4-dl.png": 224530,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-5-1-dl.png": 68943,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-5-2-dl.png": 364438,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-5-3-dl.png": 271870,
	"./charts/frosthaven/die-lines/fh-scenario-flowchart-page-5-4-dl.png": 932463,
	"./charts/frosthaven/no-die-lines/fh-alchemy-chart-page-1-ndl.png": 105288,
	"./charts/frosthaven/no-die-lines/fh-alchemy-chart-page-2-ndl.png": 843004,
	"./charts/frosthaven/no-die-lines/fh-alchemy-chart-page-3-ndl.png": 845585,
	"./charts/frosthaven/no-die-lines/fh-campaign-sheet-ndl.png": 2177,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-1-1-ndl.png": 662477,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-1-2-ndl.png": 764870,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-1-3-ndl.png": 264336,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-1-4-ndl.png": 375606,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-2-1-ndl.png": 455557,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-2-2-ndl.png": 168313,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-2-3-ndl.png": 441440,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-2-4-ndl.png": 365242,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-3-1-ndl.png": 550717,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-3-2-ndl.png": 497096,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-3-3-ndl.png": 137562,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-3-4-ndl.png": 449902,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-4-1-ndl.png": 698037,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-4-2-ndl.png": 313469,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-4-3-ndl.png": 48160,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-4-4-ndl.png": 224029,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-5-1-ndl.png": 401405,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-5-2-ndl.png": 719994,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-5-3-ndl.png": 866873,
	"./charts/frosthaven/no-die-lines/fh-scenario-flowchart-page-5-4-ndl.png": 671746,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-01-v1.png": 887620,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-02-v1.png": 540705,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-03-v1.png": 811458,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-04-v1.png": 746694,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-05-v1.png": 136794,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-06-v1.png": 527314,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-07-v1.png": 113216,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-08-v1.png": 976915,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-09-v1.png": 329393,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-10-v1.png": 563369,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-11-v1.png": 287062,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-12-v1.png": 600797,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-13-v1.png": 222096,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-14-v1.png": 412304,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-15-v1.png": 343331,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-16-v1.png": 718470,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-17-v1.png": 121396,
	"./deprecated-assets/crimson-scales/attack-modifiers/AA-V1/cs-am-aa-back-v1.png": 428041,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-01-v1.png": 781985,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-02-v1.png": 678142,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-03-v1.png": 59918,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-04-v1.png": 627958,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-05-v1.png": 17739,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-06-v1.png": 304795,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-07-v1.png": 778010,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-08-v1.png": 524364,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-09-v1.png": 275448,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-10-v1.png": 91292,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-11-v1.png": 945276,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-12-v1.png": 108677,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-13-v1.png": 476849,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-14-v1.png": 230801,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-15-v1.png": 267666,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-16-v1.png": 194991,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-17-v1.png": 336434,
	"./deprecated-assets/crimson-scales/attack-modifiers/QA-V1/cs-am-qa-back-v1.png": 741400,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-01-v1.png": 541573,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-02-v1.png": 509076,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-03-v1.png": 617807,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-04-v1.png": 559330,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-05-v1.png": 988527,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-06-v1.png": 591541,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-07-v1.png": 190809,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-08-v1.png": 699507,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-09-v1.png": 146652,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-10-v1.png": 765189,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-11-v1.png": 986783,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-12-v1.png": 472073,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-13-v1.png": 503895,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-14-v1.png": 842111,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-15-v1.png": 545399,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-16-v1.png": 264269,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-17-v1.png": 408184,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-18-v1.png": 466310,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-19-v1.png": 979856,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-20-v1.png": 865660,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-21-v1.png": 106861,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-22-v1.png": 825693,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-23-v1.png": 790050,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-am-rm-back-v1.png": 479100,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-pe-rm-01-v1.png": 349626,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-pe-rm-02-v1.png": 372900,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-pe-rm-03-v1.png": 386907,
	"./deprecated-assets/crimson-scales/attack-modifiers/RM-V1/cs-pe-rm-back-v1.png": 66435,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-aa-back-v1.png": 379493,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-alate-dispersion-v1.png": 414908,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-anti-venom-v1.png": 60797,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-assimilate-adversaries-v1.png": 390140,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-birthing-chambers-v1.png": 179671,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-burning-stingers-v1.png": 252656,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-burrow-under-v1.png": 580216,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-clad-in-spikes-v1.png": 348467,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-coordinated-infestation-v1.png": 802275,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-corrosive-spittle-v1.png": 243286,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-divide-and-conquer-v1.png": 793615,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-encasing-webs-v1.png": 832078,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-erupting-mandibles-v1.png": 753600,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-ferocious-proliferation-v1.png": 87302,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-frantic-migration-v1.png": 733274,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-horned-carapace-v1.png": 80574,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-lacerating-horde-v1.png": 226912,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-maddening-chatter-v1.png": 699002,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-march-of-multitudes-v1.png": 757147,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-nurture-the-weak-v1.png": 456849,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-overwhelming-swarm-v1.png": 669007,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-primal-pheromones-v1.png": 309823,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-repel-intruders-v1.png": 913277,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-retribution-of-the-hive-v1.png": 373219,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-seek-nourishment-v1.png": 753260,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-sentry-swarm-v1.png": 65435,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-shelter-the-nest-v1.png": 808518,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-stalk-the-prey-v1.png": 931289,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-steelsilk-weaver-v1.png": 505556,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-supreme-authority-v1.png": 312620,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V1/cs-violent-outlash-v1.png": 340741,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V2/cs-aa-back.png": 311757,
	"./deprecated-assets/crimson-scales/character-ability-cards/AA-V2/cs-stalk-the-prey-v2.png": 274907,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-annihilating-contraption-v1.png": 46315,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-double-barrel-railcaster-v1.png": 281830,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-elemental-condenser-v1.png": 12704,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-energy-transmission-v1.png": 513341,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-fragmentation-grenade-v1.png": 176120,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-galvanic-coil-v1.png": 334427,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-gravity-inverter-module-v1.png": 359880,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-improvised-exosuit-v1.png": 577120,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-improvised-mortar-v1.png": 900400,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-instant-relocation-matrix-v1.png": 233904,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-jury-rigged-machine-v1.png": 867542,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-launch-skywards-v1.png": 54915,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-march-of-machines-v1.png": 872592,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-oscillating-projector-v1.png": 123996,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-particle-ray-beam-v1.png": 166987,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-perfected-exosuit-v1.png": 400266,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-phase-field-emitter-v1.png": 115305,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-power-modulation-v1.png": 339793,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-qa-back-v1.png": 177224,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-ransack-clutter-v1.png": 975033,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-recycle-parts-v1.png": 877280,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-reinforce-armor-v1.png": 223843,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-remote-control-v1.png": 3906,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-repurpose-leftovers-v1.png": 626593,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-retrofit-weapons-v1.png": 954714,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-salvage-grappler-v1.png": 685609,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-seeker-missiles-v1.png": 197620,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-trajectory-diverter-v1.png": 653772,
	"./deprecated-assets/crimson-scales/character-ability-cards/QA-V1/cs-trudging-bulwark-v1.png": 640187,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-belly-of-the-beast-v1.png": 882516,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-berserk-barrage-v1.png": 859540,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-burning-bile-v1.png": 942301,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-caustic-claws-v1.png": 999259,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-cornered-animal-v1.png": 847676,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-corrosive-spew-v1.png": 875790,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-devour-whole-v1.png": 643287,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-easy-prey-v1.png": 828617,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-fatal-frenzy-v1.png": 616387,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-feast-of-flesh-v1.png": 329138,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-feral-lunge-v1.png": 747927,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-ferocious-fling-v1.png": 124806,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-fight-or-flight-v1.png": 669264,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-heartripper-v1.png": 198117,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-indomitable-craving-v1.png": 416215,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-lie-in-wait-v1.png": 901587,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-nourishing-meal-v1.png": 653191,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-pouncing-predator-v1.png": 969836,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-ravenous-roar-v1.png": 240115,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-reckless-attack-v1.png": 157524,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-rend-and-mutilate-v1.png": 685632,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-rip-and-tear-v1.png": 514100,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-rm-back-v1.png": 757221,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-savage-stalker-v1.png": 728099,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-scrape-and-scrounge-v1.png": 614063,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-seize-v1.png": 502939,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-slake-thirst-v1.png": 348983,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-strip-the-flesh-v1.png": 680890,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-survival-instincts-v1.png": 844669,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-terrifying-howl-v1.png": 713425,
	"./deprecated-assets/crimson-scales/character-ability-cards/RM-V1/cs-voracious-hunter-v1.png": 694291,
	"./deprecated-assets/crimson-scales/character-mats/cs-artificer-back-v1.png": 616918,
	"./deprecated-assets/crimson-scales/character-mats/cs-artificer-v1.png": 512446,
	"./deprecated-assets/crimson-scales/character-mats/cs-ruinmaw-back-v1.png": 870847,
	"./deprecated-assets/crimson-scales/character-mats/cs-ruinmaw-v1.png": 74165,
	"./deprecated-assets/crimson-scales/character-perks/cs-amber-aegis-perks-v1.png": 424821,
	"./deprecated-assets/crimson-scales/character-perks/cs-artificer-perks-v1.png": 869300,
	"./deprecated-assets/crimson-scales/character-perks/cs-ruinmaw-perks-v1.png": 468976,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-13-b-v1.png": 374486,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-13-f-v1.png": 204755,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-aa-01-b-v1.png": 656759,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-aa-01-f-v1.png": 786921,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-aa-02-b-v1.png": 974428,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-aa-02-f-v1.png": 922514,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-qa-01-b-v1.png": 225323,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-qa-01-f-v1.png": 177959,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-qa-02-b-v1.png": 286263,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-qa-02-f-v1.png": 506137,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-qa-03-b-v1.png": 101504,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-qa-03-f-v1.png": 432578,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-rm-01-b-v1.png": 721205,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-rm-01-f-v1.png": 18728,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-rm-02-b-v1.png": 276352,
	"./deprecated-assets/crimson-scales/events/city/cs-ce-rm-02-f-v1.png": 268425,
	"./deprecated-assets/crimson-scales/events/road/cs-re-15-b-v1.png": 672950,
	"./deprecated-assets/crimson-scales/events/road/cs-re-15-f-v1.png": 826359,
	"./deprecated-assets/crimson-scales/events/road/cs-re-aa-01-b-v1.png": 244430,
	"./deprecated-assets/crimson-scales/events/road/cs-re-aa-01-f-v1.png": 793919,
	"./deprecated-assets/crimson-scales/events/road/cs-re-aa-02-b-v1.png": 514631,
	"./deprecated-assets/crimson-scales/events/road/cs-re-aa-02-f-v1.png": 780236,
	"./deprecated-assets/crimson-scales/events/road/cs-re-qa-01-b-v1.png": 468633,
	"./deprecated-assets/crimson-scales/events/road/cs-re-qa-01-f-v1.png": 191116,
	"./deprecated-assets/crimson-scales/events/road/cs-re-qa-02-b-v1.png": 672567,
	"./deprecated-assets/crimson-scales/events/road/cs-re-qa-02-f-v1.png": 115911,
	"./deprecated-assets/crimson-scales/events/road/cs-re-rm-01-b-v1.png": 50516,
	"./deprecated-assets/crimson-scales/events/road/cs-re-rm-01-f-v1.png": 970144,
	"./deprecated-assets/crimson-scales/events/road/cs-re-rm-02-b-v1.png": 298255,
	"./deprecated-assets/crimson-scales/events/road/cs-re-rm-02-f-v1.png": 199392,
	"./deprecated-assets/crimson-scales/items/cs-aa01-rockspine-bulwark-back-v1.png": 740335,
	"./deprecated-assets/crimson-scales/items/cs-aa01-rockspine-bulwark-v1.png": 414630,
	"./deprecated-assets/crimson-scales/items/cs-aa02-ghostshimmer-honey-back-v1.png": 320992,
	"./deprecated-assets/crimson-scales/items/cs-aa02-ghostshimmer-honey-v1.png": 51418,
	"./deprecated-assets/crimson-scales/items/cs-aa03-steelsilk-spinneret-back-v1.png": 856690,
	"./deprecated-assets/crimson-scales/items/cs-aa03-steelsilk-spinneret-v1.png": 150264,
	"./deprecated-assets/crimson-scales/items/cs-qa01-power-modulator-back-v1.png": 694141,
	"./deprecated-assets/crimson-scales/items/cs-qa01-power-modulator-v1.png": 581540,
	"./deprecated-assets/crimson-scales/items/cs-qa02a-steam-piston-hammer-back-v1.png": 77391,
	"./deprecated-assets/crimson-scales/items/cs-qa02a-steam-piston-hammer-v1.png": 745896,
	"./deprecated-assets/crimson-scales/items/cs-qa02b-steam-piston-hammer-back-v1.png": 585129,
	"./deprecated-assets/crimson-scales/items/cs-qa02b-steam-piston-hammer-v1.png": 166436,
	"./deprecated-assets/crimson-scales/items/cs-qa03a-spider-climb-gloves-back-v1.png": 736181,
	"./deprecated-assets/crimson-scales/items/cs-qa03a-spider-climb-gloves-v1.png": 932409,
	"./deprecated-assets/crimson-scales/items/cs-qa03b-spider-climb-gloves-back-v1.png": 519279,
	"./deprecated-assets/crimson-scales/items/cs-qa03b-spider-climb-gloves-v1.png": 991039,
	"./deprecated-assets/crimson-scales/items/cs-qa04-gravity-inversion-pads-back-v1.png": 646394,
	"./deprecated-assets/crimson-scales/items/cs-qa04-gravity-inversion-pads-v1.png": 731684,
	"./deprecated-assets/crimson-scales/items/cs-qa05-delicate-model-back-v1.png": 286163,
	"./deprecated-assets/crimson-scales/items/cs-qa05-delicate-model-v1.png": 739354,
	"./deprecated-assets/crimson-scales/items/cs-qa06-auscudec-of-the-makers-back-v1.png": 442272,
	"./deprecated-assets/crimson-scales/items/cs-qa06-auscudec-of-the-makers-v1.png": 687370,
	"./deprecated-assets/crimson-scales/items/cs-rm01-serrated-edge-back-v1.png": 198615,
	"./deprecated-assets/crimson-scales/items/cs-rm01a-serrated-edge-v1.png": 773796,
	"./deprecated-assets/crimson-scales/items/cs-rm01b-serrated-edge-v1.png": 786857,
	"./deprecated-assets/crimson-scales/items/cs-rm02-grisly-boots-back-v1.png": 412622,
	"./deprecated-assets/crimson-scales/items/cs-rm02-grisly-boots-v1.png": 248411,
	"./deprecated-assets/crimson-scales/items/cs-rm03-terrorscale-saber-back-v1.png": 387133,
	"./deprecated-assets/crimson-scales/items/cs-rm03-terrorscale-saber-v1.png": 378548,
	"./deprecated-assets/crimson-scales/items/cs-rm04-terrorscale-crossblades-back-v1.png": 599140,
	"./deprecated-assets/crimson-scales/items/cs-rm04-terrorscale-crossblades-v1.png": 620950,
	"./deprecated-assets/crimson-scales/items/cs-rm05-rite-of-ruin-back-v1.png": 321596,
	"./deprecated-assets/crimson-scales/items/cs-rm05-rite-of-ruin-v1.png": 342709,
	"./deprecated-assets/crimson-scales/items/cs-rm06-savage-cuirass-back-v1.png": 450166,
	"./deprecated-assets/crimson-scales/items/cs-rm06-savage-cuirass-v1.png": 988473,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-343-v1.png": 463613,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-349-v1.png": 336493,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-aa-001-v1.png": 268614,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-aa-002-v1.png": 319177,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-back-v1.png": 724497,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-qa-001-v1.png": 693554,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-qa-002-v1.png": 56354,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-rm-001-v1.png": 885667,
	"./deprecated-assets/crimson-scales/personal-quests/cs-pq-rm-002-v1.png": 105890,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-anguish-and-salvation-v1.png": 443596,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-anticipate-intricacies-v1.png": 47306,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-bad-omen-v1.png": 676025,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-call-of-the-nether-v1.png": 813186,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-careful-attunement-v1.png": 738873,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-clairvoyance-v1.png": 355627,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-cleansing-rite-v1.png": 117968,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-curative-flux-v1.png": 673497,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-cursed-ground-v1.png": 518437,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-deep-contemplation-v1.png": 765120,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-dimensional-divide-v1.png": 128738,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-dimensional-transfer-v1.png": 892292,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-dr-back-v1.png": 499166,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-duality-shards-v1.png": 148886,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-enfeebling-hex-v1.png": 409664,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-envision-the-course-v1.png": 832888,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-ethereal-vortex-v1.png": 572330,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-gift-of-the-void-v1.png": 862687,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-hand-of-destiny-v1.png": 141575,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-inspiration-from-beyond-v1.png": 157637,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-otherworldly-journey-v1.png": 680315,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-peer-into-battle-v1.png": 941617,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-preordain-the-path-v1.png": 142326,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-protective-aura-v1.png": 42469,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-revitalizing-fount-v1.png": 440211,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-seal-their-fate-v1.png": 878416,
	"./deprecated-assets/forgotten-circles/character-ability-cards/DR-V1/fc-void-snare-v1.png": 355223,
	"./deprecated-assets/forgotten-circles/character-ability-cards/ZZ/zz.txt": 972212,
	"./deprecated-assets/forgotten-circles/events/city-v1/fc-ce-82-b-v1.png": 804731,
	"./deprecated-assets/forgotten-circles/events/city-v1/fc-ce-88-b-v1.png": 47266,
	"./deprecated-assets/forgotten-circles/events/city-v1/fc-ce-88-f-v1.png": 831338,
	"./deprecated-assets/forgotten-circles/events/city-v1/fc-ce-89-b-v1.png": 256961,
	"./deprecated-assets/forgotten-circles/events/city-v1/fc-ce-89-f-v1.png": 647158,
	"./deprecated-assets/forgotten-circles/events/city-v1/fc-ce-90-b-v1.png": 1581,
	"./deprecated-assets/forgotten-circles/events/city-v1/fc-ce-90-f-v1.png": 600139,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-02-b-v1.png": 937250,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-02-f-v1.png": 551068,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-09-f-v1.png": 338874,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-10-f-v1.png": 558498,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-11-f-v1.png": 782912,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-12-b-v1.png": 974116,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-13-f-v1.png": 646353,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-15-f-v1.png": 316058,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-16-b-v1.png": 260591,
	"./deprecated-assets/forgotten-circles/events/rift-v1/fc-rf-19-f-v1.png": 646889,
	"./deprecated-assets/forgotten-circles/events/road-v1/fc-re-82-f-v1.png": 368917,
	"./deprecated-assets/gloomhaven/attack-modifiers/BS-V3/gh-am-bs-09-v3.png": 537311,
	"./deprecated-assets/gloomhaven/attack-modifiers/BS-V3/gh-am-bs-10-v3.png": 4687,
	"./deprecated-assets/gloomhaven/attack-modifiers/BS-V3/gh-am-bs-11-v3.png": 648029,
	"./deprecated-assets/gloomhaven/attack-modifiers/BS-V3/gh-am-bs-12-v3.png": 956260,
	"./deprecated-assets/gloomhaven/attack-modifiers/BS-V3/gh-am-bs-14-v3.png": 783342,
	"./deprecated-assets/gloomhaven/attack-modifiers/BS-V3/gh-am-bs-back-v3.png": 934833,
	"./deprecated-assets/gloomhaven/attack-modifiers/ZZ/zz.txt": 136502,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-bs-back-v2.png": 815357,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-corrupting-parasites-v2.png": 797321,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-engulfing-stingers-v2.png": 208180,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-focused-scourge-v2.png": 580385,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-oasis-v2.png": 799327,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-putrid-grubs-v2.png": 791840,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-sword-of-tenacity-v2.png": 799715,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-unstoppable-army-v2.png": 446214,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V2/gh-wasteland-v2.png": 574512,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-bioluminescence-v3.png": 899297,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-blood-drain-v3.png": 267796,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-bone-daggers-v3.png": 177335,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-bs-back-v3.png": 76307,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-call-of-the-grave-v3.png": 269351,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-corrupting-parasites-v3.png": 613725,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-death-march-v3.png": 282858,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-deflecting-blades-v3.png": 745906,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-engulfing-stingers-v3.png": 494863,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-erosion-v3.png": 376992,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-focused-scourge-v3.png": 517618,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-grasping-advance-v3.png": 923179,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-hive-mind-v3.png": 839995,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-incubation-v3.png": 116957,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-infest-v3.png": 539274,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-oasis-v3.png": 707308,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-omniscient-assault-v3.png": 364722,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-prismatic-cyclone-v3.png": 148046,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-putrid-grubs-v3.png": 257939,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-sand-scythe-v3.png": 80030,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-scattered-defense-v3.png": 190156,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-solitary-horde-v3.png": 309981,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-sunstroke-v3.png": 272507,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-swarming-minions-v3.png": 462018,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-sword-of-tenacity-v3.png": 280865,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-the-storms-edge-v3.png": 303975,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-tomb-of-the-immortal-v3.png": 988799,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-unstoppable-army-v3.png": 673517,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-vampiric-tempest-v3.png": 239382,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-venomous-barbs-v3.png": 243315,
	"./deprecated-assets/gloomhaven/character-ability-cards/BS-V3/gh-wasteland-v3.png": 81694,
	"./deprecated-assets/gloomhaven/character-ability-cards/BT-V1/gh-bt-back.png": 114252,
	"./deprecated-assets/gloomhaven/character-ability-cards/BT-V1/gh-disorienting-roar-v1.png": 31638,
	"./deprecated-assets/gloomhaven/character-ability-cards/BT-V1/gh-primal-blessing-v1.png": 713964,
	"./deprecated-assets/gloomhaven/character-ability-cards/BT-V1/gh-spirit-swap-v1.png": 592668,
	"./deprecated-assets/gloomhaven/character-ability-cards/DS-V1/gh-ds-back-v1.png": 574831,
	"./deprecated-assets/gloomhaven/character-ability-cards/DS-V1/gh-felling-swoop-v1.png": 255802,
	"./deprecated-assets/gloomhaven/character-ability-cards/NS-V1/gh-concealed-dominance-v1.png": 241297,
	"./deprecated-assets/gloomhaven/character-ability-cards/NS-V1/gh-ns-back-v1.png": 540107,
	"./deprecated-assets/gloomhaven/character-ability-cards/SU-V1/gh-otherworldly-rage-v1.png": 24422,
	"./deprecated-assets/gloomhaven/character-ability-cards/SU-V1/gh-su-back-v1.png": 658676,
	"./deprecated-assets/gloomhaven/character-perks/gh-bladeswarm-perks-v3.png": 181769,
	"./events/crimson-scales/city/cs-ce-01-b.png": 903389,
	"./events/crimson-scales/city/cs-ce-01-f.png": 426774,
	"./events/crimson-scales/city/cs-ce-02-b.png": 12393,
	"./events/crimson-scales/city/cs-ce-02-f.png": 691629,
	"./events/crimson-scales/city/cs-ce-03-b.png": 232576,
	"./events/crimson-scales/city/cs-ce-03-f.png": 913138,
	"./events/crimson-scales/city/cs-ce-04-b.png": 293545,
	"./events/crimson-scales/city/cs-ce-04-f.png": 902331,
	"./events/crimson-scales/city/cs-ce-05-b.png": 174453,
	"./events/crimson-scales/city/cs-ce-05-f.png": 601841,
	"./events/crimson-scales/city/cs-ce-06-b.png": 681330,
	"./events/crimson-scales/city/cs-ce-06-f.png": 846904,
	"./events/crimson-scales/city/cs-ce-07-b.png": 614363,
	"./events/crimson-scales/city/cs-ce-07-f.png": 831466,
	"./events/crimson-scales/city/cs-ce-08-b.png": 795376,
	"./events/crimson-scales/city/cs-ce-08-f.png": 696354,
	"./events/crimson-scales/city/cs-ce-09-b.png": 814330,
	"./events/crimson-scales/city/cs-ce-09-f.png": 36525,
	"./events/crimson-scales/city/cs-ce-10-b.png": 354770,
	"./events/crimson-scales/city/cs-ce-10-f.png": 208451,
	"./events/crimson-scales/city/cs-ce-11-b.png": 527433,
	"./events/crimson-scales/city/cs-ce-11-f.png": 876668,
	"./events/crimson-scales/city/cs-ce-12-b.png": 469807,
	"./events/crimson-scales/city/cs-ce-12-f.png": 410728,
	"./events/crimson-scales/city/cs-ce-13-b.png": 131014,
	"./events/crimson-scales/city/cs-ce-13-f.png": 52893,
	"./events/crimson-scales/city/cs-ce-14-b.png": 945106,
	"./events/crimson-scales/city/cs-ce-14-f.png": 117121,
	"./events/crimson-scales/city/cs-ce-15-b.png": 523833,
	"./events/crimson-scales/city/cs-ce-15-f.png": 321268,
	"./events/crimson-scales/city/cs-ce-16-b.png": 918783,
	"./events/crimson-scales/city/cs-ce-16-f.png": 682025,
	"./events/crimson-scales/city/cs-ce-17-b.png": 442204,
	"./events/crimson-scales/city/cs-ce-17-f.png": 628926,
	"./events/crimson-scales/city/cs-ce-18-b.png": 559415,
	"./events/crimson-scales/city/cs-ce-18-f.png": 343481,
	"./events/crimson-scales/city/cs-ce-19-b.png": 990533,
	"./events/crimson-scales/city/cs-ce-19-f.png": 163052,
	"./events/crimson-scales/city/cs-ce-20-b.png": 701802,
	"./events/crimson-scales/city/cs-ce-20-f.png": 507836,
	"./events/crimson-scales/city/cs-ce-21-b.png": 969834,
	"./events/crimson-scales/city/cs-ce-21-f.png": 487053,
	"./events/crimson-scales/city/cs-ce-22-b.png": 289158,
	"./events/crimson-scales/city/cs-ce-22-f.png": 759919,
	"./events/crimson-scales/city/cs-ce-23-b.png": 755519,
	"./events/crimson-scales/city/cs-ce-23-f.png": 653017,
	"./events/crimson-scales/city/cs-ce-24-b.png": 605187,
	"./events/crimson-scales/city/cs-ce-24-f.png": 260165,
	"./events/crimson-scales/city/cs-ce-25-b.png": 851677,
	"./events/crimson-scales/city/cs-ce-25-f.png": 348436,
	"./events/crimson-scales/city/cs-ce-26-b.png": 937334,
	"./events/crimson-scales/city/cs-ce-26-f.png": 504439,
	"./events/crimson-scales/city/cs-ce-27-b.png": 353312,
	"./events/crimson-scales/city/cs-ce-27-f.png": 308651,
	"./events/crimson-scales/city/cs-ce-28-b.png": 39029,
	"./events/crimson-scales/city/cs-ce-28-f.png": 2643,
	"./events/crimson-scales/city/cs-ce-29-b.png": 396212,
	"./events/crimson-scales/city/cs-ce-29-f.png": 697704,
	"./events/crimson-scales/city/cs-ce-30-b.png": 733706,
	"./events/crimson-scales/city/cs-ce-30-f.png": 118914,
	"./events/crimson-scales/city/cs-ce-31-b.png": 38470,
	"./events/crimson-scales/city/cs-ce-31-f.png": 219726,
	"./events/crimson-scales/city/cs-ce-32-b.png": 928847,
	"./events/crimson-scales/city/cs-ce-32-f.png": 957277,
	"./events/crimson-scales/city/cs-ce-33-b.png": 785365,
	"./events/crimson-scales/city/cs-ce-33-f.png": 444814,
	"./events/crimson-scales/city/cs-ce-34-b.png": 674538,
	"./events/crimson-scales/city/cs-ce-34-f.png": 687985,
	"./events/crimson-scales/city/cs-ce-35-b.png": 456366,
	"./events/crimson-scales/city/cs-ce-35-f.png": 138473,
	"./events/crimson-scales/city/cs-ce-36-b.png": 623306,
	"./events/crimson-scales/city/cs-ce-36-f.png": 320685,
	"./events/crimson-scales/city/cs-ce-37-b.png": 571451,
	"./events/crimson-scales/city/cs-ce-37-f.png": 880575,
	"./events/crimson-scales/city/cs-ce-38-b.png": 752684,
	"./events/crimson-scales/city/cs-ce-38-f.png": 46730,
	"./events/crimson-scales/city/cs-ce-39-b.png": 170675,
	"./events/crimson-scales/city/cs-ce-39-f.png": 466559,
	"./events/crimson-scales/city/cs-ce-40-b.png": 858821,
	"./events/crimson-scales/city/cs-ce-40-f.png": 154106,
	"./events/crimson-scales/city/cs-ce-41-b.png": 968651,
	"./events/crimson-scales/city/cs-ce-41-f.png": 688464,
	"./events/crimson-scales/city/cs-ce-42-b.png": 248050,
	"./events/crimson-scales/city/cs-ce-42-f.png": 838255,
	"./events/crimson-scales/city/cs-ce-43-b.png": 344018,
	"./events/crimson-scales/city/cs-ce-43-f.png": 833150,
	"./events/crimson-scales/city/cs-ce-44-b.png": 23685,
	"./events/crimson-scales/city/cs-ce-44-f.png": 30615,
	"./events/crimson-scales/city/cs-ce-45-b.png": 62785,
	"./events/crimson-scales/city/cs-ce-45-f.png": 26792,
	"./events/crimson-scales/city/cs-ce-46-b.png": 320237,
	"./events/crimson-scales/city/cs-ce-46-f.png": 74863,
	"./events/crimson-scales/city/cs-ce-47-b.png": 759433,
	"./events/crimson-scales/city/cs-ce-47-f.png": 563442,
	"./events/crimson-scales/city/cs-ce-48-b.png": 864255,
	"./events/crimson-scales/city/cs-ce-48-f.png": 456039,
	"./events/crimson-scales/city/cs-ce-49-b.png": 870158,
	"./events/crimson-scales/city/cs-ce-49-f.png": 794205,
	"./events/crimson-scales/city/cs-ce-50-b.png": 127748,
	"./events/crimson-scales/city/cs-ce-50-f.png": 359031,
	"./events/crimson-scales/city/cs-ce-51-b.png": 314466,
	"./events/crimson-scales/city/cs-ce-51-f.png": 864609,
	"./events/crimson-scales/city/cs-ce-52-b.png": 594433,
	"./events/crimson-scales/city/cs-ce-52-f.png": 722352,
	"./events/crimson-scales/city/cs-ce-53-b.png": 933027,
	"./events/crimson-scales/city/cs-ce-53-f.png": 900790,
	"./events/crimson-scales/city/cs-ce-54-b.png": 856274,
	"./events/crimson-scales/city/cs-ce-54-f.png": 681758,
	"./events/crimson-scales/city/cs-ce-55-b.png": 825603,
	"./events/crimson-scales/city/cs-ce-55-f.png": 70107,
	"./events/crimson-scales/city/cs-ce-56-b.png": 843823,
	"./events/crimson-scales/city/cs-ce-56-f.png": 487812,
	"./events/crimson-scales/city/cs-ce-57-b.png": 888835,
	"./events/crimson-scales/city/cs-ce-57-f.png": 403799,
	"./events/crimson-scales/city/cs-ce-58-b.png": 5201,
	"./events/crimson-scales/city/cs-ce-58-f.png": 40410,
	"./events/crimson-scales/city/cs-ce-59-b.png": 446738,
	"./events/crimson-scales/city/cs-ce-59-f.png": 955506,
	"./events/crimson-scales/city/cs-ce-60-b.png": 29138,
	"./events/crimson-scales/city/cs-ce-60-f.png": 360061,
	"./events/crimson-scales/city/cs-ce-aa-01-b.png": 770897,
	"./events/crimson-scales/city/cs-ce-aa-01-f.png": 578063,
	"./events/crimson-scales/city/cs-ce-aa-02-b.png": 968594,
	"./events/crimson-scales/city/cs-ce-aa-02-f.png": 869215,
	"./events/crimson-scales/city/cs-ce-qa-01-b.png": 926415,
	"./events/crimson-scales/city/cs-ce-qa-01-f.png": 583096,
	"./events/crimson-scales/city/cs-ce-qa-02-b.png": 976987,
	"./events/crimson-scales/city/cs-ce-qa-02-f.png": 817969,
	"./events/crimson-scales/city/cs-ce-qa-03-b.png": 179383,
	"./events/crimson-scales/city/cs-ce-qa-03-f.png": 417726,
	"./events/crimson-scales/city/cs-ce-rm-01-b.png": 356775,
	"./events/crimson-scales/city/cs-ce-rm-01-f.png": 984097,
	"./events/crimson-scales/city/cs-ce-rm-02-b.png": 666557,
	"./events/crimson-scales/city/cs-ce-rm-02-f.png": 745435,
	"./events/crimson-scales/road/cs-re-01-b.png": 106037,
	"./events/crimson-scales/road/cs-re-01-f.png": 41789,
	"./events/crimson-scales/road/cs-re-02-b.png": 547507,
	"./events/crimson-scales/road/cs-re-02-f.png": 301125,
	"./events/crimson-scales/road/cs-re-03-b.png": 665611,
	"./events/crimson-scales/road/cs-re-03-f.png": 800220,
	"./events/crimson-scales/road/cs-re-04-b.png": 307585,
	"./events/crimson-scales/road/cs-re-04-f.png": 798054,
	"./events/crimson-scales/road/cs-re-05-b.png": 617746,
	"./events/crimson-scales/road/cs-re-05-f.png": 440386,
	"./events/crimson-scales/road/cs-re-06-b.png": 48168,
	"./events/crimson-scales/road/cs-re-06-f.png": 367832,
	"./events/crimson-scales/road/cs-re-07-b.png": 563641,
	"./events/crimson-scales/road/cs-re-07-f.png": 206628,
	"./events/crimson-scales/road/cs-re-08-b.png": 626510,
	"./events/crimson-scales/road/cs-re-08-f.png": 379194,
	"./events/crimson-scales/road/cs-re-09-b.png": 77427,
	"./events/crimson-scales/road/cs-re-09-f.png": 87718,
	"./events/crimson-scales/road/cs-re-10-b.png": 641079,
	"./events/crimson-scales/road/cs-re-10-f.png": 8594,
	"./events/crimson-scales/road/cs-re-11-b.png": 957799,
	"./events/crimson-scales/road/cs-re-11-f.png": 279253,
	"./events/crimson-scales/road/cs-re-12-b.png": 919628,
	"./events/crimson-scales/road/cs-re-12-f.png": 998532,
	"./events/crimson-scales/road/cs-re-13-b.png": 370062,
	"./events/crimson-scales/road/cs-re-13-f.png": 424788,
	"./events/crimson-scales/road/cs-re-14-b.png": 481778,
	"./events/crimson-scales/road/cs-re-14-f.png": 25129,
	"./events/crimson-scales/road/cs-re-15-b.png": 203542,
	"./events/crimson-scales/road/cs-re-15-f.png": 92978,
	"./events/crimson-scales/road/cs-re-16-b.png": 834647,
	"./events/crimson-scales/road/cs-re-16-f.png": 210495,
	"./events/crimson-scales/road/cs-re-17-b.png": 639713,
	"./events/crimson-scales/road/cs-re-17-f.png": 335433,
	"./events/crimson-scales/road/cs-re-18-b.png": 979772,
	"./events/crimson-scales/road/cs-re-18-f.png": 182688,
	"./events/crimson-scales/road/cs-re-19-b.png": 891837,
	"./events/crimson-scales/road/cs-re-19-f.png": 131813,
	"./events/crimson-scales/road/cs-re-20-b.png": 604252,
	"./events/crimson-scales/road/cs-re-20-f.png": 624750,
	"./events/crimson-scales/road/cs-re-21-b.png": 453842,
	"./events/crimson-scales/road/cs-re-21-f.png": 688923,
	"./events/crimson-scales/road/cs-re-22-b.png": 683705,
	"./events/crimson-scales/road/cs-re-22-f.png": 704294,
	"./events/crimson-scales/road/cs-re-23-b.png": 910706,
	"./events/crimson-scales/road/cs-re-23-f.png": 719271,
	"./events/crimson-scales/road/cs-re-24-b.png": 540523,
	"./events/crimson-scales/road/cs-re-24-f.png": 806060,
	"./events/crimson-scales/road/cs-re-25-b.png": 808594,
	"./events/crimson-scales/road/cs-re-25-f.png": 255143,
	"./events/crimson-scales/road/cs-re-26-b.png": 614483,
	"./events/crimson-scales/road/cs-re-26-f.png": 371199,
	"./events/crimson-scales/road/cs-re-27-b.png": 409064,
	"./events/crimson-scales/road/cs-re-27-f.png": 625778,
	"./events/crimson-scales/road/cs-re-28-b.png": 833722,
	"./events/crimson-scales/road/cs-re-28-f.png": 461238,
	"./events/crimson-scales/road/cs-re-29-b.png": 724950,
	"./events/crimson-scales/road/cs-re-29-f.png": 784122,
	"./events/crimson-scales/road/cs-re-30-b.png": 385210,
	"./events/crimson-scales/road/cs-re-30-f.png": 356161,
	"./events/crimson-scales/road/cs-re-31-b.png": 404265,
	"./events/crimson-scales/road/cs-re-31-f.png": 279328,
	"./events/crimson-scales/road/cs-re-32-b.png": 243635,
	"./events/crimson-scales/road/cs-re-32-f.png": 847070,
	"./events/crimson-scales/road/cs-re-33-b.png": 268509,
	"./events/crimson-scales/road/cs-re-33-f.png": 165145,
	"./events/crimson-scales/road/cs-re-34-b.png": 379498,
	"./events/crimson-scales/road/cs-re-34-f.png": 959387,
	"./events/crimson-scales/road/cs-re-35-b.png": 463043,
	"./events/crimson-scales/road/cs-re-35-f.png": 624680,
	"./events/crimson-scales/road/cs-re-36-b.png": 641529,
	"./events/crimson-scales/road/cs-re-36-f.png": 368470,
	"./events/crimson-scales/road/cs-re-37-b.png": 895062,
	"./events/crimson-scales/road/cs-re-37-f.png": 176049,
	"./events/crimson-scales/road/cs-re-38-b.png": 314501,
	"./events/crimson-scales/road/cs-re-38-f.png": 471766,
	"./events/crimson-scales/road/cs-re-39-b.png": 247043,
	"./events/crimson-scales/road/cs-re-39-f.png": 36631,
	"./events/crimson-scales/road/cs-re-40-b.png": 772086,
	"./events/crimson-scales/road/cs-re-40-f.png": 59271,
	"./events/crimson-scales/road/cs-re-41-b.png": 486228,
	"./events/crimson-scales/road/cs-re-41-f.png": 479663,
	"./events/crimson-scales/road/cs-re-42-b.png": 761574,
	"./events/crimson-scales/road/cs-re-42-f.png": 50064,
	"./events/crimson-scales/road/cs-re-43-b.png": 107726,
	"./events/crimson-scales/road/cs-re-43-f.png": 205308,
	"./events/crimson-scales/road/cs-re-44-b.png": 500208,
	"./events/crimson-scales/road/cs-re-44-f.png": 437068,
	"./events/crimson-scales/road/cs-re-45-b.png": 964409,
	"./events/crimson-scales/road/cs-re-45-f.png": 581144,
	"./events/crimson-scales/road/cs-re-46-b.png": 857928,
	"./events/crimson-scales/road/cs-re-46-f.png": 636923,
	"./events/crimson-scales/road/cs-re-47-b.png": 394139,
	"./events/crimson-scales/road/cs-re-47-f.png": 299613,
	"./events/crimson-scales/road/cs-re-48-b.png": 546902,
	"./events/crimson-scales/road/cs-re-48-f.png": 404254,
	"./events/crimson-scales/road/cs-re-49-b.png": 514592,
	"./events/crimson-scales/road/cs-re-49-f.png": 311788,
	"./events/crimson-scales/road/cs-re-50-b.png": 800216,
	"./events/crimson-scales/road/cs-re-50-f.png": 288857,
	"./events/crimson-scales/road/cs-re-51-b.png": 813025,
	"./events/crimson-scales/road/cs-re-51-f.png": 873113,
	"./events/crimson-scales/road/cs-re-52-b.png": 520078,
	"./events/crimson-scales/road/cs-re-52-f.png": 669693,
	"./events/crimson-scales/road/cs-re-53-b.png": 470867,
	"./events/crimson-scales/road/cs-re-53-f.png": 991324,
	"./events/crimson-scales/road/cs-re-54-b.png": 571818,
	"./events/crimson-scales/road/cs-re-54-f.png": 652722,
	"./events/crimson-scales/road/cs-re-55-b.png": 398787,
	"./events/crimson-scales/road/cs-re-55-f.png": 351041,
	"./events/crimson-scales/road/cs-re-56-b.png": 996946,
	"./events/crimson-scales/road/cs-re-56-f.png": 256367,
	"./events/crimson-scales/road/cs-re-57-b.png": 677867,
	"./events/crimson-scales/road/cs-re-57-f.png": 680242,
	"./events/crimson-scales/road/cs-re-58-b.png": 498356,
	"./events/crimson-scales/road/cs-re-58-f.png": 810713,
	"./events/crimson-scales/road/cs-re-59-b.png": 997651,
	"./events/crimson-scales/road/cs-re-59-f.png": 870914,
	"./events/crimson-scales/road/cs-re-60-b.png": 524527,
	"./events/crimson-scales/road/cs-re-60-f.png": 713903,
	"./events/crimson-scales/road/cs-re-aa-01-b.png": 88338,
	"./events/crimson-scales/road/cs-re-aa-01-f.png": 863964,
	"./events/crimson-scales/road/cs-re-aa-02-b.png": 677086,
	"./events/crimson-scales/road/cs-re-aa-02-f.png": 92916,
	"./events/crimson-scales/road/cs-re-qa-01-b.png": 648034,
	"./events/crimson-scales/road/cs-re-qa-01-f.png": 427661,
	"./events/crimson-scales/road/cs-re-qa-02-b.png": 318528,
	"./events/crimson-scales/road/cs-re-qa-02-f.png": 739936,
	"./events/crimson-scales/road/cs-re-rm-01-b.png": 650779,
	"./events/crimson-scales/road/cs-re-rm-01-f.png": 587924,
	"./events/crimson-scales/road/cs-re-rm-02-b.png": 181016,
	"./events/crimson-scales/road/cs-re-rm-02-f.png": 454865,
	"./events/forgotten-circles/city/fc-ce-82-b.png": 826667,
	"./events/forgotten-circles/city/fc-ce-82-f.png": 338933,
	"./events/forgotten-circles/city/fc-ce-83-b.png": 782136,
	"./events/forgotten-circles/city/fc-ce-83-f.png": 339406,
	"./events/forgotten-circles/city/fc-ce-84-b.png": 989015,
	"./events/forgotten-circles/city/fc-ce-84-f.png": 426297,
	"./events/forgotten-circles/city/fc-ce-85-b.png": 54153,
	"./events/forgotten-circles/city/fc-ce-85-f.png": 325492,
	"./events/forgotten-circles/city/fc-ce-86-b.png": 126020,
	"./events/forgotten-circles/city/fc-ce-86-f.png": 186958,
	"./events/forgotten-circles/city/fc-ce-87-b.png": 103621,
	"./events/forgotten-circles/city/fc-ce-87-f.png": 910832,
	"./events/forgotten-circles/city/fc-ce-88-b.png": 107452,
	"./events/forgotten-circles/city/fc-ce-88-f.png": 750318,
	"./events/forgotten-circles/city/fc-ce-89-b.png": 358083,
	"./events/forgotten-circles/city/fc-ce-89-f.png": 430075,
	"./events/forgotten-circles/city/fc-ce-90-b.png": 542575,
	"./events/forgotten-circles/city/fc-ce-90-f.png": 64734,
	"./events/forgotten-circles/rift/fc-rf-01-b.png": 441571,
	"./events/forgotten-circles/rift/fc-rf-01-f.png": 934277,
	"./events/forgotten-circles/rift/fc-rf-02-b.png": 631661,
	"./events/forgotten-circles/rift/fc-rf-02-f.png": 798969,
	"./events/forgotten-circles/rift/fc-rf-03-b.png": 847636,
	"./events/forgotten-circles/rift/fc-rf-03-f.png": 357641,
	"./events/forgotten-circles/rift/fc-rf-04-b.png": 612816,
	"./events/forgotten-circles/rift/fc-rf-04-f.png": 649591,
	"./events/forgotten-circles/rift/fc-rf-05-b.png": 144253,
	"./events/forgotten-circles/rift/fc-rf-05-f.png": 335582,
	"./events/forgotten-circles/rift/fc-rf-06-b.png": 547419,
	"./events/forgotten-circles/rift/fc-rf-06-f.png": 951431,
	"./events/forgotten-circles/rift/fc-rf-07-b.png": 86654,
	"./events/forgotten-circles/rift/fc-rf-07-f.png": 307977,
	"./events/forgotten-circles/rift/fc-rf-08-b.png": 144870,
	"./events/forgotten-circles/rift/fc-rf-08-f.png": 16808,
	"./events/forgotten-circles/rift/fc-rf-09-b.png": 230687,
	"./events/forgotten-circles/rift/fc-rf-09-f.png": 15035,
	"./events/forgotten-circles/rift/fc-rf-10-b.png": 222226,
	"./events/forgotten-circles/rift/fc-rf-10-f.png": 629971,
	"./events/forgotten-circles/rift/fc-rf-11-b.png": 360182,
	"./events/forgotten-circles/rift/fc-rf-11-f.png": 367151,
	"./events/forgotten-circles/rift/fc-rf-12-b.png": 679981,
	"./events/forgotten-circles/rift/fc-rf-12-f.png": 663700,
	"./events/forgotten-circles/rift/fc-rf-13-b.png": 199062,
	"./events/forgotten-circles/rift/fc-rf-13-f.png": 372918,
	"./events/forgotten-circles/rift/fc-rf-14-b.png": 394741,
	"./events/forgotten-circles/rift/fc-rf-14-f.png": 109825,
	"./events/forgotten-circles/rift/fc-rf-15-b.png": 794862,
	"./events/forgotten-circles/rift/fc-rf-15-f.png": 739047,
	"./events/forgotten-circles/rift/fc-rf-16-b.png": 726349,
	"./events/forgotten-circles/rift/fc-rf-16-f.png": 83789,
	"./events/forgotten-circles/rift/fc-rf-17-b.png": 822145,
	"./events/forgotten-circles/rift/fc-rf-17-f.png": 539628,
	"./events/forgotten-circles/rift/fc-rf-18-b.png": 580126,
	"./events/forgotten-circles/rift/fc-rf-18-f.png": 554538,
	"./events/forgotten-circles/rift/fc-rf-19-b.png": 52573,
	"./events/forgotten-circles/rift/fc-rf-19-f.png": 354777,
	"./events/forgotten-circles/rift/fc-rf-20-b.png": 933324,
	"./events/forgotten-circles/rift/fc-rf-20-f.png": 46389,
	"./events/forgotten-circles/road/fc-re-82-b.png": 552781,
	"./events/forgotten-circles/road/fc-re-82-f.png": 364953,
	"./events/forgotten-circles/road/fc-re-83-b.png": 153361,
	"./events/forgotten-circles/road/fc-re-83-f.png": 765445,
	"./events/frosthaven/boat/fh-be-01-b.png": 801795,
	"./events/frosthaven/boat/fh-be-01-f.png": 281797,
	"./events/frosthaven/boat/fh-be-02-b.png": 574187,
	"./events/frosthaven/boat/fh-be-02-f.png": 620719,
	"./events/frosthaven/boat/fh-be-03-b.png": 746400,
	"./events/frosthaven/boat/fh-be-03-f.png": 597990,
	"./events/frosthaven/boat/fh-be-04-b.png": 648864,
	"./events/frosthaven/boat/fh-be-04-f.png": 436239,
	"./events/frosthaven/boat/fh-be-05-b.png": 562841,
	"./events/frosthaven/boat/fh-be-05-f.png": 323254,
	"./events/frosthaven/boat/fh-be-06-b.png": 986573,
	"./events/frosthaven/boat/fh-be-06-f.png": 722563,
	"./events/frosthaven/boat/fh-be-07-b.png": 513603,
	"./events/frosthaven/boat/fh-be-07-f.png": 770945,
	"./events/frosthaven/boat/fh-be-08-b.png": 475789,
	"./events/frosthaven/boat/fh-be-08-f.png": 632557,
	"./events/frosthaven/boat/fh-be-09-b.png": 2848,
	"./events/frosthaven/boat/fh-be-09-f.png": 663041,
	"./events/frosthaven/boat/fh-be-10-b.png": 222581,
	"./events/frosthaven/boat/fh-be-10-f.png": 554252,
	"./events/frosthaven/boat/fh-be-11-b.png": 939077,
	"./events/frosthaven/boat/fh-be-11-f.png": 668370,
	"./events/frosthaven/boat/fh-be-12-b.png": 673114,
	"./events/frosthaven/boat/fh-be-12-f.png": 615750,
	"./events/frosthaven/boat/fh-be-13-b.png": 784220,
	"./events/frosthaven/boat/fh-be-13-f.png": 447059,
	"./events/frosthaven/boat/fh-be-14-b.png": 881214,
	"./events/frosthaven/boat/fh-be-14-f.png": 826207,
	"./events/frosthaven/boat/fh-be-15-b.png": 985666,
	"./events/frosthaven/boat/fh-be-15-f.png": 77698,
	"./events/frosthaven/boat/fh-be-16-b.png": 934725,
	"./events/frosthaven/boat/fh-be-16-f.png": 252095,
	"./events/frosthaven/boat/fh-be-17-b.png": 919536,
	"./events/frosthaven/boat/fh-be-17-f.png": 375569,
	"./events/frosthaven/boat/fh-be-18-b.png": 701138,
	"./events/frosthaven/boat/fh-be-18-f.png": 366385,
	"./events/frosthaven/boat/fh-be-19-b.png": 80749,
	"./events/frosthaven/boat/fh-be-19-f.png": 626247,
	"./events/frosthaven/outpost/fh-soe-01-b.png": 49741,
	"./events/frosthaven/outpost/fh-soe-01-f.png": 3610,
	"./events/frosthaven/outpost/fh-soe-02-b.png": 343259,
	"./events/frosthaven/outpost/fh-soe-02-f.png": 201967,
	"./events/frosthaven/outpost/fh-soe-03-b.png": 175150,
	"./events/frosthaven/outpost/fh-soe-03-f.png": 432938,
	"./events/frosthaven/outpost/fh-soe-04-b.png": 88139,
	"./events/frosthaven/outpost/fh-soe-04-f.png": 957628,
	"./events/frosthaven/outpost/fh-soe-05-b.png": 770609,
	"./events/frosthaven/outpost/fh-soe-05-f.png": 439723,
	"./events/frosthaven/outpost/fh-soe-06-b.png": 182342,
	"./events/frosthaven/outpost/fh-soe-06-f.png": 9482,
	"./events/frosthaven/outpost/fh-soe-07-b.png": 324777,
	"./events/frosthaven/outpost/fh-soe-07-f.png": 245030,
	"./events/frosthaven/outpost/fh-soe-08-b.png": 838551,
	"./events/frosthaven/outpost/fh-soe-08-f.png": 720030,
	"./events/frosthaven/outpost/fh-soe-09-b.png": 458331,
	"./events/frosthaven/outpost/fh-soe-09-f.png": 664195,
	"./events/frosthaven/outpost/fh-soe-10-b.png": 7155,
	"./events/frosthaven/outpost/fh-soe-10-f.png": 531924,
	"./events/frosthaven/outpost/fh-soe-11-b.png": 398437,
	"./events/frosthaven/outpost/fh-soe-11-f.png": 740887,
	"./events/frosthaven/outpost/fh-soe-12-b.png": 543410,
	"./events/frosthaven/outpost/fh-soe-12-f.png": 260988,
	"./events/frosthaven/outpost/fh-soe-13-b.png": 341985,
	"./events/frosthaven/outpost/fh-soe-13-f.png": 722738,
	"./events/frosthaven/outpost/fh-soe-14-b.png": 795227,
	"./events/frosthaven/outpost/fh-soe-14-f.png": 560450,
	"./events/frosthaven/outpost/fh-soe-15-b.png": 741583,
	"./events/frosthaven/outpost/fh-soe-15-f.png": 991796,
	"./events/frosthaven/outpost/fh-soe-16-b.png": 884412,
	"./events/frosthaven/outpost/fh-soe-16-f.png": 663162,
	"./events/frosthaven/outpost/fh-soe-17-b.png": 454409,
	"./events/frosthaven/outpost/fh-soe-17-f.png": 854581,
	"./events/frosthaven/outpost/fh-soe-18-b.png": 728769,
	"./events/frosthaven/outpost/fh-soe-18-f.png": 902822,
	"./events/frosthaven/outpost/fh-soe-19-b.png": 783356,
	"./events/frosthaven/outpost/fh-soe-19-f.png": 508499,
	"./events/frosthaven/outpost/fh-soe-20-b.png": 308744,
	"./events/frosthaven/outpost/fh-soe-20-f.png": 288887,
	"./events/frosthaven/outpost/fh-soe-21-b.png": 406798,
	"./events/frosthaven/outpost/fh-soe-21-f.png": 412165,
	"./events/frosthaven/outpost/fh-soe-22-b.png": 697944,
	"./events/frosthaven/outpost/fh-soe-22-f.png": 258430,
	"./events/frosthaven/outpost/fh-soe-23-b.png": 471020,
	"./events/frosthaven/outpost/fh-soe-23-f.png": 880964,
	"./events/frosthaven/outpost/fh-soe-24-b.png": 630699,
	"./events/frosthaven/outpost/fh-soe-24-f.png": 341247,
	"./events/frosthaven/outpost/fh-soe-25-b.png": 693726,
	"./events/frosthaven/outpost/fh-soe-25-f.png": 724983,
	"./events/frosthaven/outpost/fh-soe-26-b.png": 316360,
	"./events/frosthaven/outpost/fh-soe-26-f.png": 603575,
	"./events/frosthaven/outpost/fh-soe-27-b.png": 463728,
	"./events/frosthaven/outpost/fh-soe-27-f.png": 303903,
	"./events/frosthaven/outpost/fh-soe-28-b.png": 270766,
	"./events/frosthaven/outpost/fh-soe-28-f.png": 469420,
	"./events/frosthaven/outpost/fh-soe-29-b.png": 912223,
	"./events/frosthaven/outpost/fh-soe-29-f.png": 708867,
	"./events/frosthaven/outpost/fh-soe-30-b.png": 385588,
	"./events/frosthaven/outpost/fh-soe-30-f.png": 499029,
	"./events/frosthaven/outpost/fh-soe-31-b.png": 255115,
	"./events/frosthaven/outpost/fh-soe-31-f.png": 206200,
	"./events/frosthaven/outpost/fh-soe-32-b.png": 822389,
	"./events/frosthaven/outpost/fh-soe-32-f.png": 580288,
	"./events/frosthaven/outpost/fh-soe-33-b.png": 150563,
	"./events/frosthaven/outpost/fh-soe-33-f.png": 853484,
	"./events/frosthaven/outpost/fh-soe-34-b.png": 454549,
	"./events/frosthaven/outpost/fh-soe-34-f.png": 979411,
	"./events/frosthaven/outpost/fh-soe-35-b.png": 179864,
	"./events/frosthaven/outpost/fh-soe-35-f.png": 713209,
	"./events/frosthaven/outpost/fh-soe-36-b.png": 316283,
	"./events/frosthaven/outpost/fh-soe-36-f.png": 658411,
	"./events/frosthaven/outpost/fh-soe-37-b.png": 525734,
	"./events/frosthaven/outpost/fh-soe-37-f.png": 9163,
	"./events/frosthaven/outpost/fh-soe-38-b.png": 748719,
	"./events/frosthaven/outpost/fh-soe-38-f.png": 60342,
	"./events/frosthaven/outpost/fh-soe-39-b.png": 704644,
	"./events/frosthaven/outpost/fh-soe-39-f.png": 587220,
	"./events/frosthaven/outpost/fh-soe-40-b.png": 260299,
	"./events/frosthaven/outpost/fh-soe-40-f.png": 521857,
	"./events/frosthaven/outpost/fh-soe-41-b.png": 597889,
	"./events/frosthaven/outpost/fh-soe-41-f.png": 476599,
	"./events/frosthaven/outpost/fh-soe-42-b.png": 625457,
	"./events/frosthaven/outpost/fh-soe-42-f.png": 830096,
	"./events/frosthaven/outpost/fh-soe-43-b.png": 186326,
	"./events/frosthaven/outpost/fh-soe-43-f.png": 464913,
	"./events/frosthaven/outpost/fh-soe-44-b.png": 782113,
	"./events/frosthaven/outpost/fh-soe-44-f.png": 268124,
	"./events/frosthaven/outpost/fh-soe-45-b.png": 200210,
	"./events/frosthaven/outpost/fh-soe-45-f.png": 485285,
	"./events/frosthaven/outpost/fh-soe-46-b.png": 298539,
	"./events/frosthaven/outpost/fh-soe-46-f.png": 691516,
	"./events/frosthaven/outpost/fh-soe-47-b.png": 988323,
	"./events/frosthaven/outpost/fh-soe-47-f.png": 371663,
	"./events/frosthaven/outpost/fh-soe-48-b.png": 267592,
	"./events/frosthaven/outpost/fh-soe-48-f.png": 105969,
	"./events/frosthaven/outpost/fh-soe-49-b.png": 878785,
	"./events/frosthaven/outpost/fh-soe-49-f.png": 64711,
	"./events/frosthaven/outpost/fh-soe-50-b.png": 341097,
	"./events/frosthaven/outpost/fh-soe-50-f.png": 255242,
	"./events/frosthaven/outpost/fh-soe-51-b.png": 525153,
	"./events/frosthaven/outpost/fh-soe-51-f.png": 837810,
	"./events/frosthaven/outpost/fh-soe-52-b.png": 858886,
	"./events/frosthaven/outpost/fh-soe-52-f.png": 793302,
	"./events/frosthaven/outpost/fh-soe-53-b.png": 931748,
	"./events/frosthaven/outpost/fh-soe-53-f.png": 599885,
	"./events/frosthaven/outpost/fh-soe-54-b.png": 5353,
	"./events/frosthaven/outpost/fh-soe-54-f.png": 120177,
	"./events/frosthaven/outpost/fh-soe-55-b.png": 25995,
	"./events/frosthaven/outpost/fh-soe-55-f.png": 233162,
	"./events/frosthaven/outpost/fh-soe-56-b.png": 835299,
	"./events/frosthaven/outpost/fh-soe-56-f.png": 360957,
	"./events/frosthaven/outpost/fh-soe-57-b.png": 855346,
	"./events/frosthaven/outpost/fh-soe-57-f.png": 343700,
	"./events/frosthaven/outpost/fh-soe-58-b.png": 403591,
	"./events/frosthaven/outpost/fh-soe-58-f.png": 868855,
	"./events/frosthaven/outpost/fh-soe-59-b.png": 808086,
	"./events/frosthaven/outpost/fh-soe-59-f.png": 476161,
	"./events/frosthaven/outpost/fh-soe-60-b.png": 54260,
	"./events/frosthaven/outpost/fh-soe-60-f.png": 599697,
	"./events/frosthaven/outpost/fh-soe-61-b.png": 713830,
	"./events/frosthaven/outpost/fh-soe-61-f.png": 640284,
	"./events/frosthaven/outpost/fh-soe-62-b.png": 582503,
	"./events/frosthaven/outpost/fh-soe-62-f.png": 61505,
	"./events/frosthaven/outpost/fh-soe-63-b.png": 717042,
	"./events/frosthaven/outpost/fh-soe-63-f.png": 533261,
	"./events/frosthaven/outpost/fh-soe-64-b.png": 2105,
	"./events/frosthaven/outpost/fh-soe-64-f.png": 655026,
	"./events/frosthaven/outpost/fh-soe-65-b.png": 88896,
	"./events/frosthaven/outpost/fh-soe-65-f.png": 73493,
	"./events/frosthaven/outpost/fh-woe-01-b.png": 902182,
	"./events/frosthaven/outpost/fh-woe-01-f.png": 939590,
	"./events/frosthaven/outpost/fh-woe-02-b.png": 972569,
	"./events/frosthaven/outpost/fh-woe-02-f.png": 555647,
	"./events/frosthaven/outpost/fh-woe-03-b.png": 692446,
	"./events/frosthaven/outpost/fh-woe-03-f.png": 590099,
	"./events/frosthaven/outpost/fh-woe-04-b.png": 593048,
	"./events/frosthaven/outpost/fh-woe-04-f.png": 389764,
	"./events/frosthaven/outpost/fh-woe-05-b.png": 326953,
	"./events/frosthaven/outpost/fh-woe-05-f.png": 779055,
	"./events/frosthaven/outpost/fh-woe-06-b.png": 351053,
	"./events/frosthaven/outpost/fh-woe-06-f.png": 827050,
	"./events/frosthaven/outpost/fh-woe-07-b.png": 273365,
	"./events/frosthaven/outpost/fh-woe-07-f.png": 844414,
	"./events/frosthaven/outpost/fh-woe-08-b.png": 553782,
	"./events/frosthaven/outpost/fh-woe-08-f.png": 214599,
	"./events/frosthaven/outpost/fh-woe-09-b.png": 849083,
	"./events/frosthaven/outpost/fh-woe-09-f.png": 840857,
	"./events/frosthaven/outpost/fh-woe-10-b.png": 469475,
	"./events/frosthaven/outpost/fh-woe-10-f.png": 103050,
	"./events/frosthaven/outpost/fh-woe-11-b.png": 292562,
	"./events/frosthaven/outpost/fh-woe-11-f.png": 944833,
	"./events/frosthaven/outpost/fh-woe-12-b.png": 23559,
	"./events/frosthaven/outpost/fh-woe-12-f.png": 429134,
	"./events/frosthaven/outpost/fh-woe-13-b.png": 621790,
	"./events/frosthaven/outpost/fh-woe-13-f.png": 443539,
	"./events/frosthaven/outpost/fh-woe-14-b.png": 154761,
	"./events/frosthaven/outpost/fh-woe-14-f.png": 977155,
	"./events/frosthaven/outpost/fh-woe-15-b.png": 555711,
	"./events/frosthaven/outpost/fh-woe-15-f.png": 543755,
	"./events/frosthaven/outpost/fh-woe-16-b.png": 401479,
	"./events/frosthaven/outpost/fh-woe-16-f.png": 756360,
	"./events/frosthaven/outpost/fh-woe-17-b.png": 662622,
	"./events/frosthaven/outpost/fh-woe-17-f.png": 363748,
	"./events/frosthaven/outpost/fh-woe-18-b.png": 752116,
	"./events/frosthaven/outpost/fh-woe-18-f.png": 207880,
	"./events/frosthaven/outpost/fh-woe-19-b.png": 258879,
	"./events/frosthaven/outpost/fh-woe-19-f.png": 337363,
	"./events/frosthaven/outpost/fh-woe-20-b.png": 40173,
	"./events/frosthaven/outpost/fh-woe-20-f.png": 447239,
	"./events/frosthaven/outpost/fh-woe-21-b.png": 278557,
	"./events/frosthaven/outpost/fh-woe-21-f.png": 459561,
	"./events/frosthaven/outpost/fh-woe-22-b.png": 976930,
	"./events/frosthaven/outpost/fh-woe-22-f.png": 729579,
	"./events/frosthaven/outpost/fh-woe-23-b.png": 526173,
	"./events/frosthaven/outpost/fh-woe-23-f.png": 256285,
	"./events/frosthaven/outpost/fh-woe-24-b.png": 442949,
	"./events/frosthaven/outpost/fh-woe-24-f.png": 343988,
	"./events/frosthaven/outpost/fh-woe-25-b.png": 304390,
	"./events/frosthaven/outpost/fh-woe-25-f.png": 851366,
	"./events/frosthaven/outpost/fh-woe-26-b.png": 587016,
	"./events/frosthaven/outpost/fh-woe-26-f.png": 865391,
	"./events/frosthaven/outpost/fh-woe-27-b.png": 287229,
	"./events/frosthaven/outpost/fh-woe-27-f.png": 523469,
	"./events/frosthaven/outpost/fh-woe-28-b.png": 664138,
	"./events/frosthaven/outpost/fh-woe-28-f.png": 865300,
	"./events/frosthaven/outpost/fh-woe-29-b.png": 291987,
	"./events/frosthaven/outpost/fh-woe-29-f.png": 968595,
	"./events/frosthaven/outpost/fh-woe-30-b.png": 603316,
	"./events/frosthaven/outpost/fh-woe-30-f.png": 366349,
	"./events/frosthaven/outpost/fh-woe-31-b.png": 849891,
	"./events/frosthaven/outpost/fh-woe-31-f.png": 695912,
	"./events/frosthaven/outpost/fh-woe-32-b.png": 962586,
	"./events/frosthaven/outpost/fh-woe-32-f.png": 93459,
	"./events/frosthaven/outpost/fh-woe-33-b.png": 758804,
	"./events/frosthaven/outpost/fh-woe-33-f.png": 266757,
	"./events/frosthaven/outpost/fh-woe-34-b.png": 602302,
	"./events/frosthaven/outpost/fh-woe-34-f.png": 671953,
	"./events/frosthaven/outpost/fh-woe-35-b.png": 294099,
	"./events/frosthaven/outpost/fh-woe-35-f.png": 93327,
	"./events/frosthaven/outpost/fh-woe-36-b.png": 397340,
	"./events/frosthaven/outpost/fh-woe-36-f.png": 612301,
	"./events/frosthaven/outpost/fh-woe-37-b.png": 767573,
	"./events/frosthaven/outpost/fh-woe-37-f.png": 551710,
	"./events/frosthaven/outpost/fh-woe-38-b.png": 106581,
	"./events/frosthaven/outpost/fh-woe-38-f.png": 976772,
	"./events/frosthaven/outpost/fh-woe-39-b.png": 496698,
	"./events/frosthaven/outpost/fh-woe-39-f.png": 746129,
	"./events/frosthaven/outpost/fh-woe-40-b.png": 58823,
	"./events/frosthaven/outpost/fh-woe-40-f.png": 640753,
	"./events/frosthaven/outpost/fh-woe-41-b.png": 716730,
	"./events/frosthaven/outpost/fh-woe-41-f.png": 548270,
	"./events/frosthaven/outpost/fh-woe-42-b.png": 564365,
	"./events/frosthaven/outpost/fh-woe-42-f.png": 932591,
	"./events/frosthaven/outpost/fh-woe-43-b.png": 500717,
	"./events/frosthaven/outpost/fh-woe-43-f.png": 188387,
	"./events/frosthaven/outpost/fh-woe-44-b.png": 460876,
	"./events/frosthaven/outpost/fh-woe-44-f.png": 821665,
	"./events/frosthaven/outpost/fh-woe-45-b.png": 314465,
	"./events/frosthaven/outpost/fh-woe-45-f.png": 911206,
	"./events/frosthaven/outpost/fh-woe-46-b.png": 903167,
	"./events/frosthaven/outpost/fh-woe-46-f.png": 640705,
	"./events/frosthaven/outpost/fh-woe-47-b.png": 395373,
	"./events/frosthaven/outpost/fh-woe-47-f.png": 269747,
	"./events/frosthaven/outpost/fh-woe-48-b.png": 495788,
	"./events/frosthaven/outpost/fh-woe-48-f.png": 747915,
	"./events/frosthaven/outpost/fh-woe-49-b.png": 473709,
	"./events/frosthaven/outpost/fh-woe-49-f.png": 930449,
	"./events/frosthaven/outpost/fh-woe-50-b.png": 853901,
	"./events/frosthaven/outpost/fh-woe-50-f.png": 765973,
	"./events/frosthaven/outpost/fh-woe-51-b.png": 187834,
	"./events/frosthaven/outpost/fh-woe-51-f.png": 613474,
	"./events/frosthaven/outpost/fh-woe-52-b.png": 657819,
	"./events/frosthaven/outpost/fh-woe-52-f.png": 11410,
	"./events/frosthaven/outpost/fh-woe-53-b.png": 858853,
	"./events/frosthaven/outpost/fh-woe-53-f.png": 235991,
	"./events/frosthaven/outpost/fh-woe-54-b.png": 153866,
	"./events/frosthaven/outpost/fh-woe-54-f.png": 313921,
	"./events/frosthaven/outpost/fh-woe-55-b.png": 176769,
	"./events/frosthaven/outpost/fh-woe-55-f.png": 167963,
	"./events/frosthaven/outpost/fh-woe-56-b.png": 434008,
	"./events/frosthaven/outpost/fh-woe-56-f.png": 771320,
	"./events/frosthaven/outpost/fh-woe-57-b.png": 34386,
	"./events/frosthaven/outpost/fh-woe-57-f.png": 550928,
	"./events/frosthaven/outpost/fh-woe-58-b.png": 31412,
	"./events/frosthaven/outpost/fh-woe-58-f.png": 880075,
	"./events/frosthaven/outpost/fh-woe-59-b.png": 631147,
	"./events/frosthaven/outpost/fh-woe-59-f.png": 213549,
	"./events/frosthaven/outpost/fh-woe-60-b.png": 675984,
	"./events/frosthaven/outpost/fh-woe-60-f.png": 307209,
	"./events/frosthaven/outpost/fh-woe-61-b.png": 641172,
	"./events/frosthaven/outpost/fh-woe-61-f.png": 206322,
	"./events/frosthaven/outpost/fh-woe-62-b.png": 842495,
	"./events/frosthaven/outpost/fh-woe-62-f.png": 56418,
	"./events/frosthaven/outpost/fh-woe-63-b.png": 901479,
	"./events/frosthaven/outpost/fh-woe-63-f.png": 728403,
	"./events/frosthaven/outpost/fh-woe-64-b.png": 772909,
	"./events/frosthaven/outpost/fh-woe-64-f.png": 927695,
	"./events/frosthaven/outpost/fh-woe-65-b.png": 459870,
	"./events/frosthaven/outpost/fh-woe-65-f.png": 195959,
	"./events/frosthaven/outpost/fh-woe-66-b.png": 153985,
	"./events/frosthaven/outpost/fh-woe-66-f.png": 482645,
	"./events/frosthaven/outpost/fh-woe-67-b.png": 372731,
	"./events/frosthaven/outpost/fh-woe-67-f.png": 111939,
	"./events/frosthaven/outpost/fh-woe-68-b.png": 515183,
	"./events/frosthaven/outpost/fh-woe-68-f.png": 818841,
	"./events/frosthaven/outpost/fh-woe-69-b.png": 610261,
	"./events/frosthaven/outpost/fh-woe-69-f.png": 983211,
	"./events/frosthaven/outpost/fh-woe-70-b.png": 825806,
	"./events/frosthaven/outpost/fh-woe-70-f.png": 960168,
	"./events/frosthaven/outpost/fh-woe-71-b.png": 648234,
	"./events/frosthaven/outpost/fh-woe-71-f.png": 527799,
	"./events/frosthaven/outpost/fh-woe-72-b.png": 240033,
	"./events/frosthaven/outpost/fh-woe-72-f.png": 717288,
	"./events/frosthaven/outpost/fh-woe-73-b.png": 855663,
	"./events/frosthaven/outpost/fh-woe-73-f.png": 887669,
	"./events/frosthaven/outpost/fh-woe-74-b.png": 98199,
	"./events/frosthaven/outpost/fh-woe-74-f.png": 368890,
	"./events/frosthaven/outpost/fh-woe-75-b.png": 505944,
	"./events/frosthaven/outpost/fh-woe-75-f.png": 992158,
	"./events/frosthaven/outpost/fh-woe-76-b.png": 883557,
	"./events/frosthaven/outpost/fh-woe-76-f.png": 360026,
	"./events/frosthaven/outpost/fh-woe-77-b.png": 296977,
	"./events/frosthaven/outpost/fh-woe-77-f.png": 769724,
	"./events/frosthaven/outpost/fh-woe-78-b.png": 446961,
	"./events/frosthaven/outpost/fh-woe-78-f.png": 221071,
	"./events/frosthaven/outpost/fh-woe-79-b.png": 13209,
	"./events/frosthaven/outpost/fh-woe-79-f.png": 888564,
	"./events/frosthaven/outpost/fh-woe-80-b.png": 602614,
	"./events/frosthaven/outpost/fh-woe-80-f.png": 248767,
	"./events/frosthaven/outpost/fh-woe-81-b.png": 894207,
	"./events/frosthaven/outpost/fh-woe-81-f.png": 339510,
	"./events/frosthaven/road/fh-sre-01-b.png": 267694,
	"./events/frosthaven/road/fh-sre-01-f.png": 62163,
	"./events/frosthaven/road/fh-sre-02-b.png": 191781,
	"./events/frosthaven/road/fh-sre-02-f.png": 815587,
	"./events/frosthaven/road/fh-sre-03-b.png": 715608,
	"./events/frosthaven/road/fh-sre-03-f.png": 56308,
	"./events/frosthaven/road/fh-sre-04-b.png": 980277,
	"./events/frosthaven/road/fh-sre-04-f.png": 163341,
	"./events/frosthaven/road/fh-sre-05-b.png": 349496,
	"./events/frosthaven/road/fh-sre-05-f.png": 749806,
	"./events/frosthaven/road/fh-sre-06-b.png": 793499,
	"./events/frosthaven/road/fh-sre-06-f.png": 623254,
	"./events/frosthaven/road/fh-sre-07-b.png": 72821,
	"./events/frosthaven/road/fh-sre-07-f.png": 505775,
	"./events/frosthaven/road/fh-sre-08-b.png": 738313,
	"./events/frosthaven/road/fh-sre-08-f.png": 94684,
	"./events/frosthaven/road/fh-sre-09-b.png": 644900,
	"./events/frosthaven/road/fh-sre-09-f.png": 96820,
	"./events/frosthaven/road/fh-sre-10-b.png": 517700,
	"./events/frosthaven/road/fh-sre-10-f.png": 391855,
	"./events/frosthaven/road/fh-sre-11-b.png": 369350,
	"./events/frosthaven/road/fh-sre-11-f.png": 96954,
	"./events/frosthaven/road/fh-sre-12-b.png": 84576,
	"./events/frosthaven/road/fh-sre-12-f.png": 322158,
	"./events/frosthaven/road/fh-sre-13-b.png": 143816,
	"./events/frosthaven/road/fh-sre-13-f.png": 75430,
	"./events/frosthaven/road/fh-sre-14-b.png": 409189,
	"./events/frosthaven/road/fh-sre-14-f.png": 152495,
	"./events/frosthaven/road/fh-sre-15-b.png": 534491,
	"./events/frosthaven/road/fh-sre-15-f.png": 736616,
	"./events/frosthaven/road/fh-sre-16-b.png": 597230,
	"./events/frosthaven/road/fh-sre-16-f.png": 29444,
	"./events/frosthaven/road/fh-sre-17-b.png": 601141,
	"./events/frosthaven/road/fh-sre-17-f.png": 265298,
	"./events/frosthaven/road/fh-sre-18-b.png": 135962,
	"./events/frosthaven/road/fh-sre-18-f.png": 138604,
	"./events/frosthaven/road/fh-sre-19-b.png": 214023,
	"./events/frosthaven/road/fh-sre-19-f.png": 742151,
	"./events/frosthaven/road/fh-sre-20-b.png": 943179,
	"./events/frosthaven/road/fh-sre-20-f.png": 826098,
	"./events/frosthaven/road/fh-sre-21-b.png": 398243,
	"./events/frosthaven/road/fh-sre-21-f.png": 469403,
	"./events/frosthaven/road/fh-sre-22-b.png": 124512,
	"./events/frosthaven/road/fh-sre-22-f.png": 275140,
	"./events/frosthaven/road/fh-sre-23-b.png": 955171,
	"./events/frosthaven/road/fh-sre-23-f.png": 90397,
	"./events/frosthaven/road/fh-sre-24-b.png": 643369,
	"./events/frosthaven/road/fh-sre-24-f.png": 585698,
	"./events/frosthaven/road/fh-sre-25-b.png": 343522,
	"./events/frosthaven/road/fh-sre-25-f.png": 131287,
	"./events/frosthaven/road/fh-sre-26-b.png": 623719,
	"./events/frosthaven/road/fh-sre-26-f.png": 807404,
	"./events/frosthaven/road/fh-sre-27-b.png": 494201,
	"./events/frosthaven/road/fh-sre-27-f.png": 224572,
	"./events/frosthaven/road/fh-sre-28-b.png": 658596,
	"./events/frosthaven/road/fh-sre-28-f.png": 993339,
	"./events/frosthaven/road/fh-sre-29-b.png": 768049,
	"./events/frosthaven/road/fh-sre-29-f.png": 928895,
	"./events/frosthaven/road/fh-sre-30-b.png": 764939,
	"./events/frosthaven/road/fh-sre-30-f.png": 209824,
	"./events/frosthaven/road/fh-sre-31-b.png": 539116,
	"./events/frosthaven/road/fh-sre-31-f.png": 856143,
	"./events/frosthaven/road/fh-sre-32-b.png": 920317,
	"./events/frosthaven/road/fh-sre-32-f.png": 525095,
	"./events/frosthaven/road/fh-sre-33-b.png": 59210,
	"./events/frosthaven/road/fh-sre-33-f.png": 73078,
	"./events/frosthaven/road/fh-sre-34-b.png": 452395,
	"./events/frosthaven/road/fh-sre-34-f.png": 369629,
	"./events/frosthaven/road/fh-sre-35-b.png": 770476,
	"./events/frosthaven/road/fh-sre-35-f.png": 252249,
	"./events/frosthaven/road/fh-sre-36-b.png": 7304,
	"./events/frosthaven/road/fh-sre-36-f.png": 751859,
	"./events/frosthaven/road/fh-sre-37-b.png": 800538,
	"./events/frosthaven/road/fh-sre-37-f.png": 323663,
	"./events/frosthaven/road/fh-sre-38-b.png": 478845,
	"./events/frosthaven/road/fh-sre-38-f.png": 315603,
	"./events/frosthaven/road/fh-sre-39-b.png": 311225,
	"./events/frosthaven/road/fh-sre-39-f.png": 730057,
	"./events/frosthaven/road/fh-sre-40-b.png": 133709,
	"./events/frosthaven/road/fh-sre-40-f.png": 20194,
	"./events/frosthaven/road/fh-sre-41-b.png": 858955,
	"./events/frosthaven/road/fh-sre-41-f.png": 927754,
	"./events/frosthaven/road/fh-sre-42-b.png": 554342,
	"./events/frosthaven/road/fh-sre-42-f.png": 499858,
	"./events/frosthaven/road/fh-sre-43-b.png": 889173,
	"./events/frosthaven/road/fh-sre-43-f.png": 968975,
	"./events/frosthaven/road/fh-sre-44-b.png": 667377,
	"./events/frosthaven/road/fh-sre-44-f.png": 75163,
	"./events/frosthaven/road/fh-sre-45-b.png": 940236,
	"./events/frosthaven/road/fh-sre-45-f.png": 9735,
	"./events/frosthaven/road/fh-sre-46-b.png": 368550,
	"./events/frosthaven/road/fh-sre-46-f.png": 21151,
	"./events/frosthaven/road/fh-sre-47-b.png": 533346,
	"./events/frosthaven/road/fh-sre-47-f.png": 762466,
	"./events/frosthaven/road/fh-sre-48-b.png": 773794,
	"./events/frosthaven/road/fh-sre-48-f.png": 556834,
	"./events/frosthaven/road/fh-sre-49-b.png": 664301,
	"./events/frosthaven/road/fh-sre-49-f.png": 782011,
	"./events/frosthaven/road/fh-sre-50-b.png": 334564,
	"./events/frosthaven/road/fh-sre-50-f.png": 690304,
	"./events/frosthaven/road/fh-sre-51-b.png": 733294,
	"./events/frosthaven/road/fh-sre-51-f.png": 688939,
	"./events/frosthaven/road/fh-sre-52-b.png": 21500,
	"./events/frosthaven/road/fh-sre-52-f.png": 433817,
	"./events/frosthaven/road/fh-wre-01-b.png": 271977,
	"./events/frosthaven/road/fh-wre-01-f.png": 2656,
	"./events/frosthaven/road/fh-wre-02-b.png": 396454,
	"./events/frosthaven/road/fh-wre-02-f.png": 820597,
	"./events/frosthaven/road/fh-wre-03-b.png": 998098,
	"./events/frosthaven/road/fh-wre-03-f.png": 475390,
	"./events/frosthaven/road/fh-wre-04-b.png": 590448,
	"./events/frosthaven/road/fh-wre-04-f.png": 691248,
	"./events/frosthaven/road/fh-wre-05-b.png": 18664,
	"./events/frosthaven/road/fh-wre-05-f.png": 33814,
	"./events/frosthaven/road/fh-wre-06-b.png": 323225,
	"./events/frosthaven/road/fh-wre-06-f.png": 747666,
	"./events/frosthaven/road/fh-wre-07-b.png": 626774,
	"./events/frosthaven/road/fh-wre-07-f.png": 571421,
	"./events/frosthaven/road/fh-wre-08-b.png": 913085,
	"./events/frosthaven/road/fh-wre-08-f.png": 620990,
	"./events/frosthaven/road/fh-wre-09-b.png": 504872,
	"./events/frosthaven/road/fh-wre-09-f.png": 830651,
	"./events/frosthaven/road/fh-wre-10-b.png": 241899,
	"./events/frosthaven/road/fh-wre-10-f.png": 35360,
	"./events/frosthaven/road/fh-wre-11-b.png": 586023,
	"./events/frosthaven/road/fh-wre-11-f.png": 149953,
	"./events/frosthaven/road/fh-wre-12-b.png": 556428,
	"./events/frosthaven/road/fh-wre-12-f.png": 928254,
	"./events/frosthaven/road/fh-wre-13-b.png": 789964,
	"./events/frosthaven/road/fh-wre-13-f.png": 569021,
	"./events/frosthaven/road/fh-wre-14-b.png": 820554,
	"./events/frosthaven/road/fh-wre-14-f.png": 475004,
	"./events/frosthaven/road/fh-wre-15-b.png": 157438,
	"./events/frosthaven/road/fh-wre-15-f.png": 611729,
	"./events/frosthaven/road/fh-wre-16-b.png": 591959,
	"./events/frosthaven/road/fh-wre-16-f.png": 749852,
	"./events/frosthaven/road/fh-wre-17-b.png": 889605,
	"./events/frosthaven/road/fh-wre-17-f.png": 6867,
	"./events/frosthaven/road/fh-wre-18-b.png": 588080,
	"./events/frosthaven/road/fh-wre-18-f.png": 950112,
	"./events/frosthaven/road/fh-wre-19-b.png": 753008,
	"./events/frosthaven/road/fh-wre-19-f.png": 783695,
	"./events/frosthaven/road/fh-wre-20-b.png": 278641,
	"./events/frosthaven/road/fh-wre-20-f.png": 995851,
	"./events/frosthaven/road/fh-wre-21-b.png": 39601,
	"./events/frosthaven/road/fh-wre-21-f.png": 784816,
	"./events/frosthaven/road/fh-wre-22-b.png": 387771,
	"./events/frosthaven/road/fh-wre-22-f.png": 606543,
	"./events/frosthaven/road/fh-wre-23-b.png": 718501,
	"./events/frosthaven/road/fh-wre-23-f.png": 286632,
	"./events/frosthaven/road/fh-wre-24-b.png": 240516,
	"./events/frosthaven/road/fh-wre-24-f.png": 269440,
	"./events/frosthaven/road/fh-wre-25-b.png": 980815,
	"./events/frosthaven/road/fh-wre-25-f.png": 9842,
	"./events/frosthaven/road/fh-wre-26-b.png": 806370,
	"./events/frosthaven/road/fh-wre-26-f.png": 465497,
	"./events/frosthaven/road/fh-wre-27-b.png": 32309,
	"./events/frosthaven/road/fh-wre-27-f.png": 29475,
	"./events/frosthaven/road/fh-wre-28-b.png": 628790,
	"./events/frosthaven/road/fh-wre-28-f.png": 278063,
	"./events/frosthaven/road/fh-wre-29-b.png": 66526,
	"./events/frosthaven/road/fh-wre-29-f.png": 513213,
	"./events/frosthaven/road/fh-wre-30-b.png": 627996,
	"./events/frosthaven/road/fh-wre-30-f.png": 657204,
	"./events/frosthaven/road/fh-wre-31-b.png": 376737,
	"./events/frosthaven/road/fh-wre-31-f.png": 163717,
	"./events/frosthaven/road/fh-wre-32-b.png": 269752,
	"./events/frosthaven/road/fh-wre-32-f.png": 350169,
	"./events/frosthaven/road/fh-wre-33-b.png": 783381,
	"./events/frosthaven/road/fh-wre-33-f.png": 815216,
	"./events/frosthaven/road/fh-wre-34-b.png": 7869,
	"./events/frosthaven/road/fh-wre-34-f.png": 830757,
	"./events/frosthaven/road/fh-wre-35-b.png": 982745,
	"./events/frosthaven/road/fh-wre-35-f.png": 582242,
	"./events/frosthaven/road/fh-wre-36-b.png": 759310,
	"./events/frosthaven/road/fh-wre-36-f.png": 21375,
	"./events/frosthaven/road/fh-wre-37-b.png": 907085,
	"./events/frosthaven/road/fh-wre-37-f.png": 206804,
	"./events/frosthaven/road/fh-wre-38-b.png": 310284,
	"./events/frosthaven/road/fh-wre-38-f.png": 559349,
	"./events/frosthaven/road/fh-wre-39-b.png": 127603,
	"./events/frosthaven/road/fh-wre-39-f.png": 1731,
	"./events/frosthaven/road/fh-wre-40-b.png": 756805,
	"./events/frosthaven/road/fh-wre-40-f.png": 638401,
	"./events/frosthaven/road/fh-wre-41-b.png": 568244,
	"./events/frosthaven/road/fh-wre-41-f.png": 591062,
	"./events/frosthaven/road/fh-wre-42-b.png": 303148,
	"./events/frosthaven/road/fh-wre-42-f.png": 930591,
	"./events/frosthaven/road/fh-wre-43-b.png": 9675,
	"./events/frosthaven/road/fh-wre-43-f.png": 366141,
	"./events/frosthaven/road/fh-wre-44-b.png": 972888,
	"./events/frosthaven/road/fh-wre-44-f.png": 59418,
	"./events/frosthaven/road/fh-wre-45-b.png": 926049,
	"./events/frosthaven/road/fh-wre-45-f.png": 629750,
	"./events/frosthaven/road/fh-wre-46-b.png": 780478,
	"./events/frosthaven/road/fh-wre-46-f.png": 810356,
	"./events/frosthaven/road/fh-wre-47-b.png": 57696,
	"./events/frosthaven/road/fh-wre-47-f.png": 127895,
	"./events/frosthaven/road/fh-wre-48-b.png": 820084,
	"./events/frosthaven/road/fh-wre-48-f.png": 439622,
	"./events/frosthaven/road/fh-wre-49-b.png": 684115,
	"./events/frosthaven/road/fh-wre-49-f.png": 42489,
	"./events/gloomhaven/city/gh-ce-01-b.png": 412307,
	"./events/gloomhaven/city/gh-ce-01-f.png": 366415,
	"./events/gloomhaven/city/gh-ce-02-b.png": 633592,
	"./events/gloomhaven/city/gh-ce-02-f.png": 908810,
	"./events/gloomhaven/city/gh-ce-03-b.png": 777622,
	"./events/gloomhaven/city/gh-ce-03-f.png": 651103,
	"./events/gloomhaven/city/gh-ce-04-b.png": 677171,
	"./events/gloomhaven/city/gh-ce-04-f.png": 863655,
	"./events/gloomhaven/city/gh-ce-05-b.png": 671976,
	"./events/gloomhaven/city/gh-ce-05-f.png": 550620,
	"./events/gloomhaven/city/gh-ce-06-b.png": 75018,
	"./events/gloomhaven/city/gh-ce-06-f.png": 475869,
	"./events/gloomhaven/city/gh-ce-07-b.png": 455216,
	"./events/gloomhaven/city/gh-ce-07-f.png": 912512,
	"./events/gloomhaven/city/gh-ce-08-b.png": 187403,
	"./events/gloomhaven/city/gh-ce-08-f.png": 590847,
	"./events/gloomhaven/city/gh-ce-09-b.png": 369636,
	"./events/gloomhaven/city/gh-ce-09-f.png": 895145,
	"./events/gloomhaven/city/gh-ce-10-b.png": 52480,
	"./events/gloomhaven/city/gh-ce-10-f.png": 15345,
	"./events/gloomhaven/city/gh-ce-11-b.png": 750354,
	"./events/gloomhaven/city/gh-ce-11-f.png": 237287,
	"./events/gloomhaven/city/gh-ce-12-b.png": 958049,
	"./events/gloomhaven/city/gh-ce-12-f.png": 508156,
	"./events/gloomhaven/city/gh-ce-13-b.png": 552858,
	"./events/gloomhaven/city/gh-ce-13-f.png": 151019,
	"./events/gloomhaven/city/gh-ce-14-b.png": 641420,
	"./events/gloomhaven/city/gh-ce-14-f.png": 622346,
	"./events/gloomhaven/city/gh-ce-15-b.png": 820581,
	"./events/gloomhaven/city/gh-ce-15-f.png": 122901,
	"./events/gloomhaven/city/gh-ce-16-b.png": 320403,
	"./events/gloomhaven/city/gh-ce-16-f.png": 232353,
	"./events/gloomhaven/city/gh-ce-17-b.png": 532265,
	"./events/gloomhaven/city/gh-ce-17-f.png": 748729,
	"./events/gloomhaven/city/gh-ce-18-b.png": 900031,
	"./events/gloomhaven/city/gh-ce-18-f.png": 796489,
	"./events/gloomhaven/city/gh-ce-19-b.png": 940356,
	"./events/gloomhaven/city/gh-ce-19-f.png": 936714,
	"./events/gloomhaven/city/gh-ce-20-b.png": 898941,
	"./events/gloomhaven/city/gh-ce-20-f.png": 812517,
	"./events/gloomhaven/city/gh-ce-21-b.png": 30354,
	"./events/gloomhaven/city/gh-ce-21-f.png": 326642,
	"./events/gloomhaven/city/gh-ce-22-b.png": 355436,
	"./events/gloomhaven/city/gh-ce-22-f.png": 466720,
	"./events/gloomhaven/city/gh-ce-23-b.png": 181647,
	"./events/gloomhaven/city/gh-ce-23-f.png": 448701,
	"./events/gloomhaven/city/gh-ce-24-b.png": 325778,
	"./events/gloomhaven/city/gh-ce-24-f.png": 382837,
	"./events/gloomhaven/city/gh-ce-25-b.png": 704230,
	"./events/gloomhaven/city/gh-ce-25-f.png": 391098,
	"./events/gloomhaven/city/gh-ce-26-b.png": 3426,
	"./events/gloomhaven/city/gh-ce-26-f.png": 502740,
	"./events/gloomhaven/city/gh-ce-27-b.png": 893814,
	"./events/gloomhaven/city/gh-ce-27-f.png": 111449,
	"./events/gloomhaven/city/gh-ce-28-b.png": 159432,
	"./events/gloomhaven/city/gh-ce-28-f.png": 887434,
	"./events/gloomhaven/city/gh-ce-29-b.png": 896049,
	"./events/gloomhaven/city/gh-ce-29-f.png": 363001,
	"./events/gloomhaven/city/gh-ce-30-b.png": 76535,
	"./events/gloomhaven/city/gh-ce-30-f.png": 514637,
	"./events/gloomhaven/city/gh-ce-31-b.png": 561842,
	"./events/gloomhaven/city/gh-ce-31-f.png": 123218,
	"./events/gloomhaven/city/gh-ce-32-b.png": 777577,
	"./events/gloomhaven/city/gh-ce-32-f.png": 869585,
	"./events/gloomhaven/city/gh-ce-33-b.png": 76621,
	"./events/gloomhaven/city/gh-ce-33-f.png": 560360,
	"./events/gloomhaven/city/gh-ce-34-b.png": 146464,
	"./events/gloomhaven/city/gh-ce-34-f.png": 394895,
	"./events/gloomhaven/city/gh-ce-35-b.png": 592262,
	"./events/gloomhaven/city/gh-ce-35-f.png": 571530,
	"./events/gloomhaven/city/gh-ce-36-b.png": 124095,
	"./events/gloomhaven/city/gh-ce-36-f.png": 825307,
	"./events/gloomhaven/city/gh-ce-37-b.png": 504975,
	"./events/gloomhaven/city/gh-ce-37-f.png": 721745,
	"./events/gloomhaven/city/gh-ce-38-b.png": 563698,
	"./events/gloomhaven/city/gh-ce-38-f.png": 638997,
	"./events/gloomhaven/city/gh-ce-39-b.png": 186522,
	"./events/gloomhaven/city/gh-ce-39-f.png": 264058,
	"./events/gloomhaven/city/gh-ce-40-b.png": 478973,
	"./events/gloomhaven/city/gh-ce-40-f.png": 369446,
	"./events/gloomhaven/city/gh-ce-41-b.png": 439176,
	"./events/gloomhaven/city/gh-ce-41-f.png": 118525,
	"./events/gloomhaven/city/gh-ce-42-b.png": 693784,
	"./events/gloomhaven/city/gh-ce-42-f.png": 88585,
	"./events/gloomhaven/city/gh-ce-43-b.png": 930660,
	"./events/gloomhaven/city/gh-ce-43-f.png": 10628,
	"./events/gloomhaven/city/gh-ce-44-b.png": 38018,
	"./events/gloomhaven/city/gh-ce-44-f.png": 946332,
	"./events/gloomhaven/city/gh-ce-45-b.png": 769921,
	"./events/gloomhaven/city/gh-ce-45-f.png": 154413,
	"./events/gloomhaven/city/gh-ce-46-b.png": 778170,
	"./events/gloomhaven/city/gh-ce-46-f.png": 451400,
	"./events/gloomhaven/city/gh-ce-47-b.png": 742353,
	"./events/gloomhaven/city/gh-ce-47-f.png": 310705,
	"./events/gloomhaven/city/gh-ce-48-b.png": 436295,
	"./events/gloomhaven/city/gh-ce-48-f.png": 622015,
	"./events/gloomhaven/city/gh-ce-49-b.png": 282298,
	"./events/gloomhaven/city/gh-ce-49-f.png": 762143,
	"./events/gloomhaven/city/gh-ce-50-b.png": 304907,
	"./events/gloomhaven/city/gh-ce-50-f.png": 481754,
	"./events/gloomhaven/city/gh-ce-51-b.png": 890569,
	"./events/gloomhaven/city/gh-ce-51-f.png": 841973,
	"./events/gloomhaven/city/gh-ce-52-b.png": 11489,
	"./events/gloomhaven/city/gh-ce-52-f.png": 274989,
	"./events/gloomhaven/city/gh-ce-53-b.png": 347046,
	"./events/gloomhaven/city/gh-ce-53-f.png": 295038,
	"./events/gloomhaven/city/gh-ce-54-b.png": 898370,
	"./events/gloomhaven/city/gh-ce-54-f.png": 881813,
	"./events/gloomhaven/city/gh-ce-55-b.png": 640149,
	"./events/gloomhaven/city/gh-ce-55-f.png": 356356,
	"./events/gloomhaven/city/gh-ce-56-b.png": 714595,
	"./events/gloomhaven/city/gh-ce-56-f.png": 951064,
	"./events/gloomhaven/city/gh-ce-57-b.png": 239037,
	"./events/gloomhaven/city/gh-ce-57-f.png": 879398,
	"./events/gloomhaven/city/gh-ce-58-b.png": 594308,
	"./events/gloomhaven/city/gh-ce-58-f.png": 594254,
	"./events/gloomhaven/city/gh-ce-59-b.png": 973043,
	"./events/gloomhaven/city/gh-ce-59-f.png": 843082,
	"./events/gloomhaven/city/gh-ce-60-b.png": 987808,
	"./events/gloomhaven/city/gh-ce-60-f.png": 683185,
	"./events/gloomhaven/city/gh-ce-61-b.png": 935862,
	"./events/gloomhaven/city/gh-ce-61-f.png": 863426,
	"./events/gloomhaven/city/gh-ce-62-b.png": 398237,
	"./events/gloomhaven/city/gh-ce-62-f.png": 64791,
	"./events/gloomhaven/city/gh-ce-63-b.png": 96520,
	"./events/gloomhaven/city/gh-ce-63-f.png": 791625,
	"./events/gloomhaven/city/gh-ce-64-b.png": 99103,
	"./events/gloomhaven/city/gh-ce-64-f.png": 870990,
	"./events/gloomhaven/city/gh-ce-65-b.png": 556534,
	"./events/gloomhaven/city/gh-ce-65-f.png": 691386,
	"./events/gloomhaven/city/gh-ce-66-b.png": 716784,
	"./events/gloomhaven/city/gh-ce-66-f.png": 391066,
	"./events/gloomhaven/city/gh-ce-67-b.png": 703880,
	"./events/gloomhaven/city/gh-ce-67-f.png": 291984,
	"./events/gloomhaven/city/gh-ce-68-b.png": 63301,
	"./events/gloomhaven/city/gh-ce-68-f.png": 468850,
	"./events/gloomhaven/city/gh-ce-69-b.png": 105119,
	"./events/gloomhaven/city/gh-ce-69-f.png": 208292,
	"./events/gloomhaven/city/gh-ce-70-b.png": 942950,
	"./events/gloomhaven/city/gh-ce-70-f.png": 448009,
	"./events/gloomhaven/city/gh-ce-71-b.png": 16456,
	"./events/gloomhaven/city/gh-ce-71-f.png": 584366,
	"./events/gloomhaven/city/gh-ce-72-b.png": 663576,
	"./events/gloomhaven/city/gh-ce-72-f.png": 421118,
	"./events/gloomhaven/city/gh-ce-73-b.png": 752781,
	"./events/gloomhaven/city/gh-ce-73-f.png": 523983,
	"./events/gloomhaven/city/gh-ce-74-b.png": 772845,
	"./events/gloomhaven/city/gh-ce-74-f.png": 262604,
	"./events/gloomhaven/city/gh-ce-75-b.png": 352886,
	"./events/gloomhaven/city/gh-ce-75-f.png": 80796,
	"./events/gloomhaven/city/gh-ce-76-b.png": 50797,
	"./events/gloomhaven/city/gh-ce-76-f.png": 110740,
	"./events/gloomhaven/city/gh-ce-77-b.png": 916341,
	"./events/gloomhaven/city/gh-ce-77-f.png": 701678,
	"./events/gloomhaven/city/gh-ce-78-b.png": 8817,
	"./events/gloomhaven/city/gh-ce-78-f.png": 491448,
	"./events/gloomhaven/city/gh-ce-79-b.png": 28882,
	"./events/gloomhaven/city/gh-ce-79-f.png": 73699,
	"./events/gloomhaven/city/gh-ce-80-b.png": 105297,
	"./events/gloomhaven/city/gh-ce-80-f.png": 481157,
	"./events/gloomhaven/city/gh-ce-81-b.png": 163289,
	"./events/gloomhaven/city/gh-ce-81-f.png": 460217,
	"./events/gloomhaven/road/gh-re-01-b.png": 510167,
	"./events/gloomhaven/road/gh-re-01-f.png": 85415,
	"./events/gloomhaven/road/gh-re-02-b.png": 479419,
	"./events/gloomhaven/road/gh-re-02-f.png": 88059,
	"./events/gloomhaven/road/gh-re-03-b.png": 188376,
	"./events/gloomhaven/road/gh-re-03-f.png": 190476,
	"./events/gloomhaven/road/gh-re-04-b.png": 750656,
	"./events/gloomhaven/road/gh-re-04-f.png": 731659,
	"./events/gloomhaven/road/gh-re-05-b.png": 238504,
	"./events/gloomhaven/road/gh-re-05-f.png": 958945,
	"./events/gloomhaven/road/gh-re-06-b.png": 713384,
	"./events/gloomhaven/road/gh-re-06-f.png": 266256,
	"./events/gloomhaven/road/gh-re-07-b.png": 603082,
	"./events/gloomhaven/road/gh-re-07-f.png": 488819,
	"./events/gloomhaven/road/gh-re-08-b.png": 700263,
	"./events/gloomhaven/road/gh-re-08-f.png": 303883,
	"./events/gloomhaven/road/gh-re-09-b.png": 16865,
	"./events/gloomhaven/road/gh-re-09-f.png": 591227,
	"./events/gloomhaven/road/gh-re-10-b.png": 394331,
	"./events/gloomhaven/road/gh-re-10-f.png": 820128,
	"./events/gloomhaven/road/gh-re-11-b.png": 946095,
	"./events/gloomhaven/road/gh-re-11-f.png": 189199,
	"./events/gloomhaven/road/gh-re-12-b.png": 948065,
	"./events/gloomhaven/road/gh-re-12-f.png": 989719,
	"./events/gloomhaven/road/gh-re-13-b.png": 911826,
	"./events/gloomhaven/road/gh-re-13-f.png": 873767,
	"./events/gloomhaven/road/gh-re-14-b.png": 613097,
	"./events/gloomhaven/road/gh-re-14-f.png": 214278,
	"./events/gloomhaven/road/gh-re-15-b.png": 563978,
	"./events/gloomhaven/road/gh-re-15-f.png": 689229,
	"./events/gloomhaven/road/gh-re-16-b.png": 249202,
	"./events/gloomhaven/road/gh-re-16-f.png": 799659,
	"./events/gloomhaven/road/gh-re-17-b.png": 906859,
	"./events/gloomhaven/road/gh-re-17-f.png": 427518,
	"./events/gloomhaven/road/gh-re-18-b.png": 325625,
	"./events/gloomhaven/road/gh-re-18-f.png": 24325,
	"./events/gloomhaven/road/gh-re-19-b.png": 981440,
	"./events/gloomhaven/road/gh-re-19-f.png": 403149,
	"./events/gloomhaven/road/gh-re-20-b.png": 759371,
	"./events/gloomhaven/road/gh-re-20-f.png": 779,
	"./events/gloomhaven/road/gh-re-21-b.png": 188130,
	"./events/gloomhaven/road/gh-re-21-f.png": 78167,
	"./events/gloomhaven/road/gh-re-22-b.png": 747400,
	"./events/gloomhaven/road/gh-re-22-f.png": 77035,
	"./events/gloomhaven/road/gh-re-23-b.png": 323593,
	"./events/gloomhaven/road/gh-re-23-f.png": 553780,
	"./events/gloomhaven/road/gh-re-24-b.png": 331426,
	"./events/gloomhaven/road/gh-re-24-f.png": 49707,
	"./events/gloomhaven/road/gh-re-25-b.png": 484601,
	"./events/gloomhaven/road/gh-re-25-f.png": 60061,
	"./events/gloomhaven/road/gh-re-26-b.png": 934721,
	"./events/gloomhaven/road/gh-re-26-f.png": 309155,
	"./events/gloomhaven/road/gh-re-27-b.png": 263280,
	"./events/gloomhaven/road/gh-re-27-f.png": 193443,
	"./events/gloomhaven/road/gh-re-28-b.png": 401173,
	"./events/gloomhaven/road/gh-re-28-f.png": 419406,
	"./events/gloomhaven/road/gh-re-29-b.png": 702897,
	"./events/gloomhaven/road/gh-re-29-f.png": 713963,
	"./events/gloomhaven/road/gh-re-30-b.png": 947304,
	"./events/gloomhaven/road/gh-re-30-f.png": 693669,
	"./events/gloomhaven/road/gh-re-31-b.png": 373343,
	"./events/gloomhaven/road/gh-re-31-f.png": 201178,
	"./events/gloomhaven/road/gh-re-32-b.png": 285245,
	"./events/gloomhaven/road/gh-re-32-f.png": 14781,
	"./events/gloomhaven/road/gh-re-33-b.png": 27117,
	"./events/gloomhaven/road/gh-re-33-f.png": 614925,
	"./events/gloomhaven/road/gh-re-34-b.png": 83297,
	"./events/gloomhaven/road/gh-re-34-f.png": 622282,
	"./events/gloomhaven/road/gh-re-35-b.png": 370937,
	"./events/gloomhaven/road/gh-re-35-f.png": 552135,
	"./events/gloomhaven/road/gh-re-36-b.png": 185641,
	"./events/gloomhaven/road/gh-re-36-f.png": 209449,
	"./events/gloomhaven/road/gh-re-37-b.png": 737607,
	"./events/gloomhaven/road/gh-re-37-f.png": 531695,
	"./events/gloomhaven/road/gh-re-38-b.png": 55523,
	"./events/gloomhaven/road/gh-re-38-f.png": 667680,
	"./events/gloomhaven/road/gh-re-39-b.png": 281796,
	"./events/gloomhaven/road/gh-re-39-f.png": 338355,
	"./events/gloomhaven/road/gh-re-40-b.png": 814658,
	"./events/gloomhaven/road/gh-re-40-f.png": 740181,
	"./events/gloomhaven/road/gh-re-41-b.png": 728121,
	"./events/gloomhaven/road/gh-re-41-f.png": 628661,
	"./events/gloomhaven/road/gh-re-42-b.png": 474037,
	"./events/gloomhaven/road/gh-re-42-f.png": 380204,
	"./events/gloomhaven/road/gh-re-43-b.png": 706131,
	"./events/gloomhaven/road/gh-re-43-f.png": 191543,
	"./events/gloomhaven/road/gh-re-44-b.png": 616180,
	"./events/gloomhaven/road/gh-re-44-f.png": 481828,
	"./events/gloomhaven/road/gh-re-45-b.png": 330961,
	"./events/gloomhaven/road/gh-re-45-f.png": 733377,
	"./events/gloomhaven/road/gh-re-46-b.png": 437588,
	"./events/gloomhaven/road/gh-re-46-f.png": 451867,
	"./events/gloomhaven/road/gh-re-47-b.png": 191930,
	"./events/gloomhaven/road/gh-re-47-f.png": 972825,
	"./events/gloomhaven/road/gh-re-48-b.png": 42154,
	"./events/gloomhaven/road/gh-re-48-f.png": 784892,
	"./events/gloomhaven/road/gh-re-49-b.png": 557386,
	"./events/gloomhaven/road/gh-re-49-f.png": 86850,
	"./events/gloomhaven/road/gh-re-50-b.png": 977797,
	"./events/gloomhaven/road/gh-re-50-f.png": 288150,
	"./events/gloomhaven/road/gh-re-51-b.png": 975262,
	"./events/gloomhaven/road/gh-re-51-f.png": 687383,
	"./events/gloomhaven/road/gh-re-52-b.png": 514247,
	"./events/gloomhaven/road/gh-re-52-f.png": 789928,
	"./events/gloomhaven/road/gh-re-53-b.png": 44562,
	"./events/gloomhaven/road/gh-re-53-f.png": 440542,
	"./events/gloomhaven/road/gh-re-54-b.png": 566114,
	"./events/gloomhaven/road/gh-re-54-f.png": 230799,
	"./events/gloomhaven/road/gh-re-55-b.png": 828639,
	"./events/gloomhaven/road/gh-re-55-f.png": 46323,
	"./events/gloomhaven/road/gh-re-56-b.png": 933291,
	"./events/gloomhaven/road/gh-re-56-f.png": 419981,
	"./events/gloomhaven/road/gh-re-57-b.png": 952594,
	"./events/gloomhaven/road/gh-re-57-f.png": 741059,
	"./events/gloomhaven/road/gh-re-58-b.png": 628398,
	"./events/gloomhaven/road/gh-re-58-f.png": 860730,
	"./events/gloomhaven/road/gh-re-59-b.png": 782294,
	"./events/gloomhaven/road/gh-re-59-f.png": 536375,
	"./events/gloomhaven/road/gh-re-60-b.png": 907013,
	"./events/gloomhaven/road/gh-re-60-f.png": 156382,
	"./events/gloomhaven/road/gh-re-61-b.png": 549477,
	"./events/gloomhaven/road/gh-re-61-f.png": 632549,
	"./events/gloomhaven/road/gh-re-62-b.png": 499064,
	"./events/gloomhaven/road/gh-re-62-f.png": 894997,
	"./events/gloomhaven/road/gh-re-63-b.png": 697962,
	"./events/gloomhaven/road/gh-re-63-f.png": 29652,
	"./events/gloomhaven/road/gh-re-64-b.png": 32835,
	"./events/gloomhaven/road/gh-re-64-f.png": 401958,
	"./events/gloomhaven/road/gh-re-65-b.png": 220254,
	"./events/gloomhaven/road/gh-re-65-f.png": 62615,
	"./events/gloomhaven/road/gh-re-66-b.png": 457807,
	"./events/gloomhaven/road/gh-re-66-f.png": 330260,
	"./events/gloomhaven/road/gh-re-67-b.png": 6422,
	"./events/gloomhaven/road/gh-re-67-f.png": 325855,
	"./events/gloomhaven/road/gh-re-68-b.png": 424875,
	"./events/gloomhaven/road/gh-re-68-f.png": 573197,
	"./events/gloomhaven/road/gh-re-69-b.png": 419379,
	"./events/gloomhaven/road/gh-re-69-f.png": 904948,
	"./events/jaws-of-the-lion/ZZ/zz.txt": 196205,
	"./events/jaws-of-the-lion/city/jl-ce-01-b.png": 339557,
	"./events/jaws-of-the-lion/city/jl-ce-01-f.png": 721517,
	"./events/jaws-of-the-lion/city/jl-ce-02-b.png": 826302,
	"./events/jaws-of-the-lion/city/jl-ce-02-f.png": 956146,
	"./events/jaws-of-the-lion/city/jl-ce-03-b.png": 746637,
	"./events/jaws-of-the-lion/city/jl-ce-03-f.png": 893659,
	"./events/jaws-of-the-lion/city/jl-ce-04-b.png": 221426,
	"./events/jaws-of-the-lion/city/jl-ce-04-f.png": 354782,
	"./events/jaws-of-the-lion/city/jl-ce-05-b.png": 977309,
	"./events/jaws-of-the-lion/city/jl-ce-05-f.png": 870624,
	"./events/jaws-of-the-lion/city/jl-ce-06-b.png": 904827,
	"./events/jaws-of-the-lion/city/jl-ce-06-f.png": 26523,
	"./events/jaws-of-the-lion/city/jl-ce-07-b.png": 229737,
	"./events/jaws-of-the-lion/city/jl-ce-07-f.png": 262286,
	"./events/jaws-of-the-lion/city/jl-ce-08-b.png": 901811,
	"./events/jaws-of-the-lion/city/jl-ce-08-f.png": 809978,
	"./events/jaws-of-the-lion/city/jl-ce-09-b.png": 436429,
	"./events/jaws-of-the-lion/city/jl-ce-09-f.png": 336662,
	"./events/jaws-of-the-lion/city/jl-ce-10-b.png": 809808,
	"./events/jaws-of-the-lion/city/jl-ce-10-f.png": 157667,
	"./events/jaws-of-the-lion/city/jl-ce-11-b.png": 655886,
	"./events/jaws-of-the-lion/city/jl-ce-11-f.png": 131795,
	"./events/jaws-of-the-lion/city/jl-ce-12-b.png": 48196,
	"./events/jaws-of-the-lion/city/jl-ce-12-f.png": 391513,
	"./events/jaws-of-the-lion/city/jl-ce-13-b.png": 584455,
	"./events/jaws-of-the-lion/city/jl-ce-13-f.png": 243268,
	"./events/jaws-of-the-lion/city/jl-ce-14-b.png": 874839,
	"./events/jaws-of-the-lion/city/jl-ce-14-f.png": 280578,
	"./events/jaws-of-the-lion/city/jl-ce-15-b.png": 963761,
	"./events/jaws-of-the-lion/city/jl-ce-15-f.png": 212428,
	"./events/jaws-of-the-lion/city/jl-ce-16-b.png": 580152,
	"./events/jaws-of-the-lion/city/jl-ce-16-f.png": 307154,
	"./events/jaws-of-the-lion/city/jl-ce-17-b.png": 769876,
	"./events/jaws-of-the-lion/city/jl-ce-17-f.png": 452087,
	"./events/jaws-of-the-lion/city/jl-ce-18-b.png": 901977,
	"./events/jaws-of-the-lion/city/jl-ce-18-f.png": 935487,
	"./events/jaws-of-the-lion/city/jl-ce-19-b.png": 417016,
	"./events/jaws-of-the-lion/city/jl-ce-19-f.png": 937316,
	"./events/jaws-of-the-lion/city/jl-ce-20-b.png": 449204,
	"./events/jaws-of-the-lion/city/jl-ce-20-f.png": 348299,
	"./events/jaws-of-the-lion/city/jl-ce-21-b.png": 88898,
	"./events/jaws-of-the-lion/city/jl-ce-21-f.png": 893372,
	"./events/jaws-of-the-lion/city/jl-ce-22-b.png": 60325,
	"./events/jaws-of-the-lion/city/jl-ce-22-f.png": 462376,
	"./events/trail-of-ashes/city/toa-ce-61-b.png": 161109,
	"./events/trail-of-ashes/city/toa-ce-61-f.png": 605591,
	"./events/trail-of-ashes/city/toa-ce-62-b.png": 516074,
	"./events/trail-of-ashes/city/toa-ce-62-f.png": 616750,
	"./events/trail-of-ashes/city/toa-ce-63-b.png": 36354,
	"./events/trail-of-ashes/city/toa-ce-63-f.png": 34147,
	"./events/trail-of-ashes/city/toa-ce-64-b.png": 936796,
	"./events/trail-of-ashes/city/toa-ce-64-f.png": 260376,
	"./events/trail-of-ashes/city/toa-ce-65-b.png": 176602,
	"./events/trail-of-ashes/city/toa-ce-65-f.png": 117638,
	"./events/trail-of-ashes/city/toa-ce-66-b.png": 938244,
	"./events/trail-of-ashes/city/toa-ce-66-f.png": 162642,
	"./events/trail-of-ashes/city/toa-ce-67-b.png": 247340,
	"./events/trail-of-ashes/city/toa-ce-67-f.png": 82079,
	"./events/trail-of-ashes/city/toa-ce-68-b.png": 566,
	"./events/trail-of-ashes/city/toa-ce-68-f.png": 919689,
	"./events/trail-of-ashes/city/toa-ce-69-b.png": 587087,
	"./events/trail-of-ashes/city/toa-ce-69-f.png": 205774,
	"./events/trail-of-ashes/city/toa-ce-70-b.png": 819952,
	"./events/trail-of-ashes/city/toa-ce-70-f.png": 980619,
	"./events/trail-of-ashes/city/toa-ce-71-b.png": 105135,
	"./events/trail-of-ashes/city/toa-ce-71-f.png": 641920,
	"./events/trail-of-ashes/city/toa-ce-72-b.png": 168434,
	"./events/trail-of-ashes/city/toa-ce-72-f.png": 334309,
	"./events/trail-of-ashes/city/toa-ce-73-b.png": 640179,
	"./events/trail-of-ashes/city/toa-ce-73-f.png": 361303,
	"./events/trail-of-ashes/city/toa-ce-74-b.png": 579803,
	"./events/trail-of-ashes/city/toa-ce-74-f.png": 178813,
	"./events/trail-of-ashes/city/toa-ce-75-b.png": 916124,
	"./events/trail-of-ashes/city/toa-ce-75-f.png": 10173,
	"./events/trail-of-ashes/road/toa-re-61-b.png": 954937,
	"./events/trail-of-ashes/road/toa-re-61-f.png": 361410,
	"./events/trail-of-ashes/road/toa-re-62-b.png": 240252,
	"./events/trail-of-ashes/road/toa-re-62-f.png": 339185,
	"./events/trail-of-ashes/road/toa-re-63-b.png": 869176,
	"./events/trail-of-ashes/road/toa-re-63-f.png": 341859,
	"./events/trail-of-ashes/road/toa-re-64-b.png": 882629,
	"./events/trail-of-ashes/road/toa-re-64-f.png": 164958,
	"./events/trail-of-ashes/road/toa-re-65-b.png": 978716,
	"./events/trail-of-ashes/road/toa-re-65-f.png": 336148,
	"./events/trail-of-ashes/road/toa-re-66-b.png": 944342,
	"./events/trail-of-ashes/road/toa-re-66-f.png": 930056,
	"./events/trail-of-ashes/road/toa-re-67-b.png": 283337,
	"./events/trail-of-ashes/road/toa-re-67-f.png": 374730,
	"./events/trail-of-ashes/road/toa-re-68-b.png": 342323,
	"./events/trail-of-ashes/road/toa-re-68-f.png": 134783,
	"./events/trail-of-ashes/road/toa-re-69-b.png": 119398,
	"./events/trail-of-ashes/road/toa-re-69-f.png": 7423,
	"./events/trail-of-ashes/road/toa-re-70-b.png": 322161,
	"./events/trail-of-ashes/road/toa-re-70-f.png": 882366,
	"./events/trail-of-ashes/road/toa-re-71-b.png": 431822,
	"./events/trail-of-ashes/road/toa-re-71-f.png": 171206,
	"./events/trail-of-ashes/road/toa-re-72-b.png": 668617,
	"./events/trail-of-ashes/road/toa-re-72-f.png": 341906,
	"./events/trail-of-ashes/road/toa-re-73-b.png": 383101,
	"./events/trail-of-ashes/road/toa-re-73-f.png": 868883,
	"./events/trail-of-ashes/road/toa-re-74-b.png": 176323,
	"./events/trail-of-ashes/road/toa-re-74-f.png": 340116,
	"./events/trail-of-ashes/road/toa-re-75-b.png": 607427,
	"./events/trail-of-ashes/road/toa-re-75-f.png": 704303,
	"./items/crimson-scales/cs-01-orb-of-confusion-back.png": 849287,
	"./items/crimson-scales/cs-01a-orb-of-confusion.png": 463668,
	"./items/crimson-scales/cs-01b-orb-of-confusion.png": 927922,
	"./items/crimson-scales/cs-02-orb-of-momentum-back.png": 272892,
	"./items/crimson-scales/cs-02a-orb-of-momentum.png": 660352,
	"./items/crimson-scales/cs-02b-orb-of-momentum.png": 403414,
	"./items/crimson-scales/cs-03-orb-of-agility-back.png": 864455,
	"./items/crimson-scales/cs-03a-orb-of-agility.png": 280913,
	"./items/crimson-scales/cs-03b-orb-of-agility.png": 18974,
	"./items/crimson-scales/cs-04-orb-of-vigor-back.png": 512196,
	"./items/crimson-scales/cs-04a-orb-of-vigor.png": 703092,
	"./items/crimson-scales/cs-04b-orb-of-vigor.png": 54600,
	"./items/crimson-scales/cs-05-orb-of-retribution-back.png": 804069,
	"./items/crimson-scales/cs-05a-orb-of-retribution.png": 599158,
	"./items/crimson-scales/cs-05b-orb-of-retribution.png": 81249,
	"./items/crimson-scales/cs-06-orb-of-infection-back.png": 215556,
	"./items/crimson-scales/cs-06a-orb-of-infection.png": 227626,
	"./items/crimson-scales/cs-06b-orb-of-infection.png": 505272,
	"./items/crimson-scales/cs-07-orb-of-vitality-back.png": 685194,
	"./items/crimson-scales/cs-07a-orb-of-vitality.png": 610826,
	"./items/crimson-scales/cs-07b-orb-of-vitality.png": 67395,
	"./items/crimson-scales/cs-08-orb-of-protection-back.png": 989933,
	"./items/crimson-scales/cs-08a-orb-of-protection.png": 934213,
	"./items/crimson-scales/cs-08b-orb-of-protection.png": 295665,
	"./items/crimson-scales/cs-09-orb-of-fortune-back.png": 892314,
	"./items/crimson-scales/cs-09a-orb-of-fortune.png": 719918,
	"./items/crimson-scales/cs-09b-orb-of-fortune.png": 649554,
	"./items/crimson-scales/cs-10-orb-of-despair-back.png": 995954,
	"./items/crimson-scales/cs-100-wonder-stone-back.png": 518310,
	"./items/crimson-scales/cs-100-wonder-stone.png": 7859,
	"./items/crimson-scales/cs-10a-orb-of-despair.png": 186389,
	"./items/crimson-scales/cs-10b-orb-of-despair.png": 410594,
	"./items/crimson-scales/cs-11-pox-antidote-back.png": 994173,
	"./items/crimson-scales/cs-11-pox-antidote.png": 809771,
	"./items/crimson-scales/cs-12-trophy-helm-back.png": 484771,
	"./items/crimson-scales/cs-12-trophy-helm.png": 815936,
	"./items/crimson-scales/cs-13-war-pick-back.png": 890227,
	"./items/crimson-scales/cs-13a-war-pick.png": 526777,
	"./items/crimson-scales/cs-13b-war-pick.png": 455069,
	"./items/crimson-scales/cs-14-chain-mace-back.png": 731858,
	"./items/crimson-scales/cs-14a-chain-mace.png": 797516,
	"./items/crimson-scales/cs-14b-chain-mace.png": 950442,
	"./items/crimson-scales/cs-15-draining-greaves-back.png": 168529,
	"./items/crimson-scales/cs-15a-draining-greaves.png": 2473,
	"./items/crimson-scales/cs-15b-draining-greaves.png": 270933,
	"./items/crimson-scales/cs-16-shoes-of-phasing-back.png": 836615,
	"./items/crimson-scales/cs-16-shoes-of-phasing.png": 348070,
	"./items/crimson-scales/cs-17-lightweight-boots-back.png": 542314,
	"./items/crimson-scales/cs-17a-lightweight-boots.png": 999267,
	"./items/crimson-scales/cs-17b-lightweight-boots.png": 865553,
	"./items/crimson-scales/cs-18-bottled-moonlight-back.png": 762288,
	"./items/crimson-scales/cs-18a-bottled-moonlight.png": 49168,
	"./items/crimson-scales/cs-18b-bottled-moonlight.png": 283339,
	"./items/crimson-scales/cs-19-boots-of-perpetuity-back.png": 322850,
	"./items/crimson-scales/cs-19-boots-of-perpetuity.png": 180668,
	"./items/crimson-scales/cs-20-curious-pendant-back.png": 325858,
	"./items/crimson-scales/cs-20a-curious-pendant.png": 56033,
	"./items/crimson-scales/cs-20b-curious-pendant.png": 687829,
	"./items/crimson-scales/cs-21-infrared-goggles-back.png": 744717,
	"./items/crimson-scales/cs-21-infrared-goggles.png": 737977,
	"./items/crimson-scales/cs-22-steel-helmet-back.png": 550583,
	"./items/crimson-scales/cs-22a-steel-helmet.png": 803859,
	"./items/crimson-scales/cs-22b-steel-helmet.png": 2612,
	"./items/crimson-scales/cs-23-woven-plate-armor-back.png": 482098,
	"./items/crimson-scales/cs-23a-woven-plate-armor.png": 496864,
	"./items/crimson-scales/cs-23b-woven-plate-armor.png": 386194,
	"./items/crimson-scales/cs-24-mantle-of-purity-back.png": 1276,
	"./items/crimson-scales/cs-24a-mantle-of-purity.png": 413145,
	"./items/crimson-scales/cs-24b-mantle-of-purity.png": 50485,
	"./items/crimson-scales/cs-25-boneclad-shawl-back.png": 180525,
	"./items/crimson-scales/cs-25a-boneclad-shawl.png": 268928,
	"./items/crimson-scales/cs-25b-boneclad-shawl.png": 304598,
	"./items/crimson-scales/cs-26-silhouette-cuirass-back.png": 598196,
	"./items/crimson-scales/cs-26-silhouette-cuirass.png": 256969,
	"./items/crimson-scales/cs-27-translocation-device-back.png": 450454,
	"./items/crimson-scales/cs-27-translocation-device.png": 435061,
	"./items/crimson-scales/cs-28-alchemy-potion-back.png": 147217,
	"./items/crimson-scales/cs-28a-alchemy-potion.png": 282778,
	"./items/crimson-scales/cs-28b-alchemy-potion.png": 268274,
	"./items/crimson-scales/cs-29-intoxicating-potion-back.png": 215355,
	"./items/crimson-scales/cs-29-intoxicating-potion.png": 279393,
	"./items/crimson-scales/cs-30-iron-snare-back.png": 201832,
	"./items/crimson-scales/cs-30a-iron-snare.png": 361102,
	"./items/crimson-scales/cs-30b-iron-snare.png": 315324,
	"./items/crimson-scales/cs-31-concussion-mine-back.png": 262050,
	"./items/crimson-scales/cs-31a-concussion-mine.png": 518070,
	"./items/crimson-scales/cs-31b-concussion-mine.png": 375991,
	"./items/crimson-scales/cs-32-shifting-compass-back.png": 886377,
	"./items/crimson-scales/cs-32-shifting-compass.png": 389379,
	"./items/crimson-scales/cs-33-battering-ram-back.png": 549664,
	"./items/crimson-scales/cs-33-battering-ram.png": 435085,
	"./items/crimson-scales/cs-34-claw-trap-back.png": 210367,
	"./items/crimson-scales/cs-34-claw-trap.png": 278882,
	"./items/crimson-scales/cs-35-staff-of-retribution-back.png": 321542,
	"./items/crimson-scales/cs-35-staff-of-retribution.png": 586046,
	"./items/crimson-scales/cs-36-curseblood-blade-back.png": 84578,
	"./items/crimson-scales/cs-36-curseblood-blade.png": 837541,
	"./items/crimson-scales/cs-37-drakescale-shield-back.png": 887513,
	"./items/crimson-scales/cs-37a-drakescale-shield.png": 713009,
	"./items/crimson-scales/cs-37b-drakescale-shield.png": 39615,
	"./items/crimson-scales/cs-38-drakescale-dagger-back.png": 76005,
	"./items/crimson-scales/cs-38-drakescale-dagger.png": 361644,
	"./items/crimson-scales/cs-39-hook-shot-back.png": 772088,
	"./items/crimson-scales/cs-39-hook-shot.png": 338331,
	"./items/crimson-scales/cs-40-moonleather-boots-back.png": 630950,
	"./items/crimson-scales/cs-40-moonleather-boots.png": 293587,
	"./items/crimson-scales/cs-41-spirit-libation-back.png": 483863,
	"./items/crimson-scales/cs-41-spirit-libation.png": 981723,
	"./items/crimson-scales/cs-42-robe-of-soothing-back.png": 863308,
	"./items/crimson-scales/cs-42-robe-of-soothing.png": 237148,
	"./items/crimson-scales/cs-43-resplendent-mitre-back.png": 207053,
	"./items/crimson-scales/cs-43-resplendent-mitre.png": 180617,
	"./items/crimson-scales/cs-44-canister-projectile-back.png": 326552,
	"./items/crimson-scales/cs-44-canister-projectile.png": 146707,
	"./items/crimson-scales/cs-45-chain-cannon-back.png": 670758,
	"./items/crimson-scales/cs-45-chain-cannon.png": 427433,
	"./items/crimson-scales/cs-46-summoners-whistle-back.png": 547554,
	"./items/crimson-scales/cs-46-summoners-whistle.png": 842959,
	"./items/crimson-scales/cs-47-nature-armlets-back.png": 369840,
	"./items/crimson-scales/cs-47-nature-armlets.png": 51496,
	"./items/crimson-scales/cs-48-test-tube-back.png": 957068,
	"./items/crimson-scales/cs-48-test-tube.png": 458791,
	"./items/crimson-scales/cs-49-booster-shot-back.png": 379570,
	"./items/crimson-scales/cs-49-booster-shot.png": 745738,
	"./items/crimson-scales/cs-50-luminous-carapace-back.png": 104499,
	"./items/crimson-scales/cs-50-luminous-carapace.png": 428901,
	"./items/crimson-scales/cs-51-flaming-armor-back.png": 591582,
	"./items/crimson-scales/cs-51-flaming-armor.png": 886942,
	"./items/crimson-scales/cs-52-flaming-axe-back.png": 466513,
	"./items/crimson-scales/cs-52-flaming-axe.png": 128876,
	"./items/crimson-scales/cs-53-field-mortar-back.png": 580784,
	"./items/crimson-scales/cs-53-field-mortar.png": 25384,
	"./items/crimson-scales/cs-54-vipertooth-dagger-back.png": 638851,
	"./items/crimson-scales/cs-54-vipertooth-dagger.png": 314106,
	"./items/crimson-scales/cs-55-ghost-viper-venom-back.png": 447397,
	"./items/crimson-scales/cs-55a-ghost-viper-venom.png": 578231,
	"./items/crimson-scales/cs-55b-ghost-viper-venom.png": 123073,
	"./items/crimson-scales/cs-56-clamp-trap-back.png": 892233,
	"./items/crimson-scales/cs-56-clamp-trap.png": 943978,
	"./items/crimson-scales/cs-57-cleansed-voidheart-back.png": 566021,
	"./items/crimson-scales/cs-57-cleansed-voidheart.png": 625073,
	"./items/crimson-scales/cs-58-dizzying-tincture-back.png": 294957,
	"./items/crimson-scales/cs-58a-dizzying-tincture.png": 677164,
	"./items/crimson-scales/cs-58b-dizzying-tincture.png": 586772,
	"./items/crimson-scales/cs-59-drakes-blood-back.png": 166382,
	"./items/crimson-scales/cs-59a-drakes-blood.png": 517397,
	"./items/crimson-scales/cs-59b-drakes-blood.png": 77121,
	"./items/crimson-scales/cs-60-mana-medicine-back.png": 80804,
	"./items/crimson-scales/cs-60a-mana-medicine.png": 771668,
	"./items/crimson-scales/cs-60b-mana-medicine.png": 325529,
	"./items/crimson-scales/cs-61-ashsteel-gauntlets-back.png": 623533,
	"./items/crimson-scales/cs-61-ashsteel-gauntlets.png": 969814,
	"./items/crimson-scales/cs-62-smog-emitter-back.png": 78569,
	"./items/crimson-scales/cs-62-smog-emitter.png": 804291,
	"./items/crimson-scales/cs-63-lucky-horseshoe-back.png": 206080,
	"./items/crimson-scales/cs-63-lucky-horseshoe.png": 652079,
	"./items/crimson-scales/cs-64-mild-kindled-tonic-back.png": 204381,
	"./items/crimson-scales/cs-64-mild-kindled-tonic.png": 307259,
	"./items/crimson-scales/cs-65-rescue-axe-back.png": 978080,
	"./items/crimson-scales/cs-65-rescue-axe.png": 878867,
	"./items/crimson-scales/cs-66-iron-malleus-back.png": 749084,
	"./items/crimson-scales/cs-66-iron-malleus.png": 200523,
	"./items/crimson-scales/cs-67-pike-hook-back.png": 510612,
	"./items/crimson-scales/cs-67-pike-hook.png": 43176,
	"./items/crimson-scales/cs-68-explosive-tonic-back.png": 751481,
	"./items/crimson-scales/cs-68-explosive-tonic.png": 34078,
	"./items/crimson-scales/cs-69-spicy-kindled-tonic-back.png": 673322,
	"./items/crimson-scales/cs-69-spicy-kindled-tonic.png": 739630,
	"./items/crimson-scales/cs-70-utility-rope-back.png": 333724,
	"./items/crimson-scales/cs-70-utility-rope.png": 99505,
	"./items/crimson-scales/cs-71-fireproof-helm-back.png": 89563,
	"./items/crimson-scales/cs-71-fireproof-helm.png": 909402,
	"./items/crimson-scales/cs-72-wooden-ladder-back.png": 597433,
	"./items/crimson-scales/cs-72-wooden-ladder.png": 116579,
	"./items/crimson-scales/cs-73-medical-kit-back.png": 427677,
	"./items/crimson-scales/cs-73-medical-kit.png": 192757,
	"./items/crimson-scales/cs-74-mild-bolstering-tonic-back.png": 944933,
	"./items/crimson-scales/cs-74-mild-bolstering-tonic.png": 970610,
	"./items/crimson-scales/cs-75-medallion-of-the-oak-back.png": 627844,
	"./items/crimson-scales/cs-75-medallion-of-the-oak.png": 74909,
	"./items/crimson-scales/cs-76-cauterizing-knife-back.png": 474623,
	"./items/crimson-scales/cs-76-cauterizing-knife.png": 151260,
	"./items/crimson-scales/cs-77-trauma-kit-back.png": 569306,
	"./items/crimson-scales/cs-77-trauma-kit.png": 219669,
	"./items/crimson-scales/cs-78-scroll-of-charisma-back.png": 647540,
	"./items/crimson-scales/cs-78-scroll-of-charisma.png": 960121,
	"./items/crimson-scales/cs-79-rescue-shield-back.png": 727769,
	"./items/crimson-scales/cs-79-rescue-shield.png": 500169,
	"./items/crimson-scales/cs-80-scroll-of-protection-back.png": 975474,
	"./items/crimson-scales/cs-80-scroll-of-protection.png": 698853,
	"./items/crimson-scales/cs-81-spicy-bolstering-tonic-back.png": 515611,
	"./items/crimson-scales/cs-81-spicy-bolstering-tonic.png": 765938,
	"./items/crimson-scales/cs-82-scroll-of-command-back.png": 793308,
	"./items/crimson-scales/cs-82-scroll-of-command.png": 446537,
	"./items/crimson-scales/cs-83-sphere-of-currents-back.png": 114685,
	"./items/crimson-scales/cs-83-sphere-of-currents.png": 586356,
	"./items/crimson-scales/cs-84-slug-crossbow-back.png": 344121,
	"./items/crimson-scales/cs-84-slug-crossbow.png": 769703,
	"./items/crimson-scales/cs-85-refined-slug-crossbow-back.png": 972553,
	"./items/crimson-scales/cs-85-refined-slug-crossbow.png": 824199,
	"./items/crimson-scales/cs-86-bulwark-banner-back.png": 623321,
	"./items/crimson-scales/cs-86-bulwark-banner.png": 16302,
	"./items/crimson-scales/cs-87-refined-bulwark-banner-back.png": 569593,
	"./items/crimson-scales/cs-87-refined-bulwark-banner.png": 785473,
	"./items/crimson-scales/cs-88-remote-beetle-back.png": 554106,
	"./items/crimson-scales/cs-88-remote-beetle.png": 852839,
	"./items/crimson-scales/cs-89-refined-remote-beetle-back.png": 789411,
	"./items/crimson-scales/cs-89-refined-remote-beetle.png": 720768,
	"./items/crimson-scales/cs-90-blazing-boots-back.png": 842651,
	"./items/crimson-scales/cs-90-blazing-boots.png": 136230,
	"./items/crimson-scales/cs-91-refined-blazing-boots-back.png": 247330,
	"./items/crimson-scales/cs-91-refined-blazing-boots.png": 938772,
	"./items/crimson-scales/cs-92-viper-blowgun-back.png": 993041,
	"./items/crimson-scales/cs-92-viper-blowgun.png": 284590,
	"./items/crimson-scales/cs-93-refined-viper-blowgun-back.png": 835034,
	"./items/crimson-scales/cs-93-refined-viper-blowgun.png": 417011,
	"./items/crimson-scales/cs-94-frost-stone-back.png": 519935,
	"./items/crimson-scales/cs-94-frost-stone.png": 460178,
	"./items/crimson-scales/cs-95-storm-stone-back.png": 710522,
	"./items/crimson-scales/cs-95-storm-stone.png": 280190,
	"./items/crimson-scales/cs-96-inferno-stone-back.png": 77655,
	"./items/crimson-scales/cs-96-inferno-stone.png": 900217,
	"./items/crimson-scales/cs-97-tremor-stone-back.png": 717891,
	"./items/crimson-scales/cs-97-tremor-stone.png": 361792,
	"./items/crimson-scales/cs-98-brilliant-stone-back.png": 492992,
	"./items/crimson-scales/cs-98-brilliant-stone.png": 199284,
	"./items/crimson-scales/cs-99-dark-stone-back.png": 179655,
	"./items/crimson-scales/cs-99-dark-stone.png": 706110,
	"./items/crimson-scales/cs-aa01-rockspine-bulwark-back.png": 923043,
	"./items/crimson-scales/cs-aa01-rockspine-bulwark.png": 269132,
	"./items/crimson-scales/cs-aa02-ghostshimmer-honey-back.png": 561606,
	"./items/crimson-scales/cs-aa02-ghostshimmer-honey.png": 155525,
	"./items/crimson-scales/cs-aa03-steelsilk-spinneret-back.png": 18604,
	"./items/crimson-scales/cs-aa03-steelsilk-spinneret.png": 251055,
	"./items/crimson-scales/cs-qa01-power-modulator-back.png": 219632,
	"./items/crimson-scales/cs-qa01-power-modulator.png": 21985,
	"./items/crimson-scales/cs-qa02a-steam-piston-hammer-back.png": 26208,
	"./items/crimson-scales/cs-qa02a-steam-piston-hammer.png": 497333,
	"./items/crimson-scales/cs-qa02b-steam-piston-hammer-back.png": 116804,
	"./items/crimson-scales/cs-qa02b-steam-piston-hammer.png": 196563,
	"./items/crimson-scales/cs-qa03a-spider-climb-gloves-back.png": 856755,
	"./items/crimson-scales/cs-qa03a-spider-climb-gloves.png": 561038,
	"./items/crimson-scales/cs-qa03b-spider-climb-gloves-back.png": 178569,
	"./items/crimson-scales/cs-qa03b-spider-climb-gloves.png": 472522,
	"./items/crimson-scales/cs-qa04-gravity-inversion-pads-back.png": 445586,
	"./items/crimson-scales/cs-qa04-gravity-inversion-pads.png": 557819,
	"./items/crimson-scales/cs-qa05-delicate-model-back.png": 761830,
	"./items/crimson-scales/cs-qa05-delicate-model.png": 562286,
	"./items/crimson-scales/cs-qa06-auscudec-of-the-makers-back.png": 932022,
	"./items/crimson-scales/cs-qa06-auscudec-of-the-makers.png": 297320,
	"./items/crimson-scales/cs-rm01-serrated-edge-back.png": 780312,
	"./items/crimson-scales/cs-rm01a-serrated-edge.png": 673290,
	"./items/crimson-scales/cs-rm01b-serrated-edge.png": 719560,
	"./items/crimson-scales/cs-rm02-grisly-boots-back.png": 626769,
	"./items/crimson-scales/cs-rm02-grisly-boots.png": 195488,
	"./items/crimson-scales/cs-rm03-terrorscale-saber-back.png": 941652,
	"./items/crimson-scales/cs-rm03-terrorscale-saber.png": 934080,
	"./items/crimson-scales/cs-rm04-terrorscale-crossblades-back.png": 255827,
	"./items/crimson-scales/cs-rm04-terrorscale-crossblades.png": 31124,
	"./items/crimson-scales/cs-rm05-rite-of-ruin-back.png": 399312,
	"./items/crimson-scales/cs-rm05-rite-of-ruin.png": 653750,
	"./items/crimson-scales/cs-rm06-savage-cuirass-back.png": 104703,
	"./items/crimson-scales/cs-rm06-savage-cuirass.png": 597822,
	"./items/forgotten-circles/152-165/fc-1036-living-armor-reference-back.png": 661303,
	"./items/forgotten-circles/152-165/fc-1036-living-armor-reference.png": 285825,
	"./items/forgotten-circles/152-165/fc-152-ring-of-duality-back.png": 693801,
	"./items/forgotten-circles/152-165/fc-152-ring-of-duality.png": 525722,
	"./items/forgotten-circles/152-165/fc-153-minor-antidote-back.png": 254999,
	"./items/forgotten-circles/152-165/fc-153-minor-antidote.png": 611092,
	"./items/forgotten-circles/152-165/fc-154-major-antidote-back.png": 174157,
	"./items/forgotten-circles/152-165/fc-154-major-antidote.png": 713850,
	"./items/forgotten-circles/152-165/fc-155-curseward-armor-back.png": 161866,
	"./items/forgotten-circles/152-165/fc-155-curseward-armor.png": 36946,
	"./items/forgotten-circles/152-165/fc-156-elemental-claymore-back.png": 236482,
	"./items/forgotten-circles/152-165/fc-156-elemental-claymore.png": 510531,
	"./items/forgotten-circles/152-165/fc-157-ancient-bow-back.png": 317603,
	"./items/forgotten-circles/152-165/fc-157-ancient-bow.png": 109988,
	"./items/forgotten-circles/152-165/fc-158-rejuvenation-greaves-back.png": 894885,
	"./items/forgotten-circles/152-165/fc-158-rejuvenation-greaves.png": 747876,
	"./items/forgotten-circles/152-165/fc-159-scroll-of-haste-back.png": 312771,
	"./items/forgotten-circles/152-165/fc-159-scroll-of-haste.png": 10375,
	"./items/forgotten-circles/152-165/fc-160-cutpurse-dagger-back.png": 320144,
	"./items/forgotten-circles/152-165/fc-160-cutpurse-dagger.png": 166165,
	"./items/forgotten-circles/152-165/fc-161-throwing-axe-back.png": 154308,
	"./items/forgotten-circles/152-165/fc-161-throwing-axe.png": 922237,
	"./items/forgotten-circles/152-165/fc-162-rift-device-back.png": 686598,
	"./items/forgotten-circles/152-165/fc-162-rift-device.png": 675104,
	"./items/forgotten-circles/152-165/fc-163-crystal-tiara-back.png": 87896,
	"./items/forgotten-circles/152-165/fc-163-crystal-tiara.png": 839413,
	"./items/forgotten-circles/152-165/fc-164-basin-of-prophecy-back.png": 976354,
	"./items/forgotten-circles/152-165/fc-164-basin-of-prophecy.png": 505661,
	"./items/forgotten-circles/152-165/fc-165-living-armor-back.png": 52733,
	"./items/forgotten-circles/152-165/fc-165-living-armor.png": 79355,
	"./items/forgotten-circles/ZZ/zz.txt": 894324,
	"./items/frosthaven/001-010/fh-001-spyglass-back.png": 775584,
	"./items/frosthaven/001-010/fh-001-spyglass.png": 342021,
	"./items/frosthaven/001-010/fh-002-crude-helmet-back.png": 976246,
	"./items/frosthaven/001-010/fh-002-crude-helmet.png": 113075,
	"./items/frosthaven/001-010/fh-003-traveling-cloak-back.png": 986866,
	"./items/frosthaven/001-010/fh-003-traveling-cloak.png": 137685,
	"./items/frosthaven/001-010/fh-004-crude-hide-armor-back.png": 798234,
	"./items/frosthaven/001-010/fh-004-crude-hide-armor.png": 108498,
	"./items/frosthaven/001-010/fh-005-crude-boots-back.png": 62609,
	"./items/frosthaven/001-010/fh-005-crude-boots.png": 897941,
	"./items/frosthaven/001-010/fh-006-flexible-slippers-back.png": 673938,
	"./items/frosthaven/001-010/fh-006-flexible-slippers.png": 915019,
	"./items/frosthaven/001-010/fh-007-crude-bow-back.png": 225592,
	"./items/frosthaven/001-010/fh-007-crude-bow.png": 192913,
	"./items/frosthaven/001-010/fh-008-crude-spear-back.png": 773896,
	"./items/frosthaven/001-010/fh-008-crude-spear.png": 252253,
	"./items/frosthaven/001-010/fh-009-protective-scepter-back.png": 206006,
	"./items/frosthaven/001-010/fh-009-protective-scepter.png": 877375,
	"./items/frosthaven/001-010/fh-010-crude-shield-back.png": 724714,
	"./items/frosthaven/001-010/fh-010-crude-shield.png": 151392,
	"./items/frosthaven/011-015/fh-011-simple-charm-back.png": 307372,
	"./items/frosthaven/011-015/fh-011-simple-charm.png": 155886,
	"./items/frosthaven/011-015/fh-012-crude-chain-armor-back.png": 821823,
	"./items/frosthaven/011-015/fh-012-crude-chain-armor.png": 634933,
	"./items/frosthaven/011-015/fh-013-dancing-slippers-back.png": 403736,
	"./items/frosthaven/011-015/fh-013-dancing-slippers.png": 90701,
	"./items/frosthaven/011-015/fh-014-heavy-sword-back.png": 769228,
	"./items/frosthaven/011-015/fh-014-heavy-sword.png": 954423,
	"./items/frosthaven/011-015/fh-015-reinforced-shield-back.png": 337839,
	"./items/frosthaven/011-015/fh-015-reinforced-shield.png": 494889,
	"./items/frosthaven/016-020/fh-016-inspiring-helmet-back.png": 849333,
	"./items/frosthaven/016-020/fh-016-inspiring-helmet.png": 417511,
	"./items/frosthaven/016-020/fh-017-cured-leather-armor-back.png": 649666,
	"./items/frosthaven/016-020/fh-017-cured-leather-armor.png": 83807,
	"./items/frosthaven/016-020/fh-018-rough-boots-back.png": 96830,
	"./items/frosthaven/016-020/fh-018-rough-boots.png": 367924,
	"./items/frosthaven/016-020/fh-019-ringing-hammer-back.png": 637346,
	"./items/frosthaven/016-020/fh-019-ringing-hammer.png": 3089,
	"./items/frosthaven/016-020/fh-020-well-strung-bow-back.png": 608295,
	"./items/frosthaven/016-020/fh-020-well-strung-bow.png": 725209,
	"./items/frosthaven/021-025/fh-021-chain-hood-back.png": 965182,
	"./items/frosthaven/021-025/fh-021-chain-hood.png": 402236,
	"./items/frosthaven/021-025/fh-022-heavy-chain-armor-back.png": 605584,
	"./items/frosthaven/021-025/fh-022-heavy-chain-armor.png": 211329,
	"./items/frosthaven/021-025/fh-023-sturdy-greaves-back.png": 261806,
	"./items/frosthaven/021-025/fh-023-sturdy-greaves.png": 393488,
	"./items/frosthaven/021-025/fh-024-corrupted-blade-back.png": 543824,
	"./items/frosthaven/021-025/fh-024-corrupted-blade.png": 630940,
	"./items/frosthaven/021-025/fh-025-soothing-scepter-back.png": 353055,
	"./items/frosthaven/021-025/fh-025-soothing-scepter.png": 93574,
	"./items/frosthaven/026-030/fh-026-truesight-lenses-back.png": 699366,
	"./items/frosthaven/026-030/fh-026-truesight-lenses.png": 797273,
	"./items/frosthaven/026-030/fh-027-cloak-of-warding-back.png": 724158,
	"./items/frosthaven/026-030/fh-027-cloak-of-warding.png": 68837,
	"./items/frosthaven/026-030/fh-028-sturdy-boots-back.png": 479592,
	"./items/frosthaven/026-030/fh-028-sturdy-boots.png": 251270,
	"./items/frosthaven/026-030/fh-029-cleaving-axe-back.png": 894174,
	"./items/frosthaven/026-030/fh-029-cleaving-axe.png": 244849,
	"./items/frosthaven/026-030/fh-030-parrying-gauntlet-back.png": 776394,
	"./items/frosthaven/026-030/fh-030-parrying-gauntlet.png": 649714,
	"./items/frosthaven/031-035/fh-031-deathproof-charm-back.png": 654509,
	"./items/frosthaven/031-035/fh-031-deathproof-charm.png": 209856,
	"./items/frosthaven/031-035/fh-032-shell-armor-back.png": 405109,
	"./items/frosthaven/031-035/fh-032-shell-armor.png": 677342,
	"./items/frosthaven/031-035/fh-033-volatile-boots-back.png": 485255,
	"./items/frosthaven/031-035/fh-033-volatile-boots.png": 990816,
	"./items/frosthaven/031-035/fh-034-shrapnel-bomb-back.png": 903174,
	"./items/frosthaven/031-035/fh-034-shrapnel-bomb.png": 886130,
	"./items/frosthaven/031-035/fh-035-kite-shield-back.png": 534802,
	"./items/frosthaven/031-035/fh-035-kite-shield.png": 135729,
	"./items/frosthaven/036-040/fh-036-plumed-helmet-back.png": 299662,
	"./items/frosthaven/036-040/fh-036-plumed-helmet.png": 795450,
	"./items/frosthaven/036-040/fh-037-ghost-cloak-back.png": 675059,
	"./items/frosthaven/036-040/fh-037-ghost-cloak.png": 327060,
	"./items/frosthaven/036-040/fh-038-duelists-shoes-back.png": 980371,
	"./items/frosthaven/036-040/fh-038-duelists-shoes.png": 207854,
	"./items/frosthaven/036-040/fh-039-abyss-axe-back.png": 567219,
	"./items/frosthaven/036-040/fh-039-abyss-axe.png": 204469,
	"./items/frosthaven/036-040/fh-040-heartstrike-bow-back.png": 404794,
	"./items/frosthaven/036-040/fh-040-heartstrike-bow.png": 780359,
	"./items/frosthaven/041-045/fh-041-intricate-charm-back.png": 396291,
	"./items/frosthaven/041-045/fh-041-intricate-charm.png": 813519,
	"./items/frosthaven/041-045/fh-042-ornate-armor-back.png": 55536,
	"./items/frosthaven/041-045/fh-042-ornate-armor.png": 953665,
	"./items/frosthaven/041-045/fh-043-kicking-boots-back.png": 296495,
	"./items/frosthaven/041-045/fh-043-kicking-boots.png": 840432,
	"./items/frosthaven/041-045/fh-044-sword-of-absolution-back.png": 476346,
	"./items/frosthaven/041-045/fh-044-sword-of-absolution.png": 370125,
	"./items/frosthaven/041-045/fh-045-master-scepter-back.png": 167646,
	"./items/frosthaven/041-045/fh-045-master-scepter.png": 13179,
	"./items/frosthaven/046-050/fh-046-double-lens-goggles-back.png": 431593,
	"./items/frosthaven/046-050/fh-046-double-lens-goggles.png": 334849,
	"./items/frosthaven/046-050/fh-047-robes-of-doom-back.png": 12749,
	"./items/frosthaven/046-050/fh-047-robes-of-doom.png": 971136,
	"./items/frosthaven/046-050/fh-048-living-shoes-back.png": 756080,
	"./items/frosthaven/046-050/fh-048-living-shoes.png": 556046,
	"./items/frosthaven/046-050/fh-049-cruel-dagger-back.png": 495463,
	"./items/frosthaven/046-050/fh-049-cruel-dagger.png": 525822,
	"./items/frosthaven/046-050/fh-050-shield-of-reciprocity-back.png": 460111,
	"./items/frosthaven/046-050/fh-050-shield-of-reciprocity.png": 506681,
	"./items/frosthaven/051-065/fh-051a-spiked-collar-back.png": 750697,
	"./items/frosthaven/051-065/fh-051a-spiked-collar.png": 359824,
	"./items/frosthaven/051-065/fh-051b-spiked-collar-back.png": 980496,
	"./items/frosthaven/051-065/fh-051b-spiked-collar.png": 207159,
	"./items/frosthaven/051-065/fh-052a-laser-lens-back.png": 468105,
	"./items/frosthaven/051-065/fh-052a-laser-lens.png": 873065,
	"./items/frosthaven/051-065/fh-052b-laser-lens-back.png": 609288,
	"./items/frosthaven/051-065/fh-052b-laser-lens.png": 445157,
	"./items/frosthaven/051-065/fh-053a-hobnail-boots-back.png": 131021,
	"./items/frosthaven/051-065/fh-053a-hobnail-boots.png": 184148,
	"./items/frosthaven/051-065/fh-053b-hobnail-boots-back.png": 263402,
	"./items/frosthaven/051-065/fh-053b-hobnail-boots.png": 833240,
	"./items/frosthaven/051-065/fh-054a-restful-slippers-back.png": 708029,
	"./items/frosthaven/051-065/fh-054a-restful-slippers.png": 827772,
	"./items/frosthaven/051-065/fh-054b-restful-slippers-back.png": 650776,
	"./items/frosthaven/051-065/fh-054b-restful-slippers.png": 229018,
	"./items/frosthaven/051-065/fh-055a-biting-gauntlet-back.png": 399837,
	"./items/frosthaven/051-065/fh-055a-biting-gauntlet.png": 9587,
	"./items/frosthaven/051-065/fh-055b-biting-gauntlet-back.png": 541854,
	"./items/frosthaven/051-065/fh-055b-biting-gauntlet.png": 657662,
	"./items/frosthaven/051-065/fh-056a-scavengers-magnet-back.png": 556516,
	"./items/frosthaven/051-065/fh-056a-scavengers-magnet.png": 648411,
	"./items/frosthaven/051-065/fh-056b-scavengers-magnet-back.png": 196103,
	"./items/frosthaven/051-065/fh-056b-scavengers-magnet.png": 347569,
	"./items/frosthaven/051-065/fh-057a-shovel-back.png": 89154,
	"./items/frosthaven/051-065/fh-057a-shovel.png": 514324,
	"./items/frosthaven/051-065/fh-057b-shovel-back.png": 754406,
	"./items/frosthaven/051-065/fh-057b-shovel.png": 54440,
	"./items/frosthaven/051-065/fh-058a-slippery-sword-back.png": 839705,
	"./items/frosthaven/051-065/fh-058a-slippery-sword.png": 52070,
	"./items/frosthaven/051-065/fh-058b-slippery-sword-back.png": 468357,
	"./items/frosthaven/051-065/fh-058b-slippery-sword.png": 14586,
	"./items/frosthaven/051-065/fh-059a-charm-of-expertise-back.png": 937443,
	"./items/frosthaven/051-065/fh-059a-charm-of-expertise.png": 407774,
	"./items/frosthaven/051-065/fh-059b-charm-of-expertise-back.png": 831547,
	"./items/frosthaven/051-065/fh-059b-charm-of-expertise.png": 751278,
	"./items/frosthaven/051-065/fh-060a-cloak-of-many-pockets-back.png": 410365,
	"./items/frosthaven/051-065/fh-060a-cloak-of-many-pockets.png": 998309,
	"./items/frosthaven/051-065/fh-060b-cloak-of-many-pockets-back.png": 681510,
	"./items/frosthaven/051-065/fh-060b-cloak-of-many-pockets.png": 360649,
	"./items/frosthaven/051-065/fh-061a-spiked-shell-back.png": 541145,
	"./items/frosthaven/051-065/fh-061a-spiked-shell.png": 768623,
	"./items/frosthaven/051-065/fh-061b-spiked-shell-back.png": 439454,
	"./items/frosthaven/051-065/fh-061b-spiked-shell.png": 943384,
	"./items/frosthaven/051-065/fh-062a-everlasting-boots-back.png": 51577,
	"./items/frosthaven/051-065/fh-062a-everlasting-boots.png": 827312,
	"./items/frosthaven/051-065/fh-062b-everlasting-boots-back.png": 199697,
	"./items/frosthaven/051-065/fh-062b-everlasting-boots.png": 9294,
	"./items/frosthaven/051-065/fh-063a-shadow-stompers-back.png": 213285,
	"./items/frosthaven/051-065/fh-063a-shadow-stompers.png": 588158,
	"./items/frosthaven/051-065/fh-063b-shadow-stompers-back.png": 731611,
	"./items/frosthaven/051-065/fh-063b-shadow-stompers.png": 150846,
	"./items/frosthaven/051-065/fh-064a-detonator-back.png": 45590,
	"./items/frosthaven/051-065/fh-064a-detonator.png": 188298,
	"./items/frosthaven/051-065/fh-064b-detonator-back.png": 284620,
	"./items/frosthaven/051-065/fh-064b-detonator.png": 916581,
	"./items/frosthaven/051-065/fh-065a-rust-powder-back.png": 462278,
	"./items/frosthaven/051-065/fh-065a-rust-powder.png": 42136,
	"./items/frosthaven/051-065/fh-065b-rust-powder-back.png": 109333,
	"./items/frosthaven/051-065/fh-065b-rust-powder.png": 974125,
	"./items/frosthaven/066-082/fh-066-amulet-of-eternal-life-back.png": 307720,
	"./items/frosthaven/066-082/fh-066-amulet-of-eternal-life.png": 725244,
	"./items/frosthaven/066-082/fh-067-converging-lenses-back.png": 222469,
	"./items/frosthaven/066-082/fh-067-converging-lenses.png": 801391,
	"./items/frosthaven/066-082/fh-068-scaled-armor-back.png": 325541,
	"./items/frosthaven/066-082/fh-068-scaled-armor.png": 528587,
	"./items/frosthaven/066-082/fh-069-feathered-cloak-back.png": 235095,
	"./items/frosthaven/066-082/fh-069-feathered-cloak.png": 440662,
	"./items/frosthaven/066-082/fh-070-aesther-robe-back.png": 609294,
	"./items/frosthaven/066-082/fh-070-aesther-robe.png": 602401,
	"./items/frosthaven/066-082/fh-071-bone-boots-back.png": 307818,
	"./items/frosthaven/066-082/fh-071-bone-boots.png": 997258,
	"./items/frosthaven/066-082/fh-072-oak-staff-back.png": 114013,
	"./items/frosthaven/066-082/fh-072-oak-staff.png": 744204,
	"./items/frosthaven/066-082/fh-073-energizing-baton-back.png": 772633,
	"./items/frosthaven/066-082/fh-073-energizing-baton.png": 920657,
	"./items/frosthaven/066-082/fh-074-shock-grenades-back.png": 685428,
	"./items/frosthaven/066-082/fh-074-shock-grenades.png": 702952,
	"./items/frosthaven/066-082/fh-075-rose-gauntlet-back.png": 901483,
	"./items/frosthaven/066-082/fh-075-rose-gauntlet.png": 896410,
	"./items/frosthaven/066-082/fh-076-horn-of-command-back.png": 577217,
	"./items/frosthaven/066-082/fh-076-horn-of-command.png": 428078,
	"./items/frosthaven/066-082/fh-077-chaos-cannon-back.png": 178540,
	"./items/frosthaven/066-082/fh-077-chaos-cannon.png": 652286,
	"./items/frosthaven/066-082/fh-078-balanced-scales-back.png": 891091,
	"./items/frosthaven/066-082/fh-078-balanced-scales.png": 641594,
	"./items/frosthaven/066-082/fh-079-roasted-fowl-back.png": 579604,
	"./items/frosthaven/066-082/fh-079-roasted-fowl.png": 577917,
	"./items/frosthaven/066-082/fh-080-living-stone-back.png": 451480,
	"./items/frosthaven/066-082/fh-080-living-stone.png": 719721,
	"./items/frosthaven/066-082/fh-081-pain-simulacrum-back.png": 28415,
	"./items/frosthaven/066-082/fh-081-pain-simulacrum.png": 809552,
	"./items/frosthaven/066-082/fh-082-mechanical-cube-back.png": 756942,
	"./items/frosthaven/066-082/fh-082-mechanical-cube.png": 508043,
	"./items/frosthaven/083-119/fh-083-healing-potion-back.png": 734617,
	"./items/frosthaven/083-119/fh-083-healing-potion.png": 249804,
	"./items/frosthaven/083-119/fh-084-stamina-potion-back.png": 944098,
	"./items/frosthaven/083-119/fh-084-stamina-potion.png": 360302,
	"./items/frosthaven/083-119/fh-085-power-potion-back.png": 789618,
	"./items/frosthaven/083-119/fh-085-power-potion.png": 514138,
	"./items/frosthaven/083-119/fh-086-element-potion-back.png": 930653,
	"./items/frosthaven/083-119/fh-086-element-potion.png": 822146,
	"./items/frosthaven/083-119/fh-087-cure-potion-back.png": 557811,
	"./items/frosthaven/083-119/fh-087-cure-potion.png": 883884,
	"./items/frosthaven/083-119/fh-088-fireshield-potion-back.png": 823882,
	"./items/frosthaven/083-119/fh-088-fireshield-potion.png": 967429,
	"./items/frosthaven/083-119/fh-089-stoneskin-potion-back.png": 326351,
	"./items/frosthaven/083-119/fh-089-stoneskin-potion.png": 332603,
	"./items/frosthaven/083-119/fh-090-muscle-potion-back.png": 764632,
	"./items/frosthaven/083-119/fh-090-muscle-potion.png": 256786,
	"./items/frosthaven/083-119/fh-091-holy-water-back.png": 8721,
	"./items/frosthaven/083-119/fh-091-holy-water.png": 121394,
	"./items/frosthaven/083-119/fh-092-renewing-potion-back.png": 618856,
	"./items/frosthaven/083-119/fh-092-renewing-potion.png": 388371,
	"./items/frosthaven/083-119/fh-093-glancing-potion-back.png": 10871,
	"./items/frosthaven/083-119/fh-093-glancing-potion.png": 664696,
	"./items/frosthaven/083-119/fh-094-frenzy-potion-back.png": 448978,
	"./items/frosthaven/083-119/fh-094-frenzy-potion.png": 997979,
	"./items/frosthaven/083-119/fh-095-poison-vial-back.png": 259536,
	"./items/frosthaven/083-119/fh-095-poison-vial.png": 48602,
	"./items/frosthaven/083-119/fh-096-flame-vial-back.png": 609936,
	"./items/frosthaven/083-119/fh-096-flame-vial.png": 143578,
	"./items/frosthaven/083-119/fh-097-explosive-vial-back.png": 976169,
	"./items/frosthaven/083-119/fh-097-explosive-vial.png": 866073,
	"./items/frosthaven/083-119/fh-098-unhealthy-mixture-back.png": 885939,
	"./items/frosthaven/083-119/fh-098-unhealthy-mixture.png": 191489,
	"./items/frosthaven/083-119/fh-099-major-healing-potion-back.png": 724051,
	"./items/frosthaven/083-119/fh-099-major-healing-potion.png": 103518,
	"./items/frosthaven/083-119/fh-100-major-stamina-potion-back.png": 224235,
	"./items/frosthaven/083-119/fh-100-major-stamina-potion.png": 363654,
	"./items/frosthaven/083-119/fh-101-major-power-potion-back.png": 180335,
	"./items/frosthaven/083-119/fh-101-major-power-potion.png": 149872,
	"./items/frosthaven/083-119/fh-102-major-element-potion-back.png": 127752,
	"./items/frosthaven/083-119/fh-102-major-element-potion.png": 674123,
	"./items/frosthaven/083-119/fh-103-major-cure-potion-back.png": 969930,
	"./items/frosthaven/083-119/fh-103-major-cure-potion.png": 676311,
	"./items/frosthaven/083-119/fh-104-swiftness-potion-back.png": 979713,
	"./items/frosthaven/083-119/fh-104-swiftness-potion.png": 759650,
	"./items/frosthaven/083-119/fh-105-major-fireshield-potion-back.png": 467548,
	"./items/frosthaven/083-119/fh-105-major-fireshield-potion.png": 992804,
	"./items/frosthaven/083-119/fh-106-stonewall-potion-back.png": 956861,
	"./items/frosthaven/083-119/fh-106-stonewall-potion.png": 884351,
	"./items/frosthaven/083-119/fh-107-vigor-potion-back.png": 408721,
	"./items/frosthaven/083-119/fh-107-vigor-potion.png": 555843,
	"./items/frosthaven/083-119/fh-108-holy-rain-back.png": 91809,
	"./items/frosthaven/083-119/fh-108-holy-rain.png": 220899,
	"./items/frosthaven/083-119/fh-109-major-renewing-potion-back.png": 246121,
	"./items/frosthaven/083-119/fh-109-major-renewing-potion.png": 650260,
	"./items/frosthaven/083-119/fh-110-precision-potion-back.png": 665509,
	"./items/frosthaven/083-119/fh-110-precision-potion.png": 981026,
	"./items/frosthaven/083-119/fh-111-major-frenzy-potion-back.png": 340153,
	"./items/frosthaven/083-119/fh-111-major-frenzy-potion.png": 469631,
	"./items/frosthaven/083-119/fh-112-hammer-potion-back.png": 251954,
	"./items/frosthaven/083-119/fh-112-hammer-potion.png": 408740,
	"./items/frosthaven/083-119/fh-113-expertise-potion-back.png": 224093,
	"./items/frosthaven/083-119/fh-113-expertise-potion.png": 679337,
	"./items/frosthaven/083-119/fh-114-foresight-potion-back.png": 185386,
	"./items/frosthaven/083-119/fh-114-foresight-potion.png": 747098,
	"./items/frosthaven/083-119/fh-115-infusion-potion-back.png": 961329,
	"./items/frosthaven/083-119/fh-115-infusion-potion.png": 418211,
	"./items/frosthaven/083-119/fh-116-plague-flask-back.png": 815697,
	"./items/frosthaven/083-119/fh-116-plague-flask.png": 374770,
	"./items/frosthaven/083-119/fh-117-inferno-flask-back.png": 90715,
	"./items/frosthaven/083-119/fh-117-inferno-flask.png": 994793,
	"./items/frosthaven/083-119/fh-118-fulminant-flask-back.png": 881314,
	"./items/frosthaven/083-119/fh-118-fulminant-flask.png": 655273,
	"./items/frosthaven/083-119/fh-119-deadly-mixture-back.png": 564177,
	"./items/frosthaven/083-119/fh-119-deadly-mixture.png": 566593,
	"./items/frosthaven/120-128/fh-120-amulet-of-life-back.png": 114060,
	"./items/frosthaven/120-128/fh-120-amulet-of-life.png": 752811,
	"./items/frosthaven/120-128/fh-121-circlet-of-elements-back.png": 390560,
	"./items/frosthaven/120-128/fh-121-circlet-of-elements.png": 513209,
	"./items/frosthaven/120-128/fh-122-wardens-robes-back.png": 105624,
	"./items/frosthaven/120-128/fh-122-wardens-robes.png": 929302,
	"./items/frosthaven/120-128/fh-123-leather-armor-back.png": 457281,
	"./items/frosthaven/120-128/fh-123-leather-armor.png": 739691,
	"./items/frosthaven/120-128/fh-124-winged-shoes-back.png": 538560,
	"./items/frosthaven/120-128/fh-124-winged-shoes.png": 543489,
	"./items/frosthaven/120-128/fh-125-boots-of-speed-back.png": 970566,
	"./items/frosthaven/120-128/fh-125-boots-of-speed.png": 857154,
	"./items/frosthaven/120-128/fh-126-weighted-net-back.png": 256470,
	"./items/frosthaven/120-128/fh-126-weighted-net.png": 129102,
	"./items/frosthaven/120-128/fh-127-poison-dagger-back.png": 670259,
	"./items/frosthaven/120-128/fh-127-poison-dagger.png": 541349,
	"./items/frosthaven/120-128/fh-128-heater-shield-back.png": 746208,
	"./items/frosthaven/120-128/fh-128-heater-shield.png": 513047,
	"./items/frosthaven/129-167/fh-129-eagle-eye-goggles-back.png": 703041,
	"./items/frosthaven/129-167/fh-129-eagle-eye-goggles.png": 986653,
	"./items/frosthaven/129-167/fh-130-iron-helmet-back.png": 169453,
	"./items/frosthaven/129-167/fh-130-iron-helmet.png": 972323,
	"./items/frosthaven/129-167/fh-131-chainmail-back.png": 719627,
	"./items/frosthaven/129-167/fh-131-chainmail.png": 983118,
	"./items/frosthaven/129-167/fh-132-cloak-of-pockets-back.png": 894519,
	"./items/frosthaven/129-167/fh-132-cloak-of-pockets.png": 745583,
	"./items/frosthaven/129-167/fh-133-nimble-legguards-back.png": 275278,
	"./items/frosthaven/129-167/fh-133-nimble-legguards.png": 414073,
	"./items/frosthaven/129-167/fh-134-comfortable-shoes-back.png": 76197,
	"./items/frosthaven/129-167/fh-134-comfortable-shoes.png": 474032,
	"./items/frosthaven/129-167/fh-135-armorbane-bow-back.png": 501340,
	"./items/frosthaven/129-167/fh-135-armorbane-bow.png": 334555,
	"./items/frosthaven/129-167/fh-136-battle-axe-back.png": 61103,
	"./items/frosthaven/129-167/fh-136-battle-axe.png": 159220,
	"./items/frosthaven/129-167/fh-137-tower-shield-back.png": 975992,
	"./items/frosthaven/129-167/fh-137-tower-shield.png": 991277,
	"./items/frosthaven/129-167/fh-138-heavy-basinet-back.png": 118306,
	"./items/frosthaven/129-167/fh-138-heavy-basinet.png": 757607,
	"./items/frosthaven/129-167/fh-139-horned-helm-back.png": 876365,
	"./items/frosthaven/129-167/fh-139-horned-helm.png": 932904,
	"./items/frosthaven/129-167/fh-140-mantle-of-summoning-back.png": 49041,
	"./items/frosthaven/129-167/fh-140-mantle-of-summoning.png": 218189,
	"./items/frosthaven/129-167/fh-141-studded-leather-back.png": 4496,
	"./items/frosthaven/129-167/fh-141-studded-leather.png": 825142,
	"./items/frosthaven/129-167/fh-142-boots-of-quickness-back.png": 380507,
	"./items/frosthaven/129-167/fh-142-boots-of-quickness.png": 776958,
	"./items/frosthaven/129-167/fh-143-endurance-footwraps-back.png": 995965,
	"./items/frosthaven/129-167/fh-143-endurance-footwraps.png": 701726,
	"./items/frosthaven/129-167/fh-144-staff-of-eminence-back.png": 698223,
	"./items/frosthaven/129-167/fh-144-staff-of-eminence.png": 77136,
	"./items/frosthaven/129-167/fh-145-versatile-dagger-back.png": 225098,
	"./items/frosthaven/129-167/fh-145-versatile-dagger.png": 299133,
	"./items/frosthaven/129-167/fh-146-hooked-chain-back.png": 705558,
	"./items/frosthaven/129-167/fh-146-hooked-chain.png": 78800,
	"./items/frosthaven/129-167/fh-147-mask-of-terror-back.png": 245334,
	"./items/frosthaven/129-167/fh-147-mask-of-terror.png": 992795,
	"./items/frosthaven/129-167/fh-148-circlet-of-sanctity-back.png": 946905,
	"./items/frosthaven/129-167/fh-148-circlet-of-sanctity.png": 749835,
	"./items/frosthaven/129-167/fh-149-platemail-back.png": 836114,
	"./items/frosthaven/129-167/fh-149-platemail.png": 515154,
	"./items/frosthaven/129-167/fh-150-robes-of-the-oak-back.png": 8702,
	"./items/frosthaven/129-167/fh-150-robes-of-the-oak.png": 638078,
	"./items/frosthaven/129-167/fh-151-serene-sandals-back.png": 700741,
	"./items/frosthaven/129-167/fh-151-serene-sandals.png": 724082,
	"./items/frosthaven/129-167/fh-152-steel-sabatons-back.png": 892999,
	"./items/frosthaven/129-167/fh-152-steel-sabatons.png": 851788,
	"./items/frosthaven/129-167/fh-153-long-spear-back.png": 947926,
	"./items/frosthaven/129-167/fh-153-long-spear.png": 250653,
	"./items/frosthaven/129-167/fh-154-volatile-bomb-back.png": 14752,
	"./items/frosthaven/129-167/fh-154-volatile-bomb.png": 72545,
	"./items/frosthaven/129-167/fh-155-wall-shield-back.png": 206000,
	"./items/frosthaven/129-167/fh-155-wall-shield.png": 588278,
	"./items/frosthaven/129-167/fh-156-moon-earring-back.png": 700444,
	"./items/frosthaven/129-167/fh-156-moon-earring.png": 763077,
	"./items/frosthaven/129-167/fh-157-steel-ring-back.png": 574744,
	"./items/frosthaven/129-167/fh-157-steel-ring.png": 39030,
	"./items/frosthaven/129-167/fh-158-deep-earth-brooch-back.png": 451280,
	"./items/frosthaven/129-167/fh-158-deep-earth-brooch.png": 591781,
	"./items/frosthaven/129-167/fh-159-glorious-bracelet-back.png": 745944,
	"./items/frosthaven/129-167/fh-159-glorious-bracelet.png": 424252,
	"./items/frosthaven/129-167/fh-160-sun-earring-back.png": 659575,
	"./items/frosthaven/129-167/fh-160-sun-earring.png": 639957,
	"./items/frosthaven/129-167/fh-161-strategists-ring-back.png": 643530,
	"./items/frosthaven/129-167/fh-161-strategists-ring.png": 549058,
	"./items/frosthaven/129-167/fh-162-howling-ice-brooch-back.png": 903152,
	"./items/frosthaven/129-167/fh-162-howling-ice-brooch.png": 70156,
	"./items/frosthaven/129-167/fh-163-stunning-bracelet-back.png": 94520,
	"./items/frosthaven/129-167/fh-163-stunning-bracelet.png": 692040,
	"./items/frosthaven/129-167/fh-164-star-earring-back.png": 381373,
	"./items/frosthaven/129-167/fh-164-star-earring.png": 191298,
	"./items/frosthaven/129-167/fh-165-ring-of-haste-back.png": 109380,
	"./items/frosthaven/129-167/fh-165-ring-of-haste.png": 705614,
	"./items/frosthaven/129-167/fh-166-blazing-sun-brooch-back.png": 699417,
	"./items/frosthaven/129-167/fh-166-blazing-sun-brooch.png": 624643,
	"./items/frosthaven/129-167/fh-167-attractive-bracelet-back.png": 111958,
	"./items/frosthaven/129-167/fh-167-attractive-bracelet.png": 465856,
	"./items/frosthaven/168-192/fh-168-circlet-of-eyes-back.png": 673070,
	"./items/frosthaven/168-192/fh-168-circlet-of-eyes.png": 928152,
	"./items/frosthaven/168-192/fh-169-fateful-charm-back.png": 668088,
	"./items/frosthaven/168-192/fh-169-fateful-charm.png": 462973,
	"./items/frosthaven/168-192/fh-170-eye-of-truth-back.png": 457150,
	"./items/frosthaven/168-192/fh-170-eye-of-truth.png": 662841,
	"./items/frosthaven/168-192/fh-171-rejuvenating-charm-back.png": 816102,
	"./items/frosthaven/168-192/fh-171-rejuvenating-charm.png": 67066,
	"./items/frosthaven/168-192/fh-172-cap-of-premonition-back.png": 451285,
	"./items/frosthaven/168-192/fh-172-cap-of-premonition.png": 760121,
	"./items/frosthaven/168-192/fh-173-multi-colored-cloak-back.png": 673094,
	"./items/frosthaven/168-192/fh-173-multi-colored-cloak.png": 26048,
	"./items/frosthaven/168-192/fh-174-magnetic-cape-back.png": 773929,
	"./items/frosthaven/168-192/fh-174-magnetic-cape.png": 609775,
	"./items/frosthaven/168-192/fh-175-mirrored-armor-back.png": 984442,
	"./items/frosthaven/168-192/fh-175-mirrored-armor.png": 786516,
	"./items/frosthaven/168-192/fh-176-blinking-cape-back.png": 830643,
	"./items/frosthaven/168-192/fh-176-blinking-cape.png": 622958,
	"./items/frosthaven/168-192/fh-177-boots-of-transference-back.png": 85030,
	"./items/frosthaven/168-192/fh-177-boots-of-transference.png": 247791,
	"./items/frosthaven/168-192/fh-178-tranquil-shoes-back.png": 270851,
	"./items/frosthaven/168-192/fh-178-tranquil-shoes.png": 315426,
	"./items/frosthaven/168-192/fh-179-burst-boots-back.png": 882809,
	"./items/frosthaven/168-192/fh-179-burst-boots.png": 373027,
	"./items/frosthaven/168-192/fh-180-boots-of-greed-back.png": 63811,
	"./items/frosthaven/168-192/fh-180-boots-of-greed.png": 767017,
	"./items/frosthaven/168-192/fh-181-translocation-rod-back.png": 853953,
	"./items/frosthaven/168-192/fh-181-translocation-rod.png": 308837,
	"./items/frosthaven/168-192/fh-182-wing-clippers-back.png": 81081,
	"./items/frosthaven/168-192/fh-182-wing-clippers.png": 778324,
	"./items/frosthaven/168-192/fh-183-decanter-of-mists-back.png": 932923,
	"./items/frosthaven/168-192/fh-183-decanter-of-mists.png": 917987,
	"./items/frosthaven/168-192/fh-184-flashing-axe-back.png": 63363,
	"./items/frosthaven/168-192/fh-184-flashing-axe.png": 462595,
	"./items/frosthaven/168-192/fh-185-mirrored-knife-back.png": 42456,
	"./items/frosthaven/168-192/fh-185-mirrored-knife.png": 33218,
	"./items/frosthaven/168-192/fh-186-wild-growth-seeds-back.png": 92734,
	"./items/frosthaven/168-192/fh-186-wild-growth-seeds.png": 551295,
	"./items/frosthaven/168-192/fh-187-dangerous-gear-back.png": 883330,
	"./items/frosthaven/168-192/fh-187-dangerous-gear.png": 937668,
	"./items/frosthaven/168-192/fh-188-freezing-crystal-back.png": 948484,
	"./items/frosthaven/168-192/fh-188-freezing-crystal.png": 605064,
	"./items/frosthaven/168-192/fh-189-ring-of-the-night-back.png": 752474,
	"./items/frosthaven/168-192/fh-189-ring-of-the-night.png": 411644,
	"./items/frosthaven/168-192/fh-190-white-card-back.png": 12981,
	"./items/frosthaven/168-192/fh-190-white-card.png": 248370,
	"./items/frosthaven/168-192/fh-191-corrupted-scroll-back.png": 246333,
	"./items/frosthaven/168-192/fh-191-corrupted-scroll.png": 408578,
	"./items/frosthaven/168-192/fh-192-enticing-bell-back.png": 615235,
	"./items/frosthaven/168-192/fh-192-enticing-bell.png": 418705,
	"./items/frosthaven/193-247/fh-193-mind-thieving-helmet-back.png": 566053,
	"./items/frosthaven/193-247/fh-193-mind-thieving-helmet.png": 747512,
	"./items/frosthaven/193-247/fh-194-temporal-amulet-back.png": 485836,
	"./items/frosthaven/193-247/fh-194-temporal-amulet.png": 973897,
	"./items/frosthaven/193-247/fh-195-tri-corner-hat-back.png": 706341,
	"./items/frosthaven/193-247/fh-195-tri-corner-hat.png": 394650,
	"./items/frosthaven/193-247/fh-196-choker-of-sacrifice-back.png": 583537,
	"./items/frosthaven/193-247/fh-196-choker-of-sacrifice.png": 450789,
	"./items/frosthaven/193-247/fh-197-aesther-diadem-back.png": 19518,
	"./items/frosthaven/193-247/fh-197-aesther-diadem.png": 487094,
	"./items/frosthaven/193-247/fh-198-hunters-necklace-back.png": 854807,
	"./items/frosthaven/193-247/fh-198-hunters-necklace.png": 106116,
	"./items/frosthaven/193-247/fh-199-opulent-shoes-back.png": 302611,
	"./items/frosthaven/193-247/fh-199-opulent-shoes.png": 429867,
	"./items/frosthaven/193-247/fh-200-eventide-scepter-back.png": 139800,
	"./items/frosthaven/193-247/fh-200-eventide-scepter.png": 558806,
	"./items/frosthaven/193-247/fh-201-wave-blade-back.png": 913980,
	"./items/frosthaven/193-247/fh-201-wave-blade.png": 222657,
	"./items/frosthaven/193-247/fh-202-giant-piranha-pig-spine-back.png": 758256,
	"./items/frosthaven/193-247/fh-202-giant-piranha-pig-spine.png": 457762,
	"./items/frosthaven/193-247/fh-203-scepter-of-control-back.png": 59144,
	"./items/frosthaven/193-247/fh-203-scepter-of-control.png": 126129,
	"./items/frosthaven/193-247/fh-204-severed-claw-back.png": 872021,
	"./items/frosthaven/193-247/fh-204-severed-claw.png": 600314,
	"./items/frosthaven/193-247/fh-205-harpoon-back.png": 615856,
	"./items/frosthaven/193-247/fh-205-harpoon.png": 60121,
	"./items/frosthaven/193-247/fh-206-giant-sword-back.png": 914062,
	"./items/frosthaven/193-247/fh-206-giant-sword.png": 620926,
	"./items/frosthaven/193-247/fh-207-fishhook-back.png": 867955,
	"./items/frosthaven/193-247/fh-207-fishhook.png": 368061,
	"./items/frosthaven/193-247/fh-208-titan-nail-back.png": 985453,
	"./items/frosthaven/193-247/fh-208-titan-nail.png": 627387,
	"./items/frosthaven/193-247/fh-209-sword-of-mastery-back.png": 271329,
	"./items/frosthaven/193-247/fh-209-sword-of-mastery.png": 919597,
	"./items/frosthaven/193-247/fh-210-tanjo-back.png": 889467,
	"./items/frosthaven/193-247/fh-210-tanjo.png": 293399,
	"./items/frosthaven/193-247/fh-211-boom-barrel-back.png": 69716,
	"./items/frosthaven/193-247/fh-211-boom-barrel.png": 523832,
	"./items/frosthaven/193-247/fh-212-elemental-stone-back.png": 616376,
	"./items/frosthaven/193-247/fh-212-elemental-stone.png": 25829,
	"./items/frosthaven/193-247/fh-213-key-of-seasons-back.png": 435840,
	"./items/frosthaven/193-247/fh-213-key-of-seasons.png": 310266,
	"./items/frosthaven/193-247/fh-214-cup-of-ventillion-back.png": 582683,
	"./items/frosthaven/193-247/fh-214-cup-of-ventillion.png": 160580,
	"./items/frosthaven/193-247/fh-215-befuddling-mug-back.png": 712166,
	"./items/frosthaven/193-247/fh-215-befuddling-mug.png": 888603,
	"./items/frosthaven/193-247/fh-216-tome-of-elements-back.png": 158289,
	"./items/frosthaven/193-247/fh-216-tome-of-elements.png": 351964,
	"./items/frosthaven/193-247/fh-217-tome-of-time-back.png": 912516,
	"./items/frosthaven/193-247/fh-217-tome-of-time.png": 201530,
	"./items/frosthaven/193-247/fh-218-tome-of-life-back.png": 575438,
	"./items/frosthaven/193-247/fh-218-tome-of-life.png": 848685,
	"./items/frosthaven/193-247/fh-219-tome-of-conflict-back.png": 165937,
	"./items/frosthaven/193-247/fh-219-tome-of-conflict.png": 531183,
	"./items/frosthaven/193-247/fh-220-belaras-quill-back.png": 103170,
	"./items/frosthaven/193-247/fh-220-belaras-quill.png": 313240,
	"./items/frosthaven/193-247/fh-221-ice-shiv-back.png": 911189,
	"./items/frosthaven/193-247/fh-221-ice-shiv.png": 158298,
	"./items/frosthaven/193-247/fh-222-black-box-back.png": 930367,
	"./items/frosthaven/193-247/fh-222-black-box.png": 648751,
	"./items/frosthaven/193-247/fh-223-lightning-rod-back.png": 756683,
	"./items/frosthaven/193-247/fh-223-lightning-rod.png": 754118,
	"./items/frosthaven/193-247/fh-224-armor-of-empathy-back.png": 372388,
	"./items/frosthaven/193-247/fh-224-armor-of-empathy.png": 980650,
	"./items/frosthaven/193-247/fh-225-algox-carving-back.png": 367318,
	"./items/frosthaven/193-247/fh-225-algox-carving.png": 780981,
	"./items/frosthaven/193-247/fh-226-unfettered-arm-back.png": 620086,
	"./items/frosthaven/193-247/fh-226-unfettered-arm.png": 720380,
	"./items/frosthaven/193-247/fh-227-data-drive-back.png": 574402,
	"./items/frosthaven/193-247/fh-227-data-drive.png": 547669,
	"./items/frosthaven/193-247/fh-228-extendable-pole-back.png": 83358,
	"./items/frosthaven/193-247/fh-228-extendable-pole.png": 325572,
	"./items/frosthaven/193-247/fh-229-exquisite-map-back.png": 224432,
	"./items/frosthaven/193-247/fh-229-exquisite-map.png": 683607,
	"./items/frosthaven/193-247/fh-230-examination-glass-back.png": 939422,
	"./items/frosthaven/193-247/fh-230-examination-glass.png": 97796,
	"./items/frosthaven/193-247/fh-231-skinning-knife-back.png": 226946,
	"./items/frosthaven/193-247/fh-231-skinning-knife.png": 981259,
	"./items/frosthaven/193-247/fh-232-orchid-wand-back.png": 671352,
	"./items/frosthaven/193-247/fh-232-orchid-wand.png": 343945,
	"./items/frosthaven/193-247/fh-233-dead-raven-back.png": 394045,
	"./items/frosthaven/193-247/fh-233-dead-raven.png": 166811,
	"./items/frosthaven/193-247/fh-234-ooze-vial-back.png": 918325,
	"./items/frosthaven/193-247/fh-234-ooze-vial.png": 442776,
	"./items/frosthaven/193-247/fh-235-small-rat-back.png": 280425,
	"./items/frosthaven/193-247/fh-235-small-rat.png": 661630,
	"./items/frosthaven/193-247/fh-236-cracked-mirror-back.png": 355447,
	"./items/frosthaven/193-247/fh-236-cracked-mirror.png": 941650,
	"./items/frosthaven/193-247/fh-237-mesmerizing-seashell-back.png": 67946,
	"./items/frosthaven/193-247/fh-237-mesmerizing-seashell.png": 724302,
	"./items/frosthaven/193-247/fh-238-cracked-idol-back.png": 451686,
	"./items/frosthaven/193-247/fh-238-cracked-idol.png": 110446,
	"./items/frosthaven/193-247/fh-239-eye-of-the-storm-back.png": 211987,
	"./items/frosthaven/193-247/fh-239-eye-of-the-storm.png": 478025,
	"./items/frosthaven/193-247/fh-240-demons-gem-back.png": 821408,
	"./items/frosthaven/193-247/fh-240-demons-gem.png": 604340,
	"./items/frosthaven/193-247/fh-241-shimmering-powder-back.png": 855894,
	"./items/frosthaven/193-247/fh-241-shimmering-powder.png": 390619,
	"./items/frosthaven/193-247/fh-242-lucky-dice-back.png": 402343,
	"./items/frosthaven/193-247/fh-242-lucky-dice.png": 229338,
	"./items/frosthaven/193-247/fh-243-cursed-rock-back.png": 265148,
	"./items/frosthaven/193-247/fh-243-cursed-rock.png": 304469,
	"./items/frosthaven/193-247/fh-244-ember-energy-source-back.png": 37197,
	"./items/frosthaven/193-247/fh-244-ember-energy-source.png": 346684,
	"./items/frosthaven/193-247/fh-245a-ancient-coin-back.png": 367099,
	"./items/frosthaven/193-247/fh-245a-ancient-coin.png": 980342,
	"./items/frosthaven/193-247/fh-245b-ancient-coin-back.png": 438266,
	"./items/frosthaven/193-247/fh-245b-ancient-coin.png": 45354,
	"./items/frosthaven/193-247/fh-245c-ancient-coin-back.png": 671390,
	"./items/frosthaven/193-247/fh-245c-ancient-coin.png": 507585,
	"./items/frosthaven/193-247/fh-245d-ancient-coin-back.png": 795604,
	"./items/frosthaven/193-247/fh-245d-ancient-coin.png": 813530,
	"./items/frosthaven/193-247/fh-246-key-card-back.png": 969075,
	"./items/frosthaven/193-247/fh-246-key-card.png": 216394,
	"./items/frosthaven/193-247/fh-247-trainers-net-back.png": 825876,
	"./items/frosthaven/193-247/fh-247-trainers-net.png": 441531,
	"./items/frosthaven/248-264/fh-248-wanderers-club-back.png": 911574,
	"./items/frosthaven/248-264/fh-248-wanderers-club.png": 629867,
	"./items/frosthaven/248-264/fh-249-recalibration-trigger-back.png": 105482,
	"./items/frosthaven/248-264/fh-249-recalibration-trigger.png": 310161,
	"./items/frosthaven/248-264/fh-250-spear-of-justice-back.png": 309254,
	"./items/frosthaven/248-264/fh-250-spear-of-justice.png": 7330,
	"./items/frosthaven/248-264/fh-251-soul-urn-back.png": 135917,
	"./items/frosthaven/248-264/fh-251-soul-urn.png": 986694,
	"./items/frosthaven/248-264/fh-252-black-earth-codex-back.png": 64080,
	"./items/frosthaven/248-264/fh-252-black-earth-codex.png": 474464,
	"./items/frosthaven/248-264/fh-253-mask-of-duality-back.png": 928178,
	"./items/frosthaven/248-264/fh-253-mask-of-duality.png": 391847,
	"./items/frosthaven/248-264/fh-254-ancestral-blade-back.png": 141371,
	"./items/frosthaven/248-264/fh-254-ancestral-blade.png": 568660,
	"./items/frosthaven/248-264/fh-255-mountains-heart-back.png": 256646,
	"./items/frosthaven/248-264/fh-255-mountains-heart.png": 702035,
	"./items/frosthaven/248-264/fh-256-sonorous-shard-back.png": 119258,
	"./items/frosthaven/248-264/fh-256-sonorous-shard.png": 433205,
	"./items/frosthaven/248-264/fh-257-sly-camouflage-back.png": 754925,
	"./items/frosthaven/248-264/fh-257-sly-camouflage.png": 330257,
	"./items/frosthaven/248-264/fh-258-skull-of-agony-back.png": 884247,
	"./items/frosthaven/248-264/fh-258-skull-of-agony.png": 583389,
	"./items/frosthaven/248-264/fh-259-storm-carving-back.png": 905111,
	"./items/frosthaven/248-264/fh-259-storm-carving.png": 367823,
	"./items/frosthaven/248-264/fh-260-freezing-orb-back.png": 113878,
	"./items/frosthaven/248-264/fh-260-freezing-orb.png": 209378,
	"./items/frosthaven/248-264/fh-261-energized-module-back.png": 671430,
	"./items/frosthaven/248-264/fh-261-energized-module.png": 654829,
	"./items/frosthaven/248-264/fh-262-exhaust-boots-back.png": 860554,
	"./items/frosthaven/248-264/fh-262-exhaust-boots.png": 534441,
	"./items/frosthaven/248-264/fh-263-warlords-skull-back.png": 895725,
	"./items/frosthaven/248-264/fh-263-warlords-skull.png": 652546,
	"./items/frosthaven/248-264/fh-264-spiraled-medallion-back.png": 821275,
	"./items/frosthaven/248-264/fh-264-spiraled-medallion.png": 35578,
	"./items/gloomhaven/1-14/gh-001-boots-of-striding-back.png": 508306,
	"./items/gloomhaven/1-14/gh-001-boots-of-striding.png": 834020,
	"./items/gloomhaven/1-14/gh-002-winged-shoes-back.png": 403006,
	"./items/gloomhaven/1-14/gh-002-winged-shoes.png": 783450,
	"./items/gloomhaven/1-14/gh-003-hide-armor-back.png": 646622,
	"./items/gloomhaven/1-14/gh-003-hide-armor.png": 368023,
	"./items/gloomhaven/1-14/gh-004-leather-armor-back.png": 245961,
	"./items/gloomhaven/1-14/gh-004-leather-armor.png": 168311,
	"./items/gloomhaven/1-14/gh-005-cloak-of-invisibility-back.png": 414784,
	"./items/gloomhaven/1-14/gh-005-cloak-of-invisibility.png": 710613,
	"./items/gloomhaven/1-14/gh-006-eagle-eye-goggles-back.png": 882253,
	"./items/gloomhaven/1-14/gh-006-eagle-eye-goggles.png": 924136,
	"./items/gloomhaven/1-14/gh-007-iron-helmet-back.png": 260350,
	"./items/gloomhaven/1-14/gh-007-iron-helmet.png": 802972,
	"./items/gloomhaven/1-14/gh-008-heater-shield-back.png": 330048,
	"./items/gloomhaven/1-14/gh-008-heater-shield.png": 466087,
	"./items/gloomhaven/1-14/gh-009-piercing-bow-back.png": 45716,
	"./items/gloomhaven/1-14/gh-009-piercing-bow.png": 85622,
	"./items/gloomhaven/1-14/gh-010-war-hammer-back.png": 880331,
	"./items/gloomhaven/1-14/gh-010-war-hammer.png": 489000,
	"./items/gloomhaven/1-14/gh-011-poison-dagger-back.png": 373162,
	"./items/gloomhaven/1-14/gh-011-poison-dagger.png": 657640,
	"./items/gloomhaven/1-14/gh-012-minor-healing-potion-back.png": 825104,
	"./items/gloomhaven/1-14/gh-012-minor-healing-potion.png": 596705,
	"./items/gloomhaven/1-14/gh-013-minor-stamina-potion-back.png": 469687,
	"./items/gloomhaven/1-14/gh-013-minor-stamina-potion.png": 935014,
	"./items/gloomhaven/1-14/gh-014-minor-power-potion-back.png": 825287,
	"./items/gloomhaven/1-14/gh-014-minor-power-potion.png": 725249,
	"./items/gloomhaven/15-21/gh-015-boots-of-speed-back.png": 111627,
	"./items/gloomhaven/15-21/gh-015-boots-of-speed.png": 825469,
	"./items/gloomhaven/15-21/gh-016-cloak-of-pockets-back.png": 3798,
	"./items/gloomhaven/15-21/gh-016-cloak-of-pockets.png": 391225,
	"./items/gloomhaven/15-21/gh-017-empowering-talisman-back.png": 707371,
	"./items/gloomhaven/15-21/gh-017-empowering-talisman.png": 213554,
	"./items/gloomhaven/15-21/gh-018-battle-axe-back.png": 284323,
	"./items/gloomhaven/15-21/gh-018-battle-axe.png": 116002,
	"./items/gloomhaven/15-21/gh-019-weighted-net-back.png": 13414,
	"./items/gloomhaven/15-21/gh-019-weighted-net.png": 803681,
	"./items/gloomhaven/15-21/gh-020-minor-mana-potion-back.png": 404753,
	"./items/gloomhaven/15-21/gh-020-minor-mana-potion.png": 985877,
	"./items/gloomhaven/15-21/gh-021-stun-powder-back.png": 890502,
	"./items/gloomhaven/15-21/gh-021-stun-powder.png": 857861,
	"./items/gloomhaven/22-28/gh-022-heavy-greaves-back.png": 946376,
	"./items/gloomhaven/22-28/gh-022-heavy-greaves.png": 807194,
	"./items/gloomhaven/22-28/gh-023-chainmail-back.png": 450176,
	"./items/gloomhaven/22-28/gh-023-chainmail.png": 957361,
	"./items/gloomhaven/22-28/gh-024-amulet-of-life-back.png": 983406,
	"./items/gloomhaven/22-28/gh-024-amulet-of-life.png": 360705,
	"./items/gloomhaven/22-28/gh-025-jagged-sword-back.png": 591170,
	"./items/gloomhaven/22-28/gh-025-jagged-sword.png": 148483,
	"./items/gloomhaven/22-28/gh-026-long-spear-back.png": 990193,
	"./items/gloomhaven/22-28/gh-026-long-spear.png": 177345,
	"./items/gloomhaven/22-28/gh-027-major-healing-potion-back.png": 704186,
	"./items/gloomhaven/22-28/gh-027-major-healing-potion.png": 355512,
	"./items/gloomhaven/22-28/gh-028-moon-earring-back.png": 792513,
	"./items/gloomhaven/22-28/gh-028-moon-earring.png": 745437,
	"./items/gloomhaven/29-35/gh-029-comfortable-shoes-back.png": 490524,
	"./items/gloomhaven/29-35/gh-029-comfortable-shoes.png": 999838,
	"./items/gloomhaven/29-35/gh-030-studded-leather-back.png": 3690,
	"./items/gloomhaven/29-35/gh-030-studded-leather.png": 784172,
	"./items/gloomhaven/29-35/gh-031-hawk-helm-back.png": 173002,
	"./items/gloomhaven/29-35/gh-031-hawk-helm.png": 148658,
	"./items/gloomhaven/29-35/gh-032-tower-shield-back.png": 173390,
	"./items/gloomhaven/29-35/gh-032-tower-shield.png": 484879,
	"./items/gloomhaven/29-35/gh-033-volatile-bomb-back.png": 80634,
	"./items/gloomhaven/29-35/gh-033-volatile-bomb.png": 90253,
	"./items/gloomhaven/29-35/gh-034-major-stamina-potion-back.png": 186199,
	"./items/gloomhaven/29-35/gh-034-major-stamina-potion.png": 751593,
	"./items/gloomhaven/29-35/gh-035-falcon-figurine-back.png": 519201,
	"./items/gloomhaven/29-35/gh-035-falcon-figurine.png": 536747,
	"./items/gloomhaven/36-42/gh-036-boots-of-dashing-back.png": 845825,
	"./items/gloomhaven/36-42/gh-036-boots-of-dashing.png": 440113,
	"./items/gloomhaven/36-42/gh-037-robes-of-evocation-back.png": 842737,
	"./items/gloomhaven/36-42/gh-037-robes-of-evocation.png": 331913,
	"./items/gloomhaven/36-42/gh-038-heavy-basinet-back.png": 941401,
	"./items/gloomhaven/36-42/gh-038-heavy-basinet.png": 98986,
	"./items/gloomhaven/36-42/gh-039-hooked-chain-back.png": 410041,
	"./items/gloomhaven/36-42/gh-039-hooked-chain.png": 163855,
	"./items/gloomhaven/36-42/gh-040-versatile-dagger-back.png": 569905,
	"./items/gloomhaven/36-42/gh-040-versatile-dagger.png": 327085,
	"./items/gloomhaven/36-42/gh-041-major-power-potion-back.png": 548374,
	"./items/gloomhaven/36-42/gh-041-major-power-potion.png": 40456,
	"./items/gloomhaven/36-42/gh-042-ring-of-haste-back.png": 33685,
	"./items/gloomhaven/36-42/gh-042-ring-of-haste.png": 295859,
	"./items/gloomhaven/43-49/gh-043-boots-of-quickness-back.png": 546906,
	"./items/gloomhaven/43-49/gh-043-boots-of-quickness.png": 747503,
	"./items/gloomhaven/43-49/gh-044-splintmail-back.png": 506557,
	"./items/gloomhaven/43-49/gh-044-splintmail.png": 504654,
	"./items/gloomhaven/43-49/gh-045-pendant-of-dark-pacts-back.png": 13970,
	"./items/gloomhaven/43-49/gh-045-pendant-of-dark-pacts.png": 937554,
	"./items/gloomhaven/43-49/gh-046-spiked-shield-back.png": 669255,
	"./items/gloomhaven/43-49/gh-046-spiked-shield.png": 933999,
	"./items/gloomhaven/43-49/gh-047-reaping-scythe-back.png": 397296,
	"./items/gloomhaven/43-49/gh-047-reaping-scythe.png": 494848,
	"./items/gloomhaven/43-49/gh-048-major-mana-potion-back.png": 833190,
	"./items/gloomhaven/43-49/gh-048-major-mana-potion.png": 828186,
	"./items/gloomhaven/43-49/gh-049-sun-earring-back.png": 976875,
	"./items/gloomhaven/43-49/gh-049-sun-earring.png": 438859,
	"./items/gloomhaven/50-56/gh-050-steel-sabatons-back.png": 619231,
	"./items/gloomhaven/50-56/gh-050-steel-sabatons.png": 843943,
	"./items/gloomhaven/50-56/gh-051-shadow-armor-back.png": 219704,
	"./items/gloomhaven/50-56/gh-051-shadow-armor.png": 753484,
	"./items/gloomhaven/50-56/gh-052-protective-charm-back.png": 757282,
	"./items/gloomhaven/50-56/gh-052-protective-charm.png": 109745,
	"./items/gloomhaven/50-56/gh-053-black-knife-back.png": 715908,
	"./items/gloomhaven/50-56/gh-053-black-knife.png": 849399,
	"./items/gloomhaven/50-56/gh-054-staff-of-eminence-back.png": 433415,
	"./items/gloomhaven/50-56/gh-054-staff-of-eminence.png": 589391,
	"./items/gloomhaven/50-56/gh-055-super-healing-potion-back.png": 314293,
	"./items/gloomhaven/50-56/gh-055-super-healing-potion.png": 53173,
	"./items/gloomhaven/50-56/gh-056-ring-of-brutality-back.png": 938844,
	"./items/gloomhaven/50-56/gh-056-ring-of-brutality.png": 589607,
	"./items/gloomhaven/57-63/gh-057-serene-sandals-back.png": 257138,
	"./items/gloomhaven/57-63/gh-057-serene-sandals.png": 924650,
	"./items/gloomhaven/57-63/gh-058-cloak-of-phasing-back.png": 840362,
	"./items/gloomhaven/57-63/gh-058-cloak-of-phasing.png": 846863,
	"./items/gloomhaven/57-63/gh-059-telescopic-lens-back.png": 542384,
	"./items/gloomhaven/57-63/gh-059-telescopic-lens.png": 835119,
	"./items/gloomhaven/57-63/gh-060-unstable-explosives-back.png": 226982,
	"./items/gloomhaven/57-63/gh-060-unstable-explosives.png": 930024,
	"./items/gloomhaven/57-63/gh-061-wall-shield-back.png": 694377,
	"./items/gloomhaven/57-63/gh-061-wall-shield.png": 488411,
	"./items/gloomhaven/57-63/gh-062-doom-powder-back.png": 627757,
	"./items/gloomhaven/57-63/gh-062-doom-powder.png": 769755,
	"./items/gloomhaven/57-63/gh-063-lucky-eye-back.png": 346999,
	"./items/gloomhaven/57-63/gh-063-lucky-eye.png": 437101,
	"./items/gloomhaven/64-151/gh-064-boots-of-sprinting-back.png": 366235,
	"./items/gloomhaven/64-151/gh-064-boots-of-sprinting.png": 324323,
	"./items/gloomhaven/64-151/gh-065-platemail-back.png": 177770,
	"./items/gloomhaven/64-151/gh-065-platemail.png": 416649,
	"./items/gloomhaven/64-151/gh-066-mask-of-terror-back.png": 427002,
	"./items/gloomhaven/64-151/gh-066-mask-of-terror.png": 280971,
	"./items/gloomhaven/64-151/gh-067-balanced-blade-back.png": 363150,
	"./items/gloomhaven/64-151/gh-067-balanced-blade.png": 597366,
	"./items/gloomhaven/64-151/gh-068-halberd-back.png": 343054,
	"./items/gloomhaven/64-151/gh-068-halberd.png": 932534,
	"./items/gloomhaven/64-151/gh-069-star-earring-back.png": 515783,
	"./items/gloomhaven/64-151/gh-069-star-earring.png": 581919,
	"./items/gloomhaven/64-151/gh-070-second-chance-ring-back.png": 203919,
	"./items/gloomhaven/64-151/gh-070-second-chance-ring.png": 547130,
	"./items/gloomhaven/64-151/gh-071a-boots-of-levitation-back.png": 355834,
	"./items/gloomhaven/64-151/gh-071a-boots-of-levitation.png": 821212,
	"./items/gloomhaven/64-151/gh-071b-boots-of-levitation-back.png": 429241,
	"./items/gloomhaven/64-151/gh-071b-boots-of-levitation.png": 815199,
	"./items/gloomhaven/64-151/gh-072a-shoes-of-happiness-back.png": 499716,
	"./items/gloomhaven/64-151/gh-072a-shoes-of-happiness.png": 283726,
	"./items/gloomhaven/64-151/gh-072b-shoes-of-happiness-back.png": 577175,
	"./items/gloomhaven/64-151/gh-072b-shoes-of-happiness.png": 510645,
	"./items/gloomhaven/64-151/gh-073a-blinking-cape-back.png": 844849,
	"./items/gloomhaven/64-151/gh-073a-blinking-cape.png": 920270,
	"./items/gloomhaven/64-151/gh-073b-blinking-cape-back.png": 875441,
	"./items/gloomhaven/64-151/gh-073b-blinking-cape.png": 388306,
	"./items/gloomhaven/64-151/gh-074a-swordedge-armor-back.png": 473181,
	"./items/gloomhaven/64-151/gh-074a-swordedge-armor.png": 586854,
	"./items/gloomhaven/64-151/gh-074b-swordedge-armor-back.png": 505650,
	"./items/gloomhaven/64-151/gh-074b-swordedge-armor.png": 508295,
	"./items/gloomhaven/64-151/gh-075a-circlet-of-elements-back.png": 637714,
	"./items/gloomhaven/64-151/gh-075a-circlet-of-elements.png": 806191,
	"./items/gloomhaven/64-151/gh-075b-circlet-of-elements-back.png": 962913,
	"./items/gloomhaven/64-151/gh-075b-circlet-of-elements.png": 52181,
	"./items/gloomhaven/64-151/gh-076a-chain-hood-back.png": 89897,
	"./items/gloomhaven/64-151/gh-076a-chain-hood.png": 612724,
	"./items/gloomhaven/64-151/gh-076b-chain-hood-back.png": 476697,
	"./items/gloomhaven/64-151/gh-076b-chain-hood.png": 224513,
	"./items/gloomhaven/64-151/gh-077a-frigid-blade-back.png": 460366,
	"./items/gloomhaven/64-151/gh-077a-frigid-blade.png": 128381,
	"./items/gloomhaven/64-151/gh-077b-frigid-blade-back.png": 129214,
	"./items/gloomhaven/64-151/gh-077b-frigid-blade.png": 596150,
	"./items/gloomhaven/64-151/gh-078a-storm-blade-back.png": 91439,
	"./items/gloomhaven/64-151/gh-078a-storm-blade.png": 3473,
	"./items/gloomhaven/64-151/gh-078b-storm-blade-back.png": 825858,
	"./items/gloomhaven/64-151/gh-078b-storm-blade.png": 147075,
	"./items/gloomhaven/64-151/gh-079a-inferno-blade-back.png": 111051,
	"./items/gloomhaven/64-151/gh-079a-inferno-blade.png": 185017,
	"./items/gloomhaven/64-151/gh-079b-inferno-blade-back.png": 134895,
	"./items/gloomhaven/64-151/gh-079b-inferno-blade.png": 890066,
	"./items/gloomhaven/64-151/gh-080a-tremor-blade-back.png": 707057,
	"./items/gloomhaven/64-151/gh-080a-tremor-blade.png": 561566,
	"./items/gloomhaven/64-151/gh-080b-tremor-blade-back.png": 426160,
	"./items/gloomhaven/64-151/gh-080b-tremor-blade.png": 210373,
	"./items/gloomhaven/64-151/gh-081a-brilliant-blade-back.png": 720046,
	"./items/gloomhaven/64-151/gh-081a-brilliant-blade.png": 527891,
	"./items/gloomhaven/64-151/gh-081b-brilliant-blade-back.png": 166847,
	"./items/gloomhaven/64-151/gh-081b-brilliant-blade.png": 592480,
	"./items/gloomhaven/64-151/gh-082a-night-blade-back.png": 857376,
	"./items/gloomhaven/64-151/gh-082a-night-blade.png": 481761,
	"./items/gloomhaven/64-151/gh-082b-night-blade-back.png": 275542,
	"./items/gloomhaven/64-151/gh-082b-night-blade.png": 527331,
	"./items/gloomhaven/64-151/gh-083a-wand-of-frost-back.png": 67412,
	"./items/gloomhaven/64-151/gh-083a-wand-of-frost.png": 738693,
	"./items/gloomhaven/64-151/gh-083b-wand-of-frost-back.png": 12792,
	"./items/gloomhaven/64-151/gh-083b-wand-of-frost.png": 221966,
	"./items/gloomhaven/64-151/gh-084a-wand-of-storms-back.png": 444673,
	"./items/gloomhaven/64-151/gh-084a-wand-of-storms.png": 224859,
	"./items/gloomhaven/64-151/gh-084b-wand-of-storms-back.png": 285729,
	"./items/gloomhaven/64-151/gh-084b-wand-of-storms.png": 566079,
	"./items/gloomhaven/64-151/gh-085a-wand-of-infernos-back.png": 7146,
	"./items/gloomhaven/64-151/gh-085a-wand-of-infernos.png": 674129,
	"./items/gloomhaven/64-151/gh-085b-wand-of-infernos-back.png": 954237,
	"./items/gloomhaven/64-151/gh-085b-wand-of-infernos.png": 335987,
	"./items/gloomhaven/64-151/gh-086a-wand-of-tremors-back.png": 246321,
	"./items/gloomhaven/64-151/gh-086a-wand-of-tremors.png": 951323,
	"./items/gloomhaven/64-151/gh-086b-wand-of-tremors-back.png": 878426,
	"./items/gloomhaven/64-151/gh-086b-wand-of-tremors.png": 529311,
	"./items/gloomhaven/64-151/gh-087a-wand-of-brilliance-back.png": 556576,
	"./items/gloomhaven/64-151/gh-087a-wand-of-brilliance.png": 691779,
	"./items/gloomhaven/64-151/gh-087b-wand-of-brilliance-back.png": 667569,
	"./items/gloomhaven/64-151/gh-087b-wand-of-brilliance.png": 495502,
	"./items/gloomhaven/64-151/gh-088a-wand-of-darkness-back.png": 211163,
	"./items/gloomhaven/64-151/gh-088a-wand-of-darkness.png": 658074,
	"./items/gloomhaven/64-151/gh-088b-wand-of-darkness-back.png": 22174,
	"./items/gloomhaven/64-151/gh-088b-wand-of-darkness.png": 312290,
	"./items/gloomhaven/64-151/gh-089a-minor-cure-potion-back.png": 225773,
	"./items/gloomhaven/64-151/gh-089a-minor-cure-potion.png": 287716,
	"./items/gloomhaven/64-151/gh-089b-minor-cure-potion-back.png": 34318,
	"./items/gloomhaven/64-151/gh-089b-minor-cure-potion.png": 192314,
	"./items/gloomhaven/64-151/gh-090a-major-cure-potion-back.png": 147431,
	"./items/gloomhaven/64-151/gh-090a-major-cure-potion.png": 559538,
	"./items/gloomhaven/64-151/gh-090b-major-cure-potion-back.png": 162805,
	"./items/gloomhaven/64-151/gh-090b-major-cure-potion.png": 284904,
	"./items/gloomhaven/64-151/gh-091a-steel-ring-back.png": 83072,
	"./items/gloomhaven/64-151/gh-091a-steel-ring.png": 933764,
	"./items/gloomhaven/64-151/gh-091b-steel-ring-back.png": 184501,
	"./items/gloomhaven/64-151/gh-091b-steel-ring.png": 54430,
	"./items/gloomhaven/64-151/gh-092a-dampening-ring-back.png": 932423,
	"./items/gloomhaven/64-151/gh-092a-dampening-ring.png": 114782,
	"./items/gloomhaven/64-151/gh-092b-dampening-ring-back.png": 666073,
	"./items/gloomhaven/64-151/gh-092b-dampening-ring.png": 782668,
	"./items/gloomhaven/64-151/gh-093a-scroll-of-power-back.png": 706507,
	"./items/gloomhaven/64-151/gh-093a-scroll-of-power.png": 387538,
	"./items/gloomhaven/64-151/gh-093b-scroll-of-power-back.png": 717867,
	"./items/gloomhaven/64-151/gh-093b-scroll-of-power.png": 616224,
	"./items/gloomhaven/64-151/gh-094a-scroll-of-healing-back.png": 738842,
	"./items/gloomhaven/64-151/gh-094a-scroll-of-healing.png": 945101,
	"./items/gloomhaven/64-151/gh-094b-scroll-of-healing-back.png": 764400,
	"./items/gloomhaven/64-151/gh-094b-scroll-of-healing.png": 462561,
	"./items/gloomhaven/64-151/gh-095a-scroll-of-stamina-back.png": 498027,
	"./items/gloomhaven/64-151/gh-095a-scroll-of-stamina.png": 917131,
	"./items/gloomhaven/64-151/gh-095b-scroll-of-stamina-back.png": 409611,
	"./items/gloomhaven/64-151/gh-095b-scroll-of-stamina.png": 810062,
	"./items/gloomhaven/64-151/gh-096-rocket-boots-back.png": 141022,
	"./items/gloomhaven/64-151/gh-096-rocket-boots.png": 185996,
	"./items/gloomhaven/64-151/gh-097-endurance-footwraps-back.png": 455425,
	"./items/gloomhaven/64-151/gh-097-endurance-footwraps.png": 695382,
	"./items/gloomhaven/64-151/gh-098-drakescale-boots-back.png": 619954,
	"./items/gloomhaven/64-151/gh-098-drakescale-boots.png": 597170,
	"./items/gloomhaven/64-151/gh-099-magma-waders-back.png": 690017,
	"./items/gloomhaven/64-151/gh-099-magma-waders.png": 916911,
	"./items/gloomhaven/64-151/gh-100-robes-of-summoning-back.png": 673247,
	"./items/gloomhaven/64-151/gh-100-robes-of-summoning.png": 529521,
	"./items/gloomhaven/64-151/gh-101-second-skin-back.png": 390406,
	"./items/gloomhaven/64-151/gh-101-second-skin.png": 392179,
	"./items/gloomhaven/64-151/gh-102-sacrificial-robes-back.png": 122415,
	"./items/gloomhaven/64-151/gh-102-sacrificial-robes.png": 863485,
	"./items/gloomhaven/64-151/gh-103-drakescale-armor-back.png": 553927,
	"./items/gloomhaven/64-151/gh-103-drakescale-armor.png": 111022,
	"./items/gloomhaven/64-151/gh-104-steam-armor-back.png": 268315,
	"./items/gloomhaven/64-151/gh-104-steam-armor.png": 540630,
	"./items/gloomhaven/64-151/gh-105-flea-bitten-shawl-back.png": 620405,
	"./items/gloomhaven/64-151/gh-105-flea-bitten-shawl.png": 392992,
	"./items/gloomhaven/64-151/gh-106-necklace-of-teeth-back.png": 162782,
	"./items/gloomhaven/64-151/gh-106-necklace-of-teeth.png": 847516,
	"./items/gloomhaven/64-151/gh-107-horned-helm-back.png": 806903,
	"./items/gloomhaven/64-151/gh-107-horned-helm.png": 345897,
	"./items/gloomhaven/64-151/gh-108-drakescale-helm-back.png": 511466,
	"./items/gloomhaven/64-151/gh-108-drakescale-helm.png": 602925,
	"./items/gloomhaven/64-151/gh-109-thiefs-hood-back.png": 142641,
	"./items/gloomhaven/64-151/gh-109-thiefs-hood.png": 123089,
	"./items/gloomhaven/64-151/gh-110-helm-of-the-mountain-back.png": 877161,
	"./items/gloomhaven/64-151/gh-110-helm-of-the-mountain.png": 729066,
	"./items/gloomhaven/64-151/gh-111-wave-crest-back.png": 775615,
	"./items/gloomhaven/64-151/gh-111-wave-crest.png": 625214,
	"./items/gloomhaven/64-151/gh-112-ancient-drill-back.png": 782612,
	"./items/gloomhaven/64-151/gh-112-ancient-drill.png": 837867,
	"./items/gloomhaven/64-151/gh-113-skullbane-axe-back.png": 466249,
	"./items/gloomhaven/64-151/gh-113-skullbane-axe.png": 358632,
	"./items/gloomhaven/64-151/gh-114-staff-of-xorn-back.png": 544736,
	"./items/gloomhaven/64-151/gh-114-staff-of-xorn.png": 116019,
	"./items/gloomhaven/64-151/gh-115-mountain-hammer-back.png": 718735,
	"./items/gloomhaven/64-151/gh-115-mountain-hammer.png": 658774,
	"./items/gloomhaven/64-151/gh-116-fueled-falchion-back.png": 305954,
	"./items/gloomhaven/64-151/gh-116-fueled-falchion.png": 965025,
	"./items/gloomhaven/64-151/gh-117-bloody-axe-back.png": 424637,
	"./items/gloomhaven/64-151/gh-117-bloody-axe.png": 499189,
	"./items/gloomhaven/64-151/gh-118-staff-of-elements-back.png": 11277,
	"./items/gloomhaven/64-151/gh-118-staff-of-elements.png": 613166,
	"./items/gloomhaven/64-151/gh-119-skull-of-hatred-back.png": 64541,
	"./items/gloomhaven/64-151/gh-119-skull-of-hatred.png": 527764,
	"./items/gloomhaven/64-151/gh-120-staff-of-summoning-back.png": 443847,
	"./items/gloomhaven/64-151/gh-120-staff-of-summoning.png": 905095,
	"./items/gloomhaven/64-151/gh-121-orb-of-dawn-back.png": 516475,
	"./items/gloomhaven/64-151/gh-121-orb-of-dawn.png": 211456,
	"./items/gloomhaven/64-151/gh-122-orb-of-twilight-back.png": 825210,
	"./items/gloomhaven/64-151/gh-122-orb-of-twilight.png": 777970,
	"./items/gloomhaven/64-151/gh-123-ring-of-skulls-back.png": 106078,
	"./items/gloomhaven/64-151/gh-123-ring-of-skulls.png": 20921,
	"./items/gloomhaven/64-151/gh-124-doomed-compass-back.png": 194753,
	"./items/gloomhaven/64-151/gh-124-doomed-compass.png": 290607,
	"./items/gloomhaven/64-151/gh-125-curious-gear-back.png": 913204,
	"./items/gloomhaven/64-151/gh-125-curious-gear.png": 194363,
	"./items/gloomhaven/64-151/gh-126-remote-spider-back.png": 262565,
	"./items/gloomhaven/64-151/gh-126-remote-spider.png": 821020,
	"./items/gloomhaven/64-151/gh-127-giant-remote-spider-back.png": 559978,
	"./items/gloomhaven/64-151/gh-127-giant-remote-spider.png": 713645,
	"./items/gloomhaven/64-151/gh-128-black-censer-back.png": 695686,
	"./items/gloomhaven/64-151/gh-128-black-censer.png": 445050,
	"./items/gloomhaven/64-151/gh-129-black-card-back.png": 516819,
	"./items/gloomhaven/64-151/gh-129-black-card.png": 658394,
	"./items/gloomhaven/64-151/gh-130-helix-ring-back.png": 605286,
	"./items/gloomhaven/64-151/gh-130-helix-ring.png": 860221,
	"./items/gloomhaven/64-151/gh-131-heart-of-the-betrayer-back.png": 293833,
	"./items/gloomhaven/64-151/gh-131-heart-of-the-betrayer.png": 366509,
	"./items/gloomhaven/64-151/gh-132-power-core-back.png": 715522,
	"./items/gloomhaven/64-151/gh-132-power-core.png": 896066,
	"./items/gloomhaven/64-151/gh-133-resonant-crystal-back.png": 385020,
	"./items/gloomhaven/64-151/gh-133-resonant-crystal.png": 470010,
	"./items/gloomhaven/64-151/gh-134-imposing-blade-back.png": 900930,
	"./items/gloomhaven/64-151/gh-134-imposing-blade.png": 139437,
	"./items/gloomhaven/64-151/gh-135-focusing-ray-back.png": 895301,
	"./items/gloomhaven/64-151/gh-135-focusing-ray.png": 834850,
	"./items/gloomhaven/64-151/gh-136-volatile-elixir-back.png": 419959,
	"./items/gloomhaven/64-151/gh-136-volatile-elixir.png": 817600,
	"./items/gloomhaven/64-151/gh-137-silent-stiletto-back.png": 64265,
	"./items/gloomhaven/64-151/gh-137-silent-stiletto.png": 51367,
	"./items/gloomhaven/64-151/gh-138-stone-charm-back.png": 682205,
	"./items/gloomhaven/64-151/gh-138-stone-charm.png": 576515,
	"./items/gloomhaven/64-151/gh-139-psychic-knife-back.png": 619876,
	"./items/gloomhaven/64-151/gh-139-psychic-knife.png": 293805,
	"./items/gloomhaven/64-151/gh-140-sun-shield-back.png": 707181,
	"./items/gloomhaven/64-151/gh-140-sun-shield.png": 57224,
	"./items/gloomhaven/64-151/gh-141-utility-belt-back.png": 747909,
	"./items/gloomhaven/64-151/gh-141-utility-belt.png": 97973,
	"./items/gloomhaven/64-151/gh-142-phasing-idol-back.png": 618825,
	"./items/gloomhaven/64-151/gh-142-phasing-idol.png": 167265,
	"./items/gloomhaven/64-151/gh-143-smoke-elixir-back.png": 113670,
	"./items/gloomhaven/64-151/gh-143-smoke-elixir.png": 707505,
	"./items/gloomhaven/64-151/gh-144-pendant-of-the-plague-back.png": 350530,
	"./items/gloomhaven/64-151/gh-144-pendant-of-the-plague.png": 58628,
	"./items/gloomhaven/64-151/gh-145-mask-of-death-back.png": 762087,
	"./items/gloomhaven/64-151/gh-145-mask-of-death.png": 309260,
	"./items/gloomhaven/64-151/gh-146-masters-lute-back.png": 230676,
	"./items/gloomhaven/64-151/gh-146-masters-lute.png": 69751,
	"./items/gloomhaven/64-151/gh-147-cloak-of-the-hunter-back.png": 614208,
	"./items/gloomhaven/64-151/gh-147-cloak-of-the-hunter.png": 522439,
	"./items/gloomhaven/64-151/gh-148-doctors-coat-back.png": 902986,
	"./items/gloomhaven/64-151/gh-148-doctors-coat.png": 44424,
	"./items/gloomhaven/64-151/gh-149-elemental-boots-back.png": 442923,
	"./items/gloomhaven/64-151/gh-149-elemental-boots.png": 150448,
	"./items/gloomhaven/64-151/gh-150-staff-of-command-back.png": 566406,
	"./items/gloomhaven/64-151/gh-150-staff-of-command.png": 599010,
	"./items/gloomhaven/64-151/gh-151-sword-of-the-sands-back.png": 907537,
	"./items/gloomhaven/64-151/gh-151-sword-of-the-sands.png": 534878,
	"./items/jaws-of-the-lion/1-13/jl-01-eagle-eye-goggles-back.png": 204636,
	"./items/jaws-of-the-lion/1-13/jl-01-eagle-eye-goggles.png": 113098,
	"./items/jaws-of-the-lion/1-13/jl-02-iron-helmet-back.png": 375147,
	"./items/jaws-of-the-lion/1-13/jl-02-iron-helmet.png": 755493,
	"./items/jaws-of-the-lion/1-13/jl-03-chain-armor-back.png": 660438,
	"./items/jaws-of-the-lion/1-13/jl-03-chain-armor.png": 610685,
	"./items/jaws-of-the-lion/1-13/jl-04-studded-leather-back.png": 362859,
	"./items/jaws-of-the-lion/1-13/jl-04-studded-leather.png": 523958,
	"./items/jaws-of-the-lion/1-13/jl-05-weathered-boots-back.png": 851632,
	"./items/jaws-of-the-lion/1-13/jl-05-weathered-boots.png": 778227,
	"./items/jaws-of-the-lion/1-13/jl-06-winged-shoes-back.png": 984921,
	"./items/jaws-of-the-lion/1-13/jl-06-winged-shoes.png": 391571,
	"./items/jaws-of-the-lion/1-13/jl-07-heater-shield-back.png": 887227,
	"./items/jaws-of-the-lion/1-13/jl-07-heater-shield.png": 901563,
	"./items/jaws-of-the-lion/1-13/jl-08-throwing-hammer-back.png": 61156,
	"./items/jaws-of-the-lion/1-13/jl-08-throwing-hammer.png": 914550,
	"./items/jaws-of-the-lion/1-13/jl-09-poison-dagger-back.png": 24091,
	"./items/jaws-of-the-lion/1-13/jl-09-poison-dagger.png": 546652,
	"./items/jaws-of-the-lion/1-13/jl-10-iron-spear-back.png": 926459,
	"./items/jaws-of-the-lion/1-13/jl-10-iron-spear.png": 287561,
	"./items/jaws-of-the-lion/1-13/jl-11-healing-potion-back.png": 940115,
	"./items/jaws-of-the-lion/1-13/jl-11-healing-potion.png": 174303,
	"./items/jaws-of-the-lion/1-13/jl-12-stamina-potion-back.png": 838170,
	"./items/jaws-of-the-lion/1-13/jl-12-stamina-potion.png": 383187,
	"./items/jaws-of-the-lion/1-13/jl-13-power-potion-back.png": 487714,
	"./items/jaws-of-the-lion/1-13/jl-13-power-potion.png": 672660,
	"./items/jaws-of-the-lion/14/jl-14-mana-potion-back.png": 493606,
	"./items/jaws-of-the-lion/14/jl-14-mana-potion.png": 322605,
	"./items/jaws-of-the-lion/15-20/jl-15-amulet-of-life-back.png": 969039,
	"./items/jaws-of-the-lion/15-20/jl-15-amulet-of-life.png": 373721,
	"./items/jaws-of-the-lion/15-20/jl-16-robes-of-evocation-back.png": 897469,
	"./items/jaws-of-the-lion/15-20/jl-16-robes-of-evocation.png": 248471,
	"./items/jaws-of-the-lion/15-20/jl-17-comfortable-shoes-back.png": 408518,
	"./items/jaws-of-the-lion/15-20/jl-17-comfortable-shoes.png": 325948,
	"./items/jaws-of-the-lion/15-20/jl-18-battle-axe-back.png": 97023,
	"./items/jaws-of-the-lion/15-20/jl-18-battle-axe.png": 62858,
	"./items/jaws-of-the-lion/15-20/jl-19-black-candle-back.png": 420789,
	"./items/jaws-of-the-lion/15-20/jl-19-black-candle.png": 105007,
	"./items/jaws-of-the-lion/15-20/jl-20-stun-powder-back.png": 532716,
	"./items/jaws-of-the-lion/15-20/jl-20-stun-powder.png": 8334,
	"./items/jaws-of-the-lion/21-26/jl-21-hawk-helm-back.png": 615638,
	"./items/jaws-of-the-lion/21-26/jl-21-hawk-helm.png": 266338,
	"./items/jaws-of-the-lion/21-26/jl-22-bladed-armor-back.png": 299986,
	"./items/jaws-of-the-lion/21-26/jl-22-bladed-armor.png": 45063,
	"./items/jaws-of-the-lion/21-26/jl-23-boots-of-striding-back.png": 145698,
	"./items/jaws-of-the-lion/21-26/jl-23-boots-of-striding.png": 206986,
	"./items/jaws-of-the-lion/21-26/jl-24-volatile-bomb-back.png": 750987,
	"./items/jaws-of-the-lion/21-26/jl-24-volatile-bomb.png": 165254,
	"./items/jaws-of-the-lion/21-26/jl-25-barbed-chain-back.png": 635374,
	"./items/jaws-of-the-lion/21-26/jl-25-barbed-chain.png": 511377,
	"./items/jaws-of-the-lion/21-26/jl-26-oak-charm-back.png": 729438,
	"./items/jaws-of-the-lion/21-26/jl-26-oak-charm.png": 936570,
	"./items/jaws-of-the-lion/27-36/jl-27-fateful-compass-back.png": 280353,
	"./items/jaws-of-the-lion/27-36/jl-27-fateful-compass.png": 858245,
	"./items/jaws-of-the-lion/27-36/jl-28-flea-bitten-shawl-back.png": 457057,
	"./items/jaws-of-the-lion/27-36/jl-28-flea-bitten-shawl.png": 782755,
	"./items/jaws-of-the-lion/27-36/jl-29-tower-shield-back.png": 186218,
	"./items/jaws-of-the-lion/27-36/jl-29-tower-shield.png": 421001,
	"./items/jaws-of-the-lion/27-36/jl-30-ring-of-haste-back.png": 349877,
	"./items/jaws-of-the-lion/27-36/jl-30-ring-of-haste.png": 942097,
	"./items/jaws-of-the-lion/27-36/jl-31-ring-of-strength-back.png": 676017,
	"./items/jaws-of-the-lion/27-36/jl-31-ring-of-strength.png": 3301,
	"./items/jaws-of-the-lion/27-36/jl-32-ring-of-restoration-back.png": 379578,
	"./items/jaws-of-the-lion/27-36/jl-32-ring-of-restoration.png": 452907,
	"./items/jaws-of-the-lion/27-36/jl-33-steel-ring-back.png": 413966,
	"./items/jaws-of-the-lion/27-36/jl-33-steel-ring.png": 631491,
	"./items/jaws-of-the-lion/27-36/jl-34-barbed-axe-back.png": 457133,
	"./items/jaws-of-the-lion/27-36/jl-34-barbed-axe.png": 914457,
	"./items/jaws-of-the-lion/27-36/jl-35-robes-of-command-back.png": 897784,
	"./items/jaws-of-the-lion/27-36/jl-35-robes-of-command.png": 978974,
	"./items/jaws-of-the-lion/27-36/jl-36-jet-boots-back.png": 128965,
	"./items/jaws-of-the-lion/27-36/jl-36-jet-boots.png": 222074,
	"./items/trail-of-ashes/toa-101-runic-visard-back.png": 732525,
	"./items/trail-of-ashes/toa-101-runic-visard.png": 947533,
	"./items/trail-of-ashes/toa-102-shoes-of-ataraxy-back.png": 730200,
	"./items/trail-of-ashes/toa-102a-shoes-of-ataraxy.png": 416467,
	"./items/trail-of-ashes/toa-102b-shoes-of-ataraxy.png": 862171,
	"./items/trail-of-ashes/toa-103-magnetic-relocator-back.png": 196039,
	"./items/trail-of-ashes/toa-103-magnetic-relocator.png": 247207,
	"./items/trail-of-ashes/toa-104-shepherds-flute-back.png": 367497,
	"./items/trail-of-ashes/toa-104-shepherds-flute.png": 436770,
	"./items/trail-of-ashes/toa-105-tyrannical-staff-back.png": 106198,
	"./items/trail-of-ashes/toa-105-tyrannical-staff.png": 816835,
	"./items/trail-of-ashes/toa-106-crushing-mace-back.png": 492168,
	"./items/trail-of-ashes/toa-106a-crushing-mace.png": 731283,
	"./items/trail-of-ashes/toa-106b-crushing-mace.png": 207811,
	"./items/trail-of-ashes/toa-107-chiefs-garb-back.png": 505153,
	"./items/trail-of-ashes/toa-107-chiefs-garb.png": 202786,
	"./items/trail-of-ashes/toa-108-iridescent-bracer-back.png": 463225,
	"./items/trail-of-ashes/toa-108-iridescent-bracer.png": 756974,
	"./items/trail-of-ashes/toa-109-talos-staff-back.png": 523162,
	"./items/trail-of-ashes/toa-109-talos-staff.png": 573073,
	"./items/trail-of-ashes/toa-110-mask-of-cruelty-back.png": 267078,
	"./items/trail-of-ashes/toa-110-mask-of-cruelty.png": 399467,
	"./items/trail-of-ashes/toa-111-staff-of-equilibrium-back.png": 573413,
	"./items/trail-of-ashes/toa-111-staff-of-equilibrium.png": 702793,
	"./items/trail-of-ashes/toa-112-voyagers-blade-back.png": 121548,
	"./items/trail-of-ashes/toa-112-voyagers-blade.png": 321155,
	"./items/trail-of-ashes/toa-113-looking-glass-back.png": 328343,
	"./items/trail-of-ashes/toa-113-looking-glass.png": 418420,
	"./items/trail-of-ashes/toa-114-runic-boots-of-travel-back.png": 250709,
	"./items/trail-of-ashes/toa-114-runic-boots-of-travel.png": 842818,
	"./items/trail-of-ashes/toa-115-battle-standard-back.png": 390197,
	"./items/trail-of-ashes/toa-115-battle-standard.png": 75226,
	"./items/trail-of-ashes/toa-116-matriarchs-warhorn-back.png": 914353,
	"./items/trail-of-ashes/toa-116-matriarchs-warhorn.png": 289241,
	"./items/trail-of-ashes/toa-117-dawnbloom-nectar-back.png": 179697,
	"./items/trail-of-ashes/toa-117a-dawnbloom-nectar.png": 933676,
	"./items/trail-of-ashes/toa-117b-dawnbloom-nectar.png": 995381,
	"./items/trail-of-ashes/toa-118-graveweed-extract-back.png": 107184,
	"./items/trail-of-ashes/toa-118a-graveweed-extract.png": 87903,
	"./items/trail-of-ashes/toa-118b-graveweed-extract.png": 619074,
	"./items/trail-of-ashes/toa-119-thrice-souled-warsword-back.png": 629784,
	"./items/trail-of-ashes/toa-119-thrice-souled-warsword.png": 424157,
	"./items/trail-of-ashes/toa-120-rekindled-core-back.png": 146856,
	"./items/trail-of-ashes/toa-120-rekindled-core.png": 916492,
	"./items/trail-of-ashes/toa-121-crystal-catalyst-back.png": 388589,
	"./items/trail-of-ashes/toa-121-crystal-catalyst.png": 98631,
	"./items/trail-of-ashes/toa-122-crystal-spike-back.png": 883579,
	"./items/trail-of-ashes/toa-122-crystal-spike.png": 654687,
	"./items/trail-of-ashes/toa-123-arclight-cladding-back.png": 136338,
	"./items/trail-of-ashes/toa-123-arclight-cladding.png": 616724,
	"./items/trail-of-ashes/toa-124-arcbolt-lance-back.png": 211150,
	"./items/trail-of-ashes/toa-124-arcbolt-lance.png": 931736,
	"./items/trail-of-ashes/toa-125-scroll-of-evasion-back.png": 150095,
	"./items/trail-of-ashes/toa-125-scroll-of-evasion.png": 390443,
	"./items/trail-of-ashes/toa-126-arcstone-greaves-back.png": 680251,
	"./items/trail-of-ashes/toa-126-arcstone-greaves.png": 740009,
	"./items/trail-of-ashes/toa-127-arclight-hood-back.png": 305734,
	"./items/trail-of-ashes/toa-127-arclight-hood.png": 642275,
	"./items/trail-of-ashes/toa-128-barbed-whip-back.png": 286010,
	"./items/trail-of-ashes/toa-128-barbed-whip.png": 439066,
	"./items/trail-of-ashes/toa-129-talos-rosary-back.png": 673605,
	"./items/trail-of-ashes/toa-129a-talos-rosary.png": 39522,
	"./items/trail-of-ashes/toa-129b-talos-rosary.png": 158271,
	"./items/trail-of-ashes/toa-130-dynamic-sickle-back.png": 850636,
	"./items/trail-of-ashes/toa-130-dynamic-sickle.png": 309467,
	"./items/trail-of-ashes/toa-131-predators-wristblade-back.png": 683193,
	"./items/trail-of-ashes/toa-131-predators-wristblade.png": 114828,
	"./loot-deck/ZZ/zz.txt": 103873,
	"./loot-deck/frosthaven/fh-arrowvine-1381.png": 996603,
	"./loot-deck/frosthaven/fh-arrowvine-1382.png": 913150,
	"./loot-deck/frosthaven/fh-axenut-1383.png": 30978,
	"./loot-deck/frosthaven/fh-axenut-1384.png": 872967,
	"./loot-deck/frosthaven/fh-corpsecap-1385.png": 22961,
	"./loot-deck/frosthaven/fh-corpsecap-1386.png": 591505,
	"./loot-deck/frosthaven/fh-flamefruit-1387.png": 956597,
	"./loot-deck/frosthaven/fh-flamefruit-1388.png": 535370,
	"./loot-deck/frosthaven/fh-hide-1393.png": 774337,
	"./loot-deck/frosthaven/fh-hide-1394.png": 554494,
	"./loot-deck/frosthaven/fh-hide-1395.png": 718337,
	"./loot-deck/frosthaven/fh-hide-1396.png": 949402,
	"./loot-deck/frosthaven/fh-hide-1397.png": 535926,
	"./loot-deck/frosthaven/fh-hide-1398.png": 448255,
	"./loot-deck/frosthaven/fh-hide-1399.png": 21062,
	"./loot-deck/frosthaven/fh-hide-1400.png": 390721,
	"./loot-deck/frosthaven/fh-loot-deck-back.png": 798814,
	"./loot-deck/frosthaven/fh-lumber-1401.png": 438520,
	"./loot-deck/frosthaven/fh-lumber-1402.png": 141533,
	"./loot-deck/frosthaven/fh-lumber-1403.png": 463388,
	"./loot-deck/frosthaven/fh-lumber-1404.png": 527845,
	"./loot-deck/frosthaven/fh-lumber-1405.png": 442859,
	"./loot-deck/frosthaven/fh-lumber-1406.png": 921366,
	"./loot-deck/frosthaven/fh-lumber-1407.png": 39623,
	"./loot-deck/frosthaven/fh-lumber-1408.png": 216209,
	"./loot-deck/frosthaven/fh-metal-1409.png": 432954,
	"./loot-deck/frosthaven/fh-metal-1410.png": 773782,
	"./loot-deck/frosthaven/fh-metal-1411.png": 17224,
	"./loot-deck/frosthaven/fh-metal-1412.png": 547018,
	"./loot-deck/frosthaven/fh-metal-1413.png": 531159,
	"./loot-deck/frosthaven/fh-metal-1414.png": 142985,
	"./loot-deck/frosthaven/fh-metal-1415.png": 883466,
	"./loot-deck/frosthaven/fh-metal-1416.png": 157522,
	"./loot-deck/frosthaven/fh-one-coin-1361.png": 690532,
	"./loot-deck/frosthaven/fh-one-coin-1362.png": 269767,
	"./loot-deck/frosthaven/fh-one-coin-1363.png": 784705,
	"./loot-deck/frosthaven/fh-one-coin-1364.png": 44021,
	"./loot-deck/frosthaven/fh-one-coin-1365.png": 506000,
	"./loot-deck/frosthaven/fh-one-coin-1366.png": 166396,
	"./loot-deck/frosthaven/fh-one-coin-1367.png": 84924,
	"./loot-deck/frosthaven/fh-one-coin-1368.png": 621970,
	"./loot-deck/frosthaven/fh-one-coin-1369.png": 854823,
	"./loot-deck/frosthaven/fh-one-coin-1370.png": 270644,
	"./loot-deck/frosthaven/fh-one-coin-1371.png": 535134,
	"./loot-deck/frosthaven/fh-one-coin-1372.png": 612202,
	"./loot-deck/frosthaven/fh-random-item-1417.png": 581767,
	"./loot-deck/frosthaven/fh-rockroot-1389.png": 849039,
	"./loot-deck/frosthaven/fh-rockroot-1390.png": 480025,
	"./loot-deck/frosthaven/fh-scenario-coin-1418.png": 190710,
	"./loot-deck/frosthaven/fh-scenario-coin-1419.png": 203784,
	"./loot-deck/frosthaven/fh-snowthistle-1391.png": 518658,
	"./loot-deck/frosthaven/fh-snowthistle-1392.png": 55955,
	"./loot-deck/frosthaven/fh-three-coins-1379.png": 363455,
	"./loot-deck/frosthaven/fh-three-coins-1380.png": 814329,
	"./loot-deck/frosthaven/fh-two-coins-1373.png": 698864,
	"./loot-deck/frosthaven/fh-two-coins-1374.png": 409561,
	"./loot-deck/frosthaven/fh-two-coins-1375.png": 946048,
	"./loot-deck/frosthaven/fh-two-coins-1376.png": 331930,
	"./loot-deck/frosthaven/fh-two-coins-1377.png": 975510,
	"./loot-deck/frosthaven/fh-two-coins-1378.png": 651962,
	"./map-tiles/frosthaven/fh-01a-snow.png": 760285,
	"./map-tiles/frosthaven/fh-01b-metal.png": 110382,
	"./map-tiles/frosthaven/fh-01c-snow.png": 313124,
	"./map-tiles/frosthaven/fh-01d-metal.png": 632618,
	"./map-tiles/frosthaven/fh-01e-snow.png": 842902,
	"./map-tiles/frosthaven/fh-01f-cave.png": 455330,
	"./map-tiles/frosthaven/fh-01g-snow.png": 768567,
	"./map-tiles/frosthaven/fh-01h-dungeon.png": 617178,
	"./map-tiles/frosthaven/fh-02a-dungeon.png": 574938,
	"./map-tiles/frosthaven/fh-02b-wood.png": 146465,
	"./map-tiles/frosthaven/fh-02c-dungeon.png": 128459,
	"./map-tiles/frosthaven/fh-02d-wood.png": 743517,
	"./map-tiles/frosthaven/fh-02e-snow.png": 667648,
	"./map-tiles/frosthaven/fh-02f-metal.png": 529680,
	"./map-tiles/frosthaven/fh-02g-snow.png": 952709,
	"./map-tiles/frosthaven/fh-02h-metal.png": 882008,
	"./map-tiles/frosthaven/fh-02i-dungeon.png": 650991,
	"./map-tiles/frosthaven/fh-02j-cave.png": 12537,
	"./map-tiles/frosthaven/fh-02k-dungeon.png": 767780,
	"./map-tiles/frosthaven/fh-02l-cave.png": 538318,
	"./map-tiles/frosthaven/fh-03a-cave.png": 3622,
	"./map-tiles/frosthaven/fh-03b-metal.png": 287250,
	"./map-tiles/frosthaven/fh-03c-dungeon.png": 183203,
	"./map-tiles/frosthaven/fh-03d-snow.png": 593718,
	"./map-tiles/frosthaven/fh-04a-cave.png": 311321,
	"./map-tiles/frosthaven/fh-04b-metal.png": 80078,
	"./map-tiles/frosthaven/fh-04c-snow.png": 707094,
	"./map-tiles/frosthaven/fh-04d-dungeon.png": 761501,
	"./map-tiles/frosthaven/fh-05a-cave.png": 299042,
	"./map-tiles/frosthaven/fh-05b-snow.png": 299128,
	"./map-tiles/frosthaven/fh-06a-snow.png": 740295,
	"./map-tiles/frosthaven/fh-06b-metal.png": 175472,
	"./map-tiles/frosthaven/fh-07a-cave.png": 13051,
	"./map-tiles/frosthaven/fh-07b-snow.png": 208315,
	"./map-tiles/frosthaven/fh-07c-cave.png": 479196,
	"./map-tiles/frosthaven/fh-07d-snow.png": 627919,
	"./map-tiles/frosthaven/fh-07e-dungeon.png": 479728,
	"./map-tiles/frosthaven/fh-07f-metal.png": 716289,
	"./map-tiles/frosthaven/fh-07g-wood.png": 481719,
	"./map-tiles/frosthaven/fh-07h-metal.png": 474330,
	"./map-tiles/frosthaven/fh-08a-metal.png": 93909,
	"./map-tiles/frosthaven/fh-08b-cave.png": 301162,
	"./map-tiles/frosthaven/fh-09a-snow.png": 383876,
	"./map-tiles/frosthaven/fh-09b-dungeon.png": 370165,
	"./map-tiles/frosthaven/fh-09c-metal.png": 648666,
	"./map-tiles/frosthaven/fh-09d-wood.png": 798608,
	"./map-tiles/frosthaven/fh-10a-metal.png": 976240,
	"./map-tiles/frosthaven/fh-10b-dungeon.png": 37607,
	"./map-tiles/frosthaven/fh-10c-metal.png": 993302,
	"./map-tiles/frosthaven/fh-10d-snow.png": 130282,
	"./map-tiles/frosthaven/fh-11a-snow.png": 112168,
	"./map-tiles/frosthaven/fh-11b-cave.png": 493003,
	"./map-tiles/frosthaven/fh-11c-snow.png": 724104,
	"./map-tiles/frosthaven/fh-11d-cave.png": 162079,
	"./map-tiles/frosthaven/fh-11e-dungeon.png": 100457,
	"./map-tiles/frosthaven/fh-11f-metal.png": 528908,
	"./map-tiles/frosthaven/fh-12a-metal.png": 381832,
	"./map-tiles/frosthaven/fh-12b-cave.png": 627180,
	"./map-tiles/frosthaven/fh-12c-metal.png": 433328,
	"./map-tiles/frosthaven/fh-12d-dungeon.png": 914229,
	"./map-tiles/frosthaven/fh-13a-snow.png": 805712,
	"./map-tiles/frosthaven/fh-13b-cave.png": 172964,
	"./map-tiles/frosthaven/fh-13c-snow.png": 600705,
	"./map-tiles/frosthaven/fh-13d-cave.png": 795025,
	"./map-tiles/frosthaven/fh-13e-dungeon.png": 384273,
	"./map-tiles/frosthaven/fh-13f-metal.png": 204757,
	"./map-tiles/frosthaven/fh-14a-wood.png": 14811,
	"./map-tiles/frosthaven/fh-14b-cave.png": 535276,
	"./map-tiles/frosthaven/fh-15a-snow.png": 888626,
	"./map-tiles/frosthaven/fh-15b-cave.png": 514103,
	"./map-tiles/frosthaven/fh-15c-dungeon.png": 861820,
	"./map-tiles/frosthaven/fh-15d-metal.png": 852290,
	"./map-tiles/frosthaven/fh-16a-snow.png": 924443,
	"./map-tiles/frosthaven/fh-16b-cave.png": 839618,
	"./map-tiles/frosthaven/fh-16c-dungeon.png": 653624,
	"./map-tiles/frosthaven/fh-16d-metal.png": 918283,
	"./map-tiles/frosthaven/fh-character-dial-back.png": 564898,
	"./map-tiles/frosthaven/fh-character-dial-front.png": 141412,
	"./map-tiles/frosthaven/fh-character-dial-health-back.png": 268195,
	"./map-tiles/frosthaven/fh-character-dial-health-front.png": 252851,
	"./map-tiles/frosthaven/fh-character-dial-xp-back.png": 373196,
	"./map-tiles/frosthaven/fh-character-dial-xp-front.png": 914181,
	"./map-tiles/frosthaven/fh-element-board-back.png": 560957,
	"./map-tiles/frosthaven/fh-element-board-front.png": 328725,
	"./map-tiles/gloomhaven/gh-a1a.png": 876948,
	"./map-tiles/gloomhaven/gh-a1b.png": 344750,
	"./map-tiles/gloomhaven/gh-a2a.png": 105502,
	"./map-tiles/gloomhaven/gh-a2b.png": 868145,
	"./map-tiles/gloomhaven/gh-a3a.png": 958400,
	"./map-tiles/gloomhaven/gh-a3b.png": 392935,
	"./map-tiles/gloomhaven/gh-a4a.png": 568101,
	"./map-tiles/gloomhaven/gh-a4b.png": 235562,
	"./map-tiles/gloomhaven/gh-b1a.png": 806250,
	"./map-tiles/gloomhaven/gh-b1b.png": 349175,
	"./map-tiles/gloomhaven/gh-b2a.png": 869497,
	"./map-tiles/gloomhaven/gh-b2b.png": 299689,
	"./map-tiles/gloomhaven/gh-b3a.png": 441739,
	"./map-tiles/gloomhaven/gh-b3b.png": 225651,
	"./map-tiles/gloomhaven/gh-b4a.png": 883658,
	"./map-tiles/gloomhaven/gh-b4b.png": 482107,
	"./map-tiles/gloomhaven/gh-c1a.png": 741872,
	"./map-tiles/gloomhaven/gh-c1b.png": 261226,
	"./map-tiles/gloomhaven/gh-c2a.png": 533888,
	"./map-tiles/gloomhaven/gh-c2b.png": 605038,
	"./map-tiles/gloomhaven/gh-d1a.png": 169960,
	"./map-tiles/gloomhaven/gh-d1b.png": 807183,
	"./map-tiles/gloomhaven/gh-d2a.png": 791200,
	"./map-tiles/gloomhaven/gh-d2b.png": 870925,
	"./map-tiles/gloomhaven/gh-e1a.png": 404371,
	"./map-tiles/gloomhaven/gh-e1b.png": 762256,
	"./map-tiles/gloomhaven/gh-f1a.png": 484293,
	"./map-tiles/gloomhaven/gh-f1b.png": 236326,
	"./map-tiles/gloomhaven/gh-g1a.png": 779160,
	"./map-tiles/gloomhaven/gh-g1b.png": 719775,
	"./map-tiles/gloomhaven/gh-g2a.png": 135997,
	"./map-tiles/gloomhaven/gh-g2b.png": 203982,
	"./map-tiles/gloomhaven/gh-h1a.png": 56102,
	"./map-tiles/gloomhaven/gh-h1b.png": 38982,
	"./map-tiles/gloomhaven/gh-h2a.png": 929429,
	"./map-tiles/gloomhaven/gh-h2b.png": 271706,
	"./map-tiles/gloomhaven/gh-h3a.png": 315654,
	"./map-tiles/gloomhaven/gh-h3b.png": 697058,
	"./map-tiles/gloomhaven/gh-i1a.png": 334735,
	"./map-tiles/gloomhaven/gh-i1b.png": 888184,
	"./map-tiles/gloomhaven/gh-i2a.png": 823504,
	"./map-tiles/gloomhaven/gh-i2b.png": 341322,
	"./map-tiles/gloomhaven/gh-j1a.png": 714556,
	"./map-tiles/gloomhaven/gh-j1b.png": 289206,
	"./map-tiles/gloomhaven/gh-j2a.png": 141262,
	"./map-tiles/gloomhaven/gh-j2b.png": 127659,
	"./map-tiles/gloomhaven/gh-k1a.png": 137902,
	"./map-tiles/gloomhaven/gh-k1b.png": 349481,
	"./map-tiles/gloomhaven/gh-k2a.png": 56457,
	"./map-tiles/gloomhaven/gh-k2b.png": 37071,
	"./map-tiles/gloomhaven/gh-l1a.png": 202658,
	"./map-tiles/gloomhaven/gh-l1b.png": 298297,
	"./map-tiles/gloomhaven/gh-l2a.png": 453620,
	"./map-tiles/gloomhaven/gh-l2b.png": 573291,
	"./map-tiles/gloomhaven/gh-l3a.png": 737340,
	"./map-tiles/gloomhaven/gh-l3b.png": 944652,
	"./map-tiles/gloomhaven/gh-m1a.png": 635293,
	"./map-tiles/gloomhaven/gh-m1b.png": 21952,
	"./map-tiles/gloomhaven/gh-n1a.png": 547845,
	"./map-tiles/gloomhaven/gh-n1b.png": 955100,
	"./milestone-ability-cards/ZZ/zz.txt": 169560,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-amber-aegis-back.png": 514502,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-amber-aegis.png": 524215,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-artificer-back.png": 99509,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-artificer.png": 996013,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-bombard-back.png": 64134,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-bombard.png": 949350,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-brightspark-back.png": 394604,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-brightspark.png": 212258,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-chainguard-back.png": 668432,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-chainguard.png": 605011,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-chieftain-back.png": 583411,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-chieftain.png": 291028,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-fire-knight-back.png": 106167,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-fire-knight.png": 786406,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-hierophant-back.png": 759778,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-hierophant.png": 106409,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-hollowpact-back.png": 926515,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-hollowpact.png": 75498,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-incarnate-back.png": 691126,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-incarnate.png": 961077,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-luminary-back.png": 697863,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-luminary.png": 338394,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-mirefoot-back.png": 523251,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-mirefoot.png": 203209,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-rimehearth-back.png": 15551,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-rimehearth.png": 894655,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-ruinmaw-back.png": 256137,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-ruinmaw.png": 575604,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-shardrender-back.png": 966092,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-shardrender.png": 13055,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-spirit-caller-back.png": 98505,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-spirit-caller.png": 753791,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-starslinger-back.png": 694595,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-starslinger.png": 282989,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-tempest-back.png": 365533,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-tempest.png": 139720,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-thornreaper-back.png": 293789,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-thornreaper.png": 810363,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-vanquisher-back.png": 754178,
	"./milestone-ability-cards/trail-of-ashes/toa-msa-vanquisher.png": 578534,
	"./milestones/crimson-scales/cs-ms-amber-aegis-back.png": 362133,
	"./milestones/crimson-scales/cs-ms-amber-aegis-front.png": 202596,
	"./milestones/crimson-scales/cs-ms-artificer-back.png": 493704,
	"./milestones/crimson-scales/cs-ms-artificer-front.png": 650369,
	"./milestones/crimson-scales/cs-ms-bombard-back.png": 461320,
	"./milestones/crimson-scales/cs-ms-bombard-front.png": 657493,
	"./milestones/crimson-scales/cs-ms-brightspark-back.png": 261845,
	"./milestones/crimson-scales/cs-ms-brightspark-front.png": 775717,
	"./milestones/crimson-scales/cs-ms-chainguard-back.png": 481178,
	"./milestones/crimson-scales/cs-ms-chainguard-front.png": 701803,
	"./milestones/crimson-scales/cs-ms-chieftain-back.png": 606055,
	"./milestones/crimson-scales/cs-ms-chieftain-front.png": 628260,
	"./milestones/crimson-scales/cs-ms-fire-knight-back.png": 148757,
	"./milestones/crimson-scales/cs-ms-fire-knight-front.png": 912626,
	"./milestones/crimson-scales/cs-ms-hierophant-back.png": 256397,
	"./milestones/crimson-scales/cs-ms-hierophant-front.png": 158993,
	"./milestones/crimson-scales/cs-ms-hollowpact-back.png": 879620,
	"./milestones/crimson-scales/cs-ms-hollowpact-front.png": 33367,
	"./milestones/crimson-scales/cs-ms-luminary-back.png": 476605,
	"./milestones/crimson-scales/cs-ms-luminary-front.png": 722894,
	"./milestones/crimson-scales/cs-ms-mirefoot-back.png": 884616,
	"./milestones/crimson-scales/cs-ms-mirefoot-front.png": 544376,
	"./milestones/crimson-scales/cs-ms-ruinmaw-back.png": 202563,
	"./milestones/crimson-scales/cs-ms-ruinmaw-front.png": 61171,
	"./milestones/crimson-scales/cs-ms-spirit-caller-back.png": 383042,
	"./milestones/crimson-scales/cs-ms-spirit-caller-front.png": 508701,
	"./milestones/crimson-scales/cs-ms-starslinger-back.png": 611597,
	"./milestones/crimson-scales/cs-ms-starslinger-front.png": 34158,
	"./milestones/trail-of-ashes/toa-ms-incarnate-back.png": 714665,
	"./milestones/trail-of-ashes/toa-ms-incarnate-front.png": 279724,
	"./milestones/trail-of-ashes/toa-ms-rimehearth-back.png": 332126,
	"./milestones/trail-of-ashes/toa-ms-rimehearth-front.png": 279140,
	"./milestones/trail-of-ashes/toa-ms-shardrender-back.png": 728319,
	"./milestones/trail-of-ashes/toa-ms-shardrender-front.png": 284469,
	"./milestones/trail-of-ashes/toa-ms-tempest-back.png": 297371,
	"./milestones/trail-of-ashes/toa-ms-tempest-front.png": 3212,
	"./milestones/trail-of-ashes/toa-ms-thornreaper-back.png": 73631,
	"./milestones/trail-of-ashes/toa-ms-thornreaper-front.png": 252481,
	"./milestones/trail-of-ashes/toa-ms-vanquisher-back.png": 622524,
	"./milestones/trail-of-ashes/toa-ms-vanquisher-front.png": 744518,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-1.png": 588571,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-2.png": 897533,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-3.png": 917523,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-4.png": 972028,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-5.png": 744738,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-6.png": 25697,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-7.png": 855971,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-8.png": 830696,
	"./monster-ability-cards/crimson-scales/blood-ooze/cs-ma-blood-ooze-back.png": 292327,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-1.png": 342232,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-2.png": 656757,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-3.png": 334597,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-4.png": 954038,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-5.png": 853404,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-6.png": 636937,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-7.png": 776094,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-8.png": 645511,
	"./monster-ability-cards/crimson-scales/flaming-drake/cs-ma-flaming-drake-back.png": 333820,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-1.png": 471483,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-2.png": 470331,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-3.png": 855010,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-4.png": 987683,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-5.png": 206883,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-6.png": 344901,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-7.png": 717070,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-8.png": 862827,
	"./monster-ability-cards/crimson-scales/frozen-cadaver/cs-ma-frozen-cadaver-back.png": 643261,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-1.png": 961238,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-2.png": 950174,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-3.png": 556610,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-4.png": 164967,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-5.png": 9910,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-6.png": 16337,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-7.png": 20350,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-8.png": 620181,
	"./monster-ability-cards/crimson-scales/gnashing-drake/cs-ma-gnashing-drake-back.png": 607566,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-1.png": 553218,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-2.png": 154842,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-3.png": 352286,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-4.png": 443983,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-5.png": 244484,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-6.png": 652504,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-7.png": 683472,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-8.png": 836025,
	"./monster-ability-cards/crimson-scales/hail-demon/cs-ma-hail-demon-back.png": 330258,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-1.png": 989237,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-2.png": 659902,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-3.png": 498069,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-4.png": 8067,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-5.png": 62073,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-6.png": 379220,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-7.png": 555714,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-8.png": 982514,
	"./monster-ability-cards/crimson-scales/harrower-aegis/cs-ma-harrower-aegis-back.png": 472030,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-1.png": 140423,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-2.png": 158648,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-3.png": 699459,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-4.png": 553814,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-5.png": 290949,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-6.png": 351237,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-7.png": 886069,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-8.png": 966838,
	"./monster-ability-cards/crimson-scales/harrower-icecrawlers/cs-ma-harrower-icecrawlers-back.png": 653723,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-1.png": 808853,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-2.png": 153039,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-3.png": 353327,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-4.png": 364354,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-5.png": 554665,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-6.png": 76078,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-7.png": 3471,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-8.png": 300926,
	"./monster-ability-cards/crimson-scales/ravenous-gharial/cs-ma-ravenous-gharial-back.png": 366670,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-1.png": 143986,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-2.png": 242406,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-3.png": 532630,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-4.png": 501063,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-5.png": 214870,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-6.png": 348203,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-7.png": 177131,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-8.png": 574457,
	"./monster-ability-cards/crimson-scales/toxic-imp/cs-ma-toxic-imp-back.png": 689606,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-1.png": 844822,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-2.png": 952138,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-3.png": 685055,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-4.png": 492460,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-5.png": 924959,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-6.png": 505977,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-7.png": 934843,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-8.png": 277782,
	"./monster-ability-cards/crimson-scales/water-spirit/cs-ma-water-spirit-back.png": 6107,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-1.png": 717646,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-2.png": 112609,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-3.png": 169598,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-4.png": 267870,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-5.png": 68905,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-6.png": 136108,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-7.png": 411909,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-8.png": 795967,
	"./monster-ability-cards/forgotten-circles/ashblade/fc-ma-ab-back.png": 596928,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-blistering-heat.png": 729617,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-corrupting-presence.png": 538727,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-endless-legions.png": 339208,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-flame-lance.png": 714148,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-harsh-entrapment.png": 204995,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-heed-my-call.png": 127785,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-legendary-domination.png": 509018,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-legendary-gloom.png": 760570,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-legendary-shadows.png": 471519,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-legendary-void.png": 666703,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-lure-them-in.png": 488336,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-marked-for-death.png": 829158,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-mc-back.png": 862483,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-nightmare-spheres.png": 590365,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-plague-their-dreams.png": 939606,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-pulse-of-malice.png": 930950,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-searing-vapors.png": 976227,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-toxic-blast.png": 469126,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-unfathomable-fortitude.png": 538028,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-whats-yours-is-mine.png": 867313,
	"./monster-ability-cards/forgotten-circles/manifestation-of-corruption/fc-you-dare-to-defy-me.png": 311982,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-1.png": 619115,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-2.png": 265929,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-3.png": 38767,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-4.png": 91765,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-5.png": 63252,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-6.png": 512680,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-7.png": 710693,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-8.png": 230430,
	"./monster-ability-cards/forgotten-circles/savage/fc-ma-sv-back.png": 578883,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-1.png": 949131,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-2.png": 494746,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-3.png": 711900,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-4.png": 253437,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-5.png": 93901,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-6.png": 302634,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-7.png": 204758,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-8.png": 788919,
	"./monster-ability-cards/forgotten-circles/tracker/fc-ma-tr-back.png": 924810,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-1.png": 819735,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-2.png": 271901,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-3.png": 647099,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-4.png": 393591,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-5.png": 456162,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-6.png": 968785,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-7.png": 384442,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-8.png": 205523,
	"./monster-ability-cards/frosthaven/abael-herder/fh-ma-ah-back.png": 497990,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-1.png": 514572,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-2.png": 325097,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-3.png": 124623,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-4.png": 753456,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-5.png": 380265,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-6.png": 15770,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-7.png": 923904,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-8.png": 838292,
	"./monster-ability-cards/frosthaven/algox-icespeaker/fh-ma-ai-back.png": 84757,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-1.png": 58543,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-2.png": 436992,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-3.png": 797948,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-4.png": 19813,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-5.png": 60505,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-6.png": 167978,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-7.png": 480426,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-8.png": 300968,
	"./monster-ability-cards/frosthaven/algox-snowspeaker/fh-ma-as-back.png": 786492,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-1.png": 78240,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-2.png": 772169,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-3.png": 784607,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-4.png": 125070,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-5.png": 701545,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-6.png": 573453,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-7.png": 659034,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-8.png": 784422,
	"./monster-ability-cards/frosthaven/ancient-artillery/fh-ma-aa-back.png": 855035,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-1.png": 860333,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-2.png": 573961,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-3.png": 179255,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-4.png": 278968,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-5.png": 650972,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-6.png": 878373,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-7.png": 858169,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-8.png": 245545,
	"./monster-ability-cards/frosthaven/archer/fh-ma-ar-back.png": 560399,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-1.png": 361475,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-2.png": 184958,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-3.png": 89576,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-4.png": 669640,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-5.png": 81941,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-6.png": 740318,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-7.png": 488320,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-8.png": 562641,
	"./monster-ability-cards/frosthaven/boss/fh-ma-bo-back.png": 291098,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-1.png": 21050,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-2.png": 951395,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-3.png": 128857,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-4.png": 586344,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-5.png": 13415,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-6.png": 356568,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-7.png": 41393,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-8.png": 383377,
	"./monster-ability-cards/frosthaven/burrowing-blade/fh-ma-bb-back.png": 496219,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-1.png": 999233,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-2.png": 171830,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-3.png": 890700,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-4.png": 836534,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-5.png": 339548,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-6.png": 190304,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-7.png": 133121,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-8.png": 680699,
	"./monster-ability-cards/frosthaven/chaos-demon/fh-ma-cd-back.png": 720180,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-1.png": 148818,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-2.png": 875432,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-3.png": 358232,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-4.png": 644974,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-5.png": 573626,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-6.png": 891617,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-7.png": 927011,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-8.png": 352432,
	"./monster-ability-cards/frosthaven/deep-terror/fh-ma-dt-back.png": 451484,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-1.png": 362440,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-2.png": 192226,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-3.png": 987965,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-4.png": 334459,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-5.png": 326065,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-6.png": 650477,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-7.png": 556628,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-8.png": 304528,
	"./monster-ability-cards/frosthaven/earth-demon/fh-ma-ed-back.png": 336098,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-1.png": 666398,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-2.png": 668625,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-3.png": 337378,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-4.png": 423316,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-5.png": 671955,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-6.png": 865403,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-7.png": 401027,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-8.png": 950160,
	"./monster-ability-cards/frosthaven/flame-demon/fh-ma-fld-back.png": 358061,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-1.png": 916884,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-2.png": 442211,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-3.png": 836861,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-4.png": 658309,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-5.png": 160359,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-6.png": 344275,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-7.png": 764920,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-8.png": 31365,
	"./monster-ability-cards/frosthaven/flaming-bladespinner/fh-ma-fbs-back.png": 738113,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-1.png": 836609,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-2.png": 500301,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-3.png": 956971,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-4.png": 654407,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-5.png": 124669,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-6.png": 740395,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-7.png": 259357,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-8.png": 664251,
	"./monster-ability-cards/frosthaven/frost-demon/fh-ma-frd-back.png": 38636,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-1.png": 401962,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-2.png": 181730,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-3.png": 973091,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-4.png": 418060,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-5.png": 126288,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-6.png": 704851,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-7.png": 138476,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-8.png": 180093,
	"./monster-ability-cards/frosthaven/frozen-corpse/fh-ma-fc-back.png": 8223,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-1.png": 466741,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-2.png": 919015,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-3.png": 153651,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-4.png": 862636,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-5.png": 409637,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-6.png": 189345,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-7.png": 809144,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-8.png": 836174,
	"./monster-ability-cards/frosthaven/guard/fh-ma-gu-back.png": 372337,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-1.png": 116876,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-2.png": 351342,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-3.png": 329304,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-4.png": 502753,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-5.png": 917072,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-6.png": 914986,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-7.png": 992157,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-8.png": 129631,
	"./monster-ability-cards/frosthaven/harrower-infester/fh-ma-hi-back.png": 529691,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-1.png": 755666,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-2.png": 936428,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-3.png": 483307,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-4.png": 973749,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-5.png": 75990,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-6.png": 901867,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-7.png": 114044,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-8.png": 508999,
	"./monster-ability-cards/frosthaven/hound/fh-ma-ho-back.png": 370382,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-1.png": 296085,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-2.png": 779292,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-3.png": 71123,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-4.png": 596863,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-5.png": 686482,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-6.png": 428352,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-7.png": 665495,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-8.png": 652376,
	"./monster-ability-cards/frosthaven/ice-wraith/fh-ma-iw-back.png": 219918,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-1.png": 386762,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-2.png": 222773,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-3.png": 803751,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-4.png": 604591,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-5.png": 506802,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-6.png": 17646,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-7.png": 606807,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-8.png": 220004,
	"./monster-ability-cards/frosthaven/imp/fh-ma-im-back.png": 124202,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-1.png": 164561,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-2.png": 701538,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-3.png": 393460,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-4.png": 834981,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-5.png": 268380,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-6.png": 180879,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-7.png": 756767,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-8.png": 17345,
	"./monster-ability-cards/frosthaven/lightning-eel/fh-ma-le-back.png": 452788,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-1.png": 712425,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-2.png": 657831,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-3.png": 844827,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-4.png": 562114,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-5.png": 743234,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-6.png": 161526,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-7.png": 249137,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-8.png": 67049,
	"./monster-ability-cards/frosthaven/living-bones/fh-ma-lb-back.png": 231857,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-1.png": 318187,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-2.png": 741937,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-3.png": 659463,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-4.png": 707587,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-5.png": 212913,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-6.png": 506475,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-7.png": 592597,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-8.png": 635317,
	"./monster-ability-cards/frosthaven/living-doom/fh-ma-ld-back.png": 680901,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-1.png": 512525,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-2.png": 798993,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-3.png": 382596,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-4.png": 151232,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-5.png": 692741,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-6.png": 437104,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-7.png": 4775,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-8.png": 711992,
	"./monster-ability-cards/frosthaven/living-spirit/fh-ma-ls-back.png": 876875,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-1.png": 397865,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-2.png": 920014,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-3.png": 853733,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-4.png": 752163,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-5.png": 594969,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-6.png": 801163,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-7.png": 842725,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-8.png": 135213,
	"./monster-ability-cards/frosthaven/lurker-clawcrusher/fh-ma-luc-back.png": 207694,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-1.png": 433039,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-2.png": 758347,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-3.png": 266142,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-4.png": 86461,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-5.png": 882890,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-6.png": 342466,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-7.png": 577339,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-8.png": 844053,
	"./monster-ability-cards/frosthaven/lurker-mindsnipper/fh-ma-lum-back.png": 672308,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-1.png": 252693,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-2.png": 944969,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-3.png": 904350,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-4.png": 54743,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-5.png": 594300,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-6.png": 949303,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-7.png": 487133,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-8.png": 303236,
	"./monster-ability-cards/frosthaven/lurker-soldier/fh-ma-lus-back.png": 963138,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-1.png": 285302,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-2.png": 399429,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-3.png": 588309,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-4.png": 404916,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-5.png": 909287,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-6.png": 56522,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-7.png": 687857,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-8.png": 854338,
	"./monster-ability-cards/frosthaven/lurker-wavethrower/fh-ma-luw-back.png": 51579,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-1.png": 802416,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-2.png": 632152,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-3.png": 832253,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-4.png": 514889,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-5.png": 776003,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-6.png": 297626,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-7.png": 781226,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-8.png": 611406,
	"./monster-ability-cards/frosthaven/night-demon/fh-ma-nd-back.png": 765706,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-1.png": 947573,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-2.png": 886695,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-3.png": 562602,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-4.png": 310685,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-5.png": 250731,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-6.png": 59701,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-7.png": 444440,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-8.png": 541740,
	"./monster-ability-cards/frosthaven/ooze/fh-ma-oo-back.png": 347201,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-1.png": 319711,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-2.png": 182120,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-3.png": 230444,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-4.png": 150,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-5.png": 408756,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-6.png": 939928,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-7.png": 473294,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-8.png": 26887,
	"./monster-ability-cards/frosthaven/piranha-pig/fh-ma-pp-back.png": 815467,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-1.png": 216149,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-2.png": 189937,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-3.png": 570197,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-4.png": 755759,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-5.png": 863543,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-6.png": 846984,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-7.png": 250699,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-8.png": 725398,
	"./monster-ability-cards/frosthaven/polar-bear/fh-ma-pb-back.png": 573116,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-1.png": 214443,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-2.png": 134863,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-3.png": 706853,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-4.png": 519824,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-5.png": 21939,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-6.png": 593822,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-7.png": 714979,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-8.png": 406436,
	"./monster-ability-cards/frosthaven/priest/fh-ma-pr-back.png": 92681,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-1.png": 601314,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-2.png": 145335,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-3.png": 757508,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-4.png": 921418,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-5.png": 503985,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-6.png": 710701,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-7.png": 537291,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-8.png": 824621,
	"./monster-ability-cards/frosthaven/rending-drake/fh-ma-rd-back.png": 476470,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-1.png": 220563,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-2.png": 276456,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-3.png": 137820,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-4.png": 927335,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-5.png": 796781,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-6.png": 367397,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-7.png": 712217,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-8.png": 951975,
	"./monster-ability-cards/frosthaven/robotic-boltshooter/fh-ma-rb-back.png": 798625,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-1.png": 254126,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-2.png": 528837,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-3.png": 889587,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-4.png": 393892,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-5.png": 632261,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-6.png": 586675,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-7.png": 337776,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-8.png": 862016,
	"./monster-ability-cards/frosthaven/ruined-machine/fh-ma-rm-back.png": 711275,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-1.png": 120169,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-2.png": 338322,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-3.png": 825649,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-4.png": 714135,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-5.png": 899656,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-6.png": 379925,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-7.png": 598712,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-8.png": 267311,
	"./monster-ability-cards/frosthaven/savvas-icestorm/fh-ma-si-back.png": 977898,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-1.png": 202870,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-2.png": 284552,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-3.png": 583819,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-4.png": 30289,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-5.png": 127622,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-6.png": 177682,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-7.png": 698357,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-8.png": 523781,
	"./monster-ability-cards/frosthaven/savvas-lavaflow/fh-ma-sl-back.png": 78116,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-1.png": 386933,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-2.png": 62070,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-3.png": 95513,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-4.png": 748329,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-5.png": 425267,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-6.png": 289015,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-7.png": 757303,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-8.png": 581106,
	"./monster-ability-cards/frosthaven/scout/fh-ma-sc-back.png": 762737,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-1.png": 866882,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-2.png": 409567,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-3.png": 27384,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-4.png": 472910,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-5.png": 319075,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-6.png": 254556,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-7.png": 823091,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-8.png": 121681,
	"./monster-ability-cards/frosthaven/shrike-fiend/fh-ma-sf-back.png": 142750,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-1.png": 714677,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-2.png": 914827,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-3.png": 455658,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-4.png": 824311,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-5.png": 826677,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-6.png": 381925,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-7.png": 272304,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-8.png": 936765,
	"./monster-ability-cards/frosthaven/spitting-drake/fh-ma-spd-back.png": 138481,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-1.png": 244029,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-2.png": 359107,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-3.png": 801499,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-4.png": 476814,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-5.png": 301520,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-6.png": 578688,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-7.png": 19994,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-8.png": 125825,
	"./monster-ability-cards/frosthaven/steel-automaton/fh-ma-sa-back.png": 222879,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-1.png": 173325,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-2.png": 103641,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-3.png": 346401,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-4.png": 390996,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-5.png": 103242,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-6.png": 442037,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-7.png": 459996,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-8.png": 275755,
	"./monster-ability-cards/frosthaven/sun-demon/fh-ma-sud-back.png": 698712,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-1.png": 138774,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-2.png": 467910,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-3.png": 236155,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-4.png": 115283,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-5.png": 490444,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-6.png": 302380,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-7.png": 813846,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-8.png": 492740,
	"./monster-ability-cards/frosthaven/wind-demon/fh-ma-wd-back.png": 45522,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-1.png": 506663,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-2.png": 932233,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-3.png": 211736,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-4.png": 931390,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-5.png": 268446,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-6.png": 263203,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-7.png": 398033,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-8.png": 882421,
	"./monster-ability-cards/gloomhaven/ancient-artillery/gh-ma-aa-back.png": 551891,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-1.png": 419007,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-2.png": 638158,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-3.png": 172053,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-4.png": 791172,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-5.png": 260002,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-6.png": 910018,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-7.png": 367013,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-8.png": 93563,
	"./monster-ability-cards/gloomhaven/archer/gh-ma-ar-back.png": 515696,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-1.png": 557464,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-2.png": 307110,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-3.png": 572733,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-4.png": 140773,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-5.png": 496461,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-6.png": 181237,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-7.png": 162012,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-8.png": 815069,
	"./monster-ability-cards/gloomhaven/boss/gh-ma-bo-back.png": 758645,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-1.png": 151261,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-2.png": 942022,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-3.png": 721954,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-4.png": 760616,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-5.png": 222944,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-6.png": 685291,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-7.png": 401009,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-8.png": 614985,
	"./monster-ability-cards/gloomhaven/cave-bear/gh-ma-cb-back.png": 711584,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-1.png": 859581,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-2.png": 110274,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-3.png": 360048,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-4.png": 749426,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-5.png": 25010,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-6.png": 43760,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-7.png": 825937,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-8.png": 271944,
	"./monster-ability-cards/gloomhaven/cultist/gh-ma-cu-back.png": 915268,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-1.png": 610357,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-2.png": 696380,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-3.png": 804907,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-4.png": 654534,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-5.png": 980725,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-6.png": 954651,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-7.png": 101616,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-8.png": 26011,
	"./monster-ability-cards/gloomhaven/deep-terror/gh-ma-dt-back.png": 430672,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-1.png": 290146,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-2.png": 579136,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-3.png": 821883,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-4.png": 207643,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-5.png": 34428,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-6.png": 208430,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-7.png": 34194,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-8.png": 148138,
	"./monster-ability-cards/gloomhaven/earth-demon/gh-ma-ed-back.png": 235628,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-1.png": 576822,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-2.png": 490790,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-3.png": 897629,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-4.png": 23267,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-5.png": 176993,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-6.png": 496783,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-7.png": 944203,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-8.png": 461611,
	"./monster-ability-cards/gloomhaven/flame-demon/gh-ma-fld-back.png": 603572,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-1.png": 667574,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-2.png": 208526,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-3.png": 998940,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-4.png": 160003,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-5.png": 65821,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-6.png": 999101,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-7.png": 112981,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-8.png": 868166,
	"./monster-ability-cards/gloomhaven/frost-demon/gh-ma-frd-back.png": 842797,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-1.png": 240667,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-2.png": 667672,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-3.png": 240362,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-4.png": 842941,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-5.png": 924731,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-6.png": 785621,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-7.png": 424139,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-8.png": 213013,
	"./monster-ability-cards/gloomhaven/giant-viper/gh-ma-gv-back.png": 34242,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-1.png": 557619,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-2.png": 690586,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-3.png": 783247,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-4.png": 580480,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-5.png": 362339,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-6.png": 763942,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-7.png": 476174,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-8.png": 448142,
	"./monster-ability-cards/gloomhaven/guard/gh-ma-gu-back.png": 545351,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-1.png": 54527,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-2.png": 856585,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-3.png": 364215,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-4.png": 14373,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-5.png": 865569,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-6.png": 25294,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-7.png": 577802,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-8.png": 747376,
	"./monster-ability-cards/gloomhaven/harrower-infester/gh-ma-hi-back.png": 268178,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-1.png": 328815,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-2.png": 351261,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-3.png": 504884,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-4.png": 678161,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-5.png": 942966,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-6.png": 454102,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-7.png": 868428,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-8.png": 655962,
	"./monster-ability-cards/gloomhaven/hound/gh-ma-ho-back.png": 145272,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-1.png": 829999,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-2.png": 500762,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-3.png": 959269,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-4.png": 309252,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-5.png": 951190,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-6.png": 444350,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-7.png": 683987,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-8.png": 543881,
	"./monster-ability-cards/gloomhaven/imp/gh-ma-im-back.png": 406259,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-1.png": 340682,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-2.png": 336708,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-3.png": 726417,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-4.png": 109381,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-5.png": 804746,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-6.png": 886051,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-7.png": 646381,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-8.png": 525855,
	"./monster-ability-cards/gloomhaven/living-bones/gh-ma-lb-back.png": 308376,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-1.png": 363892,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-2.png": 295879,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-3.png": 644964,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-4.png": 420667,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-5.png": 691119,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-6.png": 601016,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-7.png": 855059,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-8.png": 261956,
	"./monster-ability-cards/gloomhaven/living-corpse/gh-ma-lc-back.png": 845925,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-1.png": 256324,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-2.png": 193647,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-3.png": 70756,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-4.png": 141310,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-5.png": 389476,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-6.png": 962910,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-7.png": 910296,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-8.png": 179769,
	"./monster-ability-cards/gloomhaven/living-spirit/gh-ma-ls-back.png": 239848,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-1.png": 167531,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-2.png": 616801,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-3.png": 569994,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-4.png": 958352,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-5.png": 335843,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-6.png": 746623,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-7.png": 770482,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-8.png": 691112,
	"./monster-ability-cards/gloomhaven/lurker/gh-ma-lu-back.png": 671047,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-1.png": 763796,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-2.png": 879939,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-3.png": 625276,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-4.png": 895846,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-5.png": 185184,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-6.png": 454840,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-7.png": 814413,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-8.png": 946177,
	"./monster-ability-cards/gloomhaven/night-demon/gh-ma-nd-back.png": 592982,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-1.png": 179570,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-2.png": 979779,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-3.png": 681668,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-4.png": 672581,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-5.png": 639719,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-6.png": 21993,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-7.png": 538509,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-8.png": 98969,
	"./monster-ability-cards/gloomhaven/ooze/gh-ma-oo-back.png": 352060,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-1.png": 68582,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-2.png": 72268,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-3.png": 270530,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-4.png": 956417,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-5.png": 609018,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-6.png": 483370,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-7.png": 496610,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-8.png": 849624,
	"./monster-ability-cards/gloomhaven/rending-drake/gh-ma-rd-back.png": 191622,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-1.png": 798616,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-2.png": 338734,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-3.png": 589280,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-4.png": 392270,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-5.png": 643546,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-6.png": 418666,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-7.png": 728827,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-8.png": 578699,
	"./monster-ability-cards/gloomhaven/savvas-icestorm/gh-ma-si-back.png": 136868,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-1.png": 242264,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-2.png": 246563,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-3.png": 76473,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-4.png": 892178,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-5.png": 844539,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-6.png": 369829,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-7.png": 922980,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-8.png": 802672,
	"./monster-ability-cards/gloomhaven/savvas-lavaflow/gh-ma-sl-back.png": 404511,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-1.png": 110737,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-2.png": 956521,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-3.png": 503127,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-4.png": 838733,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-5.png": 926164,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-6.png": 534731,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-7.png": 817916,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-8.png": 831783,
	"./monster-ability-cards/gloomhaven/scout/gh-ma-sc-back.png": 284216,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-1.png": 30009,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-2.png": 174993,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-3.png": 752709,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-4.png": 182375,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-5.png": 344248,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-6.png": 698727,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-7.png": 711320,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-8.png": 673878,
	"./monster-ability-cards/gloomhaven/shaman/gh-ma-sh-back.png": 496375,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-1.png": 580839,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-2.png": 624653,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-3.png": 553570,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-4.png": 24639,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-5.png": 635110,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-6.png": 582509,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-7.png": 449199,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-8.png": 488604,
	"./monster-ability-cards/gloomhaven/spitting-drake/gh-ma-spd-back.png": 76144,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-1.png": 859903,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-2.png": 540157,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-3.png": 208071,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-4.png": 577766,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-5.png": 639208,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-6.png": 594949,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-7.png": 835491,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-8.png": 310359,
	"./monster-ability-cards/gloomhaven/stone-golem/gh-ma-sg-back.png": 838009,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-1.png": 556835,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-2.png": 43955,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-3.png": 473363,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-4.png": 403831,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-5.png": 339537,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-6.png": 873860,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-7.png": 159182,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-8.png": 404039,
	"./monster-ability-cards/gloomhaven/sun-demon/gh-ma-sud-back.png": 1099,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-1.png": 256311,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-2.png": 195874,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-3.png": 939124,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-4.png": 681924,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-5.png": 187764,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-6.png": 427191,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-7.png": 8243,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-8.png": 626438,
	"./monster-ability-cards/gloomhaven/wind-demon/gh-ma-wd-back.png": 427601,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-black-hex.png": 546197,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-black-sludge-back.png": 300854,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-calculated-strike.png": 920737,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-feed.png": 203573,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-hasty-assault.png": 61462,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-1.png": 407911,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-2.png": 351002,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-3.png": 329314,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-4.png": 67874,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-5.png": 683802,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-6.png": 537081,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-7.png": 151303,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-8.png": 415578,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-ma-bs-back.png": 35237,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-nothing-special.png": 543368,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-plasma-ward.png": 751528,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-sceptic-hex.png": 646639,
	"./monster-ability-cards/jaws-of-the-lion/black-sludge/jl-toxic-explosion.png": 633942,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-accelerated-power-1.png": 264220,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-accelerated-power-2.png": 298850,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-accelerated-power-3.png": 950069,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-boss-back.png": 105050,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-lingering-strength-1.png": 222524,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-lingering-strength-2.png": 105966,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-lingering-strength-3.png": 571215,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-1.png": 926938,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-2.png": 164927,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-3.png": 644481,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-4.png": 240441,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-5.png": 837090,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-6.png": 64442,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-7.png": 581099,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-8.png": 363294,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-ma-bo-back.png": 312249,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-nothing-special.png": 29605,
	"./monster-ability-cards/jaws-of-the-lion/boss/jl-twin-missiles.png": 561705,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-black-tendrils.png": 123696,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-chaos-demon-back.png": 465606,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-chilling-breath.png": 86589,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-flashing-claws.png": 279971,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-heat-blast.png": 861565,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-hungry-maw.png": 323456,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-1.png": 581621,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-2.png": 763701,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-3.png": 19870,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-4.png": 54608,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-5.png": 589958,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-6.png": 363445,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-7.png": 787809,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-8.png": 151025,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-ma-cd-back.png": 515597,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-mana-explosion.png": 72867,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-seismic-punch.png": 882232,
	"./monster-ability-cards/jaws-of-the-lion/chaos-demon/jl-whirlwind.png": 697776,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-basic-constrict.png": 64371,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-basic-find-cover.png": 188084,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-basic-giant-viper-back.png": 477837,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-basic-swift-fangs.png": 535978,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-basic-toxic-frenzy.png": 790330,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-calculated-strike.png": 335160,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-constrict.png": 12108,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-defensive-strike.png": 963946,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-find-cover.png": 360080,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-giant-viper-back.png": 414386,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-bgv-1.png": 93549,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-bgv-2.png": 497987,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-bgv-3.png": 67877,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-bgv-4.png": 513758,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-bgv-back.png": 255137,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-1.png": 516457,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-2.png": 545902,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-3.png": 597899,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-4.png": 452557,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-5.png": 788790,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-6.png": 586438,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-7.png": 795337,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-8.png": 671904,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-ma-gv-back.png": 109894,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-surround-1.png": 819280,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-surround-2.png": 155973,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-swift-fangs.png": 296939,
	"./monster-ability-cards/jaws-of-the-lion/giant-viper/jl-toxic-frenzy.png": 370636,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-calculated-strike.png": 858978,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-cripple.png": 580545,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-dark-charm.png": 517379,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-imp-back.png": 530992,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-1.png": 728675,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-2.png": 695899,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-3.png": 678482,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-4.png": 39565,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-5.png": 82340,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-6.png": 401139,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-7.png": 98770,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-8.png": 488738,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-ma-im-back.png": 163417,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-nothing-special-1.png": 193079,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-nothing-special-2.png": 255327,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-phase-out.png": 963707,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-restoration.png": 966287,
	"./monster-ability-cards/jaws-of-the-lion/imp/jl-tip-the-scales.png": 669799,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-calculated-strike.png": 474315,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-hasty-assault.png": 114607,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-living-corpse-back.png": 856685,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-1.png": 199894,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-2.png": 56920,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-3.png": 955679,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-4.png": 96495,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-5.png": 622098,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-6.png": 746030,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-7.png": 685544,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-8.png": 822683,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-ma-lc-back.png": 221206,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-nothing-special-1.png": 708471,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-nothing-special-2.png": 542733,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-reckless-charge.png": 209191,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-release-gas.png": 215954,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-rotting-embrace.png": 586550,
	"./monster-ability-cards/jaws-of-the-lion/living-corpse/jl-violent-slam.png": 429042,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-angry-howl.png": 700729,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-booming-scream.png": 262645,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-coupled-chain.png": 366475,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-icy-glare.png": 759568,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-leech-warmth.png": 846041,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-living-spirit-back.png": 267101,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-1.png": 550150,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-2.png": 658850,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-3.png": 788393,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-4.png": 272452,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-5.png": 811767,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-6.png": 456957,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-7.png": 127755,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-8.png": 391735,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-ma-ls-back.png": 70947,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-nothing-special-1.png": 835799,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-nothing-special-2.png": 75579,
	"./monster-ability-cards/jaws-of-the-lion/living-spirit/jl-sap-strength.png": 678995,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-calculated-strike.png": 859354,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-explosive-blisters.png": 95370,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-1.png": 234838,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-2.png": 945614,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-3.png": 196808,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-4.png": 477592,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-5.png": 795835,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-6.png": 248796,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-7.png": 814209,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-8.png": 243359,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-ma-ms-back.png": 117100,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-monstrosity-back.png": 567536,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-nothing-special.png": 773578,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-swarm-1.png": 43023,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-swarm-2.png": 492946,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-unstable-frenzy.png": 759690,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-unstable-scratch.png": 576978,
	"./monster-ability-cards/jaws-of-the-lion/monstrosity/jl-weakening-bite.png": 252094,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-calculated-strike.png": 827563,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ground-pound.png": 799377,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-hasty-assault.png": 752538,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-1.png": 584473,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-2.png": 111314,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-3.png": 734094,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-4.png": 694000,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-5.png": 784622,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-6.png": 851703,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-7.png": 527228,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-8.png": 270857,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-ma-sg-back.png": 131751,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-nothing-special.png": 445352,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-runic-draw.png": 286522,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-runic-feedback.png": 917792,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-sacrificial-hurl.png": 246810,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-stone-golem-back.png": 704496,
	"./monster-ability-cards/jaws-of-the-lion/stone-golem/jl-taxing-advance.png": 596598,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-basic-careful-throw.png": 51060,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-basic-dual-daggers.png": 921606,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-basic-nothing-special.png": 730217,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-basic-screaming-shot.png": 233862,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-basic-vermling-raider-back.png": 846094,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-careful-throw.png": 238453,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-dual-daggers.png": 883028,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-bvr-1.png": 151946,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-bvr-2.png": 745,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-bvr-3.png": 227180,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-bvr-4.png": 458055,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-bvr-back.png": 365622,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-1.png": 927533,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-2.png": 893546,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-3.png": 223272,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-4.png": 486470,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-5.png": 288173,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-6.png": 940910,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-7.png": 544441,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-8.png": 713262,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-ma-vr-back.png": 732352,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-nothing-special.png": 574380,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-parry.png": 548857,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-patch-wounds.png": 552970,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-screaming-shot.png": 106331,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-spiked-pit.png": 734230,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-vermling-raider-back.png": 677974,
	"./monster-ability-cards/jaws-of-the-lion/vermling-raider/jl-vicious-spear.png": 513542,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-calculated-strike.png": 255290,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-greed.png": 95588,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-hasty-assault.png": 746358,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-1.png": 886369,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-2.png": 362454,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-3.png": 325603,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-4.png": 419707,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-5.png": 945173,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-6.png": 945888,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-7.png": 722957,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-8.png": 156519,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-ma-vs-back.png": 821075,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-nothing-special.png": 464505,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-noxious-blade.png": 243155,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-rancid-arrow.png": 39062,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-rapid-bolts.png": 721926,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-short-bow.png": 116449,
	"./monster-ability-cards/jaws-of-the-lion/vermling-scout/jl-vermling-scout-back.png": 245549,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-basic-boil-blood.png": 257981,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-basic-drain-life.png": 947872,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-basic-hex-whip.png": 404578,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-basic-vile-scourge.png": 985436,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-basic-zealot-back.png": 498636,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-boil-blood.png": 497951,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-calculated-strike.png": 295512,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-drain-life.png": 760764,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-hasty-assault.png": 964959,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-hex-whip.png": 28653,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-bzl-1.png": 434458,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-bzl-2.png": 229795,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-bzl-3.png": 748068,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-bzl-4.png": 111242,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-bzl-back.png": 815217,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-1.png": 855351,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-2.png": 528267,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-3.png": 116843,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-4.png": 459475,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-5.png": 595903,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-6.png": 772672,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-7.png": 356030,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-8.png": 963376,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-ma-zl-back.png": 453628,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-nothing-special.png": 657675,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-unholy-flame.png": 398280,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-vile-scourge.png": 866811,
	"./monster-ability-cards/jaws-of-the-lion/zealot/jl-zealot-back.png": 448554,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-abandoned-fury.png": 114852,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-aggressive-defense.png": 79583,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-deafening-roar.png": 350086,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-enraged-destruction.png": 560649,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-ev-back.png": 751652,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-merciless-resolve.png": 245408,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-reaching-malice.png": 405928,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-share-our-anguish.png": 644370,
	"./monster-ability-cards/trail-of-ashes/enraged-vanquisher/toa-wild-leap.png": 856041,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-1.png": 946698,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-2.png": 132336,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-3.png": 581145,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-4.png": 978657,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-5.png": 131115,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-6.png": 434967,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-7.png": 808181,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-8.png": 795254,
	"./monster-ability-cards/trail-of-ashes/scavenger/toa-ma-scavenger-back.png": 114272,
	"./monster-ability-cards/trail-of-ashes/shardrender/toa-ma-shardrender-1.png": 600645,
	"./monster-ability-cards/trail-of-ashes/shardrender/toa-ma-shardrender-2.png": 214840,
	"./monster-ability-cards/trail-of-ashes/shardrender/toa-ma-shardrender-3.png": 568997,
	"./monster-ability-cards/trail-of-ashes/shardrender/toa-ma-shardrender-4.png": 197728,
	"./monster-ability-cards/trail-of-ashes/shardrender/toa-ma-shardrender-5.png": 571174,
	"./monster-ability-cards/trail-of-ashes/shardrender/toa-ma-shardrender-6.png": 765944,
	"./monster-ability-cards/trail-of-ashes/shardrender/toa-ma-shardrender-back.png": 337998,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-1.png": 234765,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-2.png": 423110,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-3.png": 447510,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-4.png": 885062,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-5.png": 821607,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-6.png": 494177,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-7.png": 644062,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-8.png": 488848,
	"./monster-ability-cards/trail-of-ashes/smoke-spirit/toa-ma-smoke-spirit-back.png": 910022,
	"./monster-ability-cards/trail-of-ashes/talo/toa-ma-talo-1.png": 207637,
	"./monster-ability-cards/trail-of-ashes/talo/toa-ma-talo-2.png": 148718,
	"./monster-ability-cards/trail-of-ashes/talo/toa-ma-talo-3.png": 58080,
	"./monster-ability-cards/trail-of-ashes/talo/toa-ma-talo-4.png": 567425,
	"./monster-ability-cards/trail-of-ashes/talo/toa-ma-talo-back.png": 233380,
	"./monster-ability-cards/trail-of-ashes/valrath-vanquisher/toa-ma-valrath-vanquisher-1.png": 366797,
	"./monster-ability-cards/trail-of-ashes/valrath-vanquisher/toa-ma-valrath-vanquisher-2.png": 895290,
	"./monster-ability-cards/trail-of-ashes/valrath-vanquisher/toa-ma-valrath-vanquisher-3.png": 4565,
	"./monster-ability-cards/trail-of-ashes/valrath-vanquisher/toa-ma-valrath-vanquisher-4.png": 121627,
	"./monster-ability-cards/trail-of-ashes/valrath-vanquisher/toa-ma-valrath-vanquisher-back.png": 181660,
	"./monster-stat-cards/crimson-scales/cs-gnashing-drake-0.png": 31930,
	"./monster-stat-cards/crimson-scales/cs-gnashing-drake-2.png": 65315,
	"./monster-stat-cards/crimson-scales/cs-gnashing-drake-4.png": 823257,
	"./monster-stat-cards/crimson-scales/cs-gnashing-drake-6.png": 849224,
	"./monster-stat-cards/crimson-scales/cs-goremyon-shatter-mind-0.png": 137431,
	"./monster-stat-cards/crimson-scales/cs-goremyon-shatter-mind-2.png": 672015,
	"./monster-stat-cards/crimson-scales/cs-goremyon-shatter-mind-4.png": 935201,
	"./monster-stat-cards/crimson-scales/cs-goremyon-shatter-mind-6.png": 281094,
	"./monster-stat-cards/crimson-scales/cs-harrower-aegis-0.png": 476074,
	"./monster-stat-cards/crimson-scales/cs-harrower-aegis-2.png": 165798,
	"./monster-stat-cards/crimson-scales/cs-harrower-aegis-4.png": 173321,
	"./monster-stat-cards/crimson-scales/cs-harrower-aegis-6.png": 929918,
	"./monster-stat-cards/crimson-scales/cs-inox-bloodguard-0.png": 24887,
	"./monster-stat-cards/crimson-scales/cs-inox-bloodguard-2.png": 197455,
	"./monster-stat-cards/crimson-scales/cs-inox-bloodguard-4.png": 529524,
	"./monster-stat-cards/crimson-scales/cs-inox-bloodguard-6.png": 211490,
	"./monster-stat-cards/crimson-scales/cs-monster-stat-card-envelope-10.png": 414853,
	"./monster-stat-cards/crimson-scales/cs-monster-stat-card-envelope-6.png": 826810,
	"./monster-stat-cards/crimson-scales/cs-ravenous-gharial-0.png": 439232,
	"./monster-stat-cards/crimson-scales/cs-ravenous-gharial-2.png": 46822,
	"./monster-stat-cards/crimson-scales/cs-ravenous-gharial-4.png": 383974,
	"./monster-stat-cards/crimson-scales/cs-ravenous-gharial-6.png": 877950,
	"./monster-stat-cards/crimson-scales/cs-ruinmaw-0.png": 838545,
	"./monster-stat-cards/crimson-scales/cs-ruinmaw-2.png": 502722,
	"./monster-stat-cards/crimson-scales/cs-ruinmaw-4.png": 603174,
	"./monster-stat-cards/crimson-scales/cs-ruinmaw-6.png": 943048,
	"./monster-stat-cards/crimson-scales/cs-terrorscale-drake-0.png": 862756,
	"./monster-stat-cards/crimson-scales/cs-terrorscale-drake-2.png": 609173,
	"./monster-stat-cards/crimson-scales/cs-terrorscale-drake-4.png": 932356,
	"./monster-stat-cards/crimson-scales/cs-terrorscale-drake-6.png": 772926,
	"./monster-stat-cards/crimson-scales/cs-water-spirit-0.png": 968178,
	"./monster-stat-cards/crimson-scales/cs-water-spirit-2.png": 608875,
	"./monster-stat-cards/crimson-scales/cs-water-spirit-4.png": 22404,
	"./monster-stat-cards/crimson-scales/cs-water-spirit-6.png": 415468,
	"./monster-stat-cards/forgotten-circles/fc-aesther-ashblade-0.png": 862553,
	"./monster-stat-cards/forgotten-circles/fc-aesther-ashblade-4.png": 115292,
	"./monster-stat-cards/forgotten-circles/fc-aesther-scout-0.png": 656199,
	"./monster-stat-cards/forgotten-circles/fc-aesther-scout-4.png": 688513,
	"./monster-stat-cards/forgotten-circles/fc-human-commander-0.png": 340003,
	"./monster-stat-cards/forgotten-circles/fc-human-commander-4.png": 551368,
	"./monster-stat-cards/forgotten-circles/fc-manifestation-of-corruption-0.png": 915171,
	"./monster-stat-cards/forgotten-circles/fc-manifestation-of-corruption-4.png": 410301,
	"./monster-stat-cards/forgotten-circles/fc-monster-stat-card-envelope-10.png": 936057,
	"./monster-stat-cards/forgotten-circles/fc-monster-stat-card-envelope-6.png": 927978,
	"./monster-stat-cards/forgotten-circles/fc-selah-naberis-0.png": 389408,
	"./monster-stat-cards/forgotten-circles/fc-selah-naberis-4.png": 306473,
	"./monster-stat-cards/forgotten-circles/fc-sraka-the-wise-0.png": 920799,
	"./monster-stat-cards/forgotten-circles/fc-sraka-the-wise-4.png": 884463,
	"./monster-stat-cards/forgotten-circles/fc-the-steel-lion-0.png": 316032,
	"./monster-stat-cards/forgotten-circles/fc-the-steel-lion-4.png": 361819,
	"./monster-stat-cards/forgotten-circles/fc-uyart-ikkuma-0.png": 208287,
	"./monster-stat-cards/forgotten-circles/fc-uyart-ikkuma-4.png": 480939,
	"./monster-stat-cards/forgotten-circles/fc-valrath-commander-0.png": 68262,
	"./monster-stat-cards/forgotten-circles/fc-valrath-commander-4.png": 543235,
	"./monster-stat-cards/forgotten-circles/fc-valrath-savage-0.png": 143219,
	"./monster-stat-cards/forgotten-circles/fc-valrath-savage-4.png": 807500,
	"./monster-stat-cards/forgotten-circles/fc-valrath-tracker-0.png": 859851,
	"./monster-stat-cards/forgotten-circles/fc-valrath-tracker-4.png": 401097,
	"./monster-stat-cards/frosthaven/fh-abael-herder-0.png": 866306,
	"./monster-stat-cards/frosthaven/fh-abael-herder-4.png": 769071,
	"./monster-stat-cards/frosthaven/fh-abael-scout-0.png": 546805,
	"./monster-stat-cards/frosthaven/fh-abael-scout-4.png": 906000,
	"./monster-stat-cards/frosthaven/fh-algox-archer-0.png": 359827,
	"./monster-stat-cards/frosthaven/fh-algox-archer-4.png": 252401,
	"./monster-stat-cards/frosthaven/fh-algox-guard-0.png": 68349,
	"./monster-stat-cards/frosthaven/fh-algox-guard-4.png": 10834,
	"./monster-stat-cards/frosthaven/fh-algox-icespeaker-0.png": 590349,
	"./monster-stat-cards/frosthaven/fh-algox-icespeaker-4.png": 128435,
	"./monster-stat-cards/frosthaven/fh-algox-priest-0.png": 491947,
	"./monster-stat-cards/frosthaven/fh-algox-priest-4.png": 610791,
	"./monster-stat-cards/frosthaven/fh-algox-scout-0.png": 156214,
	"./monster-stat-cards/frosthaven/fh-algox-scout-4.png": 695922,
	"./monster-stat-cards/frosthaven/fh-algox-snowspeaker-0.png": 583097,
	"./monster-stat-cards/frosthaven/fh-algox-snowspeaker-4.png": 30807,
	"./monster-stat-cards/frosthaven/fh-algox-stormcaller-0.png": 254722,
	"./monster-stat-cards/frosthaven/fh-algox-stormcaller-2.png": 277559,
	"./monster-stat-cards/frosthaven/fh-algox-stormcaller-4.png": 151741,
	"./monster-stat-cards/frosthaven/fh-algox-stormcaller-6.png": 726037,
	"./monster-stat-cards/frosthaven/fh-ancient-artillery-0.png": 475610,
	"./monster-stat-cards/frosthaven/fh-ancient-artillery-4.png": 912557,
	"./monster-stat-cards/frosthaven/fh-black-imp-0.png": 655352,
	"./monster-stat-cards/frosthaven/fh-black-imp-4.png": 798216,
	"./monster-stat-cards/frosthaven/fh-boss-stat-card-envelope-6.png": 455905,
	"./monster-stat-cards/frosthaven/fh-burrowing-blade-0.png": 762421,
	"./monster-stat-cards/frosthaven/fh-burrowing-blade-4.png": 667066,
	"./monster-stat-cards/frosthaven/fh-chaos-demon-0.png": 118891,
	"./monster-stat-cards/frosthaven/fh-chaos-demon-4.png": 303982,
	"./monster-stat-cards/frosthaven/fh-city-guard-0.png": 733281,
	"./monster-stat-cards/frosthaven/fh-city-guard-4.png": 983838,
	"./monster-stat-cards/frosthaven/fh-deep-terror-0.png": 432211,
	"./monster-stat-cards/frosthaven/fh-deep-terror-4.png": 568590,
	"./monster-stat-cards/frosthaven/fh-earth-demon-0.png": 303638,
	"./monster-stat-cards/frosthaven/fh-earth-demon-4.png": 540777,
	"./monster-stat-cards/frosthaven/fh-elder-ooze-0.png": 118299,
	"./monster-stat-cards/frosthaven/fh-elder-ooze-2.png": 567148,
	"./monster-stat-cards/frosthaven/fh-elder-ooze-4.png": 804689,
	"./monster-stat-cards/frosthaven/fh-elder-ooze-6.png": 84689,
	"./monster-stat-cards/frosthaven/fh-fish-king-0.png": 138263,
	"./monster-stat-cards/frosthaven/fh-fish-king-2.png": 648492,
	"./monster-stat-cards/frosthaven/fh-fish-king-4.png": 604461,
	"./monster-stat-cards/frosthaven/fh-fish-king-6.png": 424873,
	"./monster-stat-cards/frosthaven/fh-flame-demon-0.png": 850763,
	"./monster-stat-cards/frosthaven/fh-flame-demon-4.png": 938377,
	"./monster-stat-cards/frosthaven/fh-flaming-bladespinner-0.png": 843862,
	"./monster-stat-cards/frosthaven/fh-flaming-bladespinner-4.png": 988258,
	"./monster-stat-cards/frosthaven/fh-forest-imp-0.png": 789101,
	"./monster-stat-cards/frosthaven/fh-forest-imp-4.png": 893679,
	"./monster-stat-cards/frosthaven/fh-fracture-of-the-deep-0.png": 192450,
	"./monster-stat-cards/frosthaven/fh-fracture-of-the-deep-2.png": 225527,
	"./monster-stat-cards/frosthaven/fh-fracture-of-the-deep-4.png": 49584,
	"./monster-stat-cards/frosthaven/fh-fracture-of-the-deep-6.png": 751397,
	"./monster-stat-cards/frosthaven/fh-frost-demon-0.png": 949718,
	"./monster-stat-cards/frosthaven/fh-frost-demon-4.png": 890209,
	"./monster-stat-cards/frosthaven/fh-frozen-corpse-0.png": 198428,
	"./monster-stat-cards/frosthaven/fh-frozen-corpse-4.png": 139611,
	"./monster-stat-cards/frosthaven/fh-frozen-fist-0.png": 944553,
	"./monster-stat-cards/frosthaven/fh-frozen-fist-2.png": 399331,
	"./monster-stat-cards/frosthaven/fh-frozen-fist-4.png": 511929,
	"./monster-stat-cards/frosthaven/fh-frozen-fist-6.png": 134790,
	"./monster-stat-cards/frosthaven/fh-harbinger-of-shadow-0.png": 642023,
	"./monster-stat-cards/frosthaven/fh-harbinger-of-shadow-2.png": 504643,
	"./monster-stat-cards/frosthaven/fh-harbinger-of-shadow-4.png": 150623,
	"./monster-stat-cards/frosthaven/fh-harbinger-of-shadow-6.png": 844312,
	"./monster-stat-cards/frosthaven/fh-harrower-infester-0.png": 981207,
	"./monster-stat-cards/frosthaven/fh-harrower-infester-4.png": 490083,
	"./monster-stat-cards/frosthaven/fh-hound-0.png": 789885,
	"./monster-stat-cards/frosthaven/fh-hound-4.png": 404359,
	"./monster-stat-cards/frosthaven/fh-ice-wraith-0.png": 762796,
	"./monster-stat-cards/frosthaven/fh-ice-wraith-4.png": 720331,
	"./monster-stat-cards/frosthaven/fh-lightning-eel-0.png": 181245,
	"./monster-stat-cards/frosthaven/fh-lightning-eel-4.png": 575211,
	"./monster-stat-cards/frosthaven/fh-living-bones-0.png": 668967,
	"./monster-stat-cards/frosthaven/fh-living-bones-4.png": 190375,
	"./monster-stat-cards/frosthaven/fh-living-doom-0.png": 202054,
	"./monster-stat-cards/frosthaven/fh-living-doom-4.png": 380522,
	"./monster-stat-cards/frosthaven/fh-living-spirit-0.png": 431302,
	"./monster-stat-cards/frosthaven/fh-living-spirit-4.png": 664367,
	"./monster-stat-cards/frosthaven/fh-lord-of-chaos-0.png": 834999,
	"./monster-stat-cards/frosthaven/fh-lord-of-chaos-2.png": 448442,
	"./monster-stat-cards/frosthaven/fh-lord-of-chaos-4.png": 909269,
	"./monster-stat-cards/frosthaven/fh-lord-of-chaos-6.png": 540449,
	"./monster-stat-cards/frosthaven/fh-lurker-clawcrusher-0.png": 773475,
	"./monster-stat-cards/frosthaven/fh-lurker-clawcrusher-4.png": 585863,
	"./monster-stat-cards/frosthaven/fh-lurker-mindsnipper-0.png": 164369,
	"./monster-stat-cards/frosthaven/fh-lurker-mindsnipper-4.png": 173994,
	"./monster-stat-cards/frosthaven/fh-lurker-soldier-0.png": 148198,
	"./monster-stat-cards/frosthaven/fh-lurker-soldier-4.png": 120788,
	"./monster-stat-cards/frosthaven/fh-lurker-wavethrower-0.png": 391084,
	"./monster-stat-cards/frosthaven/fh-lurker-wavethrower-4.png": 861932,
	"./monster-stat-cards/frosthaven/fh-monster-stat-card-envelope-10.png": 893633,
	"./monster-stat-cards/frosthaven/fh-monster-stat-card-envelope-6.png": 675867,
	"./monster-stat-cards/frosthaven/fh-night-demon-0.png": 505322,
	"./monster-stat-cards/frosthaven/fh-night-demon-4.png": 592286,
	"./monster-stat-cards/frosthaven/fh-ooze-0.png": 742206,
	"./monster-stat-cards/frosthaven/fh-ooze-4.png": 361927,
	"./monster-stat-cards/frosthaven/fh-orphan-0.png": 230467,
	"./monster-stat-cards/frosthaven/fh-orphan-2.png": 564879,
	"./monster-stat-cards/frosthaven/fh-orphan-4.png": 484531,
	"./monster-stat-cards/frosthaven/fh-orphan-6.png": 711671,
	"./monster-stat-cards/frosthaven/fh-piranha-pig-0.png": 110117,
	"./monster-stat-cards/frosthaven/fh-piranha-pig-4.png": 886117,
	"./monster-stat-cards/frosthaven/fh-polar-bear-0.png": 344644,
	"./monster-stat-cards/frosthaven/fh-polar-bear-4.png": 294309,
	"./monster-stat-cards/frosthaven/fh-prince-of-frost-0.png": 103741,
	"./monster-stat-cards/frosthaven/fh-prince-of-frost-2.png": 784669,
	"./monster-stat-cards/frosthaven/fh-prince-of-frost-4.png": 764627,
	"./monster-stat-cards/frosthaven/fh-prince-of-frost-6.png": 478559,
	"./monster-stat-cards/frosthaven/fh-program-director-0.png": 561771,
	"./monster-stat-cards/frosthaven/fh-program-director-2.png": 490664,
	"./monster-stat-cards/frosthaven/fh-program-director-4.png": 299115,
	"./monster-stat-cards/frosthaven/fh-program-director-6.png": 17189,
	"./monster-stat-cards/frosthaven/fh-render-0.png": 732302,
	"./monster-stat-cards/frosthaven/fh-render-2.png": 891507,
	"./monster-stat-cards/frosthaven/fh-render-4.png": 72674,
	"./monster-stat-cards/frosthaven/fh-render-6.png": 595887,
	"./monster-stat-cards/frosthaven/fh-rending-drake-0.png": 141383,
	"./monster-stat-cards/frosthaven/fh-rending-drake-4.png": 814533,
	"./monster-stat-cards/frosthaven/fh-robotic-boltshooter-0.png": 102655,
	"./monster-stat-cards/frosthaven/fh-robotic-boltshooter-4.png": 900433,
	"./monster-stat-cards/frosthaven/fh-ruined-machine-0.png": 954147,
	"./monster-stat-cards/frosthaven/fh-ruined-machine-4.png": 882729,
	"./monster-stat-cards/frosthaven/fh-savvas-icestorm-0.png": 727925,
	"./monster-stat-cards/frosthaven/fh-savvas-icestorm-4.png": 24871,
	"./monster-stat-cards/frosthaven/fh-savvas-lavaflow-0.png": 695607,
	"./monster-stat-cards/frosthaven/fh-savvas-lavaflow-4.png": 514832,
	"./monster-stat-cards/frosthaven/fh-seeker-of-the-abyss-0.png": 211643,
	"./monster-stat-cards/frosthaven/fh-seeker-of-the-abyss-2.png": 414167,
	"./monster-stat-cards/frosthaven/fh-seeker-of-the-abyss-4.png": 361000,
	"./monster-stat-cards/frosthaven/fh-seeker-of-the-abyss-6.png": 160092,
	"./monster-stat-cards/frosthaven/fh-shrike-fiend-0.png": 55163,
	"./monster-stat-cards/frosthaven/fh-shrike-fiend-4.png": 236084,
	"./monster-stat-cards/frosthaven/fh-snow-imp-0.png": 692021,
	"./monster-stat-cards/frosthaven/fh-snow-imp-4.png": 77157,
	"./monster-stat-cards/frosthaven/fh-snowdancer-0.png": 575002,
	"./monster-stat-cards/frosthaven/fh-snowdancer-2.png": 140438,
	"./monster-stat-cards/frosthaven/fh-snowdancer-4.png": 543901,
	"./monster-stat-cards/frosthaven/fh-snowdancer-6.png": 677509,
	"./monster-stat-cards/frosthaven/fh-spitting-drake-0.png": 567529,
	"./monster-stat-cards/frosthaven/fh-spitting-drake-4.png": 581546,
	"./monster-stat-cards/frosthaven/fh-steel-automaton-0.png": 787908,
	"./monster-stat-cards/frosthaven/fh-steel-automaton-4.png": 661737,
	"./monster-stat-cards/frosthaven/fh-sun-demon-0.png": 833993,
	"./monster-stat-cards/frosthaven/fh-sun-demon-4.png": 773980,
	"./monster-stat-cards/frosthaven/fh-the-collector-0.png": 793014,
	"./monster-stat-cards/frosthaven/fh-the-collector-2.png": 534135,
	"./monster-stat-cards/frosthaven/fh-the-collector-4.png": 539198,
	"./monster-stat-cards/frosthaven/fh-the-collector-6.png": 524100,
	"./monster-stat-cards/frosthaven/fh-the-relic-0.png": 21655,
	"./monster-stat-cards/frosthaven/fh-the-relic-2.png": 395051,
	"./monster-stat-cards/frosthaven/fh-the-relic-4.png": 242238,
	"./monster-stat-cards/frosthaven/fh-the-relic-6.png": 360301,
	"./monster-stat-cards/frosthaven/fh-vermling-priest-0.png": 555963,
	"./monster-stat-cards/frosthaven/fh-vermling-priest-4.png": 621482,
	"./monster-stat-cards/frosthaven/fh-vermling-scout-0.png": 606923,
	"./monster-stat-cards/frosthaven/fh-vermling-scout-4.png": 322125,
	"./monster-stat-cards/frosthaven/fh-vestige-of-the-imprisoned-god-0.png": 55490,
	"./monster-stat-cards/frosthaven/fh-vestige-of-the-imprisoned-god-2.png": 691602,
	"./monster-stat-cards/frosthaven/fh-vestige-of-the-imprisoned-god-4.png": 147722,
	"./monster-stat-cards/frosthaven/fh-vestige-of-the-imprisoned-god-6.png": 73736,
	"./monster-stat-cards/frosthaven/fh-wind-demon-0.png": 920243,
	"./monster-stat-cards/frosthaven/fh-wind-demon-4.png": 250823,
	"./monster-stat-cards/gloomhaven/gh-ancient-artillery-0.png": 220431,
	"./monster-stat-cards/gloomhaven/gh-ancient-artillery-4.png": 251675,
	"./monster-stat-cards/gloomhaven/gh-bandit-archer-0.png": 890266,
	"./monster-stat-cards/gloomhaven/gh-bandit-archer-4.png": 346774,
	"./monster-stat-cards/gloomhaven/gh-bandit-commander-0.png": 75255,
	"./monster-stat-cards/gloomhaven/gh-bandit-commander-4.png": 8678,
	"./monster-stat-cards/gloomhaven/gh-bandit-guard-0.png": 56971,
	"./monster-stat-cards/gloomhaven/gh-bandit-guard-4.png": 488150,
	"./monster-stat-cards/gloomhaven/gh-black-imp-0.png": 512020,
	"./monster-stat-cards/gloomhaven/gh-black-imp-4.png": 532031,
	"./monster-stat-cards/gloomhaven/gh-captain-of-the-guard-0.png": 639165,
	"./monster-stat-cards/gloomhaven/gh-captain-of-the-guard-4.png": 390565,
	"./monster-stat-cards/gloomhaven/gh-cave-bear-0.png": 684217,
	"./monster-stat-cards/gloomhaven/gh-cave-bear-4.png": 518811,
	"./monster-stat-cards/gloomhaven/gh-city-archer-0.png": 620757,
	"./monster-stat-cards/gloomhaven/gh-city-archer-4.png": 9935,
	"./monster-stat-cards/gloomhaven/gh-city-guard-0.png": 825055,
	"./monster-stat-cards/gloomhaven/gh-city-guard-4.png": 457324,
	"./monster-stat-cards/gloomhaven/gh-cultist-0.png": 233796,
	"./monster-stat-cards/gloomhaven/gh-cultist-4.png": 558507,
	"./monster-stat-cards/gloomhaven/gh-dark-rider-0.png": 520119,
	"./monster-stat-cards/gloomhaven/gh-dark-rider-4.png": 408924,
	"./monster-stat-cards/gloomhaven/gh-deep-terror-0.png": 672301,
	"./monster-stat-cards/gloomhaven/gh-deep-terror-4.png": 25601,
	"./monster-stat-cards/gloomhaven/gh-earth-demon-0.png": 938267,
	"./monster-stat-cards/gloomhaven/gh-earth-demon-4.png": 239606,
	"./monster-stat-cards/gloomhaven/gh-elder-drake-0.png": 96457,
	"./monster-stat-cards/gloomhaven/gh-elder-drake-4.png": 340095,
	"./monster-stat-cards/gloomhaven/gh-flame-demon-0.png": 395731,
	"./monster-stat-cards/gloomhaven/gh-flame-demon-4.png": 983251,
	"./monster-stat-cards/gloomhaven/gh-forest-imp-0.png": 489165,
	"./monster-stat-cards/gloomhaven/gh-forest-imp-4.png": 256695,
	"./monster-stat-cards/gloomhaven/gh-frost-demon-0.png": 563847,
	"./monster-stat-cards/gloomhaven/gh-frost-demon-4.png": 408716,
	"./monster-stat-cards/gloomhaven/gh-giant-viper-0.png": 291525,
	"./monster-stat-cards/gloomhaven/gh-giant-viper-4.png": 677260,
	"./monster-stat-cards/gloomhaven/gh-harrower-infester-0.png": 688757,
	"./monster-stat-cards/gloomhaven/gh-harrower-infester-4.png": 218438,
	"./monster-stat-cards/gloomhaven/gh-hound-0.png": 785246,
	"./monster-stat-cards/gloomhaven/gh-hound-4.png": 323840,
	"./monster-stat-cards/gloomhaven/gh-inox-archer-0.png": 717432,
	"./monster-stat-cards/gloomhaven/gh-inox-archer-4.png": 267012,
	"./monster-stat-cards/gloomhaven/gh-inox-bodyguard-0.png": 538093,
	"./monster-stat-cards/gloomhaven/gh-inox-bodyguard-4.png": 437807,
	"./monster-stat-cards/gloomhaven/gh-inox-guard-0.png": 151068,
	"./monster-stat-cards/gloomhaven/gh-inox-guard-4.png": 601680,
	"./monster-stat-cards/gloomhaven/gh-inox-shaman-0.png": 303223,
	"./monster-stat-cards/gloomhaven/gh-inox-shaman-4.png": 770785,
	"./monster-stat-cards/gloomhaven/gh-jekserah-0.png": 746916,
	"./monster-stat-cards/gloomhaven/gh-jekserah-4.png": 721457,
	"./monster-stat-cards/gloomhaven/gh-living-bones-0.png": 232624,
	"./monster-stat-cards/gloomhaven/gh-living-bones-4.png": 886674,
	"./monster-stat-cards/gloomhaven/gh-living-corpse-0.png": 608978,
	"./monster-stat-cards/gloomhaven/gh-living-corpse-4.png": 901204,
	"./monster-stat-cards/gloomhaven/gh-living-spirit-0.png": 375924,
	"./monster-stat-cards/gloomhaven/gh-living-spirit-4.png": 751121,
	"./monster-stat-cards/gloomhaven/gh-lurker-0.png": 471443,
	"./monster-stat-cards/gloomhaven/gh-lurker-4.png": 547365,
	"./monster-stat-cards/gloomhaven/gh-merciless-overseer-0.png": 89818,
	"./monster-stat-cards/gloomhaven/gh-merciless-overseer-4.png": 832798,
	"./monster-stat-cards/gloomhaven/gh-monster-stat-card-envelope-10.png": 426717,
	"./monster-stat-cards/gloomhaven/gh-monster-stat-card-envelope-6.png": 954615,
	"./monster-stat-cards/gloomhaven/gh-night-demon-0.png": 616199,
	"./monster-stat-cards/gloomhaven/gh-night-demon-4.png": 563198,
	"./monster-stat-cards/gloomhaven/gh-ooze-0.png": 100324,
	"./monster-stat-cards/gloomhaven/gh-ooze-4.png": 982307,
	"./monster-stat-cards/gloomhaven/gh-prime-demon-0.png": 328930,
	"./monster-stat-cards/gloomhaven/gh-prime-demon-4.png": 23402,
	"./monster-stat-cards/gloomhaven/gh-rending-drake-0.png": 640011,
	"./monster-stat-cards/gloomhaven/gh-rending-drake-4.png": 514966,
	"./monster-stat-cards/gloomhaven/gh-savvas-icestorm-0.png": 213043,
	"./monster-stat-cards/gloomhaven/gh-savvas-icestorm-4.png": 545909,
	"./monster-stat-cards/gloomhaven/gh-savvas-lavaflow-0.png": 5026,
	"./monster-stat-cards/gloomhaven/gh-savvas-lavaflow-4.png": 268770,
	"./monster-stat-cards/gloomhaven/gh-spitting-drake-0.png": 92975,
	"./monster-stat-cards/gloomhaven/gh-spitting-drake-4.png": 157915,
	"./monster-stat-cards/gloomhaven/gh-stone-golem-0.png": 748461,
	"./monster-stat-cards/gloomhaven/gh-stone-golem-4.png": 704400,
	"./monster-stat-cards/gloomhaven/gh-sun-demon-0.png": 308697,
	"./monster-stat-cards/gloomhaven/gh-sun-demon-4.png": 757377,
	"./monster-stat-cards/gloomhaven/gh-the-betrayer-0.png": 142878,
	"./monster-stat-cards/gloomhaven/gh-the-betrayer-4.png": 622676,
	"./monster-stat-cards/gloomhaven/gh-the-colorless-0.png": 76753,
	"./monster-stat-cards/gloomhaven/gh-the-colorless-4.png": 103113,
	"./monster-stat-cards/gloomhaven/gh-the-gloom-0.png": 470275,
	"./monster-stat-cards/gloomhaven/gh-the-gloom-4.png": 118128,
	"./monster-stat-cards/gloomhaven/gh-the-sightless-eye-0.png": 811721,
	"./monster-stat-cards/gloomhaven/gh-the-sightless-eye-4.png": 897919,
	"./monster-stat-cards/gloomhaven/gh-vermling-scout-0.png": 71860,
	"./monster-stat-cards/gloomhaven/gh-vermling-scout-4.png": 534573,
	"./monster-stat-cards/gloomhaven/gh-vermling-shaman-0.png": 251051,
	"./monster-stat-cards/gloomhaven/gh-vermling-shaman-4.png": 878826,
	"./monster-stat-cards/gloomhaven/gh-wind-demon-0.png": 709726,
	"./monster-stat-cards/gloomhaven/gh-wind-demon-4.png": 534234,
	"./monster-stat-cards/gloomhaven/gh-winged-horror-0.png": 957148,
	"./monster-stat-cards/gloomhaven/gh-winged-horror-4.png": 550609,
	"./monster-stat-cards/jaws-of-the-lion/jl-black-imp-0.png": 515407,
	"./monster-stat-cards/jaws-of-the-lion/jl-black-imp-4.png": 152992,
	"./monster-stat-cards/jaws-of-the-lion/jl-black-sludge-0.png": 3436,
	"./monster-stat-cards/jaws-of-the-lion/jl-black-sludge-4.png": 529878,
	"./monster-stat-cards/jaws-of-the-lion/jl-blood-horror-0.png": 910452,
	"./monster-stat-cards/jaws-of-the-lion/jl-blood-horror-4.png": 834821,
	"./monster-stat-cards/jaws-of-the-lion/jl-blood-imp-0.png": 724239,
	"./monster-stat-cards/jaws-of-the-lion/jl-blood-imp-4.png": 396608,
	"./monster-stat-cards/jaws-of-the-lion/jl-blood-monstrosity-0.png": 236694,
	"./monster-stat-cards/jaws-of-the-lion/jl-blood-monstrosity-4.png": 198534,
	"./monster-stat-cards/jaws-of-the-lion/jl-blood-tumor-0.png": 192265,
	"./monster-stat-cards/jaws-of-the-lion/jl-blood-tumor-4.png": 921610,
	"./monster-stat-cards/jaws-of-the-lion/jl-chaos-demon-0.png": 964862,
	"./monster-stat-cards/jaws-of-the-lion/jl-chaos-demon-4.png": 935863,
	"./monster-stat-cards/jaws-of-the-lion/jl-first-of-the-order-0.png": 362286,
	"./monster-stat-cards/jaws-of-the-lion/jl-first-of-the-order-4.png": 798762,
	"./monster-stat-cards/jaws-of-the-lion/jl-giant-viper-0.png": 26005,
	"./monster-stat-cards/jaws-of-the-lion/jl-giant-viper-4.png": 433871,
	"./monster-stat-cards/jaws-of-the-lion/jl-living-corpse-0.png": 70479,
	"./monster-stat-cards/jaws-of-the-lion/jl-living-corpse-4.png": 343681,
	"./monster-stat-cards/jaws-of-the-lion/jl-living-spirit-0.png": 798415,
	"./monster-stat-cards/jaws-of-the-lion/jl-living-spirit-4.png": 150258,
	"./monster-stat-cards/jaws-of-the-lion/jl-monster-stat-card-envelope-10.png": 251522,
	"./monster-stat-cards/jaws-of-the-lion/jl-monster-stat-card-envelope-6.png": 808346,
	"./monster-stat-cards/jaws-of-the-lion/jl-rat-monstrosity-0.png": 686285,
	"./monster-stat-cards/jaws-of-the-lion/jl-rat-monstrosity-4.png": 764417,
	"./monster-stat-cards/jaws-of-the-lion/jl-stone-golem-0.png": 294989,
	"./monster-stat-cards/jaws-of-the-lion/jl-stone-golem-4.png": 868278,
	"./monster-stat-cards/jaws-of-the-lion/jl-vermling-raider-0.png": 423054,
	"./monster-stat-cards/jaws-of-the-lion/jl-vermling-raider-4.png": 611282,
	"./monster-stat-cards/jaws-of-the-lion/jl-vermling-scout-0.png": 511521,
	"./monster-stat-cards/jaws-of-the-lion/jl-vermling-scout-4.png": 972882,
	"./monster-stat-cards/jaws-of-the-lion/jl-zealot-0.png": 580083,
	"./monster-stat-cards/jaws-of-the-lion/jl-zealot-4.png": 884738,
	"./monster-stat-cards/trail-of-ashes/toa-harrower-bugflute-0.png": 851670,
	"./monster-stat-cards/trail-of-ashes/toa-harrower-bugflute-2.png": 604280,
	"./monster-stat-cards/trail-of-ashes/toa-harrower-bugflute-4.png": 541738,
	"./monster-stat-cards/trail-of-ashes/toa-harrower-bugflute-6.png": 903324,
	"./monster-stat-cards/trail-of-ashes/toa-shardrender-0.png": 357692,
	"./monster-stat-cards/trail-of-ashes/toa-shardrender-2.png": 515441,
	"./monster-stat-cards/trail-of-ashes/toa-shardrender-4.png": 381964,
	"./monster-stat-cards/trail-of-ashes/toa-shardrender-6.png": 444969,
	"./monster-stat-cards/trail-of-ashes/toa-smoke-spirit-0.png": 818980,
	"./monster-stat-cards/trail-of-ashes/toa-smoke-spirit-2.png": 323414,
	"./monster-stat-cards/trail-of-ashes/toa-smoke-spirit-4.png": 302561,
	"./monster-stat-cards/trail-of-ashes/toa-smoke-spirit-6.png": 472076,
	"./monster-stat-cards/trail-of-ashes/toa-talo-0.png": 252364,
	"./monster-stat-cards/trail-of-ashes/toa-talo-2.png": 608781,
	"./monster-stat-cards/trail-of-ashes/toa-talo-4.png": 213688,
	"./monster-stat-cards/trail-of-ashes/toa-talo-6.png": 709741,
	"./monster-stat-cards/trail-of-ashes/toa-valrath-vanquisher-0.png": 747587,
	"./monster-stat-cards/trail-of-ashes/toa-valrath-vanquisher-2.png": 759400,
	"./monster-stat-cards/trail-of-ashes/toa-valrath-vanquisher-4.png": 424823,
	"./monster-stat-cards/trail-of-ashes/toa-valrath-vanquisher-6.png": 142148,
	"./outpost-building-cards/ZZ/zz.txt": 521194,
	"./outpost-building-cards/frosthaven/fh-05-mining-camp-level-1-back.png": 999216,
	"./outpost-building-cards/frosthaven/fh-05-mining-camp-level-1.png": 337135,
	"./outpost-building-cards/frosthaven/fh-05-mining-camp-level-2-back.png": 127417,
	"./outpost-building-cards/frosthaven/fh-05-mining-camp-level-2.png": 207036,
	"./outpost-building-cards/frosthaven/fh-05-mining-camp-level-3-back.png": 251623,
	"./outpost-building-cards/frosthaven/fh-05-mining-camp-level-3.png": 822735,
	"./outpost-building-cards/frosthaven/fh-05-mining-camp-level-4-back.png": 251150,
	"./outpost-building-cards/frosthaven/fh-05-mining-camp-level-4.png": 547626,
	"./outpost-building-cards/frosthaven/fh-12-hunting-lodge-level-1-back.png": 975819,
	"./outpost-building-cards/frosthaven/fh-12-hunting-lodge-level-1.png": 734413,
	"./outpost-building-cards/frosthaven/fh-12-hunting-lodge-level-2-back.png": 187611,
	"./outpost-building-cards/frosthaven/fh-12-hunting-lodge-level-2.png": 58211,
	"./outpost-building-cards/frosthaven/fh-12-hunting-lodge-level-3-back.png": 859451,
	"./outpost-building-cards/frosthaven/fh-12-hunting-lodge-level-3.png": 988923,
	"./outpost-building-cards/frosthaven/fh-12-hunting-lodge-level-4-back.png": 862704,
	"./outpost-building-cards/frosthaven/fh-12-hunting-lodge-level-4.png": 321219,
	"./outpost-building-cards/frosthaven/fh-17-logging-camp-level-1-back.png": 961570,
	"./outpost-building-cards/frosthaven/fh-17-logging-camp-level-1.png": 132562,
	"./outpost-building-cards/frosthaven/fh-17-logging-camp-level-2-back.png": 618759,
	"./outpost-building-cards/frosthaven/fh-17-logging-camp-level-2.png": 554363,
	"./outpost-building-cards/frosthaven/fh-17-logging-camp-level-3-back.png": 818469,
	"./outpost-building-cards/frosthaven/fh-17-logging-camp-level-3.png": 584643,
	"./outpost-building-cards/frosthaven/fh-17-logging-camp-level-4-back.png": 616771,
	"./outpost-building-cards/frosthaven/fh-17-logging-camp-level-4.png": 796406,
	"./outpost-building-cards/frosthaven/fh-21-inn-level-1-back.png": 82748,
	"./outpost-building-cards/frosthaven/fh-21-inn-level-1.png": 471353,
	"./outpost-building-cards/frosthaven/fh-21-inn-level-2-back.png": 845785,
	"./outpost-building-cards/frosthaven/fh-21-inn-level-2.png": 319773,
	"./outpost-building-cards/frosthaven/fh-21-inn-level-3-back.png": 982760,
	"./outpost-building-cards/frosthaven/fh-21-inn-level-3.png": 773934,
	"./outpost-building-cards/frosthaven/fh-24-garden-level-1-back.png": 79454,
	"./outpost-building-cards/frosthaven/fh-24-garden-level-1.png": 69713,
	"./outpost-building-cards/frosthaven/fh-24-garden-level-2-back.png": 545056,
	"./outpost-building-cards/frosthaven/fh-24-garden-level-2.png": 919535,
	"./outpost-building-cards/frosthaven/fh-24-garden-level-3-back.png": 901772,
	"./outpost-building-cards/frosthaven/fh-24-garden-level-3.png": 599242,
	"./outpost-building-cards/frosthaven/fh-24-garden-level-4-back.png": 668907,
	"./outpost-building-cards/frosthaven/fh-24-garden-level-4.png": 918835,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-1-back.png": 2143,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-1.png": 122950,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-2-back.png": 416066,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-2.png": 53107,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-3-back.png": 826279,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-3.png": 19190,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-4-back.png": 165923,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-4.png": 966257,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-5-back.png": 814953,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-5.png": 640638,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-6-back.png": 13304,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-6.png": 220579,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-7-back.png": 380163,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-7.png": 432383,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-8-back.png": 844477,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-8.png": 201724,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-9-back.png": 887031,
	"./outpost-building-cards/frosthaven/fh-34-craftsman-level-9.png": 864712,
	"./outpost-building-cards/frosthaven/fh-35-alchemist-level-1-back.png": 354894,
	"./outpost-building-cards/frosthaven/fh-35-alchemist-level-1.png": 722541,
	"./outpost-building-cards/frosthaven/fh-35-alchemist-level-2-back.png": 957354,
	"./outpost-building-cards/frosthaven/fh-35-alchemist-level-2.png": 587272,
	"./outpost-building-cards/frosthaven/fh-35-alchemist-level-3-back.png": 942429,
	"./outpost-building-cards/frosthaven/fh-35-alchemist-level-3.png": 166756,
	"./outpost-building-cards/frosthaven/fh-37-trading-post-level-1-back.png": 483388,
	"./outpost-building-cards/frosthaven/fh-37-trading-post-level-1.png": 173146,
	"./outpost-building-cards/frosthaven/fh-37-trading-post-level-2-back.png": 301262,
	"./outpost-building-cards/frosthaven/fh-37-trading-post-level-2.png": 194593,
	"./outpost-building-cards/frosthaven/fh-37-trading-post-level-3-back.png": 306819,
	"./outpost-building-cards/frosthaven/fh-37-trading-post-level-3.png": 194766,
	"./outpost-building-cards/frosthaven/fh-37-trading-post-level-4-back.png": 398424,
	"./outpost-building-cards/frosthaven/fh-37-trading-post-level-4.png": 244638,
	"./outpost-building-cards/frosthaven/fh-39-jeweler-level-1-back.png": 351977,
	"./outpost-building-cards/frosthaven/fh-39-jeweler-level-1.png": 926187,
	"./outpost-building-cards/frosthaven/fh-39-jeweler-level-2-back.png": 3019,
	"./outpost-building-cards/frosthaven/fh-39-jeweler-level-2.png": 293446,
	"./outpost-building-cards/frosthaven/fh-39-jeweler-level-3-back.png": 708571,
	"./outpost-building-cards/frosthaven/fh-39-jeweler-level-3.png": 162377,
	"./outpost-building-cards/frosthaven/fh-42-temple-of-the-great-oak-level-1-back.png": 224902,
	"./outpost-building-cards/frosthaven/fh-42-temple-of-the-great-oak-level-1.png": 193683,
	"./outpost-building-cards/frosthaven/fh-42-temple-of-the-great-oak-level-2-back.png": 146986,
	"./outpost-building-cards/frosthaven/fh-42-temple-of-the-great-oak-level-2.png": 743904,
	"./outpost-building-cards/frosthaven/fh-42-temple-of-the-great-oak-level-3-back.png": 795863,
	"./outpost-building-cards/frosthaven/fh-42-temple-of-the-great-oak-level-3.png": 669018,
	"./outpost-building-cards/frosthaven/fh-44-enhancer-level-1-back.png": 693224,
	"./outpost-building-cards/frosthaven/fh-44-enhancer-level-1.png": 535579,
	"./outpost-building-cards/frosthaven/fh-44-enhancer-level-2-back.png": 850972,
	"./outpost-building-cards/frosthaven/fh-44-enhancer-level-2.png": 940482,
	"./outpost-building-cards/frosthaven/fh-44-enhancer-level-3-back.png": 869048,
	"./outpost-building-cards/frosthaven/fh-44-enhancer-level-3.png": 138585,
	"./outpost-building-cards/frosthaven/fh-44-enhancer-level-4-back.png": 906481,
	"./outpost-building-cards/frosthaven/fh-44-enhancer-level-4.png": 897262,
	"./outpost-building-cards/frosthaven/fh-65-metal-depot-level-1-back.png": 329814,
	"./outpost-building-cards/frosthaven/fh-65-metal-depot-level-1.png": 886691,
	"./outpost-building-cards/frosthaven/fh-65-metal-depot-level-2-back.png": 449786,
	"./outpost-building-cards/frosthaven/fh-65-metal-depot-level-2.png": 878322,
	"./outpost-building-cards/frosthaven/fh-67-lumber-depot-level-1-back.png": 623736,
	"./outpost-building-cards/frosthaven/fh-67-lumber-depot-level-1.png": 669921,
	"./outpost-building-cards/frosthaven/fh-67-lumber-depot-level-2-back.png": 37495,
	"./outpost-building-cards/frosthaven/fh-67-lumber-depot-level-2.png": 180040,
	"./outpost-building-cards/frosthaven/fh-72-hide-depot-level-1-back.png": 470514,
	"./outpost-building-cards/frosthaven/fh-72-hide-depot-level-1.png": 189754,
	"./outpost-building-cards/frosthaven/fh-72-hide-depot-level-2-back.png": 690419,
	"./outpost-building-cards/frosthaven/fh-72-hide-depot-level-2.png": 487060,
	"./outpost-building-cards/frosthaven/fh-74-tavern-level-1-back.png": 17922,
	"./outpost-building-cards/frosthaven/fh-74-tavern-level-1.png": 34572,
	"./outpost-building-cards/frosthaven/fh-74-tavern-level-2-back.png": 409614,
	"./outpost-building-cards/frosthaven/fh-74-tavern-level-2.png": 160682,
	"./outpost-building-cards/frosthaven/fh-74-tavern-level-3-back.png": 406727,
	"./outpost-building-cards/frosthaven/fh-74-tavern-level-3.png": 987780,
	"./outpost-building-cards/frosthaven/fh-81-hall-of-revelry-level-1-back.png": 842035,
	"./outpost-building-cards/frosthaven/fh-81-hall-of-revelry-level-1.png": 135757,
	"./outpost-building-cards/frosthaven/fh-81-hall-of-revelry-level-2-back.png": 776410,
	"./outpost-building-cards/frosthaven/fh-81-hall-of-revelry-level-2.png": 167015,
	"./outpost-building-cards/frosthaven/fh-83-library-level-1-back.png": 714928,
	"./outpost-building-cards/frosthaven/fh-83-library-level-1.png": 399385,
	"./outpost-building-cards/frosthaven/fh-83-library-level-2-back.png": 489910,
	"./outpost-building-cards/frosthaven/fh-83-library-level-2.png": 187972,
	"./outpost-building-cards/frosthaven/fh-83-library-level-3-back.png": 661922,
	"./outpost-building-cards/frosthaven/fh-83-library-level-3.png": 140116,
	"./outpost-building-cards/frosthaven/fh-84-workshop-level-1-back.png": 108034,
	"./outpost-building-cards/frosthaven/fh-84-workshop-level-1.png": 587745,
	"./outpost-building-cards/frosthaven/fh-85-carpenter-level-1-back.png": 543526,
	"./outpost-building-cards/frosthaven/fh-85-carpenter-level-1.png": 913385,
	"./outpost-building-cards/frosthaven/fh-85-carpenter-level-2-back.png": 577206,
	"./outpost-building-cards/frosthaven/fh-85-carpenter-level-2.png": 96738,
	"./outpost-building-cards/frosthaven/fh-88-stables-level-1-back.png": 800681,
	"./outpost-building-cards/frosthaven/fh-88-stables-level-1.png": 310198,
	"./outpost-building-cards/frosthaven/fh-88-stables-level-2-back.png": 695220,
	"./outpost-building-cards/frosthaven/fh-88-stables-level-2.png": 294215,
	"./outpost-building-cards/frosthaven/fh-88-stables-level-3-back.png": 106682,
	"./outpost-building-cards/frosthaven/fh-88-stables-level-3.png": 149977,
	"./outpost-building-cards/frosthaven/fh-88-stables-level-4-back.png": 294364,
	"./outpost-building-cards/frosthaven/fh-88-stables-level-4.png": 1999,
	"./outpost-building-cards/frosthaven/fh-90-town-hall-level-1-back.png": 286265,
	"./outpost-building-cards/frosthaven/fh-90-town-hall-level-1.png": 333239,
	"./outpost-building-cards/frosthaven/fh-90-town-hall-level-2-back.png": 331807,
	"./outpost-building-cards/frosthaven/fh-90-town-hall-level-2.png": 496929,
	"./outpost-building-cards/frosthaven/fh-90-town-hall-level-3-back.png": 706331,
	"./outpost-building-cards/frosthaven/fh-90-town-hall-level-3.png": 977785,
	"./outpost-building-cards/frosthaven/fh-98-barracks-level-1-back.png": 552767,
	"./outpost-building-cards/frosthaven/fh-98-barracks-level-1.png": 910587,
	"./outpost-building-cards/frosthaven/fh-98-barracks-level-2-back.png": 606341,
	"./outpost-building-cards/frosthaven/fh-98-barracks-level-2.png": 537593,
	"./outpost-building-cards/frosthaven/fh-98-barracks-level-3-back.png": 963385,
	"./outpost-building-cards/frosthaven/fh-98-barracks-level-3.png": 369540,
	"./outpost-building-cards/frosthaven/fh-98-barracks-level-4-back.png": 278169,
	"./outpost-building-cards/frosthaven/fh-98-barracks-level-4.png": 427660,
	"./personal-quests/crimson-scales/cs-pq-330.png": 737008,
	"./personal-quests/crimson-scales/cs-pq-331.png": 963881,
	"./personal-quests/crimson-scales/cs-pq-332.png": 652,
	"./personal-quests/crimson-scales/cs-pq-333.png": 127625,
	"./personal-quests/crimson-scales/cs-pq-334.png": 193059,
	"./personal-quests/crimson-scales/cs-pq-335.png": 970221,
	"./personal-quests/crimson-scales/cs-pq-336.png": 972548,
	"./personal-quests/crimson-scales/cs-pq-337.png": 267729,
	"./personal-quests/crimson-scales/cs-pq-338.png": 869795,
	"./personal-quests/crimson-scales/cs-pq-339.png": 980675,
	"./personal-quests/crimson-scales/cs-pq-340.png": 647030,
	"./personal-quests/crimson-scales/cs-pq-341.png": 637190,
	"./personal-quests/crimson-scales/cs-pq-342.png": 120635,
	"./personal-quests/crimson-scales/cs-pq-343.png": 172420,
	"./personal-quests/crimson-scales/cs-pq-344.png": 580805,
	"./personal-quests/crimson-scales/cs-pq-345.png": 520205,
	"./personal-quests/crimson-scales/cs-pq-346.png": 563243,
	"./personal-quests/crimson-scales/cs-pq-347.png": 67866,
	"./personal-quests/crimson-scales/cs-pq-348.png": 483350,
	"./personal-quests/crimson-scales/cs-pq-349.png": 529689,
	"./personal-quests/crimson-scales/cs-pq-350.png": 74507,
	"./personal-quests/crimson-scales/cs-pq-351.png": 144968,
	"./personal-quests/crimson-scales/cs-pq-aa-001.png": 434078,
	"./personal-quests/crimson-scales/cs-pq-aa-002.png": 725531,
	"./personal-quests/crimson-scales/cs-pq-back.png": 65875,
	"./personal-quests/crimson-scales/cs-pq-qa-001.png": 124406,
	"./personal-quests/crimson-scales/cs-pq-qa-002.png": 491767,
	"./personal-quests/crimson-scales/cs-pq-rm-001.png": 555582,
	"./personal-quests/crimson-scales/cs-pq-rm-002.png": 937463,
	"./personal-quests/frosthaven/fh-pq-01.png": 628946,
	"./personal-quests/frosthaven/fh-pq-02.png": 481502,
	"./personal-quests/frosthaven/fh-pq-03.png": 428737,
	"./personal-quests/frosthaven/fh-pq-04.png": 794325,
	"./personal-quests/frosthaven/fh-pq-05.png": 830344,
	"./personal-quests/frosthaven/fh-pq-06.png": 635937,
	"./personal-quests/frosthaven/fh-pq-07.png": 821369,
	"./personal-quests/frosthaven/fh-pq-08.png": 630308,
	"./personal-quests/frosthaven/fh-pq-09.png": 600786,
	"./personal-quests/frosthaven/fh-pq-10.png": 358182,
	"./personal-quests/frosthaven/fh-pq-11.png": 578833,
	"./personal-quests/frosthaven/fh-pq-12.png": 61997,
	"./personal-quests/frosthaven/fh-pq-13.png": 680294,
	"./personal-quests/frosthaven/fh-pq-14.png": 800000,
	"./personal-quests/frosthaven/fh-pq-15.png": 389302,
	"./personal-quests/frosthaven/fh-pq-16.png": 486325,
	"./personal-quests/frosthaven/fh-pq-17.png": 383529,
	"./personal-quests/frosthaven/fh-pq-18.png": 114214,
	"./personal-quests/frosthaven/fh-pq-19.png": 654015,
	"./personal-quests/frosthaven/fh-pq-20.png": 459109,
	"./personal-quests/frosthaven/fh-pq-21.png": 225754,
	"./personal-quests/frosthaven/fh-pq-22.png": 466508,
	"./personal-quests/frosthaven/fh-pq-23.png": 727782,
	"./personal-quests/frosthaven/fh-pq-back.png": 124517,
	"./personal-quests/gloomhaven/gh-pq-510.png": 671563,
	"./personal-quests/gloomhaven/gh-pq-511.png": 40128,
	"./personal-quests/gloomhaven/gh-pq-512.png": 532557,
	"./personal-quests/gloomhaven/gh-pq-513.png": 102963,
	"./personal-quests/gloomhaven/gh-pq-514.png": 93978,
	"./personal-quests/gloomhaven/gh-pq-515.png": 150143,
	"./personal-quests/gloomhaven/gh-pq-516.png": 945702,
	"./personal-quests/gloomhaven/gh-pq-517.png": 947074,
	"./personal-quests/gloomhaven/gh-pq-518.png": 771177,
	"./personal-quests/gloomhaven/gh-pq-519.png": 608200,
	"./personal-quests/gloomhaven/gh-pq-520.png": 20358,
	"./personal-quests/gloomhaven/gh-pq-521.png": 754811,
	"./personal-quests/gloomhaven/gh-pq-522.png": 583190,
	"./personal-quests/gloomhaven/gh-pq-523.png": 987248,
	"./personal-quests/gloomhaven/gh-pq-524.png": 953094,
	"./personal-quests/gloomhaven/gh-pq-525.png": 401620,
	"./personal-quests/gloomhaven/gh-pq-526.png": 45525,
	"./personal-quests/gloomhaven/gh-pq-527.png": 135869,
	"./personal-quests/gloomhaven/gh-pq-528.png": 857964,
	"./personal-quests/gloomhaven/gh-pq-529.png": 47690,
	"./personal-quests/gloomhaven/gh-pq-530.png": 683902,
	"./personal-quests/gloomhaven/gh-pq-531.png": 852589,
	"./personal-quests/gloomhaven/gh-pq-532.png": 431875,
	"./personal-quests/gloomhaven/gh-pq-533.png": 795049,
	"./personal-quests/gloomhaven/gh-pq-back.png": 468985,
	"./personal-quests/trail-of-ashes/toa-pq-641.png": 242343,
	"./personal-quests/trail-of-ashes/toa-pq-642.png": 482804,
	"./personal-quests/trail-of-ashes/toa-pq-643.png": 244701,
	"./personal-quests/trail-of-ashes/toa-pq-644.png": 84273,
	"./personal-quests/trail-of-ashes/toa-pq-645.png": 950989,
	"./personal-quests/trail-of-ashes/toa-pq-646.png": 302169,
	"./personal-quests/trail-of-ashes/toa-pq-647.png": 559367,
	"./personal-quests/trail-of-ashes/toa-pq-648.png": 715879,
	"./personal-quests/trail-of-ashes/toa-pq-back.png": 106552,
	"./pet-cards/ZZ/zz.txt": 844057,
	"./pet-cards/frosthaven/fh-01-piranha-pig-back.png": 721600,
	"./pet-cards/frosthaven/fh-01-piranha-pig.png": 499509,
	"./pet-cards/frosthaven/fh-02-hound-back.png": 286663,
	"./pet-cards/frosthaven/fh-02-hound.png": 924106,
	"./pet-cards/frosthaven/fh-03-spitting-drake-back.png": 556003,
	"./pet-cards/frosthaven/fh-03-spitting-drake.png": 158031,
	"./pet-cards/frosthaven/fh-04-rending-drake-back.png": 710339,
	"./pet-cards/frosthaven/fh-04-rending-drake.png": 484009,
	"./pet-cards/frosthaven/fh-05-black-imp-back.png": 376224,
	"./pet-cards/frosthaven/fh-05-black-imp.png": 613789,
	"./pet-cards/frosthaven/fh-06-forest-imp-back.png": 171972,
	"./pet-cards/frosthaven/fh-06-forest-imp.png": 23446,
	"./pet-cards/frosthaven/fh-07-snow-imp-back.png": 681527,
	"./pet-cards/frosthaven/fh-07-snow-imp.png": 580188,
	"./pet-cards/frosthaven/fh-08-ooze-back.png": 432873,
	"./pet-cards/frosthaven/fh-08-ooze.png": 816992,
	"./pet-cards/frosthaven/fh-09-ruined-machine-back.png": 871046,
	"./pet-cards/frosthaven/fh-09-ruined-machine.png": 75612,
	"./pet-cards/frosthaven/fh-10-lightning-eel-back.png": 50750,
	"./pet-cards/frosthaven/fh-10-lightning-eel.png": 251547,
	"./pet-cards/frosthaven/fh-11-heroics-back.png": 53101,
	"./pet-cards/frosthaven/fh-11-heroics.png": 610993,
	"./pet-cards/frosthaven/fh-12-brummix-back.png": 704078,
	"./pet-cards/frosthaven/fh-12-brummix.png": 944146,
	"./player-aid-cards/crimson-scales/cs-ao-halt-am-1-3-back.png": 136893,
	"./player-aid-cards/crimson-scales/cs-ao-halt-am-1-3-front.png": 850048,
	"./player-aid-cards/crimson-scales/cs-ao-halt-class-1-3-back.png": 583146,
	"./player-aid-cards/crimson-scales/cs-ao-halt-class-1-3-front.png": 628047,
	"./player-aid-cards/crimson-scales/cs-bg-halt-am-1-6-back.png": 631000,
	"./player-aid-cards/crimson-scales/cs-bg-halt-am-1-6-front.png": 185813,
	"./player-aid-cards/crimson-scales/cs-bg-halt-am-7-11-back.png": 523687,
	"./player-aid-cards/crimson-scales/cs-bg-halt-am-7-11-front.png": 891599,
	"./player-aid-cards/crimson-scales/cs-bg-halt-class-1-3-back.png": 144999,
	"./player-aid-cards/crimson-scales/cs-bg-halt-class-1-3-front.png": 447378,
	"./player-aid-cards/crimson-scales/cs-bg-halt-class-10-11-back.png": 917448,
	"./player-aid-cards/crimson-scales/cs-bg-halt-class-10-11-front.png": 811464,
	"./player-aid-cards/crimson-scales/cs-bg-halt-class-4-6-back.png": 809553,
	"./player-aid-cards/crimson-scales/cs-bg-halt-class-4-6-front.png": 982417,
	"./player-aid-cards/crimson-scales/cs-bg-halt-class-7-9-back.png": 839926,
	"./player-aid-cards/crimson-scales/cs-bg-halt-class-7-9-front.png": 413615,
	"./player-aid-cards/crimson-scales/cs-halt-am-back.png": 13269,
	"./player-aid-cards/crimson-scales/cs-halt-am-front.png": 742390,
	"./player-aid-cards/crimson-scales/cs-halt-am-party-back.png": 987455,
	"./player-aid-cards/crimson-scales/cs-halt-am-party-front.png": 7680,
	"./player-aid-cards/crimson-scales/cs-halt-class-back.png": 968687,
	"./player-aid-cards/crimson-scales/cs-halt-class-front.png": 188075,
	"./player-aid-cards/crimson-scales/cs-player-reference-back.png": 758058,
	"./player-aid-cards/crimson-scales/cs-player-reference-front-1.png": 733373,
	"./player-aid-cards/crimson-scales/cs-player-reference-front-2.png": 113248,
	"./player-aid-cards/crimson-scales/cs-player-reference-front-3.png": 891085,
	"./player-aid-cards/crimson-scales/cs-player-reference-front-4.png": 484733,
	"./player-aid-cards/crimson-scales/cs-scenario-reference-back.png": 646850,
	"./player-aid-cards/crimson-scales/cs-scenario-reference-front.png": 747804,
	"./player-aid-cards/forgotten-circles/fc-halt-bottom-back.png": 782893,
	"./player-aid-cards/forgotten-circles/fc-halt-bottom-front.png": 746836,
	"./player-aid-cards/forgotten-circles/fc-halt-top-back.png": 119503,
	"./player-aid-cards/forgotten-circles/fc-halt-top-front.png": 508551,
	"./player-aid-cards/forgotten-circles/fc-player-reference-back.png": 316492,
	"./player-aid-cards/forgotten-circles/fc-player-reference-front.png": 228542,
	"./player-aid-cards/frosthaven/fh-player-reference-back.png": 821811,
	"./player-aid-cards/frosthaven/fh-player-reference-front.png": 13149,
	"./player-aid-cards/gloomhaven/gh-player-reference-back.png": 357785,
	"./player-aid-cards/gloomhaven/gh-player-reference-front.png": 278269,
	"./player-aid-cards/trail-of-ashes/toa-halt-am-1-5-back.png": 61982,
	"./player-aid-cards/trail-of-ashes/toa-halt-am-1-5-front.png": 534227,
	"./player-aid-cards/trail-of-ashes/toa-halt-class-1-3-back.png": 659362,
	"./player-aid-cards/trail-of-ashes/toa-halt-class-1-3-front.png": 895721,
	"./player-aid-cards/trail-of-ashes/toa-halt-class-4-5-back.png": 796684,
	"./player-aid-cards/trail-of-ashes/toa-halt-class-4-5-front.png": 706767,
	"./player-aid-cards/trail-of-ashes/toa-halt-errata-back.png": 857155,
	"./player-aid-cards/trail-of-ashes/toa-halt-errata-front.png": 656288,
	"./player-aid-cards/trail-of-ashes/toa-halt-m-back.png": 400295,
	"./player-aid-cards/trail-of-ashes/toa-halt-m-front.png": 357214,
	"./player-aid-cards/trail-of-ashes/toa-halt-mini-back.png": 846827,
	"./player-aid-cards/trail-of-ashes/toa-halt-mini-front.png": 43776,
	"./player-aid-cards/trail-of-ashes/toa-player-reference-back.png": 568026,
	"./player-aid-cards/trail-of-ashes/toa-player-reference-front-1.png": 324258,
	"./player-aid-cards/trail-of-ashes/toa-player-reference-front-2.png": 551380,
	"./player-aid-cards/trail-of-ashes/toa-player-reference-front-3.png": 287525,
	"./player-aid-cards/trail-of-ashes/toa-player-reference-front-4.png": 110376,
	"./random-dungeons/forgotten-circles/ZZ/zz.txt": 988654,
	"./random-dungeons/forgotten-circles/monsters/fc-monster-arid.png": 738800,
	"./random-dungeons/forgotten-circles/monsters/fc-monster-ethereal.png": 530669,
	"./random-dungeons/forgotten-circles/monsters/fc-monster-monster-back.png": 641566,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-a-back.png": 510583,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-ab-back.png": 722866,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-attic.png": 874734,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-b-back.png": 416158,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-cache.png": 453452,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-core.png": 526017,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-crater.png": 729078,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-crevice.png": 799888,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-dock.png": 587145,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-entryway.png": 336067,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-factory.png": 21781,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-foyer.png": 843114,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-hollow.png": 440766,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-iceberg.png": 541649,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-mausoleum.png": 188375,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-parapet.png": 201588,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-pit.png": 16661,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-plant.png": 536278,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-platform.png": 133329,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-ship.png": 952206,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-station.png": 419164,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-tracks.png": 621126,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-tundra.png": 62921,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-valley.png": 491096,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-volcano.png": 12803,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-warehouse.png": 288921,
	"./random-dungeons/frosthaven/dungeons/fh-dungeon-wasteland.png": 404125,
	"./random-dungeons/frosthaven/monsters/fh-monster-abandoned.png": 885695,
	"./random-dungeons/frosthaven/monsters/fh-monster-bleak.png": 882819,
	"./random-dungeons/frosthaven/monsters/fh-monster-daunting.png": 150667,
	"./random-dungeons/frosthaven/monsters/fh-monster-decayed.png": 427653,
	"./random-dungeons/frosthaven/monsters/fh-monster-dirty.png": 641683,
	"./random-dungeons/frosthaven/monsters/fh-monster-domesticated.png": 311395,
	"./random-dungeons/frosthaven/monsters/fh-monster-feral.png": 680767,
	"./random-dungeons/frosthaven/monsters/fh-monster-grave.png": 284406,
	"./random-dungeons/frosthaven/monsters/fh-monster-luminous.png": 841223,
	"./random-dungeons/frosthaven/monsters/fh-monster-monster-back.png": 757125,
	"./random-dungeons/frosthaven/monsters/fh-monster-reinforced.png": 675173,
	"./random-dungeons/frosthaven/monsters/fh-monster-rusted.png": 863140,
	"./random-dungeons/frosthaven/monsters/fh-monster-sapping.png": 525126,
	"./random-dungeons/frosthaven/monsters/fh-monster-scorching.png": 387398,
	"./random-dungeons/frosthaven/monsters/fh-monster-segmented.png": 122124,
	"./random-dungeons/frosthaven/monsters/fh-monster-smashing.png": 162415,
	"./random-dungeons/frosthaven/monsters/fh-monster-stormy.png": 558997,
	"./random-dungeons/frosthaven/monsters/fh-monster-swarming.png": 627460,
	"./random-dungeons/frosthaven/monsters/fh-monster-swift.png": 157462,
	"./random-dungeons/frosthaven/monsters/fh-monster-taloned.png": 89584,
	"./random-dungeons/frosthaven/monsters/fh-monster-tamed.png": 350110,
	"./random-dungeons/frosthaven/monsters/fh-monster-territorial.png": 177165,
	"./random-dungeons/frosthaven/monsters/fh-monster-thrashing.png": 800700,
	"./random-dungeons/frosthaven/monsters/fh-monster-traitorous.png": 786498,
	"./random-dungeons/frosthaven/monsters/fh-monster-unsettling.png": 149718,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-a-back.png": 562702,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-ab-back.png": 360922,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-alcove.png": 806321,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-altar.png": 881995,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-armory.png": 488826,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-b-back.png": 663431,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-burrow.png": 44960,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-cabin.png": 321651,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-cave.png": 60575,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-clearing.png": 520212,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-corridor.png": 317769,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-crossroads.png": 485757,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-dead-end.png": 772568,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-den.png": 689064,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-encampment.png": 655492,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-hallway.png": 780834,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-hovel.png": 405530,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-library.png": 488997,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-passage.png": 30816,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-road.png": 373658,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-sewer.png": 756601,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-trail.png": 644843,
	"./random-dungeons/gloomhaven/dungeons/gh-dungeon-tunnel.png": 589094,
	"./random-dungeons/gloomhaven/monsters/gh-monster-archaic.png": 273042,
	"./random-dungeons/gloomhaven/monsters/gh-monster-corrupted.png": 564359,
	"./random-dungeons/gloomhaven/monsters/gh-monster-crushing.png": 185921,
	"./random-dungeons/gloomhaven/monsters/gh-monster-cutthroat.png": 911260,
	"./random-dungeons/gloomhaven/monsters/gh-monster-defiled.png": 973793,
	"./random-dungeons/gloomhaven/monsters/gh-monster-drowned.png": 150400,
	"./random-dungeons/gloomhaven/monsters/gh-monster-foggy.png": 273109,
	"./random-dungeons/gloomhaven/monsters/gh-monster-fortified.png": 720526,
	"./random-dungeons/gloomhaven/monsters/gh-monster-frigid.png": 794074,
	"./random-dungeons/gloomhaven/monsters/gh-monster-hopeless.png": 775648,
	"./random-dungeons/gloomhaven/monsters/gh-monster-horrific.png": 528392,
	"./random-dungeons/gloomhaven/monsters/gh-monster-infected.png": 459949,
	"./random-dungeons/gloomhaven/monsters/gh-monster-mangy.png": 802517,
	"./random-dungeons/gloomhaven/monsters/gh-monster-monster-back.png": 228008,
	"./random-dungeons/gloomhaven/monsters/gh-monster-putrid.png": 666865,
	"./random-dungeons/gloomhaven/monsters/gh-monster-rotting.png": 714360,
	"./random-dungeons/gloomhaven/monsters/gh-monster-scaled.png": 279237,
	"./random-dungeons/gloomhaven/monsters/gh-monster-tribal.png": 794157,
	"./random-dungeons/gloomhaven/monsters/gh-monster-unstable.png": 362550,
	"./random-dungeons/gloomhaven/monsters/gh-monster-venomous.png": 102869,
	"./random-dungeons/gloomhaven/monsters/gh-monster-wild.png": 38063,
	"./random-scenarios/frosthaven/fh-random-scenario-119.3.png": 222840,
	"./random-scenarios/frosthaven/fh-random-scenario-142.4.png": 428543,
	"./random-scenarios/frosthaven/fh-random-scenario-146.4.png": 558197,
	"./random-scenarios/frosthaven/fh-random-scenario-171.2.png": 953428,
	"./random-scenarios/frosthaven/fh-random-scenario-186.5.png": 146331,
	"./random-scenarios/frosthaven/fh-random-scenario-26.4.png": 89155,
	"./random-scenarios/frosthaven/fh-random-scenario-81.1.png": 79948,
	"./random-scenarios/frosthaven/fh-random-scenario-back.png": 538249,
	"./random-scenarios/gloomhaven/gh-arcane-library.png": 952144,
	"./random-scenarios/gloomhaven/gh-chained-isle.png": 45692,
	"./random-scenarios/gloomhaven/gh-clockwork-cove.png": 546089,
	"./random-scenarios/gloomhaven/gh-magma-pit.png": 671625,
	"./random-scenarios/gloomhaven/gh-random-scenario-back.png": 761319,
	"./random-scenarios/gloomhaven/gh-sulfur-mine.png": 913297,
	"./random-scenarios/gloomhaven/gh-toxic-moor.png": 639908,
	"./random-scenarios/gloomhaven/gh-underwater-lagoon.png": 439057,
	"./random-scenarios/gloomhaven/gh-well-of-the-unfortunate.png": 283961,
	"./random-scenarios/gloomhaven/gh-windswept-highlands.png": 81637,
	"./random-scenarios/trail-of-ashes/toa-inox-salvation.png": 112214,
	"./random-scenarios/trail-of-ashes/toa-lootpalooza.png": 81633,
	"./random-scenarios/trail-of-ashes/toa-random-scenario-back.png": 996645,
	"./random-scenarios/trail-of-ashes/toa-song-of-the-harrower.png": 761875,
	"./random-scenarios/trail-of-ashes/toa-sunken-temple.png": 790699,
	"./random-scenarios/trail-of-ashes/toa-untold-woe.png": 713053,
	"./templates/ZZ/zz.txt": 672852,
	"./templates/gloomhaven/gh-battle-goals-back.jpg": 897250,
	"./templates/gloomhaven/gh-battle-goals-front.jpg": 341202,
	"./tokens/crimson-scales/character-tokens/cs-amber-aegis-token.png": 314059,
	"./tokens/crimson-scales/character-tokens/cs-artificer-token.png": 276528,
	"./tokens/crimson-scales/character-tokens/cs-bombard-token.png": 398525,
	"./tokens/crimson-scales/character-tokens/cs-brightspark-token.png": 422952,
	"./tokens/crimson-scales/character-tokens/cs-chainguard-token.png": 876067,
	"./tokens/crimson-scales/character-tokens/cs-chieftain-token.png": 2715,
	"./tokens/crimson-scales/character-tokens/cs-fire-knight-token.png": 92444,
	"./tokens/crimson-scales/character-tokens/cs-hierophant-token.png": 124943,
	"./tokens/crimson-scales/character-tokens/cs-hollowpact-token.png": 896470,
	"./tokens/crimson-scales/character-tokens/cs-luminary-token.png": 892480,
	"./tokens/crimson-scales/character-tokens/cs-mirefoot-token.png": 534973,
	"./tokens/crimson-scales/character-tokens/cs-ruinmaw-token.png": 186878,
	"./tokens/crimson-scales/character-tokens/cs-spirit-caller-token.png": 93680,
	"./tokens/crimson-scales/character-tokens/cs-starslinger-token.png": 612559,
	"./tokens/crimson-scales/class-tokens/cs-deathshroud-spider-back.png": 326973,
	"./tokens/crimson-scales/class-tokens/cs-deathshroud-spider.png": 462150,
	"./tokens/crimson-scales/class-tokens/cs-firespitter-ant-back.png": 605859,
	"./tokens/crimson-scales/class-tokens/cs-firespitter-ant.png": 173473,
	"./tokens/crimson-scales/class-tokens/cs-ghostshimmer-bee-back.png": 770203,
	"./tokens/crimson-scales/class-tokens/cs-ghostshimmer-bee.png": 752088,
	"./tokens/crimson-scales/class-tokens/cs-ladder.png": 901371,
	"./tokens/crimson-scales/class-tokens/cs-rockspine-termite-back.png": 28817,
	"./tokens/crimson-scales/class-tokens/cs-rockspine-termite.png": 791960,
	"./tokens/crimson-scales/class-tokens/cs-sated-back.png": 135488,
	"./tokens/crimson-scales/class-tokens/cs-sated.png": 867240,
	"./tokens/crimson-scales/class-tokens/cs-scrap.png": 191967,
	"./tokens/crimson-scales/class-tokens/cs-spawn-blue-large.png": 501751,
	"./tokens/crimson-scales/class-tokens/cs-spawn-blue-small.png": 128672,
	"./tokens/crimson-scales/class-tokens/cs-spawn-green-large.png": 103528,
	"./tokens/crimson-scales/class-tokens/cs-spawn-green-small.png": 792613,
	"./tokens/crimson-scales/class-tokens/cs-spawn-purple-large.png": 29873,
	"./tokens/crimson-scales/class-tokens/cs-spawn-purple-small.png": 1199,
	"./tokens/crimson-scales/class-tokens/cs-spawn-red-large.png": 24908,
	"./tokens/crimson-scales/class-tokens/cs-spawn-red-small.png": 64447,
	"./tokens/crimson-scales/class-tokens/cs-spawn-white-large.png": 589944,
	"./tokens/crimson-scales/class-tokens/cs-spawn-white-small.png": 926591,
	"./tokens/crimson-scales/class-tokens/cs-spawn-yellow-large.png": 974604,
	"./tokens/crimson-scales/class-tokens/cs-spawn-yellow-small.png": 65240,
	"./tokens/crimson-scales/class-tokens/cs-void-energy.png": 603275,
	"./tokens/crimson-scales/condition-tokens/cs-bane.png": 370306,
	"./tokens/crimson-scales/condition-tokens/cs-chill.png": 23571,
	"./tokens/crimson-scales/condition-tokens/cs-infect.png": 475114,
	"./tokens/crimson-scales/condition-tokens/cs-poison-2.png": 967474,
	"./tokens/crimson-scales/condition-tokens/cs-poison-3.png": 887568,
	"./tokens/crimson-scales/condition-tokens/cs-poison-4.png": 426777,
	"./tokens/crimson-scales/condition-tokens/cs-rupture.png": 451989,
	"./tokens/crimson-scales/condition-tokens/cs-ward.png": 91144,
	"./tokens/crimson-scales/condition-tokens/cs-wound-2.png": 152462,
	"./tokens/crimson-scales/damage-tokens/cs-damage-20.png": 494395,
	"./tokens/crimson-scales/damage-tokens/cs-damage-50.png": 471650,
	"./tokens/crimson-scales/overlay-tokens/cs-bog.png": 837010,
	"./tokens/crimson-scales/overlay-tokens/cs-broken-log.png": 308497,
	"./tokens/crimson-scales/overlay-tokens/cs-void-pit.png": 800217,
	"./tokens/forgotten-circles/ZZ/zz.txt": 499425,
	"./tokens/forgotten-circles/character-tokens/fc-diviner-rift.png": 832421,
	"./tokens/frosthaven/conditions/fh-bane-condition.png": 753440,
	"./tokens/frosthaven/conditions/fh-bless-condition.png": 769671,
	"./tokens/frosthaven/conditions/fh-brittle-condition.png": 343232,
	"./tokens/frosthaven/conditions/fh-curse-condition.png": 633804,
	"./tokens/frosthaven/conditions/fh-disarm-condition.png": 834414,
	"./tokens/frosthaven/conditions/fh-immobilize-condition.png": 34605,
	"./tokens/frosthaven/conditions/fh-impair-condition.png": 909170,
	"./tokens/frosthaven/conditions/fh-invisible-condition.png": 553990,
	"./tokens/frosthaven/conditions/fh-muddle-condition.png": 418046,
	"./tokens/frosthaven/conditions/fh-poison-condition.png": 175844,
	"./tokens/frosthaven/conditions/fh-regenerate-condition.png": 13518,
	"./tokens/frosthaven/conditions/fh-strengthen-condition.png": 891104,
	"./tokens/frosthaven/conditions/fh-stun-condition.png": 956214,
	"./tokens/frosthaven/conditions/fh-ward-condition.png": 491761,
	"./tokens/frosthaven/conditions/fh-wound-condition.png": 529723,
	"./tokens/frosthaven/damage/fh-1-damage.png": 201954,
	"./tokens/frosthaven/damage/fh-10-damage.png": 250604,
	"./tokens/frosthaven/damage/fh-100-damage.png": 21624,
	"./tokens/frosthaven/damage/fh-20-damage.png": 118594,
	"./tokens/frosthaven/damage/fh-3-damage.png": 918251,
	"./tokens/frosthaven/elements/fh-air-element.png": 513724,
	"./tokens/frosthaven/elements/fh-dark-element.png": 651997,
	"./tokens/frosthaven/elements/fh-earth-element.png": 997245,
	"./tokens/frosthaven/elements/fh-fire-element.png": 621236,
	"./tokens/frosthaven/elements/fh-ice-element.png": 671682,
	"./tokens/frosthaven/elements/fh-light-element.png": 780993,
	"./tokens/frosthaven/scenario-aids/fh-round-tracker.png": 85345,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-a.png": 469834,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-b.png": 107283,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-c.png": 561036,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-d.png": 773399,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-e.png": 794771,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-f.png": 66849,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-g.png": 415241,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-h.png": 456591,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-i.png": 851215,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-j.png": 747974,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-k.png": 446686,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-letter-m.png": 358629,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-01.png": 747128,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-02.png": 249518,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-03.png": 20974,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-04.png": 460049,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-05.png": 7190,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-06.png": 316101,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-07.png": 699346,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-08.png": 305987,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-09.png": 27265,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-10.png": 81628,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-11.png": 373260,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-12.png": 639827,
	"./tokens/frosthaven/scenario-aids/fh-scenario-aid-number-back.png": 488737,
	"./tokens/frosthaven/terrain/fh-altar.png": 493528,
	"./tokens/frosthaven/terrain/fh-barrels.png": 411834,
	"./tokens/frosthaven/terrain/fh-barricade.png": 799661,
	"./tokens/frosthaven/terrain/fh-bear-trap.png": 589085,
	"./tokens/frosthaven/terrain/fh-bookshelf.png": 260216,
	"./tokens/frosthaven/terrain/fh-cave-corridor-large.png": 843401,
	"./tokens/frosthaven/terrain/fh-cave-corridor-small.png": 686040,
	"./tokens/frosthaven/terrain/fh-cave-door.png": 648881,
	"./tokens/frosthaven/terrain/fh-cave-rock.png": 801007,
	"./tokens/frosthaven/terrain/fh-control-console.png": 818619,
	"./tokens/frosthaven/terrain/fh-crate.png": 174776,
	"./tokens/frosthaven/terrain/fh-debris-large.png": 918186,
	"./tokens/frosthaven/terrain/fh-debris-small.png": 179248,
	"./tokens/frosthaven/terrain/fh-dungeon-corridor-large.png": 563615,
	"./tokens/frosthaven/terrain/fh-dungeon-corridor-small.png": 903906,
	"./tokens/frosthaven/terrain/fh-dungeon-door-closed.png": 486296,
	"./tokens/frosthaven/terrain/fh-dungeon-door-open.png": 833620,
	"./tokens/frosthaven/terrain/fh-glowing-orb.png": 790575,
	"./tokens/frosthaven/terrain/fh-ice-corridor-large.png": 100492,
	"./tokens/frosthaven/terrain/fh-ice-corridor-small.png": 382128,
	"./tokens/frosthaven/terrain/fh-ice-crystal.png": 463989,
	"./tokens/frosthaven/terrain/fh-ice-pillar.png": 391501,
	"./tokens/frosthaven/terrain/fh-ice-spikes.png": 745574,
	"./tokens/frosthaven/terrain/fh-lava.png": 614703,
	"./tokens/frosthaven/terrain/fh-log.png": 839804,
	"./tokens/frosthaven/terrain/fh-loot.png": 615236,
	"./tokens/frosthaven/terrain/fh-mast.png": 788341,
	"./tokens/frosthaven/terrain/fh-metal-cabinet.png": 422207,
	"./tokens/frosthaven/terrain/fh-metal-corridor-large.png": 238919,
	"./tokens/frosthaven/terrain/fh-metal-corridor-small.png": 283904,
	"./tokens/frosthaven/terrain/fh-metal-door-closed.png": 663604,
	"./tokens/frosthaven/terrain/fh-metal-door-open.png": 467706,
	"./tokens/frosthaven/terrain/fh-nest.png": 916153,
	"./tokens/frosthaven/terrain/fh-poison-trap.png": 958981,
	"./tokens/frosthaven/terrain/fh-power-conduit.png": 537118,
	"./tokens/frosthaven/terrain/fh-pressure-plate.png": 997856,
	"./tokens/frosthaven/terrain/fh-rubble.png": 628334,
	"./tokens/frosthaven/terrain/fh-sarcophagus-closed.png": 246515,
	"./tokens/frosthaven/terrain/fh-sarcophagus-open.png": 35427,
	"./tokens/frosthaven/terrain/fh-snow-corridor-large.png": 427950,
	"./tokens/frosthaven/terrain/fh-snow-corridor-small.png": 225119,
	"./tokens/frosthaven/terrain/fh-snow-door.png": 501170,
	"./tokens/frosthaven/terrain/fh-snow-rock-large.png": 995571,
	"./tokens/frosthaven/terrain/fh-snow-rock-small.png": 804379,
	"./tokens/frosthaven/terrain/fh-snowdrift.png": 452054,
	"./tokens/frosthaven/terrain/fh-spike-pit-trap.png": 552339,
	"./tokens/frosthaven/terrain/fh-stairs.png": 922773,
	"./tokens/frosthaven/terrain/fh-stalagmites.png": 165004,
	"./tokens/frosthaven/terrain/fh-supply-shelf.png": 158760,
	"./tokens/frosthaven/terrain/fh-treasure-chest.png": 378691,
	"./tokens/frosthaven/terrain/fh-tree.png": 199726,
	"./tokens/frosthaven/terrain/fh-water-huge.png": 636801,
	"./tokens/frosthaven/terrain/fh-water-large.png": 541851,
	"./tokens/frosthaven/terrain/fh-water-small.png": 64785,
	"./tokens/gloomhaven/corridors/gh-earth-1.png": 189352,
	"./tokens/gloomhaven/corridors/gh-earth-2.png": 717373,
	"./tokens/gloomhaven/corridors/gh-man-made-stone-1.png": 192762,
	"./tokens/gloomhaven/corridors/gh-man-made-stone-2.png": 77887,
	"./tokens/gloomhaven/corridors/gh-natural-stone-1.png": 604912,
	"./tokens/gloomhaven/corridors/gh-natural-stone-2.png": 828975,
	"./tokens/gloomhaven/corridors/gh-pressure-plate.png": 214448,
	"./tokens/gloomhaven/corridors/gh-wood-1.png": 568410,
	"./tokens/gloomhaven/corridors/gh-wood-2.png": 654372,
	"./tokens/gloomhaven/difficult-terrain/gh-log.png": 558259,
	"./tokens/gloomhaven/difficult-terrain/gh-rubble.png": 163659,
	"./tokens/gloomhaven/difficult-terrain/gh-stairs.png": 729084,
	"./tokens/gloomhaven/difficult-terrain/gh-water.png": 174925,
	"./tokens/gloomhaven/doors/gh-dark-fog.png": 243837,
	"./tokens/gloomhaven/doors/gh-light-fog.png": 34220,
	"./tokens/gloomhaven/doors/gh-stone-door.png": 284407,
	"./tokens/gloomhaven/doors/gh-wood-door.png": 568005,
	"./tokens/gloomhaven/hazardous-terrain/gh-hot-coals.png": 271600,
	"./tokens/gloomhaven/hazardous-terrain/gh-thorns.png": 568639,
	"./tokens/gloomhaven/obstacles/gh-altar.png": 818317,
	"./tokens/gloomhaven/obstacles/gh-barrel.png": 424180,
	"./tokens/gloomhaven/obstacles/gh-bookcase.png": 322891,
	"./tokens/gloomhaven/obstacles/gh-boulder-1.png": 4994,
	"./tokens/gloomhaven/obstacles/gh-boulder-2.png": 880980,
	"./tokens/gloomhaven/obstacles/gh-boulder-3.png": 983014,
	"./tokens/gloomhaven/obstacles/gh-bush.png": 173199,
	"./tokens/gloomhaven/obstacles/gh-cabinet.png": 711772,
	"./tokens/gloomhaven/obstacles/gh-crate.png": 913379,
	"./tokens/gloomhaven/obstacles/gh-crystal.png": 311412,
	"./tokens/gloomhaven/obstacles/gh-dark-corridor.png": 760976,
	"./tokens/gloomhaven/obstacles/gh-dark-pit.png": 794679,
	"./tokens/gloomhaven/obstacles/gh-fountain.png": 561109,
	"./tokens/gloomhaven/obstacles/gh-nest.png": 855472,
	"./tokens/gloomhaven/obstacles/gh-rock-column.png": 217418,
	"./tokens/gloomhaven/obstacles/gh-sarcophagus.png": 7045,
	"./tokens/gloomhaven/obstacles/gh-shelf.png": 251215,
	"./tokens/gloomhaven/obstacles/gh-stalagmites.png": 237010,
	"./tokens/gloomhaven/obstacles/gh-stone-pillar.png": 140208,
	"./tokens/gloomhaven/obstacles/gh-stump.png": 38454,
	"./tokens/gloomhaven/obstacles/gh-table.png": 542684,
	"./tokens/gloomhaven/obstacles/gh-totem.png": 57964,
	"./tokens/gloomhaven/obstacles/gh-tree.png": 755842,
	"./tokens/gloomhaven/obstacles/gh-wall-section.png": 20334,
	"./tokens/gloomhaven/summons/gh-summons-orig.png": 836104,
	"./tokens/gloomhaven/summons/gh-summons.png": 94251,
	"./tokens/gloomhaven/traps/gh-bear-trap.png": 184502,
	"./tokens/gloomhaven/traps/gh-poison-gas-trap.png": 469765,
	"./tokens/gloomhaven/traps/gh-spike-pit-trap.png": 158919,
	"./tokens/gloomhaven/treasures/gh-coin-1.png": 449416,
	"./tokens/gloomhaven/treasures/gh-coin-5.png": 246007,
	"./tokens/gloomhaven/treasures/gh-treasure.png": 262986,
	"./tokens/trail-of-ashes/character-tokens/toa-incarnate-token.png": 616179,
	"./tokens/trail-of-ashes/character-tokens/toa-rimehearth-token.png": 706987,
	"./tokens/trail-of-ashes/character-tokens/toa-shardrender-token.png": 37563,
	"./tokens/trail-of-ashes/character-tokens/toa-tempest-token.png": 649466,
	"./tokens/trail-of-ashes/character-tokens/toa-thornreaper-token.png": 95083,
	"./tokens/trail-of-ashes/character-tokens/toa-vanquisher-token.png": 396022,
	"./tokens/trail-of-ashes/class-tokens/toa-sparks.png": 113443,
	"./tokens/trail-of-ashes/class-tokens/toa-thorns.png": 275952,
	"./tokens/trail-of-ashes/condition-tokens/toa-brittle.png": 657001,
	"./tokens/trail-of-ashes/condition-tokens/toa-dodge.png": 743251,
	"./tokens/trail-of-ashes/condition-tokens/toa-rupture.png": 23650,
	"./trial-cards/ZZ/zz.txt": 776289,
	"./trial-cards/frosthaven/fh-trial-cards-back.png": 671207,
	"./trial-cards/frosthaven/fh-trial-of-censorship.png": 361396,
	"./trial-cards/frosthaven/fh-trial-of-deceit.png": 955984,
	"./trial-cards/frosthaven/fh-trial-of-expression.png": 618264,
	"./trial-cards/frosthaven/fh-trial-of-inquisition.png": 81565,
	"./trial-cards/frosthaven/fh-trial-of-manipulation.png": 557909,
	"./trial-cards/frosthaven/fh-trial-of-order.png": 470842,
	"./trial-cards/frosthaven/fh-trial-of-patience.png": 178783,
	"./trial-cards/frosthaven/fh-trial-of-poverty.png": 237730,
	"./trial-cards/frosthaven/fh-trial-of-prediction.png": 403904,
	"./trial-cards/frosthaven/fh-trial-of-strategy.png": 889758,
	"./trial-cards/frosthaven/fh-trial-of-trials.png": 556574,
	"./trial-cards/frosthaven/fh-trial-of-victory.png": 270704,
	"./trial-cards/frosthaven/fh-trial-of-weakness.png": 697729,
	"./world-map/frosthaven/fh-frosthaven-map.pdf": 550230,
	"./world-map/frosthaven/fh-frosthaven-map.png": 284442,
	"./world-map/gloomhaven/gh-1.png": 736419,
	"./world-map/gloomhaven/gh-10.png": 58802,
	"./world-map/gloomhaven/gh-11-12.png": 439501,
	"./world-map/gloomhaven/gh-13.png": 623678,
	"./world-map/gloomhaven/gh-14.png": 413176,
	"./world-map/gloomhaven/gh-15.png": 226565,
	"./world-map/gloomhaven/gh-16.png": 201490,
	"./world-map/gloomhaven/gh-17.png": 635750,
	"./world-map/gloomhaven/gh-18.png": 915699,
	"./world-map/gloomhaven/gh-19.png": 934666,
	"./world-map/gloomhaven/gh-2.png": 519381,
	"./world-map/gloomhaven/gh-20.png": 172795,
	"./world-map/gloomhaven/gh-21.png": 75360,
	"./world-map/gloomhaven/gh-22.png": 794304,
	"./world-map/gloomhaven/gh-23.png": 810805,
	"./world-map/gloomhaven/gh-24.png": 651927,
	"./world-map/gloomhaven/gh-25.png": 327942,
	"./world-map/gloomhaven/gh-26.png": 917604,
	"./world-map/gloomhaven/gh-27.png": 805788,
	"./world-map/gloomhaven/gh-28.png": 975034,
	"./world-map/gloomhaven/gh-29.png": 448319,
	"./world-map/gloomhaven/gh-3.png": 262087,
	"./world-map/gloomhaven/gh-30.png": 119610,
	"./world-map/gloomhaven/gh-31.png": 594171,
	"./world-map/gloomhaven/gh-32.png": 757389,
	"./world-map/gloomhaven/gh-33.png": 619095,
	"./world-map/gloomhaven/gh-34.png": 227209,
	"./world-map/gloomhaven/gh-35-36.png": 560846,
	"./world-map/gloomhaven/gh-37.png": 690831,
	"./world-map/gloomhaven/gh-38.png": 253725,
	"./world-map/gloomhaven/gh-39.png": 115271,
	"./world-map/gloomhaven/gh-4.png": 293569,
	"./world-map/gloomhaven/gh-40.png": 235846,
	"./world-map/gloomhaven/gh-41.png": 226208,
	"./world-map/gloomhaven/gh-42.png": 327769,
	"./world-map/gloomhaven/gh-43.png": 553090,
	"./world-map/gloomhaven/gh-44.png": 843319,
	"./world-map/gloomhaven/gh-45.png": 673328,
	"./world-map/gloomhaven/gh-46.png": 538358,
	"./world-map/gloomhaven/gh-47.png": 86016,
	"./world-map/gloomhaven/gh-48.png": 163244,
	"./world-map/gloomhaven/gh-49.png": 53862,
	"./world-map/gloomhaven/gh-5.png": 812779,
	"./world-map/gloomhaven/gh-50.png": 540227,
	"./world-map/gloomhaven/gh-51.png": 27281,
	"./world-map/gloomhaven/gh-52.png": 932330,
	"./world-map/gloomhaven/gh-53.png": 974606,
	"./world-map/gloomhaven/gh-54.png": 324314,
	"./world-map/gloomhaven/gh-55.png": 554154,
	"./world-map/gloomhaven/gh-56.png": 779663,
	"./world-map/gloomhaven/gh-57.png": 836366,
	"./world-map/gloomhaven/gh-58.png": 712118,
	"./world-map/gloomhaven/gh-59.png": 457553,
	"./world-map/gloomhaven/gh-6.png": 104406,
	"./world-map/gloomhaven/gh-60.png": 352982,
	"./world-map/gloomhaven/gh-61.png": 859192,
	"./world-map/gloomhaven/gh-62.png": 913522,
	"./world-map/gloomhaven/gh-63.png": 503048,
	"./world-map/gloomhaven/gh-64.png": 662617,
	"./world-map/gloomhaven/gh-65.png": 639761,
	"./world-map/gloomhaven/gh-66.png": 110007,
	"./world-map/gloomhaven/gh-67.png": 327669,
	"./world-map/gloomhaven/gh-68.png": 552138,
	"./world-map/gloomhaven/gh-69.png": 130294,
	"./world-map/gloomhaven/gh-7.png": 707456,
	"./world-map/gloomhaven/gh-70.png": 317009,
	"./world-map/gloomhaven/gh-71.png": 848387,
	"./world-map/gloomhaven/gh-72.png": 644115,
	"./world-map/gloomhaven/gh-73.png": 993779,
	"./world-map/gloomhaven/gh-74.png": 862703,
	"./world-map/gloomhaven/gh-75.png": 827309,
	"./world-map/gloomhaven/gh-76.png": 489190,
	"./world-map/gloomhaven/gh-77.png": 46155,
	"./world-map/gloomhaven/gh-78.png": 922038,
	"./world-map/gloomhaven/gh-79.png": 528348,
	"./world-map/gloomhaven/gh-8.png": 252577,
	"./world-map/gloomhaven/gh-80.png": 467011,
	"./world-map/gloomhaven/gh-81.png": 973052,
	"./world-map/gloomhaven/gh-82.png": 714590,
	"./world-map/gloomhaven/gh-83.png": 537660,
	"./world-map/gloomhaven/gh-84.png": 570603,
	"./world-map/gloomhaven/gh-85.png": 918721,
	"./world-map/gloomhaven/gh-86.png": 938250,
	"./world-map/gloomhaven/gh-87.png": 72150,
	"./world-map/gloomhaven/gh-88.png": 444009,
	"./world-map/gloomhaven/gh-89.png": 315615,
	"./world-map/gloomhaven/gh-9.png": 890070,
	"./world-map/gloomhaven/gh-90.png": 312100,
	"./world-map/gloomhaven/gh-91.png": 607683,
	"./world-map/gloomhaven/gh-92.png": 721786,
	"./world-map/gloomhaven/gh-93.png": 557397,
	"./world-map/gloomhaven/gh-94.png": 625574,
	"./world-map/gloomhaven/gh-95.png": 180199,
	"./world-map/gloomhaven/gh-gloomhaven-map-orig.png": 302625,
	"./world-map/gloomhaven/gh-gloomhaven-map.png": 365670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112690;